/// <reference path="./custom.d.ts" />
// tslint:disable
/**
 * Eurogast Hub API
 * The API for communication with Eurogast eCommerce Hub. Background information in Confluence: https://confluence.eurogast.at/display/P1801 Every request should have an Accept-Language header indicating the locale to use to display data.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


import * as url from "url";
import * as portableFetch from "portable-fetch";
import { Configuration } from "./configuration";

const BASE_PATH = "https://localhost:8070/v1".replace(/\/+$/, "");

/**
 *
 * @export
 */
export const COLLECTION_FORMATS = {
    csv: ",",
    ssv: " ",
    tsv: "\t",
    pipes: "|",
};

/**
 *
 * @export
 * @interface FetchAPI
 */
export interface FetchAPI {
    (url: string, init?: any): Promise<Response>;
}

/**
 *  
 * @export
 * @interface FetchArgs
 */
export interface FetchArgs {
    url: string;
    options: any;
}

/**
 * 
 * @export
 * @class BaseAPI
 */
export class BaseAPI {
    protected configuration: Configuration;

    constructor(configuration?: Configuration, protected basePath: string = BASE_PATH, protected fetch: FetchAPI = portableFetch) {
        if (configuration) {
            this.configuration = configuration;
            this.basePath = configuration.basePath || this.basePath;
        }
    }
};

/**
 * 
 * @export
 * @class RequiredError
 * @extends {Error}
 */
export class RequiredError extends Error {
    name: "RequiredError"
    constructor(public field: string, msg?: string) {
        super(msg);
    }
}

/**
 * 
 * @export
 * @interface AggregatedOrderTemplateDto
 */
export interface AggregatedOrderTemplateDto {
    /**
     * 
     * @type {number}
     * @memberof AggregatedOrderTemplateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof AggregatedOrderTemplateDto
     */
    customerId?: string;
    /**
     * 
     * @type {Date}
     * @memberof AggregatedOrderTemplateDto
     */
    creationTime?: Date;
    /**
     * 
     * @type {Date}
     * @memberof AggregatedOrderTemplateDto
     */
    lastEditedTime?: Date;
    /**
     * 
     * @type {UserDto}
     * @memberof AggregatedOrderTemplateDto
     */
    createdBy?: UserDto;
    /**
     * 
     * @type {Array&lt;UserDto&gt;}
     * @memberof AggregatedOrderTemplateDto
     */
    sharedWith?: Array<UserDto>;
    /**
     * 
     * @type {UserDto}
     * @memberof AggregatedOrderTemplateDto
     */
    lastEditedBy?: UserDto;
    /**
     * 
     * @type {string}
     * @memberof AggregatedOrderTemplateDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof AggregatedOrderTemplateDto
     */
    comment?: string;
    /**
     * 
     * @type {Array&lt;OrderTemplateItemDto&gt;}
     * @memberof AggregatedOrderTemplateDto
     */
    orderTemplateItems?: Array<OrderTemplateItemDto>;
    /**
     * 
     * @type {ProductSearchResult}
     * @memberof AggregatedOrderTemplateDto
     */
    productSearchResult?: ProductSearchResult;
    /**
     * 
     * @type {boolean}
     * @memberof AggregatedOrderTemplateDto
     */
    shareable?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AggregatedOrderTemplateDto
     */
    priceList?: string;
}

/**
 * Additional properties required to submit an app-order.
 * @export
 * @interface AppOrderSubmitDto
 */
export interface AppOrderSubmitDto {
    /**
     * The base order-data, which is extended by the app-specific fields
     * @type {OrderSubmitRequest}
     * @memberof AppOrderSubmitDto
     */
    orderSubmitDto?: OrderSubmitRequest;
    /**
     * Determines if the order was sent from an ordinary-app or from a bf-app-pro user.
     * @type {boolean}
     * @memberof AppOrderSubmitDto
     */
    isProOrder?: boolean;
    /**
     * The serial-number of a bf-pro device
     * @type {string}
     * @memberof AppOrderSubmitDto
     */
    deviceId?: string;
}

/**
 * Status of a specific version of the Best.Friend app.
 * @export
 * @interface AppVersionStatusDto
 */
export interface AppVersionStatusDto {
    /**
     * Whether this version is to be considered outdated.
     * @type {boolean}
     * @memberof AppVersionStatusDto
     */
    outdated?: boolean;
}

/**
 * User assigned to a customer with limited information.
 * @export
 * @interface AssignedUserDto
 */
export interface AssignedUserDto {
    /**
     * The unique id of this user, as used by the SSO provider
     * @type {string}
     * @memberof AssignedUserDto
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof AssignedUserDto
     */
    userName: string;
    /**
     * 
     * @type {string}
     * @memberof AssignedUserDto
     */
    email: string;
    /**
     * Whether this user is currently enabled, i.e. allowed to log in.
     * @type {boolean}
     * @memberof AssignedUserDto
     */
    isEnabled: boolean;
}

/**
 * A concrete delivery slot mapped to a specific date.
 * @export
 * @interface AvailableDeliverySlotDto
 */
export interface AvailableDeliverySlotDto {
    /**
     * The day for the delivery
     * @type {string}
     * @memberof AvailableDeliverySlotDto
     */
    day: string;
    /**
     * 
     * @type {string}
     * @memberof AvailableDeliverySlotDto
     */
    time: string;
}

/**
 * 
 * @export
 * @interface BaseManagementNotificationCustomerGroupDto
 */
export interface BaseManagementNotificationCustomerGroupDto {
    /**
     * 
     * @type {number}
     * @memberof BaseManagementNotificationCustomerGroupDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof BaseManagementNotificationCustomerGroupDto
     */
    tenant?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseManagementNotificationCustomerGroupDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseManagementNotificationCustomerGroupDto
     */
    description?: string;
}

/**
 * Settings for a Best.Friend scanner.
 * @export
 * @interface BestFriendSettingsDto
 */
export interface BestFriendSettingsDto {
    /**
     * Unique ID. The HUB generates it for new bestfriends.
     * @type {number}
     * @memberof BestFriendSettingsDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof BestFriendSettingsDto
     */
    scannersn?: string;
    /**
     * 
     * @type {number}
     * @memberof BestFriendSettingsDto
     */
    version?: number;
    /**
     * 
     * @type {string}
     * @memberof BestFriendSettingsDto
     */
    tenant?: string;
    /**
     * Number of minutes BF sends automatic update request
     * @type {number}
     * @memberof BestFriendSettingsDto
     */
    updateinterval?: number;
    /**
     * 
     * @type {number}
     * @memberof BestFriendSettingsDto
     */
    productIsNewForDays?: number;
    /**
     * 
     * @type {number}
     * @memberof BestFriendSettingsDto
     */
    dataIsOldAfterDays?: number;
    /**
     * 
     * @type {number}
     * @memberof BestFriendSettingsDto
     */
    showPricesForDays?: number;
    /**
     * 
     * @type {number}
     * @memberof BestFriendSettingsDto
     */
    maxSearchResults?: number;
    /**
     * Show update dialog after x days right after every order submission. 9999 = dont show update dialog.
     * @type {number}
     * @memberof BestFriendSettingsDto
     */
    updateIfDataIsOlderThanDays?: number;
    /**
     * Is BF user allowed to submit an order? Definition of values see https://confluence.eurogast.at/x/hoCD
     * @type {number}
     * @memberof BestFriendSettingsDto
     */
    submitOption?: number;
    /**
     * Show prices on BF? Defintion of values see https://confluence.eurogast.at/x/hoCD
     * @type {number}
     * @memberof BestFriendSettingsDto
     */
    priceDisplay?: number;
    /**
     * 0 = no restriction - BF user can order all articles; 1 = BF user can only order essenz articles for all customers 2 = BF user can only order articles with a special price for all customers
     * @type {number}
     * @memberof BestFriendSettingsDto
     */
    catalogRestrictionType?: number;
    /**
     * 
     * @type {boolean}
     * @memberof BestFriendSettingsDto
     */
    showPromotions?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BestFriendSettingsDto
     */
    showSpecialPrices?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BestFriendSettingsDto
     */
    allowMultipleOrders?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BestFriendSettingsDto
     */
    assignedUser?: string;
    /**
     * 
     * @type {string}
     * @memberof BestFriendSettingsDto
     */
    assignedUserName?: string;
    /**
     * 
     * @type {string}
     * @memberof BestFriendSettingsDto
     */
    infoText1?: string;
    /**
     * 
     * @type {string}
     * @memberof BestFriendSettingsDto
     */
    infoText2?: string;
    /**
     * 
     * @type {string}
     * @memberof BestFriendSettingsDto
     */
    infoText3?: string;
    /**
     * 
     * @type {string}
     * @memberof BestFriendSettingsDto
     */
    infoText4?: string;
    /**
     * 
     * @type {string}
     * @memberof BestFriendSettingsDto
     */
    infoText5?: string;
    /**
     * 
     * @type {string}
     * @memberof BestFriendSettingsDto
     */
    notes?: string;
    /**
     * 
     * @type {string}
     * @memberof BestFriendSettingsDto
     */
    softwareVersion?: string;
    /**
     * 
     * @type {string}
     * @memberof BestFriendSettingsDto
     */
    dataVersion?: string;
    /**
     * 
     * @type {Date}
     * @memberof BestFriendSettingsDto
     */
    lastConnectionTime?: Date;
    /**
     * The status of this bestfriend.
     * @type {string}
     * @memberof BestFriendSettingsDto
     */
    status?: BestFriendSettingsDto.StatusEnum;
    /**
     * 
     * @type {Date}
     * @memberof BestFriendSettingsDto
     */
    lastOrderTime?: Date;
    /**
     * 
     * @type {Date}
     * @memberof BestFriendSettingsDto
     */
    creationTime?: Date;
    /**
     * The hardware device type.
     * @type {string}
     * @memberof BestFriendSettingsDto
     */
    deviceType?: BestFriendSettingsDto.DeviceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof BestFriendSettingsDto
     */
    networkContactCompany?: string;
    /**
     * 
     * @type {string}
     * @memberof BestFriendSettingsDto
     */
    networkContactName?: string;
    /**
     * 
     * @type {string}
     * @memberof BestFriendSettingsDto
     */
    networkContactPhone?: string;
    /**
     * 
     * @type {string}
     * @memberof BestFriendSettingsDto
     */
    networkContactMail?: string;
    /**
     * 
     * @type {string}
     * @memberof BestFriendSettingsDto
     */
    networkConfigIP?: string;
    /**
     * 
     * @type {string}
     * @memberof BestFriendSettingsDto
     */
    networkConfigSubnetMask?: string;
    /**
     * 
     * @type {string}
     * @memberof BestFriendSettingsDto
     */
    networkConfigGateway?: string;
    /**
     * 
     * @type {string}
     * @memberof BestFriendSettingsDto
     */
    networkConfigDNS1?: string;
    /**
     * 
     * @type {string}
     * @memberof BestFriendSettingsDto
     */
    networkConfigDNS2?: string;
    /**
     * 
     * @type {string}
     * @memberof BestFriendSettingsDto
     */
    networkConfigFull?: string;
    /**
     * 
     * @type {string}
     * @memberof BestFriendSettingsDto
     */
    networkContactFull?: string;
    /**
     * 
     * @type {string}
     * @memberof BestFriendSettingsDto
     */
    language?: BestFriendSettingsDto.LanguageEnum;
}

/**
 * @export
 * @namespace BestFriendSettingsDto
 */
export namespace BestFriendSettingsDto {
    /**
     * @export
     * @enum {string}
     */
    export enum StatusEnum {
        TestMode = <any> 'test-mode',
        LiveMode = <any> 'live-mode'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum DeviceTypeEnum {
        MC3190RL2S02E0W = <any> 'MC3190-RL2S02E0W',
        MC3190RL2S04E0A = <any> 'MC3190-RL2S04E0A',
        M32N0RL2HCHEIA = <any> 'M32N0-RL2HCHEIA'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum LanguageEnum {
        De = <any> 'de',
        En = <any> 'en'
    }
}

/**
 * 
 * @export
 * @interface BestFriendSettingsSearchResultDto
 */
export interface BestFriendSettingsSearchResultDto {
    /**
     * 
     * @type {PageMetadataDto}
     * @memberof BestFriendSettingsSearchResultDto
     */
    page?: PageMetadataDto;
    /**
     * 
     * @type {Array&lt;BestFriendSettingsDto&gt;}
     * @memberof BestFriendSettingsSearchResultDto
     */
    result?: Array<BestFriendSettingsDto>;
}

/**
 * Fields that are necessary for creating a best.friend update notification.
 * @export
 * @interface BestFriendUpdateNotificationDto
 */
export interface BestFriendUpdateNotificationDto {
    /**
     * 
     * @type {string}
     * @memberof BestFriendUpdateNotificationDto
     */
    userId: string;
    /**
     * 
     * @type {number}
     * @memberof BestFriendUpdateNotificationDto
     */
    settingsId: number;
    /**
     * 
     * @type {string}
     * @memberof BestFriendUpdateNotificationDto
     */
    serialNumber: string;
    /**
     * 
     * @type {string}
     * @memberof BestFriendUpdateNotificationDto
     */
    dataVersion: string;
}

/**
 * An unfinished order submitted from a Best.Friend device for completion in the web shop.
 * @export
 * @interface BfOpenOrderDto
 */
export interface BfOpenOrderDto {
    /**
     * Unique id of his open order. Not related to the final order number.
     * @type {number}
     * @memberof BfOpenOrderDto
     */
    id?: number;
    /**
     * User-specified comment for this open order.
     * @type {string}
     * @memberof BfOpenOrderDto
     */
    comment?: string;
    /**
     * Time the order was received from Best.Friend.
     * @type {Date}
     * @memberof BfOpenOrderDto
     */
    creationTime?: Date;
    /**
     * The customer this open order belongs to.
     * @type {string}
     * @memberof BfOpenOrderDto
     */
    customerId?: string;
    /**
     * Tenant of the customer.
     * @type {string}
     * @memberof BfOpenOrderDto
     */
    tenant?: string;
    /**
     * 
     * @type {DeliveryAddressDto}
     * @memberof BfOpenOrderDto
     */
    orderAddress?: DeliveryAddressDto;
    /**
     * The name of the unloading area for this order
     * @type {string}
     * @memberof BfOpenOrderDto
     */
    unloadingArea?: string;
    /**
     * Proposed items for the open order.
     * @type {Array&lt;BfOpenOrderItemDto&gt;}
     * @memberof BfOpenOrderDto
     */
    orderItems?: Array<BfOpenOrderItemDto>;
}

/**
 * An item in an unfinished order.
 * @export
 * @interface BfOpenOrderItemDto
 */
export interface BfOpenOrderItemDto {
    /**
     * The SKU of the product to order.
     * @type {string}
     * @memberof BfOpenOrderItemDto
     */
    productSku?: string;
    /**
     * How many of the product to order, relative to the unit.
     * @type {number}
     * @memberof BfOpenOrderItemDto
     */
    amount?: number;
    /**
     * Abbreviation of the unit to order in.
     * @type {string}
     * @memberof BfOpenOrderItemDto
     */
    unitAbbr?: string;
}

/**
 * Represents a single page of results to a search query for open bf orders.
 * @export
 * @interface BfOpenOrderPageDto
 */
export interface BfOpenOrderPageDto {
    /**
     * The total number of elements that are available for the search query that this page is for.
     * @type {number}
     * @memberof BfOpenOrderPageDto
     */
    totalElements?: number;
    /**
     * The total number of pages available for the search query that this page is for, assuming equal size.
     * @type {number}
     * @memberof BfOpenOrderPageDto
     */
    totalPages?: number;
    /**
     * The zero-based index of this page.
     * @type {number}
     * @memberof BfOpenOrderPageDto
     */
    number?: number;
    /**
     * The number of elements allowed per page. Note that there may actually be less elements if there's not enough results.
     * @type {number}
     * @memberof BfOpenOrderPageDto
     */
    size?: number;
    /**
     * The best friend open orders contained in this page.
     * @type {Array&lt;BfOpenOrderDto&gt;}
     * @memberof BfOpenOrderPageDto
     */
    content?: Array<BfOpenOrderDto>;
}

/**
 * 
 * @export
 * @interface BooleanResponse
 */
export interface BooleanResponse {
    /**
     * 
     * @type {boolean}
     * @memberof BooleanResponse
     */
    condition?: boolean;
}

/**
 * Specifies a request for a single page while browsing a category. Note that the categoryId in the filter is ignored.
 * @export
 * @interface CategoryBrowseRequestDto
 */
export interface CategoryBrowseRequestDto {
    /**
     * The id of the category to browse.
     * @type {string}
     * @memberof CategoryBrowseRequestDto
     */
    categoryId: string;
    /**
     * 
     * @type {PageRequest}
     * @memberof CategoryBrowseRequestDto
     */
    page?: PageRequest;
    /**
     * 
     * @type {ProductSearchFilter}
     * @memberof CategoryBrowseRequestDto
     */
    filter?: ProductSearchFilter;
}

/**
 * Represents a category. Non-virtual categories may have a parent and fit into a tree structure of categories. Virtual categories do not have parents and work outside the usual structure. Multiple virtual categories may be assigned to a product, but only one non-virtual one.
 * @export
 * @interface CategoryDto
 */
export interface CategoryDto {
    /**
     * The absolute id of the category of this product, with each node in the category tree separated by a pipe. The example represents the child 20 of 07, which is a child of the root category 02.
     * @type {string}
     * @memberof CategoryDto
     */
    id: string;
    /**
     * The absolute id of the parent category, empty string if this is a root category. (i.e. has no parents)
     * @type {string}
     * @memberof CategoryDto
     */
    parentId: string;
    /**
     * 
     * @type {string}
     * @memberof CategoryDto
     */
    name: string;
    /**
     * Whether this category is virtual, that means that it cannot be the main category of a product.
     * @type {boolean}
     * @memberof CategoryDto
     */
    virtual: boolean;
    /**
     * Thumbnail image path relative to image-service, if any
     * @type {string}
     * @memberof CategoryDto
     */
    thumbnailImagePath?: string;
}

/**
 * Describes facet information for a single category
 * @export
 * @interface CategoryFacet
 */
export interface CategoryFacet {
    /**
     * 
     * @type {CategoryDto}
     * @memberof CategoryFacet
     */
    category: CategoryDto;
    /**
     * How many products in the whole result are in this category
     * @type {number}
     * @memberof CategoryFacet
     */
    resultCount: number;
}

/**
 * Describes a filled CMS form to be submitted via the hub.
 * @export
 * @interface CmsForm
 */
export interface CmsForm {
    /**
     * Unique key of this form (per tenant)
     * @type {string}
     * @memberof CmsForm
     */
    key?: string;
    /**
     * Email address of the administrator responsible for this form. Not to be shown to users.
     * @type {string}
     * @memberof CmsForm
     */
    adminContact?: string;
    /**
     * Receives of form notification emails. Not to be shown to users.
     * @type {Array&lt;string&gt;}
     * @memberof CmsForm
     */
    receiverEmails?: Array<string>;
    /**
     * Filled fields in this form
     * @type {Array&lt;CmsFormField&gt;}
     * @memberof CmsForm
     */
    fields?: Array<CmsFormField>;
    /**
     * Name of the user that submitted this form, if logged in
     * @type {string}
     * @memberof CmsForm
     */
    submittedByName?: string;
    /**
     * Tenant-specific customer number, if logged in
     * @type {string}
     * @memberof CmsForm
     */
    submittedByCustomerId?: string;
    /**
     * IP address this form was submitted by
     * @type {string}
     * @memberof CmsForm
     */
    submittedByIpAddress?: string;
}

/**
 * A single filled form field
 * @export
 * @interface CmsFormField
 */
export interface CmsFormField {
    /**
     * Label for this field
     * @type {string}
     * @memberof CmsFormField
     */
    label?: string;
    /**
     * Value entered by the user. Note, untrusted user input. Do not expect this to be sanitised.
     * @type {string}
     * @memberof CmsFormField
     */
    value?: string;
}

/**
 * A billing address for a customer. Note that there must be exactly one billing address.
 * @export
 * @interface CustomerAddressDto
 */
export interface CustomerAddressDto {
    /**
     * 
     * @type {string}
     * @memberof CustomerAddressDto
     */
    tenant: string;
    /**
     * The external address id, note that this is only unique combined with unloading area and tenant.
     * @type {string}
     * @memberof CustomerAddressDto
     */
    externalId: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerAddressDto
     */
    customerId?: string;
    /**
     * Lines of the company part of the address, may contain up to three lines.
     * @type {Array&lt;string&gt;}
     * @memberof CustomerAddressDto
     */
    companyLines: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CustomerAddressDto
     */
    street: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerAddressDto
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerAddressDto
     */
    postCode: string;
    /**
     * See https://confluence.eurogast.at/pages/viewpage.action?pageId=3770513
     * @type {string}
     * @memberof CustomerAddressDto
     */
    countryCode: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerAddressDto
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerAddressDto
     */
    lastName?: string;
}

/**
 * 
 * @export
 * @interface CustomerSearchResultDto
 */
export interface CustomerSearchResultDto {
    /**
     * 
     * @type {PageMetadataDto}
     * @memberof CustomerSearchResultDto
     */
    page?: PageMetadataDto;
    /**
     * 
     * @type {Array&lt;EffectiveCustomerDto&gt;}
     * @memberof CustomerSearchResultDto
     */
    result?: Array<EffectiveCustomerDto>;
}

/**
 * A deleted cart item.
 * @export
 * @interface DeletedCartItemDto
 */
export interface DeletedCartItemDto {
    /**
     * Stock Keeping unit of the deleted product.
     * @type {string}
     * @memberof DeletedCartItemDto
     */
    sku: string;
    /**
     * Unit of the product that was in the cart
     * @type {string}
     * @memberof DeletedCartItemDto
     */
    unitAbbr: string;
    /**
     * Instant this item was removed from the cart at. This is provided as local date time in the server time zone (Europe/Vienna).
     * @type {string}
     * @memberof DeletedCartItemDto
     */
    deletedAt: string;
}

/**
 * An address that orders may be delivered to.
 * @export
 * @interface DeliveryAddressDto
 */
export interface DeliveryAddressDto {
    /**
     * 
     * @type {string}
     * @memberof DeliveryAddressDto
     */
    tenant: string;
    /**
     * The external address id, note that this is only unique combined with unloading area and tenant.
     * @type {string}
     * @memberof DeliveryAddressDto
     */
    externalId: string;
    /**
     * Lines of the company part of the address, may contain up to three lines.
     * @type {Array&lt;string&gt;}
     * @memberof DeliveryAddressDto
     */
    companyLines: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof DeliveryAddressDto
     */
    street: string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryAddressDto
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryAddressDto
     */
    postCode: string;
    /**
     * See https://confluence.eurogast.at/pages/viewpage.action?pageId=3770513
     * @type {string}
     * @memberof DeliveryAddressDto
     */
    countryCode: string;
    /**
     * The unloading areas for this delivery address, empty if none
     * @type {Array&lt;string&gt;}
     * @memberof DeliveryAddressDto
     */
    unloadingAreas: Array<string>;
}

/**
 * A general delivery slot, mapped to a day of week.
 * @export
 * @interface DeliverySlotDto
 */
export interface DeliverySlotDto {
    /**
     * The internal generated id of this delivery slot.
     * @type {number}
     * @memberof DeliverySlotDto
     */
    id?: number;
    /**
     * The weekday when the delivery will be performed (1-7). Monday = 1, Tuesday = 2, ... Sunday = 7
     * @type {number}
     * @memberof DeliverySlotDto
     */
    day: number;
    /**
     * Text for UI display only, can contain additional information like before lunch etc.
     * @type {string}
     * @memberof DeliverySlotDto
     */
    time: string;
    /**
     * The weekday until the slot is allowed to be displayed. Monday = 1, Tuesday = 2, ... Sunday = 7
     * @type {number}
     * @memberof DeliverySlotDto
     */
    lastOrderDay: number;
    /**
     * Time until the slot is allowed to be displayed on the last order day. Allowed formats are HH:MM or HH:MM:SS
     * @type {string}
     * @memberof DeliverySlotDto
     */
    lastOrderTime: string;
}

/**
 * Specifies when in the price calculation a discount is to be applied.
 * @export
 * @enum {string}
 */
export enum DiscountApplicationOrderDto {
    TOTAL = <any> 'TOTAL',
    SINGLE = <any> 'SINGLE'
}

/**
 * Specifies the way a price is to be discounted.
 * @export
 * @interface DiscountDto
 */
export interface DiscountDto {
    /**
     * 
     * @type {DiscountTypeDto}
     * @memberof DiscountDto
     */
    type: DiscountTypeDto;
    /**
     * 
     * @type {DiscountApplicationOrderDto}
     * @memberof DiscountDto
     */
    applicationOrder: DiscountApplicationOrderDto;
    /**
     * Factor to multiply the price with to apply this discount.
     * @type {number}
     * @memberof DiscountDto
     */
    discountFactor: number;
    /**
     * A string containing the exact discount factor.
     * @type {string}
     * @memberof DiscountDto
     */
    discountFactorString: string;
}

/**
 * Type of discount, might signal different behaviour in the future.
 * @export
 * @enum {string}
 */
export enum DiscountTypeDto {
    DISCOUNT = <any> 'DISCOUNT'
}

/**
 * A customer that may have multiple users assigned to it. Name has historic reasons.
 * @export
 * @interface EffectiveCustomerDto
 */
export interface EffectiveCustomerDto {
    /**
     * The internal id of this effective customer, different from the customer id
     * @type {number}
     * @memberof EffectiveCustomerDto
     */
    id?: number;
    /**
     * The Eurogast-assigned customer id for the customer (unique only per tenant)
     * @type {string}
     * @memberof EffectiveCustomerDto
     */
    customerId: string;
    /**
     * The EGB code of this effective customer's tenant
     * @type {string}
     * @memberof EffectiveCustomerDto
     */
    tenant: string;
    /**
     * Human-readable display name, should usually be the same between all effectives
     * @type {string}
     * @memberof EffectiveCustomerDto
     */
    displayName: string;
    /**
     * names of the price lists for this customer
     * @type {Array&lt;string&gt;}
     * @memberof EffectiveCustomerDto
     */
    priceLists: Array<string>;
    /**
     * Whether this customer is disabled, i.e. cannot issue any more orders
     * @type {boolean}
     * @memberof EffectiveCustomerDto
     */
    disabled: boolean;
    /**
     * List of addresses this customer wants orders delivered to
     * @type {Array&lt;DeliveryAddressDto&gt;}
     * @memberof EffectiveCustomerDto
     */
    deliveryAddresses?: Array<DeliveryAddressDto>;
    /**
     * 
     * @type {CustomerAddressDto}
     * @memberof EffectiveCustomerDto
     */
    customerAddress?: CustomerAddressDto;
    /**
     * Delivery slots of this customer in general
     * @type {Array&lt;DeliverySlotDto&gt;}
     * @memberof EffectiveCustomerDto
     */
    deliverySlots?: Array<DeliverySlotDto>;
    /**
     * Number of days that delivery slots are displayed in advance.
     * @type {number}
     * @memberof EffectiveCustomerDto
     */
    upcomingDays?: number;
    /**
     * The list of users assigned to this customer, not usually populated.
     * @type {Array&lt;AssignedUserDto&gt;}
     * @memberof EffectiveCustomerDto
     */
    assignedUsers?: Array<AssignedUserDto>;
    /**
     * null if never ordered
     * @type {Date}
     * @memberof EffectiveCustomerDto
     */
    lastOrderTime?: Date;
    /**
     * True only if a catalog restriction is applied, i.e. this customer cannot see all products.
     * @type {boolean}
     * @memberof EffectiveCustomerDto
     */
    hasCatalogRestriction?: boolean;
    /**
     * How long into the past essence items should be shown.
     * @type {number}
     * @memberof EffectiveCustomerDto
     */
    showEssenceForDays?: number;
}

/**
 * 
 * @export
 * @interface ErrorDto
 */
export interface ErrorDto {
    /**
     * The type of error that occurred
     * @type {string}
     * @memberof ErrorDto
     */
    error: string;
    /**
     * Detail message
     * @type {string}
     * @memberof ErrorDto
     */
    message: string;
    /**
     * Full error description, suitable for display to end users
     * @type {string}
     * @memberof ErrorDto
     */
    humanMessage?: string;
}

/**
 * A item from the essence list that loosely resembles past orders.
 * @export
 * @interface EssenceItemDto
 */
export interface EssenceItemDto {
    /**
     * The tenant-specific customer id of the customer
     * @type {string}
     * @memberof EssenceItemDto
     */
    customerId: string;
    /**
     * 
     * @type {string}
     * @memberof EssenceItemDto
     */
    tenant: string;
    /**
     * 
     * @type {string}
     * @memberof EssenceItemDto
     */
    date: string;
    /**
     * The Stock Keeping Unit id of the product represented by this item.
     * @type {string}
     * @memberof EssenceItemDto
     */
    sku: string;
    /**
     * Whether this item is relevant to users.
     * @type {boolean}
     * @memberof EssenceItemDto
     */
    isRelevant: boolean;
    /**
     * 
     * @type {number}
     * @memberof EssenceItemDto
     */
    quantity?: number;
    /**
     * Storage unit of the product ordered
     * @type {string}
     * @memberof EssenceItemDto
     */
    smallestUnit?: string;
}

/**
 * A essence-restriction for one specific sku. An essence-restriction can have two states: shown/hidden.
 * @export
 * @interface EssenceRestrictionDto
 */
export interface EssenceRestrictionDto {
    /**
     * 
     * @type {string}
     * @memberof EssenceRestrictionDto
     */
    sku: string;
    /**
     * Is true if the essence-item was not hidden by the customer.
     * @type {boolean}
     * @memberof EssenceRestrictionDto
     */
    isVisible?: boolean;
}

/**
 * Filters products by whether they occur in the essence list of a customer. IGNORE (the default) means to also show non-essential products.
 * @export
 * @enum {string}
 */
export enum EssentialProductFilter {
    IGNORE = <any> 'IGNORE',
    SHOWNONLY = <any> 'SHOWN_ONLY',
    HIDDENONLY = <any> 'HIDDEN_ONLY',
    ALL = <any> 'ALL'
}

/**
 * Specifies a request for a single page while browsing essential products. Note that, contrary to usual behaviour, an EssentialProductFilter of IGNORE will be treated like SHOWN_ONLY in this request.
 * @export
 * @interface EssentialProductsRequestDto
 */
export interface EssentialProductsRequestDto {
    /**
     * 
     * @type {ProductSearchFilter}
     * @memberof EssentialProductsRequestDto
     */
    filter?: ProductSearchFilter;
    /**
     * 
     * @type {PageRequest}
     * @memberof EssentialProductsRequestDto
     */
    page?: PageRequest;
}

/**
 * A deleted cart item.
 * @export
 * @interface FairCartDeletedItemDto
 */
export interface FairCartDeletedItemDto {
    /**
     * Stock Keeping unit of the deleted product.
     * @type {string}
     * @memberof FairCartDeletedItemDto
     */
    sku: string;
    /**
     * Unit of the product that was in the cart
     * @type {string}
     * @memberof FairCartDeletedItemDto
     */
    unitAbbr: string;
    /**
     * Instant this item was removed from the cart at. This is provided as local date time in the server time zone (Europe/Vienna).
     * @type {string}
     * @memberof FairCartDeletedItemDto
     */
    deletedAt: string;
}

/**
 * The current state of a shopping cart.
 * @export
 * @interface FairCartDto
 */
export interface FairCartDto {
    /**
     * The Eurogast customer number of the customer
     * @type {string}
     * @memberof FairCartDto
     */
    customerId: string;
    /**
     * The SSO user id of the user for this cart
     * @type {string}
     * @memberof FairCartDto
     */
    userId: string;
    /**
     * 
     * @type {Array&lt;FairCartItemDto&gt;}
     * @memberof FairCartDto
     */
    items: Array<FairCartItemDto>;
    /**
     * Items that have been deleted, for synchronisation.
     * @type {Array&lt;FairCartDeletedItemDto&gt;}
     * @memberof FairCartDto
     */
    deletedItems: Array<FairCartDeletedItemDto>;
}

/**
 * An item in a shopping cart. Note that only the required properties must be set for writing an item, but when receiving an item from the server, all properties will be populated. Note that only the root-level (required) properties are recognised when sending this entity to the server, any identifiers stored in entities (unit, product) will be ignored. In fact, those are not supposed to be passed to the server, but rather provided as convenience in responses from the server only. The update timestamp is automatically set by the server. To make sure that only a single clock is used, timestamps provided by the client are discarded.
 * @export
 * @interface FairCartItemDto
 */
export interface FairCartItemDto {
    /**
     * The Stock Keeping Unit id of the product represented by this item.
     * @type {string}
     * @memberof FairCartItemDto
     */
    sku: string;
    /**
     * How many units of this product are in the cart.
     * @type {number}
     * @memberof FairCartItemDto
     */
    amount: number;
    /**
     * The product-unique abbreviation of the unit this item is measured in.
     * @type {string}
     * @memberof FairCartItemDto
     */
    unitAbbreviation: string;
    /**
     * 
     * @type {ProductUnitDto}
     * @memberof FairCartItemDto
     */
    unit?: ProductUnitDto;
    /**
     * 
     * @type {ProductDto}
     * @memberof FairCartItemDto
     */
    product?: ProductDto;
    /**
     * The instant of the last change to this cart item, for synchronisation purposes. This is provided as local date time in the server time zone (Europe/Vienna).
     * @type {Date}
     * @memberof FairCartItemDto
     */
    lastUpdatedAt?: Date;
    /**
     * 
     * @type {NaraDto}
     * @memberof FairCartItemDto
     */
    naraDto?: NaraDto;
}

/**
 * Additional properties required to submit an order.
 * @export
 * @interface FairCartSubmitDto
 */
export interface FairCartSubmitDto {
    /**
     * The Eurogast-internal identifier of the delivery address
     * @type {string}
     * @memberof FairCartSubmitDto
     */
    deliveryAddressExternalId: string;
    /**
     * A custom delivery-date for non-perishable-products.
     * @type {string}
     * @memberof FairCartSubmitDto
     */
    requestedDeliveryDay?: string;
    /**
     * A custom delivery-date for perishable-products.
     * @type {string}
     * @memberof FairCartSubmitDto
     */
    requestedDeliveryDayFreshProducts?: string;
    /**
     * The id of the unloading area of the delivery address to deliver to, or null if the delivery address does not have unloading areas.
     * @type {string}
     * @memberof FairCartSubmitDto
     */
    unloadingArea?: string;
    /**
     * Optional custom reference number for the order
     * @type {string}
     * @memberof FairCartSubmitDto
     */
    customerOrderId?: string;
    /**
     * Notes for the delivery driver
     * @type {string}
     * @memberof FairCartSubmitDto
     */
    notes?: string;
}

/**
 * The details of a fair
 * @export
 * @interface FairDto
 */
export interface FairDto {
    /**
     * The unique identifier of a fair. This value must be unqiue for a single tenant.
     * @type {string}
     * @memberof FairDto
     */
    code: string;
    /**
     * The human-readable name of the fair
     * @type {string}
     * @memberof FairDto
     */
    displayName: string;
    /**
     * A field to identify if this fair is currently valid. Users are not allowed to interact with invalid fairs. A fair can be invalid if it is manually disabled or if the validity-end-date was reached.
     * @type {boolean}
     * @memberof FairDto
     */
    active: boolean;
    /**
     * The first possible delivery date if a user submits a order from this cart.
     * @type {string}
     * @memberof FairDto
     */
    firstPossibleDeliveryDate?: string;
    /**
     * The last possible delivery date if a users submits a order from this cart.
     * @type {string}
     * @memberof FairDto
     */
    lastPossibleDeliveryDate?: string;
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum FeatureFlagDto {
    ProductDatasheetEan = <any> 'product.datasheet_ean',
    ProductGross = <any> 'product.gross',
    CmsMemberAreaLink = <any> 'cms.member_area_link'
}

/**
 * A group of inventories by date.
 * @export
 * @interface GroupedInventoryDto
 */
export interface GroupedInventoryDto {
    /**
     * Human-readable label for this group
     * @type {string}
     * @memberof GroupedInventoryDto
     */
    groupingLabel: string;
    /**
     * Unique identifier of this group
     * @type {string}
     * @memberof GroupedInventoryDto
     */
    groupingId: string;
    /**
     * Inventories in this group
     * @type {Array&lt;InventoryDto&gt;}
     * @memberof GroupedInventoryDto
     */
    inventories?: Array<InventoryDto>;
}

/**
 * Paged inventories, grouped by year and month.
 * @export
 * @interface GroupedPagedInventoriesDto
 */
export interface GroupedPagedInventoriesDto {
    /**
     * 
     * @type {PageMetadataDto}
     * @memberof GroupedPagedInventoriesDto
     */
    page?: PageMetadataDto;
    /**
     * 
     * @type {Array&lt;GroupedInventoryDto&gt;}
     * @memberof GroupedPagedInventoriesDto
     */
    inventories?: Array<GroupedInventoryDto>;
}

/**
 * Specifies the result of requesting a page of grouped products.
 * @export
 * @interface GroupedProductsDto
 */
export interface GroupedProductsDto {
    /**
     * 
     * @type {ProductSearchFilter}
     * @memberof GroupedProductsDto
     */
    filter?: ProductSearchFilter;
    /**
     * The wall clock time that passed between sending the request to the index and having received the full result, in milliseconds.
     * @type {number}
     * @memberof GroupedProductsDto
     */
    queryDurationMs?: number;
    /**
     * The groupings of products contained in this page.
     * @type {Array&lt;ProductGroupingDto&gt;}
     * @memberof GroupedProductsDto
     */
    groupings?: Array<ProductGroupingDto>;
    /**
     * 
     * @type {PageMetadataDto}
     * @memberof GroupedProductsDto
     */
    page?: PageMetadataDto;
    /**
     * 
     * @type {ProductFacetsDto}
     * @memberof GroupedProductsDto
     */
    facets?: ProductFacetsDto;
}

/**
 * An import error relating to a single entity.
 * @export
 * @interface ImportError
 */
export interface ImportError {
    /**
     * The tenant-unique identifier of the entity that couldn't be imported
     * @type {string}
     * @memberof ImportError
     */
    id: string;
    /**
     * An optional error message
     * @type {string}
     * @memberof ImportError
     */
    message?: string;
}

/**
 * Internal errors that occurred during customer import.
 * @export
 * @interface ImportErrors
 */
export interface ImportErrors extends Array<ImportError> {
}

/**
 * An inventory captured by the BestFriend-App.
 * @export
 * @interface InventoryCreationDto
 */
export interface InventoryCreationDto {
    /**
     * The unloading area of the address, if any
     * @type {string}
     * @memberof InventoryCreationDto
     */
    unloadingArea?: string;
    /**
     * The address this inventory belongs to
     * @type {string}
     * @memberof InventoryCreationDto
     */
    externalAddressId: string;
    /**
     * An additional comment to the inventory.
     * @type {string}
     * @memberof InventoryCreationDto
     */
    comment?: string;
    /**
     * Products amounts captured in this inventory
     * @type {Array&lt;InventoryItemCreationDto&gt;}
     * @memberof InventoryCreationDto
     */
    inventoryItems: Array<InventoryItemCreationDto>;
}

/**
 * An inventory captured by a Best.Friend device. This is a representation of what products the customer currently has stored.
 * @export
 * @interface InventoryDto
 */
export interface InventoryDto {
    /**
     * The globally-unique id of this inventory
     * @type {number}
     * @memberof InventoryDto
     */
    id: number;
    /**
     * The tenant-specific id of the customer
     * @type {string}
     * @memberof InventoryDto
     */
    customerId: string;
    /**
     * The tenant assigned to the customer
     * @type {string}
     * @memberof InventoryDto
     */
    tenant: string;
    /**
     * Username of the user that created this inventory
     * @type {string}
     * @memberof InventoryDto
     */
    createdBy: string;
    /**
     * Creation timestamp of this inventory
     * @type {Date}
     * @memberof InventoryDto
     */
    createdAt: Date;
    /**
     * Unused
     * @type {string}
     * @memberof InventoryDto
     */
    inventoryLocation?: string;
    /**
     * A user-specified comment to describe this inventory
     * @type {string}
     * @memberof InventoryDto
     */
    comment?: string;
    /**
     * The unloading area of the address, if any
     * @type {string}
     * @memberof InventoryDto
     */
    unloadingArea?: string;
    /**
     * The address this inventory belongs to
     * @type {string}
     * @memberof InventoryDto
     */
    externalAddressId: string;
    /**
     * Product smounts captured in this inventory
     * @type {Array&lt;InventoryItemDto&gt;}
     * @memberof InventoryDto
     */
    inventoryItems?: Array<InventoryItemDto>;
}

/**
 * An item captured in an inventory. A product may be captured multiple times, e.g. with different units.
 * @export
 * @interface InventoryItemCreationDto
 */
export interface InventoryItemCreationDto {
    /**
     * The SKU of the product
     * @type {string}
     * @memberof InventoryItemCreationDto
     */
    productSku: string;
    /**
     * The quantity of the product that was captured
     * @type {number}
     * @memberof InventoryItemCreationDto
     */
    capturedQuantity: number;
    /**
     * The abbreviation of the unit this item was captured in
     * @type {string}
     * @memberof InventoryItemCreationDto
     */
    capturedUnit: string;
}

/**
 * An item captured in an inventory. A product may be captured multiple times, e.g. with different units.
 * @export
 * @interface InventoryItemDto
 */
export interface InventoryItemDto {
    /**
     * The globally-unique id of this inventory item.
     * @type {number}
     * @memberof InventoryItemDto
     */
    id: number;
    /**
     * The SKU of the product
     * @type {string}
     * @memberof InventoryItemDto
     */
    productSku: string;
    /**
     * The quantity of the product that was captured
     * @type {number}
     * @memberof InventoryItemDto
     */
    capturedQuantity: number;
    /**
     * The abbreviation of the unit this item was captured in
     * @type {string}
     * @memberof InventoryItemDto
     */
    capturedUnit: string;
    /**
     * The ratio of this item's unit, for if the unit gets deleted
     * @type {number}
     * @memberof InventoryItemDto
     */
    unitRatio: number;
    /**
     * The category of this item's product, for it it gets deleted
     * @type {string}
     * @memberof InventoryItemDto
     */
    categoryId?: string;
}

/**
 * Represents an invoice
 * @export
 * @interface InvoiceDto
 */
export interface InvoiceDto {
    /**
     * Unique id of this invoice
     * @type {string}
     * @memberof InvoiceDto
     */
    id?: string;
    /**
     * Date this invoice was issued at
     * @type {string}
     * @memberof InvoiceDto
     */
    date?: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceDto
     */
    documentNumber?: string;
    /**
     * Type of invoice
     * @type {string}
     * @memberof InvoiceDto
     */
    documentType?: InvoiceDto.DocumentTypeEnum;
    /**
     * Total sum of this invoice
     * @type {number}
     * @memberof InvoiceDto
     */
    total?: number;
    /**
     * 
     * @type {string}
     * @memberof InvoiceDto
     */
    information?: string;
}

/**
 * @export
 * @namespace InvoiceDto
 */
export namespace InvoiceDto {
    /**
     * @export
     * @enum {string}
     */
    export enum DocumentTypeEnum {
        Invoice = <any> 'invoice',
        Creditmemo = <any> 'creditmemo',
        Deliverynote = <any> 'deliverynote'
    }
}

/**
 * Response to an invoice request.
 * @export
 * @interface InvoicesDto
 */
export interface InvoicesDto {
    /**
     * 
     * @type {PageMetadataDto}
     * @memberof InvoicesDto
     */
    page?: PageMetadataDto;
    /**
     * 
     * @type {Array&lt;InvoiceDto&gt;}
     * @memberof InvoicesDto
     */
    invoices?: Array<InvoiceDto>;
}

/**
 * Specifies a product which should be included in a label-print-email.
 * @export
 * @interface LabelMailItemDto
 */
export interface LabelMailItemDto {
    /**
     * The product-sku of the label
     * @type {string}
     * @memberof LabelMailItemDto
     */
    sku: string;
    /**
     * The amount of labels which should be printend for this sku.
     * @type {number}
     * @memberof LabelMailItemDto
     */
    amount: number;
}

/**
 * Represents the label selection with all items
 * @export
 * @interface LabelPrintDto
 */
export interface LabelPrintDto {
    /**
     * The id of the owner
     * @type {string}
     * @memberof LabelPrintDto
     */
    userId: string;
    /**
     * The tenant-specific id of the customer
     * @type {string}
     * @memberof LabelPrintDto
     */
    customerId: string;
    /**
     * The tenant of the customer
     * @type {string}
     * @memberof LabelPrintDto
     */
    tenant: string;
    /**
     * Items included in the selection
     * @type {Array&lt;LabelPrintItemDto&gt;}
     * @memberof LabelPrintDto
     */
    selectionItems: Array<LabelPrintItemDto>;
}

/**
 * Represents a product in the label selection list
 * @export
 * @interface LabelPrintItemDto
 */
export interface LabelPrintItemDto {
    /**
     * 
     * @type {string}
     * @memberof LabelPrintItemDto
     */
    sku: string;
    /**
     * 
     * @type {number}
     * @memberof LabelPrintItemDto
     */
    amount: number;
}

/**
 * Specifies which products to include in a label print
 * @export
 * @interface LabelProductRequest
 */
export interface LabelProductRequest {
    /**
     * 
     * @type {Array&lt;LabelProductRequestPairs&gt;}
     * @memberof LabelProductRequest
     */
    pairs: Array<LabelProductRequestPairs>;
}

/**
 * 
 * @export
 * @interface LabelProductRequestPairs
 */
export interface LabelProductRequestPairs {
    /**
     * The SKU of the product to include
     * @type {string}
     * @memberof LabelProductRequestPairs
     */
    sku: string;
    /**
     * How many labels to print for this product
     * @type {number}
     * @memberof LabelProductRequestPairs
     */
    amount: number;
}

/**
 * A facet that maps a product property to the amount of associated documents and provides a localised display name.
 * @export
 * @interface LocalizedFacet
 */
export interface LocalizedFacet {
    /**
     * The unique key of the property
     * @type {string}
     * @memberof LocalizedFacet
     */
    key?: string;
    /**
     * The human-readable display name of the property
     * @type {string}
     * @memberof LocalizedFacet
     */
    displayName?: string;
    /**
     * How many products for given query are in this category
     * @type {number}
     * @memberof LocalizedFacet
     */
    resultCount?: number;
}

/**
 * An item in an order template which is assigned to a customer.
 * @export
 * @interface ManageCustomerOrderTemplateItemDto
 */
export interface ManageCustomerOrderTemplateItemDto {
    /**
     * The SKU of the product this item represents.
     * @type {string}
     * @memberof ManageCustomerOrderTemplateItemDto
     */
    productSku?: string;
    /**
     * The amount of the product to add when adding this template to the cart. Relative to the unit.
     * @type {number}
     * @memberof ManageCustomerOrderTemplateItemDto
     */
    amount?: number;
    /**
     * The unit to add when adding this order template to the cart.
     * @type {string}
     * @memberof ManageCustomerOrderTemplateItemDto
     */
    unit?: string;
    /**
     * The customer this template item belongs to.
     * @type {string}
     * @memberof ManageCustomerOrderTemplateItemDto
     */
    customerId?: string;
}

/**
 * Represents information about a category, for management
 * @export
 * @interface ManagementCategoryDto
 */
export interface ManagementCategoryDto {
    /**
     * The absolute id of this category, with each node in the category tree separated by a pipe. The example represents the child 20 of 07, which is a child of the root category 02.
     * @type {string}
     * @memberof ManagementCategoryDto
     */
    id: string;
    /**
     * The absolute id of the parent category, empty string if this is a root category.
     * @type {string}
     * @memberof ManagementCategoryDto
     */
    parentId: string;
    /**
     * 
     * @type {string}
     * @memberof ManagementCategoryDto
     */
    name: string;
    /**
     * Whether this category is virtual, that means that it cannot be the main category of a product.
     * @type {boolean}
     * @memberof ManagementCategoryDto
     */
    virtual: boolean;
    /**
     * 
     * @type {string}
     * @memberof ManagementCategoryDto
     */
    thumbnailImagePath?: string;
    /**
     * The number of products currently assigned to this category. This is never populated if the category was not requested directly, i.e. is only referenced by another entity that was requested. It is populated in the list of categories.
     * @type {number}
     * @memberof ManagementCategoryDto
     */
    productCount?: number;
}

/**
 * 
 * @export
 * @interface ManagementCategorySearchResultDto
 */
export interface ManagementCategorySearchResultDto {
    /**
     * 
     * @type {PageMetadataDto}
     * @memberof ManagementCategorySearchResultDto
     */
    page?: PageMetadataDto;
    /**
     * 
     * @type {Array&lt;ManagementCategoryDto&gt;}
     * @memberof ManagementCategorySearchResultDto
     */
    result?: Array<ManagementCategoryDto>;
}

/**
 * Dto to interact with fair-cart-types throught the management api. It is used to create/update fairs.
 * @export
 * @interface ManagementFairCartTypeDto
 */
export interface ManagementFairCartTypeDto {
    /**
     * The identifier of the cart. Needs to be unqiue along a single tenant.
     * @type {string}
     * @memberof ManagementFairCartTypeDto
     */
    code: string;
    /**
     * A human readable name used to display the fair in the frontend.
     * @type {string}
     * @memberof ManagementFairCartTypeDto
     */
    displayName: string;
    /**
     * The additional price-list which should be applied if the user is in the fair subshop
     * @type {string}
     * @memberof ManagementFairCartTypeDto
     */
    priceList?: string;
    /**
     * Declares if users are allowed to add items or submit orders from this cart-type. In general a user is allowed to interact with a fair-cart, if it is enabled and the current-date is within validityStartDate and validityEndDate.
     * @type {boolean}
     * @memberof ManagementFairCartTypeDto
     */
    enabled: boolean;
    /**
     * The first date this fair-cart-type is valid (inclusive). Before this date users cannot interact with this cart-type.
     * @type {string}
     * @memberof ManagementFairCartTypeDto
     */
    validityStartDate?: string;
    /**
     * The last date this- fair-cart-type is valid (inclusive). After this date users can no longer interact with this cart-type.
     * @type {string}
     * @memberof ManagementFairCartTypeDto
     */
    validityEndDate?: string;
    /**
     * The first possible delivery date if a user submits a order from this cart.
     * @type {string}
     * @memberof ManagementFairCartTypeDto
     */
    firstPossibleDeliveryDate?: string;
    /**
     * The last possible delivery date if a users submits a order from this cart.
     * @type {string}
     * @memberof ManagementFairCartTypeDto
     */
    lastPossibleDeliveryDate?: string;
}

/**
 * 
 * @export
 * @interface ManagementNotificationDto
 */
export interface ManagementNotificationDto {
    /**
     * 
     * @type {number}
     * @memberof ManagementNotificationDto
     */
    id?: number;
    /**
     * 
     * @type {BaseManagementNotificationCustomerGroupDto}
     * @memberof ManagementNotificationDto
     */
    targetCustomerGroup?: BaseManagementNotificationCustomerGroupDto;
    /**
     * 
     * @type {Array&lt;string&gt;}
     * @memberof ManagementNotificationDto
     */
    targetTenants: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ManagementNotificationDto
     */
    publicationDate?: string;
    /**
     * 
     * @type {ManagementNotificationTranslationsDto}
     * @memberof ManagementNotificationDto
     */
    translations?: ManagementNotificationTranslationsDto;
    /**
     * 
     * @type {number}
     * @memberof ManagementNotificationDto
     */
    typeId: number;
    /**
     * 
     * @type {NotificationTypeDto}
     * @memberof ManagementNotificationDto
     */
    type?: NotificationTypeDto;
    /**
     * 
     * @type {Array&lt;NotificationChannelDto&gt;}
     * @memberof ManagementNotificationDto
     */
    channels: Array<NotificationChannelDto>;
    /**
     * 
     * @type {ManagementNotificationSkusDto}
     * @memberof ManagementNotificationDto
     */
    attachmentSkus?: ManagementNotificationSkusDto;
    /**
     * 
     * @type {Array&lt;string&gt;}
     * @memberof ManagementNotificationDto
     */
    visibleFor?: Array<string>;
    /**
     * Day till that the notification should be displayed as popup if it is unread.
     * @type {string}
     * @memberof ManagementNotificationDto
     */
    showAsPopupUntil?: string;
}

/**
 * 
 * @export
 * @interface ManagementNotificationSearchResultDto
 */
export interface ManagementNotificationSearchResultDto {
    /**
     * 
     * @type {PageMetadataDto}
     * @memberof ManagementNotificationSearchResultDto
     */
    page: PageMetadataDto;
    /**
     * 
     * @type {Array&lt;ManagementNotificationDto&gt;}
     * @memberof ManagementNotificationSearchResultDto
     */
    result: Array<ManagementNotificationDto>;
}

/**
 * Map of tenant code to skus
 * @export
 * @interface ManagementNotificationSkusDto
 */
export interface ManagementNotificationSkusDto {
    [key: string]: Array<string>;

}

/**
 * 
 * @export
 * @interface ManagementNotificationTranslationDto
 */
export interface ManagementNotificationTranslationDto {
    /**
     * 
     * @type {string}
     * @memberof ManagementNotificationTranslationDto
     */
    subject: string;
    /**
     * 
     * @type {string}
     * @memberof ManagementNotificationTranslationDto
     */
    content: string;
    /**
     * 
     * @type {boolean}
     * @memberof ManagementNotificationTranslationDto
     */
    cmsPath?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ManagementNotificationTranslationDto
     */
    attachmentLocation?: string;
    /**
     * 
     * @type {string}
     * @memberof ManagementNotificationTranslationDto
     */
    attachmentCaption?: string;
}

/**
 * Map of language code to translation
 * @export
 * @interface ManagementNotificationTranslationsDto
 */
export interface ManagementNotificationTranslationsDto {
    [key: string]: ManagementNotificationTranslationDto;

}

/**
 * Map of language code to translation
 * @export
 * @interface ManagementNotificationTypeTranslationsDto
 */
export interface ManagementNotificationTypeTranslationsDto {
    [key: string]: string;

}

/**
 * 
 * @export
 * @interface ManagementProductAttributeInfoDto
 */
export interface ManagementProductAttributeInfoDto {
    /**
     * 
     * @type {ProductAttributeType}
     * @memberof ManagementProductAttributeInfoDto
     */
    key: ProductAttributeType;
    /**
     * Additional information for this attribute
     * @type {string}
     * @memberof ManagementProductAttributeInfoDto
     */
    extension?: string;
}

/**
 * Represents a product in the store with additional parameters for management purposes.
 * @export
 * @interface ManagementProductDto
 */
export interface ManagementProductDto {
    /**
     * Stock Keeping Unit, the unique internal id for this product.
     * @type {string}
     * @memberof ManagementProductDto
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof ManagementProductDto
     */
    tenant?: string;
    /**
     * 
     * @type {string}
     * @memberof ManagementProductDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ManagementProductDto
     */
    bestFriendStatus?: string;
    /**
     * 
     * @type {string}
     * @memberof ManagementProductDto
     */
    shortDescription?: string;
    /**
     * 
     * @type {string}
     * @memberof ManagementProductDto
     */
    description?: string;
    /**
     * List of virtual categories (Sortimentslisten)
     * @type {Array&lt;string&gt;}
     * @memberof ManagementProductDto
     */
    virtualCategories?: Array<string>;
    /**
     * The absolute id of the category of this product, with each node in the category tree separated by a pipe. The example represents the child 20 of 07, which is a child of the root category 02.
     * @type {string}
     * @memberof ManagementProductDto
     */
    categoryId?: string;
    /**
     * 
     * @type {CategoryDto}
     * @memberof ManagementProductDto
     */
    resolvedCategory?: CategoryDto;
    /**
     * 
     * @type {Array&lt;ProductImageDto&gt;}
     * @memberof ManagementProductDto
     */
    images?: Array<ProductImageDto>;
    /**
     * The status of this product, 1 meaning valid and allowed to be displayed in the webshop.
     * @type {number}
     * @memberof ManagementProductDto
     */
    status?: number;
    /**
     * The availability of this product. Only relevant when status is 1 (active). Product should be listed and orderable if value is ACTIVE. Product should be listed but not orderable if value is any other.
     * @type {string}
     * @memberof ManagementProductDto
     */
    availability?: ManagementProductDto.AvailabilityEnum;
    /**
     * 
     * @type {number}
     * @memberof ManagementProductDto
     */
    minSaleQuantity?: number;
    /**
     * 
     * @type {number}
     * @memberof ManagementProductDto
     */
    maxSaleQuantity?: number;
    /**
     * Attributes inherent to this product, for example stating that this product is deep-fried.
     * @type {Array&lt;ManagementProductAttributeInfoDto&gt;}
     * @memberof ManagementProductDto
     */
    attributes?: Array<ManagementProductAttributeInfoDto>;
    /**
     * The units in which this product is stored and sold.
     * @type {Array&lt;ProductUnitDto&gt;}
     * @memberof ManagementProductDto
     */
    units?: Array<ProductUnitDto>;
}

/**
 * @export
 * @namespace ManagementProductDto
 */
export namespace ManagementProductDto {
    /**
     * @export
     * @enum {string}
     */
    export enum AvailabilityEnum {
        ACTIVE = <any> 'ACTIVE',
        PREORDER = <any> 'PRE_ORDER',
        NOTDELIVERABLE = <any> 'NOT_DELIVERABLE'
    }
}

/**
 * 
 * @export
 * @interface ManagementProductSearchResultDto
 */
export interface ManagementProductSearchResultDto {
    /**
     * 
     * @type {PageMetadataDto}
     * @memberof ManagementProductSearchResultDto
     */
    page?: PageMetadataDto;
    /**
     * 
     * @type {Array&lt;ManagementProductDto&gt;}
     * @memberof ManagementProductSearchResultDto
     */
    result?: Array<ManagementProductDto>;
}

/**
 * Contains information about one nara-discount for a specific product. A nara-discount is quantity related discount. For instance if you buy five packs you receive an additional sixth pack for free.
 * @export
 * @interface NaraDto
 */
export interface NaraDto {
    /**
     * The sku of the product this discount is applied to.
     * @type {string}
     * @memberof NaraDto
     */
    sku: string;
    /**
     * The identifiers of a nara-discount for one product.
     * @type {Array&lt;string&gt;}
     * @memberof NaraDto
     */
    naraCodes: Array<string>;
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum NotificationChannelDto {
    WEBSHOP = <any> 'WEBSHOP',
    EMAIL = <any> 'EMAIL',
    SMS = <any> 'SMS'
}

/**
 * 
 * @export
 * @interface NotificationPreferenceDto
 */
export interface NotificationPreferenceDto {
    /**
     * 
     * @type {UserNotificationTypeDto}
     * @memberof NotificationPreferenceDto
     */
    notificationType: UserNotificationTypeDto;
    /**
     * 
     * @type {Array&lt;NotificationChannelDto&gt;}
     * @memberof NotificationPreferenceDto
     */
    notificationChannels: Array<NotificationChannelDto>;
}

/**
 * 
 * @export
 * @interface NotificationTypeDto
 */
export interface NotificationTypeDto {
    /**
     * 
     * @type {number}
     * @memberof NotificationTypeDto
     */
    id?: number;
    /**
     * 
     * @type {ManagementNotificationTypeTranslationsDto}
     * @memberof NotificationTypeDto
     */
    translations: ManagementNotificationTypeTranslationsDto;
}

/**
 * Confirmation that an order has been processed by the ERP system successfully.
 * @export
 * @interface OrderConfirmationManagementDto
 */
export interface OrderConfirmationManagementDto {
    /**
     * 
     * @type {string}
     * @memberof OrderConfirmationManagementDto
     */
    confirmedVia: OrderConfirmationManagementDto.ConfirmedViaEnum;
    /**
     * 
     * @type {string}
     * @memberof OrderConfirmationManagementDto
     */
    erpOrderNumber?: string;
    /**
     * 
     * @type {Date}
     * @memberof OrderConfirmationManagementDto
     */
    confirmationTime?: Date;
}

/**
 * @export
 * @namespace OrderConfirmationManagementDto
 */
export namespace OrderConfirmationManagementDto {
    /**
     * @export
     * @enum {string}
     */
    export enum ConfirmedViaEnum {
        Manually = <any> 'manually',
        Erp = <any> 'erp'
    }
}

/**
 * An order that was already submitted.
 * @export
 * @interface OrderDto
 */
export interface OrderDto {
    /**
     * The globally-unique id of this order.
     * @type {string}
     * @memberof OrderDto
     */
    id: string;
    /**
     * User-specified comment for this order
     * @type {string}
     * @memberof OrderDto
     */
    comment?: string;
    /**
     * Time the order was received from the user
     * @type {Date}
     * @memberof OrderDto
     */
    creationTime: Date;
    /**
     * Tenant-specific id of the customer
     * @type {string}
     * @memberof OrderDto
     */
    customerId: string;
    /**
     * Optional customer-internal reference number for the order
     * @type {string}
     * @memberof OrderDto
     */
    customerOrderId?: string;
    /**
     * Date of the delivery slot, if any
     * @type {string}
     * @memberof OrderDto
     */
    deliverySlotDate?: string;
    /**
     * Time description of the delivery slot, if any
     * @type {string}
     * @memberof OrderDto
     */
    deliverySlotTime?: string;
    /**
     * 
     * @type {DeliveryAddressDto}
     * @memberof OrderDto
     */
    deliveryAdress: DeliveryAddressDto;
    /**
     * Unloading area of the delivery address, if any.
     * @type {string}
     * @memberof OrderDto
     */
    unloadingArea?: string;
    /**
     * Unused
     * @type {string}
     * @memberof OrderDto
     */
    glnTenant?: string;
    /**
     * Channel the order was received on, e.g. WEB_SHOP
     * @type {string}
     * @memberof OrderDto
     */
    source: string;
    /**
     * Email addresses the order confirmation was sent to
     * @type {string}
     * @memberof OrderDto
     */
    confirmationEmails?: string;
    /**
     * Items included in the order
     * @type {Array&lt;OrderItemDto&gt;}
     * @memberof OrderDto
     */
    orderItems: Array<OrderItemDto>;
    /**
     * Most readable name associated with the user that submitted this order
     * @type {string}
     * @memberof OrderDto
     */
    userName?: string;
}

/**
 * An item included in an order.
 * @export
 * @interface OrderItemDto
 */
export interface OrderItemDto {
    /**
     * The SKU of the product
     * @type {string}
     * @memberof OrderItemDto
     */
    productSku: string;
    /**
     * The price that was calculated at order time. Note that the ERP may have different prices. Unset if the current user does not have access to prices.
     * @type {number}
     * @memberof OrderItemDto
     */
    price?: number;
    /**
     * The most accurate row total available from the persisted data. Might be inconsistent with price due to rounding issues. Unset if the current user does not have access to prices.
     * @type {number}
     * @memberof OrderItemDto
     */
    mostAccurateRowTotal?: number;
    /**
     * The amount that was ordered, in given unit
     * @type {number}
     * @memberof OrderItemDto
     */
    amount: number;
    /**
     * Abbreviation of the storage unit for the product at order time
     * @type {string}
     * @memberof OrderItemDto
     */
    baseUnit: string;
    /**
     * Ratio of the ordered unit at order time
     * @type {number}
     * @memberof OrderItemDto
     */
    ratio: number;
    /**
     * Abbreviation of the unit at order time
     * @type {string}
     * @memberof OrderItemDto
     */
    unitAbbr: string;
    /**
     * Unused
     * @type {string}
     * @memberof OrderItemDto
     */
    imagePath?: string;
    /**
     * true only if this item was a pre-order item
     * @type {boolean}
     * @memberof OrderItemDto
     */
    preOrder?: boolean;
    /**
     * A display name for the product, if recorded at order time. May be absent for older orders.
     * @type {string}
     * @memberof OrderItemDto
     */
    name?: string;
}

/**
 * 
 * @export
 * @interface OrderItemManagementDto
 */
export interface OrderItemManagementDto {
    /**
     * 
     * @type {string}
     * @memberof OrderItemManagementDto
     */
    productSku?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderItemManagementDto
     */
    productName?: string;
    /**
     * Price of 1 storage/base unit
     * @type {number}
     * @memberof OrderItemManagementDto
     */
    price?: number;
    /**
     * 
     * @type {number}
     * @memberof OrderItemManagementDto
     */
    quantity?: number;
    /**
     * 
     * @type {string}
     * @memberof OrderItemManagementDto
     */
    unitAbbr?: string;
    /**
     * 
     * @type {number}
     * @memberof OrderItemManagementDto
     */
    priceSum?: number;
}

/**
 * Internal management representation for orders
 * @export
 * @interface OrderManagementDto
 */
export interface OrderManagementDto {
    /**
     * 
     * @type {string}
     * @memberof OrderManagementDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderManagementDto
     */
    tenant?: string;
    /**
     * Order comment
     * @type {string}
     * @memberof OrderManagementDto
     */
    comment?: string;
    /**
     * Date and time when order was created.
     * @type {Date}
     * @memberof OrderManagementDto
     */
    creationTime?: Date;
    /**
     * 
     * @type {OrderManagementDtoCreatedBy}
     * @memberof OrderManagementDto
     */
    createdBy?: OrderManagementDtoCreatedBy;
    /**
     * 
     * @type {string}
     * @memberof OrderManagementDto
     */
    customerId?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderManagementDto
     */
    customerDisplayName?: string;
    /**
     * Internal order number from the customer if he/she provided one.
     * @type {string}
     * @memberof OrderManagementDto
     */
    customerOrderId?: string;
    /**
     * 
     * @type {OrderSourceDto}
     * @memberof OrderManagementDto
     */
    orderSource?: OrderSourceDto;
    /**
     * 
     * @type {string}
     * @memberof OrderManagementDto
     */
    deliverySlotDate?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderManagementDto
     */
    deliverySlotTime?: string;
    /**
     * 
     * @type {DeliveryAddressDto}
     * @memberof OrderManagementDto
     */
    deliveryAdress?: DeliveryAddressDto;
    /**
     * 
     * @type {string}
     * @memberof OrderManagementDto
     */
    unloadingArea?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderManagementDto
     */
    glnTenant?: string;
    /**
     * Has this order already been exported to the ESB?
     * @type {boolean}
     * @memberof OrderManagementDto
     */
    isExported?: boolean;
    /**
     * 
     * @type {Array&lt;OrderConfirmationManagementDto&gt;}
     * @memberof OrderManagementDto
     */
    orderConfirmations?: Array<OrderConfirmationManagementDto>;
    /**
     * 
     * @type {Array&lt;OrderItemManagementDto&gt;}
     * @memberof OrderManagementDto
     */
    orderItems?: Array<OrderItemManagementDto>;
}

/**
 * 
 * @export
 * @interface OrderManagementDtoCreatedBy
 */
export interface OrderManagementDtoCreatedBy {
    /**
     * The unique id of the order creator, as used by the SSO provider
     * @type {string}
     * @memberof OrderManagementDtoCreatedBy
     */
    uniqueId?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderManagementDtoCreatedBy
     */
    username?: string;
}

/**
 * 
 * @export
 * @interface OrderManagementFilterDto
 */
export interface OrderManagementFilterDto {
    /**
     * The page to get
     * @type {number}
     * @memberof OrderManagementFilterDto
     */
    pageNumber: number;
    /**
     * The amount of items to retrieve per page
     * @type {number}
     * @memberof OrderManagementFilterDto
     */
    pageSize: number;
    /**
     * Tenants to filter against, eg. tenants=LL,LS
     * @type {Array&lt;string&gt;}
     * @memberof OrderManagementFilterDto
     */
    tenants?: Array<string>;
    /**
     * Order ID to filter
     * @type {number}
     * @memberof OrderManagementFilterDto
     */
    orderId?: number;
    /**
     * Matches all orders whose customerId contains this value
     * @type {string}
     * @memberof OrderManagementFilterDto
     */
    customerId?: string;
    /**
     * Matches all orders which are created on this day
     * @type {string}
     * @memberof OrderManagementFilterDto
     */
    creationDate?: string;
    /**
     * Matches all orders which are created on this day or later
     * @type {string}
     * @memberof OrderManagementFilterDto
     */
    creationDateFrom?: string;
    /**
     * Matches all orders which are created on this day or earlier
     * @type {string}
     * @memberof OrderManagementFilterDto
     */
    creationDateTo?: string;
    /**
     * Search in all orders of customers which contain this name
     * @type {string}
     * @memberof OrderManagementFilterDto
     */
    customerDisplayName?: string;
    /**
     * Matches all orders whose creator contains this value
     * @type {string}
     * @memberof OrderManagementFilterDto
     */
    userName?: string;
    /**
     * Matches all orders of this source
     * @type {OrderSourceDto}
     * @memberof OrderManagementFilterDto
     */
    orderSource?: OrderSourceDto;
    /**
     * Filter for order which have been exported to the Lobster. If param is missing both orders which are exported AND those which are not exported are returned.
     * @type {boolean}
     * @memberof OrderManagementFilterDto
     */
    isExported?: boolean;
    /**
     * Filter for orders which have been confirmed to be processed at an EGB. If param is missing both orders which are confirmed AND those which are not confirmed are returned.
     * @type {boolean}
     * @memberof OrderManagementFilterDto
     */
    orderConfirmed?: boolean;
}

/**
 * 
 * @export
 * @interface OrderSearchResultDto
 */
export interface OrderSearchResultDto {
    /**
     * 
     * @type {PageMetadataDto}
     * @memberof OrderSearchResultDto
     */
    page?: PageMetadataDto;
    /**
     * 
     * @type {Array&lt;OrderManagementDto&gt;}
     * @memberof OrderSearchResultDto
     */
    result?: Array<OrderManagementDto>;
}

/**
 * The source of this order
 * @export
 * @enum {string}
 */
export enum OrderSourceDto {
    WEBSHOP = <any> 'WEB_SHOP',
    BESTFRIEND = <any> 'BEST_FRIEND',
    APP = <any> 'APP',
    APPPRO = <any> 'APP_PRO'
}

/**
 * Additional properties required to submit an order. Address is mis-spelled in property names for compatibility reasons. Provided delivery and billing address entities are not used, and instead retrieved from the database. Same applies for the confirmation email addresses. Order source defaults to WEB_SHOP.
 * @export
 * @interface OrderSubmitRequest
 */
export interface OrderSubmitRequest {
    /**
     * The Eurogast-internal identifier of the delivery address
     * @type {string}
     * @memberof OrderSubmitRequest
     */
    deliveryAddressExternalId: string;
    /**
     * 
     * @type {DeliveryAddressDto}
     * @memberof OrderSubmitRequest
     */
    deliveryAdress?: DeliveryAddressDto;
    /**
     * 
     * @type {CustomerAddressDto}
     * @memberof OrderSubmitRequest
     */
    billingAdress?: CustomerAddressDto;
    /**
     * 
     * @type {AvailableDeliverySlotDto}
     * @memberof OrderSubmitRequest
     */
    deliverySlot?: AvailableDeliverySlotDto;
    /**
     * Unused
     * @type {Array&lt;string&gt;}
     * @memberof OrderSubmitRequest
     */
    confirmationMailAdresses?: Array<string>;
    /**
     * The id of the unloading area of the delivery address to deliver to, or null if the delivery address does not have unloading areas.
     * @type {string}
     * @memberof OrderSubmitRequest
     */
    unloadingArea?: string;
    /**
     * Optional custom reference number for the order
     * @type {string}
     * @memberof OrderSubmitRequest
     */
    customerOrderId?: string;
    /**
     * Notes for the delivery driver
     * @type {string}
     * @memberof OrderSubmitRequest
     */
    notes?: string;
    /**
     * 
     * @type {OrderSourceDto}
     * @memberof OrderSubmitRequest
     */
    orderSource?: OrderSourceDto;
}

/**
 * 
 * @export
 * @interface OrderTemplateDto
 */
export interface OrderTemplateDto {
    /**
     * 
     * @type {number}
     * @memberof OrderTemplateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof OrderTemplateDto
     */
    customerId?: string;
    /**
     * 
     * @type {Date}
     * @memberof OrderTemplateDto
     */
    creationTime?: Date;
    /**
     * 
     * @type {Date}
     * @memberof OrderTemplateDto
     */
    lastEditedTime?: Date;
    /**
     * 
     * @type {UserDto}
     * @memberof OrderTemplateDto
     */
    createdBy?: UserDto;
    /**
     * 
     * @type {Array&lt;string&gt;}
     * @memberof OrderTemplateDto
     */
    sharedWith?: Array<string>;
    /**
     * 
     * @type {UserDto}
     * @memberof OrderTemplateDto
     */
    lastEditedBy?: UserDto;
    /**
     * 
     * @type {string}
     * @memberof OrderTemplateDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderTemplateDto
     */
    comment?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderTemplateDto
     */
    priceList?: string;
    /**
     * 
     * @type {Array&lt;OrderTemplateItemDto&gt;}
     * @memberof OrderTemplateDto
     */
    orderTemplateItems?: Array<OrderTemplateItemDto>;
}

/**
 * An item in an order template
 * @export
 * @interface OrderTemplateItemDto
 */
export interface OrderTemplateItemDto {
    /**
     * The SKU of the product this item represents.
     * @type {string}
     * @memberof OrderTemplateItemDto
     */
    productSku?: string;
    /**
     * The amount of the product to add when adding this template to the cart. Relative to the unit.
     * @type {number}
     * @memberof OrderTemplateItemDto
     */
    amount?: number;
    /**
     * The unit to add when adding this order template to the cart.
     * @type {string}
     * @memberof OrderTemplateItemDto
     */
    unit?: string;
    /**
     * 
     * @type {Date}
     * @memberof OrderTemplateItemDto
     */
    addedAt?: Date;
}

/**
 * Represents a single page of results to a search query for aggregated order templates.
 * @export
 * @interface OrderTemplatePageDto
 */
export interface OrderTemplatePageDto {
    /**
     * The total number of elements that are available for the search query that this page is for.
     * @type {number}
     * @memberof OrderTemplatePageDto
     */
    totalElements?: number;
    /**
     * The total number of pages available for the search query that this page is for, assuming equal size.
     * @type {number}
     * @memberof OrderTemplatePageDto
     */
    totalPages?: number;
    /**
     * The zero-based index of this page.
     * @type {number}
     * @memberof OrderTemplatePageDto
     */
    number?: number;
    /**
     * The number of elements allowed per page. Note that there may actually be less elements if there's not enough results.
     * @type {number}
     * @memberof OrderTemplatePageDto
     */
    size?: number;
    /**
     * The aggregated customers contained in this page.
     * @type {Array&lt;OrderTemplateDto&gt;}
     * @memberof OrderTemplatePageDto
     */
    content?: Array<OrderTemplateDto>;
}

/**
 * 
 * @export
 * @interface OrderTemplateSubmitDto
 */
export interface OrderTemplateSubmitDto {
    /**
     * 
     * @type {string}
     * @memberof OrderTemplateSubmitDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderTemplateSubmitDto
     */
    comment?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderTemplateSubmitDto
     */
    customerId?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderTemplateSubmitDto
     */
    priceList?: string;
}

/**
 * Represents metadata regarding a single page of results to a paged query.
 * @export
 * @interface PageMetadataDto
 */
export interface PageMetadataDto {
    /**
     * The total number of elements that are available for the search query that this page is for.
     * @type {number}
     * @memberof PageMetadataDto
     */
    totalElements?: number;
    /**
     * The total number of pages available for the search query that this page is for, assuming equal size.
     * @type {number}
     * @memberof PageMetadataDto
     */
    totalPages?: number;
    /**
     * The zero-based index of this page.
     * @type {number}
     * @memberof PageMetadataDto
     */
    number?: number;
    /**
     * The number of elements allowed per page. Note that there may actually be less elements if there are not enough results.
     * @type {number}
     * @memberof PageMetadataDto
     */
    size?: number;
}

/**
 * 
 * @export
 * @interface PageRequest
 */
export interface PageRequest {
    /**
     * the index of the page to retrieve
     * @type {number}
     * @memberof PageRequest
     */
    page?: number;
    /**
     * the amount of entries per page
     * @type {number}
     * @memberof PageRequest
     */
    size?: number;
    /**
     * the field to sort by, or null if unsorted
     * @type {string}
     * @memberof PageRequest
     */
    sortBy?: string;
    /**
     * ASC to sort in ascending order, DESC to sort in descending order. May be null if sortBy is null as well.
     * @type {string}
     * @memberof PageRequest
     */
    sortDirection?: string;
}

/**
 * A page of orders
 * @export
 * @interface PagedOrdersDto
 */
export interface PagedOrdersDto {
    /**
     * 
     * @type {PageMetadataDto}
     * @memberof PagedOrdersDto
     */
    page?: PageMetadataDto;
    /**
     * 
     * @type {Array&lt;OrderDto&gt;}
     * @memberof PagedOrdersDto
     */
    orders?: Array<OrderDto>;
}

/**
 * A price eligible for a product. How price selection works in detail is described in Confluence: https://confluence.eurogast.at/display/P1801/Preisfindung Note that the type may be obscured if the current user is not allowed to see special prices. In that case, SPECIAL and SPECIAL_LIST prices will be marked as LIST prices.
 * @export
 * @interface PriceDto
 */
export interface PriceDto {
    /**
     * 
     * @type {string}
     * @memberof PriceDto
     */
    sku: string;
    /**
     * End of validity of this price, if any
     * @type {string}
     * @memberof PriceDto
     */
    toDate?: string;
    /**
     * Minimum quantity, in the storage unit, that needs to be ordered for this price to apply.
     * @type {number}
     * @memberof PriceDto
     */
    minQuantity: number;
    /**
     * Float value of this price
     * @type {number}
     * @memberof PriceDto
     */
    price: number;
    /**
     * A string containing the exact raw value of this price. The reason for this property is that the Swagger generator generates numbers as floating point instead of their exact values TypeScript.
     * @type {string}
     * @memberof PriceDto
     */
    rawValueString: string;
    /**
     * 
     * @type {PriceTypeDto}
     * @memberof PriceDto
     */
    type: PriceTypeDto;
    /**
     * 
     * @type {DiscountDto}
     * @memberof PriceDto
     */
    attachedDiscount?: DiscountDto;
    /**
     * Float value of the uvp
     * @type {number}
     * @memberof PriceDto
     */
    uvp?: number;
}

/**
 * Filters products by their prices. Values correspond to price types, except BULK_PRICE, which denotes any bulk price. Note that results may be approximate (e.g. the product itself may have a promotional price, but it need not be the best price for the current customer). However, price expiry is guaranteed to be respected. SPECIAL also covers the SPECIAL_LIST price type.
 * @export
 * @enum {string}
 */
export enum PriceFilterDto {
    SPECIAL = <any> 'SPECIAL',
    PROMOTION = <any> 'PROMOTION',
    BULK = <any> 'BULK'
}

/**
 * Type of price, describes how it was selected internally.
 * @export
 * @enum {string}
 */
export enum PriceTypeDto {
    LIST = <any> 'LIST',
    PROMOTION = <any> 'PROMOTION',
    SPECIAL = <any> 'SPECIAL',
    SPECIALLIST = <any> 'SPECIAL_LIST',
    FAIRLIST = <any> 'FAIR_LIST'
}

/**
 * An attribute assignment to a product.
 * @export
 * @interface ProductAttributeInfo
 */
export interface ProductAttributeInfo {
    /**
     * 
     * @type {ProductAttributeType}
     * @memberof ProductAttributeInfo
     */
    key: ProductAttributeType;
    /**
     * Additional information for this attribute
     * @type {string}
     * @memberof ProductAttributeInfo
     */
    extension?: string;
    /**
     * Localised display name for this attribute
     * @type {string}
     * @memberof ProductAttributeInfo
     */
    displayName: string;
}

/**
 * Inherent attributes of products
 * @export
 * @enum {string}
 */
export enum ProductAttributeType {
    Tiefgekuehlt = <any> 'Tiefgekuehlt',
    Gekuehlt = <any> 'Gekuehlt',
    Wiegeartikel = <any> 'Wiegeartikel',
    Bestellartikel = <any> 'Bestellartikel',
    BIO = <any> 'BIO',
    MSC = <any> 'MSC',
    ASC = <any> 'ASC',
    VEG = <any> 'VEG',
    GF = <any> 'GF',
    LF = <any> 'LF',
    EG = <any> 'EG',
    ED = <any> 'ED',
    AMAGuetesiegel = <any> 'AMAGuetesiegel',
    AMAGenussregion = <any> 'AMAGenussregion'
}

/**
 * Represents the base price (\"Grundpreisauszeichnung\") of a product.
 * @export
 * @interface ProductBasePrice
 */
export interface ProductBasePrice {
    /**
     * the quantity without a unit
     * @type {number}
     * @memberof ProductBasePrice
     */
    quantity?: number;
    /**
     * The unit of the quantity, which is *not* guranteed to be one of the unit codes defined at https://confluence.eurogast.at/pages/viewpage.action?spaceKey=P1801&title=Einheitencodes
     * @type {string}
     * @memberof ProductBasePrice
     */
    unit?: string;
    /**
     * Conversion factor for the reference unit.
     * @type {number}
     * @memberof ProductBasePrice
     */
    refQuantity?: number;
    /**
     * Reference unit as string
     * @type {string}
     * @memberof ProductBasePrice
     */
    refUnit?: string;
}

/**
 * Request for auto-completion of product search.
 * @export
 * @interface ProductCompletionRequest
 */
export interface ProductCompletionRequest {
    /**
     * The text currently in the search box
     * @type {string}
     * @memberof ProductCompletionRequest
     */
    query?: string;
    /**
     * 
     * @type {ProductSearchFilter}
     * @memberof ProductCompletionRequest
     */
    filter?: ProductSearchFilter;
}

/**
 * Result of an auto-completion. Note that this specifies
 * @export
 * @interface ProductCompletionResponse
 */
export interface ProductCompletionResponse {
    /**
     * 
     * @type {Array&lt;CategoryDto&gt;}
     * @memberof ProductCompletionResponse
     */
    categories: Array<CategoryDto>;
    /**
     * 
     * @type {Array&lt;ProductDto&gt;}
     * @memberof ProductCompletionResponse
     */
    products: Array<ProductDto>;
    /**
     * The total number of elements found by this search-query
     * @type {number}
     * @memberof ProductCompletionResponse
     */
    totalNumberOfProductsFound?: number;
}

/**
 * Represents a product in the store. Text attributes are localised in the language of the user that requested the product. All attributes except SKU and name may be empty if absent.
 * @export
 * @interface ProductDto
 */
export interface ProductDto {
    /**
     * Stock Keeping Unit, the unique internal id for this product.
     * @type {string}
     * @memberof ProductDto
     */
    sku: string;
    /**
     * 
     * @type {string}
     * @memberof ProductDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ProductDto
     */
    shortDescription: string;
    /**
     * 
     * @type {string}
     * @memberof ProductDto
     */
    description: string;
    /**
     * The absolute id of the category of this product, with each node in the category tree separated by a pipe. The example represents the child 20 of 07, which is a child of the root category 02.
     * @type {string}
     * @memberof ProductDto
     */
    categoryId: string;
    /**
     * 
     * @type {CategoryDto}
     * @memberof ProductDto
     */
    resolvedCategory?: CategoryDto;
    /**
     * virtual categories of the product.
     * @type {Array&lt;string&gt;}
     * @memberof ProductDto
     */
    virtualCategories: Array<string>;
    /**
     * 
     * @type {Array&lt;ProductImageDto&gt;}
     * @memberof ProductDto
     */
    images: Array<ProductImageDto>;
    /**
     * The status of this product, 1 meaning valid and allowed to be displayed in the webshop.
     * @type {number}
     * @memberof ProductDto
     */
    status?: number;
    /**
     * The availability of this product. Only relevant when status is 1 (active). Product should be listed and orderable if value is ACTIVE. Product should be listed but not orderable if value is any other.
     * @type {string}
     * @memberof ProductDto
     */
    availability?: ProductDto.AvailabilityEnum;
    /**
     * Attributes inherent to this product, for example stating that this product is deep-fried.
     * @type {Array&lt;ProductAttributeInfo&gt;}
     * @memberof ProductDto
     */
    attributes?: Array<ProductAttributeInfo>;
    /**
     * Indicates the minimum order amount of the product.
     * @type {number}
     * @memberof ProductDto
     */
    minSaleQuantity?: number;
    /**
     * Conditions that control the state of a product relating to sale.
     * @type {Array&lt;SalesConditionInfo&gt;}
     * @memberof ProductDto
     */
    salesConditions?: Array<SalesConditionInfo>;
    /**
     * The units in which this product is stored and sold.
     * @type {Array&lt;ProductUnitDto&gt;}
     * @memberof ProductDto
     */
    units: Array<ProductUnitDto>;
    /**
     * 
     * @type {ProductNetFillQuantity}
     * @memberof ProductDto
     */
    netFillingQuantity?: ProductNetFillQuantity;
    /**
     * 
     * @type {ProductBasePrice}
     * @memberof ProductDto
     */
    basePrice?: ProductBasePrice;
    /**
     * allergen info code as documented in Confluence
     * @type {string}
     * @memberof ProductDto
     */
    allergenInfoCodes: string;
    /**
     * storage note for the product.
     * @type {string}
     * @memberof ProductDto
     */
    storageNote: string;
    /**
     * ingredients of the product.
     * @type {string}
     * @memberof ProductDto
     */
    ingredients: string;
    /**
     * True if this product is represented in the essence list of the current customer or it is hidden from the essence-list Note that this is related to isEssential: This represents eligibility for the essence list, i.e. the customer may select this product as essential. This flag is also set if the item has been hidden from the essence list by the customer
     * @type {boolean}
     * @memberof ProductDto
     */
    isAvailableForEssence?: boolean;
    /**
     * True if and only if this product is represented in the essence list of the current customer, if any, and has not been hidden by the customer.
     * @type {boolean}
     * @memberof ProductDto
     */
    isEssential?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ProductDto
     */
    alcohol?: number;
    /**
     * 
     * @type {Array&lt;PriceDto&gt;}
     * @memberof ProductDto
     */
    bulkPrices?: Array<PriceDto>;
}

/**
 * @export
 * @namespace ProductDto
 */
export namespace ProductDto {
    /**
     * @export
     * @enum {string}
     */
    export enum AvailabilityEnum {
        ACTIVE = <any> 'ACTIVE',
        PREORDER = <any> 'PRE_ORDER',
        NOTDELIVERABLE = <any> 'NOT_DELIVERABLE'
    }
}

/**
 * Provides summary information about the whole search result, not only the current page.
 * @export
 * @interface ProductFacetsDto
 */
export interface ProductFacetsDto {
    /**
     * List of attributes present in the search result
     * @type {Array&lt;LocalizedFacet&gt;}
     * @memberof ProductFacetsDto
     */
    attributes: Array<LocalizedFacet>;
    /**
     * List of sales conditions present in the search result
     * @type {Array&lt;LocalizedFacet&gt;}
     * @memberof ProductFacetsDto
     */
    salesConditions: Array<LocalizedFacet>;
    /**
     * Direct child categories of the category the request is currently, filtered on. Root categories if the request is not currently filtered.
     * @type {Array&lt;CategoryFacet&gt;}
     * @memberof ProductFacetsDto
     */
    rootCategories: Array<CategoryFacet>;
    /**
     * Third-level categories represented in the result. Not used in the frontend currently, may be removed in the future.
     * @type {Array&lt;CategoryFacet&gt;}
     * @memberof ProductFacetsDto
     */
    detailCategories?: Array<CategoryFacet>;
    /**
     * The parent categories of the requested category, including that category itself. In order such that the root category is the first element of the array. Empty if no specific category was requested.
     * @type {Array&lt;CategoryDto&gt;}
     * @memberof ProductFacetsDto
     */
    parentCategories: Array<CategoryDto>;
    /**
     * Virtual categories represented in the result
     * @type {Array&lt;CategoryFacet&gt;}
     * @memberof ProductFacetsDto
     */
    virtualCategories: Array<CategoryFacet>;
}

/**
 * Represents a single group of products on a category browse page.
 * @export
 * @interface ProductGroupingDto
 */
export interface ProductGroupingDto {
    /**
     * 
     * @type {CategoryDto}
     * @memberof ProductGroupingDto
     */
    category?: CategoryDto;
    /**
     * The count of items in this grouping, on this page.
     * @type {number}
     * @memberof ProductGroupingDto
     */
    memberCount?: number;
    /**
     * The products contained in this grouping.
     * @type {Array&lt;ProductDto&gt;}
     * @memberof ProductGroupingDto
     */
    products?: Array<ProductDto>;
}

/**
 * A single image for a product, holding paths for different sizes.
 * @export
 * @interface ProductImageDto
 */
export interface ProductImageDto {
    /**
     * The relative paths of this image (500px) as understood by image-service.
     * @type {string}
     * @memberof ProductImageDto
     */
    mediumPath: string;
    /**
     * The relative paths of this image's thumbnail (200px) as understood by image-service.
     * @type {string}
     * @memberof ProductImageDto
     */
    thumbnailPath: string;
    /**
     * The relative paths of this image's big version (1500px) as understood by image-service.
     * @type {string}
     * @memberof ProductImageDto
     */
    bigPath: string;
    /**
     * Whether this image is part of a 3D image series
     * @type {boolean}
     * @memberof ProductImageDto
     */
    is3d: boolean;
}

/**
 * Represents a tuple of quantity and unit used for net filling quantity and base price.
 * @export
 * @interface ProductNetFillQuantity
 */
export interface ProductNetFillQuantity {
    /**
     * the quantity without a unit
     * @type {number}
     * @memberof ProductNetFillQuantity
     */
    quantity?: number;
    /**
     * The unit of the quantity, which is not guranteed to be one of the unit codes defined at https://confluence.eurogast.at/pages/viewpage.action?spaceKey=P1801&title=Einheitencodes
     * @type {string}
     * @memberof ProductNetFillQuantity
     */
    unit?: string;
}

/**
 * Stores the number of orders that included a product in some time range.
 * @export
 * @interface ProductOrderCountDto
 */
export interface ProductOrderCountDto {
    /**
     * 
     * @type {string}
     * @memberof ProductOrderCountDto
     */
    productSku?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductOrderCountDto
     */
    orderCount?: number;
}

/**
 * Represents metadata about a product promotion.
 * @export
 * @interface ProductPromotionDto
 */
export interface ProductPromotionDto {
    /**
     * 
     * @type {number}
     * @memberof ProductPromotionDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductPromotionDto
     */
    sku: string;
    /**
     * 
     * @type {string}
     * @memberof ProductPromotionDto
     */
    tenant: string;
    /**
     * 
     * @type {string}
     * @memberof ProductPromotionDto
     */
    dateFrom: string;
    /**
     * 
     * @type {string}
     * @memberof ProductPromotionDto
     */
    dateTo: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProductPromotionDto
     */
    search: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProductPromotionDto
     */
    cart: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProductPromotionDto
     */
    name?: string;
}

/**
 * 
 * @export
 * @interface ProductPromotionSearchResultDto
 */
export interface ProductPromotionSearchResultDto {
    /**
     * 
     * @type {PageMetadataDto}
     * @memberof ProductPromotionSearchResultDto
     */
    page?: PageMetadataDto;
    /**
     * 
     * @type {Array&lt;ProductPromotionDto&gt;}
     * @memberof ProductPromotionSearchResultDto
     */
    result?: Array<ProductPromotionDto>;
}

/**
 * A object combining all product restriction information for a specific customer. Contains product-skus for catalog- and essence-restrictions
 * @export
 * @interface ProductRestrictionDto
 */
export interface ProductRestrictionDto {
    /**
     * Empty array if no restriction, otherwise list of allowed SKUs.
     * @type {Array&lt;string&gt;}
     * @memberof ProductRestrictionDto
     */
    catalogRestrictions: Array<string>;
    /**
     * 
     * @type {Array&lt;EssenceRestrictionDto&gt;}
     * @memberof ProductRestrictionDto
     */
    essenceRestrictions: Array<EssenceRestrictionDto>;
}

/**
 * Specifies actual business filters to limit search results by.
 * @export
 * @interface ProductSearchFilter
 */
export interface ProductSearchFilter {
    /**
     * The absolute id of the category to require, with each node in the category tree separated by a pipe. The example represents the child 08 of 06, which is a child of the root category 07. Use an empty string to allow all categories.
     * @type {string}
     * @memberof ProductSearchFilter
     */
    categoryId?: string;
    /**
     * Names of the attributes to require. Use an empty array to allow all attributes and products without any.
     * @type {Array&lt;ProductAttributeType&gt;}
     * @memberof ProductSearchFilter
     */
    attributes?: Array<ProductAttributeType>;
    /**
     * Names of the sales conditions to require. Use an empty array to allow all conditions and products without any.
     * @type {Array&lt;SalesConditionType&gt;}
     * @memberof ProductSearchFilter
     */
    salesConditions?: Array<SalesConditionType>;
    /**
     * 
     * @type {EssentialProductFilter}
     * @memberof ProductSearchFilter
     */
    essential?: EssentialProductFilter;
    /**
     * Price filters to require, use an empty array to allow all.
     * @type {Array&lt;PriceFilterDto&gt;}
     * @memberof ProductSearchFilter
     */
    prices?: Array<PriceFilterDto>;
    /**
     * Virtual category Ids to require, use an empty array to allow all.
     * @type {Array&lt;string&gt;}
     * @memberof ProductSearchFilter
     */
    virtualCategories?: Array<string>;
    /**
     * Restricts the search result to products, which are assigend to the given cart-type
     * @type {string}
     * @memberof ProductSearchFilter
     */
    cartType?: string;
}

/**
 * Specifies requirements for products to be returned by a search request.
 * @export
 * @interface ProductSearchRequest
 */
export interface ProductSearchRequest {
    /**
     * The raw query string, as entered by the end user. No guarantees are made as to how it is interpreted.
     * @type {string}
     * @memberof ProductSearchRequest
     */
    queryString: string;
    /**
     * set of whitelisted skus
     * @type {Array&lt;string&gt;}
     * @memberof ProductSearchRequest
     */
    whitelistedSkus?: Array<string>;
    /**
     * 
     * @type {ProductSearchFilter}
     * @memberof ProductSearchRequest
     */
    filter?: ProductSearchFilter;
    /**
     * 
     * @type {PageRequest}
     * @memberof ProductSearchRequest
     */
    page?: PageRequest;
}

/**
 * Specifies the result of a search query for products.
 * @export
 * @interface ProductSearchResult
 */
export interface ProductSearchResult {
    /**
     * 
     * @type {ProductSearchFilter}
     * @memberof ProductSearchResult
     */
    filter?: ProductSearchFilter;
    /**
     * The wall clock time that passed between sending the search request to the index and having received the full result, in milliseconds.
     * @type {number}
     * @memberof ProductSearchResult
     */
    queryDurationMs?: number;
    /**
     * The products contained in this page.
     * @type {Array&lt;ProductDto&gt;}
     * @memberof ProductSearchResult
     */
    products?: Array<ProductDto>;
    /**
     * The promoted product to be displayed at the very top of the result page
     * @type {ProductDto}
     * @memberof ProductSearchResult
     */
    promotedProduct?: ProductDto;
    /**
     * 
     * @type {PageMetadataDto}
     * @memberof ProductSearchResult
     */
    page?: PageMetadataDto;
    /**
     * 
     * @type {ProductFacetsDto}
     * @memberof ProductSearchResult
     */
    facets?: ProductFacetsDto;
}

/**
 * A search result of products
 * @export
 * @interface ProductSearchResultDto
 */
export interface ProductSearchResultDto {
    /**
     * 
     * @type {PageMetadataDto}
     * @memberof ProductSearchResultDto
     */
    page?: PageMetadataDto;
    /**
     * 
     * @type {Array&lt;ProductDto&gt;}
     * @memberof ProductSearchResultDto
     */
    result?: Array<ProductDto>;
}

/**
 * Represents a unit in which a product may be purchased. Can be understood as package size.
 * @export
 * @interface ProductUnitDto
 */
export interface ProductUnitDto {
    /**
     * Human-readable name of this unit
     * @type {string}
     * @memberof ProductUnitDto
     */
    name: string;
    /**
     * Product-unique abbreviation of this unit
     * @type {string}
     * @memberof ProductUnitDto
     */
    abbreviation: string;
    /**
     * Conversion factor from storage unit to this unit
     * @type {number}
     * @memberof ProductUnitDto
     */
    ratio: number;
    /**
     * Whether this is the default sales unit for this product. There may only be one default unit per product.
     * @type {boolean}
     * @memberof ProductUnitDto
     */
    isDefault?: boolean;
    /**
     * Whether this unit may be shown to customers
     * @type {boolean}
     * @memberof ProductUnitDto
     */
    isVisible?: boolean;
    /**
     * Whether this unit is the storage unit (= base unit)
     * @type {boolean}
     * @memberof ProductUnitDto
     */
    isStorageUnit?: boolean;
    /**
     * List of Global Trade Item Numbers associated with this unit. Relevant for image resolution.
     * @type {Array&lt;string&gt;}
     * @memberof ProductUnitDto
     */
    gtins?: Array<string>;
}

/**
 * Like attributes, but different values
 * @export
 * @interface SalesConditionInfo
 */
export interface SalesConditionInfo {
    /**
     * 
     * @type {SalesConditionType}
     * @memberof SalesConditionInfo
     */
    key: SalesConditionType;
    /**
     * Localised display name for this condition
     * @type {string}
     * @memberof SalesConditionInfo
     */
    displayName: string;
}

/**
 * Conditions associated with the sale of products.
 * @export
 * @enum {string}
 */
export enum SalesConditionType {
    New = <any> 'New'
}

/**
 * The current state of a shopping cart.
 * @export
 * @interface ShoppingCart
 */
export interface ShoppingCart {
    /**
     * The Eurogast customer number of the customer
     * @type {string}
     * @memberof ShoppingCart
     */
    customerId: string;
    /**
     * The SSO user id of the user for this cart
     * @type {string}
     * @memberof ShoppingCart
     */
    userId: string;
    /**
     * 
     * @type {Array&lt;ShoppingCartItem&gt;}
     * @memberof ShoppingCart
     */
    items: Array<ShoppingCartItem>;
    /**
     * The first instant at which this cart is considered to be valid. Any products or changes with timestamps before this instant are considered to belong to a previous shopping cart and as such must not be synched to this shopping cart. This coincides with the instant of the last order submission for this customer / user combination. If no order has been submitted, this is null meaning that all data should be considered. This is provided as local date time in the server time zone (Europe/Vienna).
     * @type {Date}
     * @memberof ShoppingCart
     */
    validSince?: Date;
    /**
     * Items that have been deleted, for synchronisation.
     * @type {Array&lt;DeletedCartItemDto&gt;}
     * @memberof ShoppingCart
     */
    deletedItems: Array<DeletedCartItemDto>;
}

/**
 * An event that occurred on a shopping cart. SKU, amount and unit are only set for actions that operate on a single item.
 * @export
 * @interface ShoppingCartEventDto
 */
export interface ShoppingCartEventDto {
    /**
     * 
     * @type {string}
     * @memberof ShoppingCartEventDto
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof ShoppingCartEventDto
     */
    customerId: string;
    /**
     * 
     * @type {ShoppingCartEventTypeDto}
     * @memberof ShoppingCartEventDto
     */
    eventType: ShoppingCartEventTypeDto;
    /**
     * 
     * @type {string}
     * @memberof ShoppingCartEventDto
     */
    sku?: string;
    /**
     * 
     * @type {number}
     * @memberof ShoppingCartEventDto
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof ShoppingCartEventDto
     */
    unitAbbreviation?: string;
    /**
     * 
     * @type {Date}
     * @memberof ShoppingCartEventDto
     */
    timestamp: Date;
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum ShoppingCartEventTypeDto {
    ADDITEM = <any> 'ADD_ITEM',
    REMOVEITEM = <any> 'REMOVE_ITEM',
    REMOVEALL = <any> 'REMOVE_ALL'
}

/**
 * An item in a shopping cart. Note that only the required properties must be set for writing an item, but when receiving an item from the server, all properties will be populated. Note that only the root-level (required) properties are recognised when sending this entity to the server, any identifiers stored in entities (unit, product) will be ignored. In fact, those are not supposed to be passed to the server, but rather provided as convenience in responses from the server only. The update timestamp is automatically set by the server. To make sure that only a single clock is used, timestamps provided by the client are discarded.
 * @export
 * @interface ShoppingCartItem
 */
export interface ShoppingCartItem {
    /**
     * The Stock Keeping Unit id of the product represented by this item.
     * @type {string}
     * @memberof ShoppingCartItem
     */
    sku: string;
    /**
     * How many units of this product are in the cart.
     * @type {number}
     * @memberof ShoppingCartItem
     */
    amount: number;
    /**
     * The product-unique abbreviation of the unit this item is measured in.
     * @type {string}
     * @memberof ShoppingCartItem
     */
    unitAbbreviation: string;
    /**
     * 
     * @type {ProductUnitDto}
     * @memberof ShoppingCartItem
     */
    unit?: ProductUnitDto;
    /**
     * 
     * @type {ProductDto}
     * @memberof ShoppingCartItem
     */
    product?: ProductDto;
    /**
     * The instant of the last change to this cart item, for synchronisation purposes. This is provided as local date time in the server time zone (Europe/Vienna).
     * @type {Date}
     * @memberof ShoppingCartItem
     */
    lastUpdatedAt?: Date;
}

/**
 * 
 * @export
 * @interface SpecialAggregatedOrderTemplateDto
 */
export interface SpecialAggregatedOrderTemplateDto {
    /**
     * 
     * @type {number}
     * @memberof SpecialAggregatedOrderTemplateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof SpecialAggregatedOrderTemplateDto
     */
    customerId?: string;
    /**
     * 
     * @type {Date}
     * @memberof SpecialAggregatedOrderTemplateDto
     */
    creationTime?: Date;
    /**
     * 
     * @type {Date}
     * @memberof SpecialAggregatedOrderTemplateDto
     */
    lastEditedTime?: Date;
    /**
     * 
     * @type {UserDto}
     * @memberof SpecialAggregatedOrderTemplateDto
     */
    createdBy?: UserDto;
    /**
     * 
     * @type {Array&lt;UserDto&gt;}
     * @memberof SpecialAggregatedOrderTemplateDto
     */
    sharedWith?: Array<UserDto>;
    /**
     * 
     * @type {UserDto}
     * @memberof SpecialAggregatedOrderTemplateDto
     */
    lastEditedBy?: UserDto;
    /**
     * 
     * @type {string}
     * @memberof SpecialAggregatedOrderTemplateDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof SpecialAggregatedOrderTemplateDto
     */
    comment?: string;
    /**
     * 
     * @type {Array&lt;OrderTemplateItemDto&gt;}
     * @memberof SpecialAggregatedOrderTemplateDto
     */
    orderTemplateItems?: Array<OrderTemplateItemDto>;
    /**
     * 
     * @type {ProductSearchResult}
     * @memberof SpecialAggregatedOrderTemplateDto
     */
    productSearchResult?: ProductSearchResult;
    /**
     * 
     * @type {boolean}
     * @memberof SpecialAggregatedOrderTemplateDto
     */
    shareable?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SpecialAggregatedOrderTemplateDto
     */
    priceList?: string;
}

/**
 * 
 * @export
 * @interface SpecialOrderTemplateDto
 */
export interface SpecialOrderTemplateDto {
    /**
     * 
     * @type {number}
     * @memberof SpecialOrderTemplateDto
     */
    id?: number;
    /**
     * 
     * @type {Date}
     * @memberof SpecialOrderTemplateDto
     */
    creationTime?: Date;
    /**
     * 
     * @type {string}
     * @memberof SpecialOrderTemplateDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof SpecialOrderTemplateDto
     */
    priceList?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SpecialOrderTemplateDto
     */
    enabled?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof SpecialOrderTemplateDto
     */
    activeFrom?: Date;
    /**
     * 
     * @type {Date}
     * @memberof SpecialOrderTemplateDto
     */
    activeTo?: Date;
    /**
     * 
     * @type {Date}
     * @memberof SpecialOrderTemplateDto
     */
    deliverFrom?: Date;
    /**
     * 
     * @type {Date}
     * @memberof SpecialOrderTemplateDto
     */
    deliverTo?: Date;
    /**
     * 
     * @type {Array&lt;SpecialOrderTemplateItemDto&gt;}
     * @memberof SpecialOrderTemplateDto
     */
    orderTemplateItems?: Array<SpecialOrderTemplateItemDto>;
}

/**
 * An item in an special order template
 * @export
 * @interface SpecialOrderTemplateItemDto
 */
export interface SpecialOrderTemplateItemDto {
    /**
     * The SKU of the product this item represents.
     * @type {string}
     * @memberof SpecialOrderTemplateItemDto
     */
    productSku?: string;
}

/**
 * 
 * @export
 * @interface SubshopGroupedProductsDto
 */
export interface SubshopGroupedProductsDto {
    /**
     * 
     * @type {GroupedProductsDto}
     * @memberof SubshopGroupedProductsDto
     */
    groupedProducts?: GroupedProductsDto;
    /**
     * 
     * @type {Array&lt;NaraDto&gt;}
     * @memberof SubshopGroupedProductsDto
     */
    naras?: Array<NaraDto>;
}

/**
 * The project completion response of a subhop search-request. Contains the normal completion-response and additional nara-info
 * @export
 * @interface SubshopProductCompletionResponseDto
 */
export interface SubshopProductCompletionResponseDto {
    /**
     * 
     * @type {ProductCompletionResponse}
     * @memberof SubshopProductCompletionResponseDto
     */
    completionResponse: ProductCompletionResponse;
    /**
     * 
     * @type {Array&lt;NaraDto&gt;}
     * @memberof SubshopProductCompletionResponseDto
     */
    naras: Array<NaraDto>;
}

/**
 * A productDto for the subshop it includes the default product-dto and additional nara-information.
 * @export
 * @interface SubshopProductDto
 */
export interface SubshopProductDto {
    /**
     * 
     * @type {ProductDto}
     * @memberof SubshopProductDto
     */
    productDto: ProductDto;
    /**
     * 
     * @type {NaraDto}
     * @memberof SubshopProductDto
     */
    naraDto: NaraDto;
}

/**
 * Result of a search-request for a subshop. It result includes nara-information about the products.
 * @export
 * @interface SubshopProductSearchResultDto
 */
export interface SubshopProductSearchResultDto {
    /**
     * 
     * @type {ProductSearchResult}
     * @memberof SubshopProductSearchResultDto
     */
    searchResult: ProductSearchResult;
    /**
     * 
     * @type {Array&lt;NaraDto&gt;}
     * @memberof SubshopProductSearchResultDto
     */
    naras: Array<NaraDto>;
}

/**
 * Feature flag for a specific tenant
 * @export
 * @interface TenantFeatureFlagDto
 */
export interface TenantFeatureFlagDto {
    /**
     * Tenant code
     * @type {string}
     * @memberof TenantFeatureFlagDto
     */
    tenant: string;
    /**
     * 
     * @type {FeatureFlagDto}
     * @memberof TenantFeatureFlagDto
     */
    flag: FeatureFlagDto;
}

/**
 * Settings for System-Notifications of a tenant.
 * @export
 * @interface TenantNotificationSettingsDto
 */
export interface TenantNotificationSettingsDto {
    /**
     * 
     * @type {boolean}
     * @memberof TenantNotificationSettingsDto
     */
    bestFriendUpdateReminder?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TenantNotificationSettingsDto
     */
    productInformation?: boolean;
}

/**
 * General settings relating to a tenant.
 * @export
 * @interface TenantSettingsDto
 */
export interface TenantSettingsDto {
    /**
     * Tenant code
     * @type {string}
     * @memberof TenantSettingsDto
     */
    tenant?: string;
    /**
     * For optimistic locking, do not modify.
     * @type {number}
     * @memberof TenantSettingsDto
     */
    version?: number;
    /**
     * 
     * @type {number}
     * @memberof TenantSettingsDto
     */
    bfUpdateinterval?: number;
    /**
     * Server address for the BF to order at
     * @type {string}
     * @memberof TenantSettingsDto
     */
    bfOrderServer?: string;
    /**
     * Server address for the BF to get data from
     * @type {string}
     * @memberof TenantSettingsDto
     */
    bfDataServer?: string;
    /**
     * 
     * @type {number}
     * @memberof TenantSettingsDto
     */
    bfProductIsNewForDays?: number;
    /**
     * 
     * @type {number}
     * @memberof TenantSettingsDto
     */
    bfDataIsOldAfterDays?: number;
    /**
     * 
     * @type {number}
     * @memberof TenantSettingsDto
     */
    bfShowPricesForDays?: number;
    /**
     * 
     * @type {number}
     * @memberof TenantSettingsDto
     */
    bfMaxSearchResults?: number;
    /**
     * 
     * @type {number}
     * @memberof TenantSettingsDto
     */
    bfUpdateIfDataIsOlderThanDays?: number;
    /**
     * 
     * @type {number}
     * @memberof TenantSettingsDto
     */
    bfPriceDisplay?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TenantSettingsDto
     */
    bfShowPromotions?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TenantSettingsDto
     */
    bfShowSpecialPrices?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TenantSettingsDto
     */
    bfAllowMultipleOrders?: boolean;
    /**
     * Defaultnumber of days to keep items in the essence list
     * @type {number}
     * @memberof TenantSettingsDto
     */
    showEssenceForDays?: number;
    /**
     * Number of products to show per default in the webshop
     * @type {number}
     * @memberof TenantSettingsDto
     */
    articlePageSizeShop?: number;
    /**
     * Official readable name of this tenant
     * @type {string}
     * @memberof TenantSettingsDto
     */
    tenantName?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantSettingsDto
     */
    tenantAddressStreet?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantSettingsDto
     */
    tenantAddressCity?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantSettingsDto
     */
    tenantAddressPostCode?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantSettingsDto
     */
    tenantAddressCountryCode?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantSettingsDto
     */
    contactEmail?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantSettingsDto
     */
    contactTelNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantSettingsDto
     */
    contactFaxNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantSettingsDto
     */
    contactName?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantSettingsDto
     */
    mailFrom?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantSettingsDto
     */
    mailFromName?: string;
    /**
     * Tenant-level default of days to show delivery slots in advance
     * @type {number}
     * @memberof TenantSettingsDto
     */
    upcomingDaysForDelivery?: number;
    /**
     * 
     * @type {string}
     * @memberof TenantSettingsDto
     */
    gln?: string;
}

/**
 * Notification which contains important information for the customer.
 * @export
 * @interface UrgentNotificationDto
 */
export interface UrgentNotificationDto {
    /**
     * 
     * @type {UserNotificationDto}
     * @memberof UrgentNotificationDto
     */
    mostRecentUnread?: UserNotificationDto;
    /**
     * 
     * @type {number}
     * @memberof UrgentNotificationDto
     */
    numberOfOlderUnread: number;
}

/**
 * Internal comment for this user made by an EG employee.
 * @export
 * @interface UserCommentDto
 */
export interface UserCommentDto {
    /**
     * The internal generated id of this comment.
     * @type {number}
     * @memberof UserCommentDto
     */
    id?: number;
    /**
     * The unique id of the user to whom the comment is assigned to, as used by the SSO provider
     * @type {string}
     * @memberof UserCommentDto
     */
    userId?: string;
    /**
     * Date and time when the comment was created.
     * @type {Date}
     * @memberof UserCommentDto
     */
    creationTime?: Date;
    /**
     * 
     * @type {UserCommentDtoCreatedBy}
     * @memberof UserCommentDto
     */
    createdBy?: UserCommentDtoCreatedBy;
    /**
     * 
     * @type {string}
     * @memberof UserCommentDto
     */
    comment: string;
}

/**
 * 
 * @export
 * @interface UserCommentDtoCreatedBy
 */
export interface UserCommentDtoCreatedBy {
    /**
     * The unique id of the comment creator, as used by the SSO provider
     * @type {string}
     * @memberof UserCommentDtoCreatedBy
     */
    uniqueId?: string;
    /**
     * 
     * @type {string}
     * @memberof UserCommentDtoCreatedBy
     */
    username?: string;
}

/**
 * A limited view of a user.
 * @export
 * @interface UserDto
 */
export interface UserDto {
    /**
     * The UUID assigned to the user
     * @type {string}
     * @memberof UserDto
     */
    userId?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    firstname?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    lastname?: string;
    /**
     * Main email address, as stored in the Hub's database.
     * @type {string}
     * @memberof UserDto
     */
    email?: string;
    /**
     * The name this user uses to log in
     * @type {string}
     * @memberof UserDto
     */
    username?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    locale?: string;
    /**
     * Additional email addresses that order confirmations should be sent to
     * @type {Array&lt;string&gt;}
     * @memberof UserDto
     */
    ordermails?: Array<string>;
    /**
     * Email addresses that label selections should be sent to.
     * @type {Array&lt;string&gt;}
     * @memberof UserDto
     */
    labelmails?: Array<string>;
}

/**
 * Represents a user belonging to a customer.
 * @export
 * @interface UserManagementDto
 */
export interface UserManagementDto {
    /**
     * The unique id of this user, as used by the SSO provider
     * @type {string}
     * @memberof UserManagementDto
     */
    uniqueId?: string;
    /**
     * 
     * @type {string}
     * @memberof UserManagementDto
     */
    assignedTenant?: string;
    /**
     * 
     * @type {Array&lt;EffectiveCustomerDto&gt;}
     * @memberof UserManagementDto
     */
    assignedCustomers?: Array<EffectiveCustomerDto>;
    /**
     * This is a computed property and will not be saved.
     * @type {string}
     * @memberof UserManagementDto
     */
    displayName?: string;
    /**
     * 
     * @type {string}
     * @memberof UserManagementDto
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof UserManagementDto
     */
    lastName: string;
    /**
     * Username cannot be changed after creating a new user.
     * @type {string}
     * @memberof UserManagementDto
     */
    userName: string;
    /**
     * 
     * @type {string}
     * @memberof UserManagementDto
     */
    email: string;
    /**
     * Additional emails used for notification
     * @type {Array&lt;string&gt;}
     * @memberof UserManagementDto
     */
    additionalOrderConfirmationEmails?: Array<string>;
    /**
     * Additional emails used for notification
     * @type {Array&lt;string&gt;}
     * @memberof UserManagementDto
     */
    additionalLabelPrintEmails?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof UserManagementDto
     */
    canSeePrices?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserManagementDto
     */
    highlightSpecialPrices?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserManagementDto
     */
    canSeeDiscounts?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserManagementDto
     */
    highlightDiscounts?: boolean;
    /**
     * This is a computed property and will not be saved.
     * @type {Array&lt;string&gt;}
     * @memberof UserManagementDto
     */
    roles?: Array<string>;
    /**
     * Whether this user is currently enabled, i.e. allowed to log in.
     * @type {boolean}
     * @memberof UserManagementDto
     */
    isEnabled?: boolean;
    /**
     * Whether this user is currently locked by brute-force protection
     * @type {boolean}
     * @memberof UserManagementDto
     */
    isLocked?: boolean;
    /**
     * Indicates if Best.Friend devices are assigned to the user. This is a computed property and will not be saved.
     * @type {boolean}
     * @memberof UserManagementDto
     */
    isBestfriendUser?: boolean;
    /**
     * Date and time when the use logged in the the last time successfully. This is a computed property and will not be saved.
     * @type {Date}
     * @memberof UserManagementDto
     */
    lastSuccessfulLogin?: Date;
    /**
     * Bestfriend settings of all assgined bestfriend devices.
     * @type {Array&lt;BestFriendSettingsDto&gt;}
     * @memberof UserManagementDto
     */
    assignedBestfriends?: Array<BestFriendSettingsDto>;
    /**
     * Date and time when the user data was updated last. This is a computed property and will not be saved.
     * @type {Date}
     * @memberof UserManagementDto
     */
    updateTime?: Date;
    /**
     * Date and time when user was created
     * @type {Date}
     * @memberof UserManagementDto
     */
    creationTime?: Date;
    /**
     * 
     * @type {Array&lt;UserCommentDto&gt;}
     * @memberof UserManagementDto
     */
    comments?: Array<UserCommentDto>;
    /**
     * Indicates whether images in order confirmation emails are displayed for the user or not
     * @type {boolean}
     * @memberof UserManagementDto
     */
    disableImagesInOrderConfirmationMail?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserManagementDto
     */
    locale?: string;
}

/**
 * 
 * @export
 * @interface UserManagementSearchResultDto
 */
export interface UserManagementSearchResultDto {
    /**
     * 
     * @type {PageMetadataDto}
     * @memberof UserManagementSearchResultDto
     */
    page?: PageMetadataDto;
    /**
     * 
     * @type {Array&lt;UserManagementDto&gt;}
     * @memberof UserManagementSearchResultDto
     */
    result?: Array<UserManagementDto>;
}

/**
 * A notification that is translated to a single language.
 * @export
 * @interface UserNotificationDto
 */
export interface UserNotificationDto {
    /**
     * 
     * @type {number}
     * @memberof UserNotificationDto
     */
    id: number;
    /**
     * This user's customers affected by this notification.
     * @type {Array&lt;string&gt;}
     * @memberof UserNotificationDto
     */
    targetCustomers: Array<string>;
    /**
     * Whether this notification is still unread.
     * @type {boolean}
     * @memberof UserNotificationDto
     */
    unread: boolean;
    /**
     * Day that the notification was published at.
     * @type {string}
     * @memberof UserNotificationDto
     */
    publishedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof UserNotificationDto
     */
    subject: string;
    /**
     * Unformatted notification text, may contain newlines.
     * @type {string}
     * @memberof UserNotificationDto
     */
    content: string;
    /**
     * 
     * @type {UserNotificationTypeDto}
     * @memberof UserNotificationDto
     */
    notificationType: UserNotificationTypeDto;
    /**
     * 
     * @type {Array&lt;ProductDto&gt;}
     * @memberof UserNotificationDto
     */
    attachedProducts?: Array<ProductDto>;
    /**
     * 
     * @type {UserNotificationUrlDto}
     * @memberof UserNotificationDto
     */
    attachedUrl?: UserNotificationUrlDto;
    /**
     * Whether this notification was once displayed as popup.
     * @type {boolean}
     * @memberof UserNotificationDto
     */
    isImportant?: boolean;
}

/**
 * A notification type that is translated to a single language.
 * @export
 * @interface UserNotificationTypeDto
 */
export interface UserNotificationTypeDto {
    /**
     * 
     * @type {number}
     * @memberof UserNotificationTypeDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof UserNotificationTypeDto
     */
    name?: string;
}

/**
 * A URL attached to a notification.
 * @export
 * @interface UserNotificationUrlDto
 */
export interface UserNotificationUrlDto {
    /**
     * 
     * @type {string}
     * @memberof UserNotificationUrlDto
     */
    url: string;
    /**
     * 
     * @type {string}
     * @memberof UserNotificationUrlDto
     */
    caption?: string;
}

/**
 * Result of a request for notifications concerning the current user. This only shows notifications delivered via the webshop channel and where this channel is enabled in the user's type-specific notification preferences.
 * @export
 * @interface UserNotificationsResultDto
 */
export interface UserNotificationsResultDto {
    /**
     * 
     * @type {PageMetadataDto}
     * @memberof UserNotificationsResultDto
     */
    page: PageMetadataDto;
    /**
     * 
     * @type {Array&lt;UserNotificationDto&gt;}
     * @memberof UserNotificationsResultDto
     */
    items: Array<UserNotificationDto>;
    /**
     * All notification types, for filtering.
     * @type {Array&lt;UserNotificationTypeDto&gt;}
     * @memberof UserNotificationsResultDto
     */
    allTypes: Array<UserNotificationTypeDto>;
}

/**
 * Describes changes to a user's profile
 * @export
 * @interface UserSubmitDto
 */
export interface UserSubmitDto {
    /**
     * 
     * @type {string}
     * @memberof UserSubmitDto
     */
    firstname?: string;
    /**
     * 
     * @type {string}
     * @memberof UserSubmitDto
     */
    lastname?: string;
    /**
     * 
     * @type {string}
     * @memberof UserSubmitDto
     */
    email?: string;
}

/**
 * 
 * @export
 * @interface ManagementNotificationCustomerGroupDto
 */
export interface ManagementNotificationCustomerGroupDto {
    /**
     * 
     * @type {number}
     * @memberof ManagementNotificationCustomerGroupDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ManagementNotificationCustomerGroupDto
     */
    tenant?: string;
    /**
     * 
     * @type {string}
     * @memberof ManagementNotificationCustomerGroupDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ManagementNotificationCustomerGroupDto
     */
    description?: string;
    /**
     * 
     * @type {Array&lt;EffectiveCustomerDto&gt;}
     * @memberof ManagementNotificationCustomerGroupDto
     */
    customers?: Array<EffectiveCustomerDto>;
}


/**
 * AppApi - fetch parameter creator
 * @export
 */
export const AppApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get information on a specific version of the Best.Friend app
         * @param {number} clientVersion The version to get information on
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppVersionStatus(clientVersion: number, options: any = {}): FetchArgs {
            // verify required parameter 'clientVersion' is not null or undefined
            if (clientVersion === null || clientVersion === undefined) {
                throw new RequiredError('clientVersion','Required parameter clientVersion was null or undefined when calling getAppVersionStatus.');
            }
            const localVarPath = `/app/version/{clientVersion}`
                .replace(`{${"clientVersion"}}`, encodeURIComponent(String(clientVersion)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AppApi - functional programming interface
 * @export
 */
export const AppApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get information on a specific version of the Best.Friend app
         * @param {number} clientVersion The version to get information on
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppVersionStatus(clientVersion: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<AppVersionStatusDto> {
            const localVarFetchArgs = AppApiFetchParamCreator(configuration).getAppVersionStatus(clientVersion, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * AppApi - factory interface
 * @export
 */
export const AppApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Get information on a specific version of the Best.Friend app
         * @param {number} clientVersion The version to get information on
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppVersionStatus(clientVersion: number, options?: any) {
            return AppApiFp(configuration).getAppVersionStatus(clientVersion, options)(fetch, basePath);
        },
    };
};

/**
 * AppApi - object-oriented interface
 * @export
 * @class AppApi
 * @extends {BaseAPI}
 */
export class AppApi extends BaseAPI {
    /**
     * 
     * @summary Get information on a specific version of the Best.Friend app
     * @param {} clientVersion The version to get information on
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    public getAppVersionStatus(clientVersion: number, options?: any) {
        return AppApiFp(this.configuration).getAppVersionStatus(clientVersion, options)(this.fetch, this.basePath);
    }

}

/**
 * AppOrderApi - fetch parameter creator
 * @export
 */
export const AppOrderApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Creates a new order submitted from a bf-app. For additional information see the description of the webshop-submit-order endpoint. There are some additional-fields of a new order which are only relevant for the bf-app. Hence this endpoint should be used for app-orders.
         * @summary Submit the current shopping cart into an order
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customer number of the customer to target
         * @param {AppOrderSubmitDto} [orderInformation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitAppOrderFromDefaultCart(tenant: string, customerId: string, orderInformation?: AppOrderSubmitDto, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling submitAppOrderFromDefaultCart.');
            }
            // verify required parameter 'customerId' is not null or undefined
            if (customerId === null || customerId === undefined) {
                throw new RequiredError('customerId','Required parameter customerId was null or undefined when calling submitAppOrderFromDefaultCart.');
            }
            const localVarPath = `/t/{tenant}/app/my/shopping-cart/{customerId}/submit`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"AppOrderSubmitDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(orderInformation || {}) : (orderInformation || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AppOrderApi - functional programming interface
 * @export
 */
export const AppOrderApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Creates a new order submitted from a bf-app. For additional information see the description of the webshop-submit-order endpoint. There are some additional-fields of a new order which are only relevant for the bf-app. Hence this endpoint should be used for app-orders.
         * @summary Submit the current shopping cart into an order
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customer number of the customer to target
         * @param {AppOrderSubmitDto} [orderInformation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitAppOrderFromDefaultCart(tenant: string, customerId: string, orderInformation?: AppOrderSubmitDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<OrderDto> {
            const localVarFetchArgs = AppOrderApiFetchParamCreator(configuration).submitAppOrderFromDefaultCart(tenant, customerId, orderInformation, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * AppOrderApi - factory interface
 * @export
 */
export const AppOrderApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * Creates a new order submitted from a bf-app. For additional information see the description of the webshop-submit-order endpoint. There are some additional-fields of a new order which are only relevant for the bf-app. Hence this endpoint should be used for app-orders.
         * @summary Submit the current shopping cart into an order
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customer number of the customer to target
         * @param {AppOrderSubmitDto} [orderInformation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitAppOrderFromDefaultCart(tenant: string, customerId: string, orderInformation?: AppOrderSubmitDto, options?: any) {
            return AppOrderApiFp(configuration).submitAppOrderFromDefaultCart(tenant, customerId, orderInformation, options)(fetch, basePath);
        },
    };
};

/**
 * AppOrderApi - object-oriented interface
 * @export
 * @class AppOrderApi
 * @extends {BaseAPI}
 */
export class AppOrderApi extends BaseAPI {
    /**
     * Creates a new order submitted from a bf-app. For additional information see the description of the webshop-submit-order endpoint. There are some additional-fields of a new order which are only relevant for the bf-app. Hence this endpoint should be used for app-orders.
     * @summary Submit the current shopping cart into an order
     * @param {} tenant The EGB code of the tenant to target
     * @param {} customerId The tenant-specific customer number of the customer to target
     * @param {} [orderInformation] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppOrderApi
     */
    public submitAppOrderFromDefaultCart(tenant: string, customerId: string, orderInformation?: AppOrderSubmitDto, options?: any) {
        return AppOrderApiFp(this.configuration).submitAppOrderFromDefaultCart(tenant, customerId, orderInformation, options)(this.fetch, this.basePath);
    }

}

/**
 * BestFriendOpenOrderApi - fetch parameter creator
 * @export
 */
export const BestFriendOpenOrderApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieve the list of open order submitted from a Best.Friend device for later completion in the webshop.
         * @summary Get Best.Friend open orders
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customer id to request the information for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllBestFriendOrders(tenant: string, customerId: string, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling getAllBestFriendOrders.');
            }
            // verify required parameter 'customerId' is not null or undefined
            if (customerId === null || customerId === undefined) {
                throw new RequiredError('customerId','Required parameter customerId was null or undefined when calling getAllBestFriendOrders.');
            }
            const localVarPath = `/t/{tenant}/my/bf-orders`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Best.Friend open order
         * @param {string} tenant The EGB code of the tenant to target
         * @param {number} bfOrderId The id of the best friend order
         * @param {string} customerId The tenant-specific customer id to request the information for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBestFriendOrderById(tenant: string, bfOrderId: number, customerId: string, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling getBestFriendOrderById.');
            }
            // verify required parameter 'bfOrderId' is not null or undefined
            if (bfOrderId === null || bfOrderId === undefined) {
                throw new RequiredError('bfOrderId','Required parameter bfOrderId was null or undefined when calling getBestFriendOrderById.');
            }
            // verify required parameter 'customerId' is not null or undefined
            if (customerId === null || customerId === undefined) {
                throw new RequiredError('customerId','Required parameter customerId was null or undefined when calling getBestFriendOrderById.');
            }
            const localVarPath = `/t/{tenant}/my/bf-order/{bfOrderId}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"bfOrderId"}}`, encodeURIComponent(String(bfOrderId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Paged Best.Friend open orders
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} [customerId] The tenant-specific customer id to request the information for. This will affect things such as prices and products.
         * @param {number} [page] the index of the page to retrieve
         * @param {number} [size] the amount of entries per page
         * @param {string} [sortBy] the field to sort by, or null if unsorted
         * @param {string} [sortDirection] ASC to sort in ascending order, DESC to sort in descending order. May be null if sortBy is null as well.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBfOrdersPage(tenant: string, customerId?: string, page?: number, size?: number, sortBy?: string, sortDirection?: string, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling getBfOrdersPage.');
            }
            const localVarPath = `/t/{tenant}/my/bf-orders/search`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Best.Friend open order
         * @param {string} tenant The EGB code of the tenant to target
         * @param {number} bfOrderId The id of the best friend order
         * @param {string} customerId The tenant-specific customer id to request the information for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeBestFriendOrder(tenant: string, bfOrderId: number, customerId: string, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling removeBestFriendOrder.');
            }
            // verify required parameter 'bfOrderId' is not null or undefined
            if (bfOrderId === null || bfOrderId === undefined) {
                throw new RequiredError('bfOrderId','Required parameter bfOrderId was null or undefined when calling removeBestFriendOrder.');
            }
            // verify required parameter 'customerId' is not null or undefined
            if (customerId === null || customerId === undefined) {
                throw new RequiredError('customerId','Required parameter customerId was null or undefined when calling removeBestFriendOrder.');
            }
            const localVarPath = `/t/{tenant}/my/bf-order/{bfOrderId}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"bfOrderId"}}`, encodeURIComponent(String(bfOrderId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BestFriendOpenOrderApi - functional programming interface
 * @export
 */
export const BestFriendOpenOrderApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Retrieve the list of open order submitted from a Best.Friend device for later completion in the webshop.
         * @summary Get Best.Friend open orders
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customer id to request the information for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllBestFriendOrders(tenant: string, customerId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<BfOpenOrderDto>> {
            const localVarFetchArgs = BestFriendOpenOrderApiFetchParamCreator(configuration).getAllBestFriendOrders(tenant, customerId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get Best.Friend open order
         * @param {string} tenant The EGB code of the tenant to target
         * @param {number} bfOrderId The id of the best friend order
         * @param {string} customerId The tenant-specific customer id to request the information for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBestFriendOrderById(tenant: string, bfOrderId: number, customerId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<BfOpenOrderDto> {
            const localVarFetchArgs = BestFriendOpenOrderApiFetchParamCreator(configuration).getBestFriendOrderById(tenant, bfOrderId, customerId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Paged Best.Friend open orders
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} [customerId] The tenant-specific customer id to request the information for. This will affect things such as prices and products.
         * @param {number} [page] the index of the page to retrieve
         * @param {number} [size] the amount of entries per page
         * @param {string} [sortBy] the field to sort by, or null if unsorted
         * @param {string} [sortDirection] ASC to sort in ascending order, DESC to sort in descending order. May be null if sortBy is null as well.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBfOrdersPage(tenant: string, customerId?: string, page?: number, size?: number, sortBy?: string, sortDirection?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<BfOpenOrderPageDto> {
            const localVarFetchArgs = BestFriendOpenOrderApiFetchParamCreator(configuration).getBfOrdersPage(tenant, customerId, page, size, sortBy, sortDirection, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Delete Best.Friend open order
         * @param {string} tenant The EGB code of the tenant to target
         * @param {number} bfOrderId The id of the best friend order
         * @param {string} customerId The tenant-specific customer id to request the information for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeBestFriendOrder(tenant: string, bfOrderId: number, customerId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = BestFriendOpenOrderApiFetchParamCreator(configuration).removeBestFriendOrder(tenant, bfOrderId, customerId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * BestFriendOpenOrderApi - factory interface
 * @export
 */
export const BestFriendOpenOrderApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * Retrieve the list of open order submitted from a Best.Friend device for later completion in the webshop.
         * @summary Get Best.Friend open orders
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customer id to request the information for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllBestFriendOrders(tenant: string, customerId: string, options?: any) {
            return BestFriendOpenOrderApiFp(configuration).getAllBestFriendOrders(tenant, customerId, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get Best.Friend open order
         * @param {string} tenant The EGB code of the tenant to target
         * @param {number} bfOrderId The id of the best friend order
         * @param {string} customerId The tenant-specific customer id to request the information for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBestFriendOrderById(tenant: string, bfOrderId: number, customerId: string, options?: any) {
            return BestFriendOpenOrderApiFp(configuration).getBestFriendOrderById(tenant, bfOrderId, customerId, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Paged Best.Friend open orders
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} [customerId] The tenant-specific customer id to request the information for. This will affect things such as prices and products.
         * @param {number} [page] the index of the page to retrieve
         * @param {number} [size] the amount of entries per page
         * @param {string} [sortBy] the field to sort by, or null if unsorted
         * @param {string} [sortDirection] ASC to sort in ascending order, DESC to sort in descending order. May be null if sortBy is null as well.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBfOrdersPage(tenant: string, customerId?: string, page?: number, size?: number, sortBy?: string, sortDirection?: string, options?: any) {
            return BestFriendOpenOrderApiFp(configuration).getBfOrdersPage(tenant, customerId, page, size, sortBy, sortDirection, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Delete Best.Friend open order
         * @param {string} tenant The EGB code of the tenant to target
         * @param {number} bfOrderId The id of the best friend order
         * @param {string} customerId The tenant-specific customer id to request the information for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeBestFriendOrder(tenant: string, bfOrderId: number, customerId: string, options?: any) {
            return BestFriendOpenOrderApiFp(configuration).removeBestFriendOrder(tenant, bfOrderId, customerId, options)(fetch, basePath);
        },
    };
};

/**
 * BestFriendOpenOrderApi - object-oriented interface
 * @export
 * @class BestFriendOpenOrderApi
 * @extends {BaseAPI}
 */
export class BestFriendOpenOrderApi extends BaseAPI {
    /**
     * Retrieve the list of open order submitted from a Best.Friend device for later completion in the webshop.
     * @summary Get Best.Friend open orders
     * @param {} tenant The EGB code of the tenant to target
     * @param {} customerId The tenant-specific customer id to request the information for.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BestFriendOpenOrderApi
     */
    public getAllBestFriendOrders(tenant: string, customerId: string, options?: any) {
        return BestFriendOpenOrderApiFp(this.configuration).getAllBestFriendOrders(tenant, customerId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get Best.Friend open order
     * @param {} tenant The EGB code of the tenant to target
     * @param {} bfOrderId The id of the best friend order
     * @param {} customerId The tenant-specific customer id to request the information for.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BestFriendOpenOrderApi
     */
    public getBestFriendOrderById(tenant: string, bfOrderId: number, customerId: string, options?: any) {
        return BestFriendOpenOrderApiFp(this.configuration).getBestFriendOrderById(tenant, bfOrderId, customerId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Paged Best.Friend open orders
     * @param {} tenant The EGB code of the tenant to target
     * @param {} [customerId] The tenant-specific customer id to request the information for. This will affect things such as prices and products.
     * @param {} [page] the index of the page to retrieve
     * @param {} [size] the amount of entries per page
     * @param {} [sortBy] the field to sort by, or null if unsorted
     * @param {} [sortDirection] ASC to sort in ascending order, DESC to sort in descending order. May be null if sortBy is null as well.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BestFriendOpenOrderApi
     */
    public getBfOrdersPage(tenant: string, customerId?: string, page?: number, size?: number, sortBy?: string, sortDirection?: string, options?: any) {
        return BestFriendOpenOrderApiFp(this.configuration).getBfOrdersPage(tenant, customerId, page, size, sortBy, sortDirection, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Delete Best.Friend open order
     * @param {} tenant The EGB code of the tenant to target
     * @param {} bfOrderId The id of the best friend order
     * @param {} customerId The tenant-specific customer id to request the information for.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BestFriendOpenOrderApi
     */
    public removeBestFriendOrder(tenant: string, bfOrderId: number, customerId: string, options?: any) {
        return BestFriendOpenOrderApiFp(this.configuration).removeBestFriendOrder(tenant, bfOrderId, customerId, options)(this.fetch, this.basePath);
    }

}

/**
 * CategoriesApi - fetch parameter creator
 * @export
 */
export const CategoriesApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieve a list of all root categories. These are categories that do not have a parent. Virtual categories are not included.
         * @summary Get root categories
         * @param {string} tenant The EGB code of the tenant to target
         * @param {boolean} [hideEmpty] Whether to omit empty and inactive categories.
         * @param {string} [customerId] The customer id to be able to apply catalog restrictions.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRootCategories(tenant: string, hideEmpty?: boolean, customerId?: string, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling getRootCategories.');
            }
            const localVarPath = `/t/{tenant}/categories/rootCategories`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuthOptional required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuthOptional", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (hideEmpty !== undefined) {
                localVarQueryParameter['hideEmpty'] = hideEmpty;
            }

            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve sub-categories, that is, categories that have any of given base categories as their direct parent. Virtual categories are ignored here.
         * @summary Find sub-categories
         * @param {string} tenant The EGB code of the tenant to target
         * @param {Array&lt;string&gt;} baseIds The ids of the base categories to retrieve direct children of
         * @param {boolean} [hideEmpty] Whether to hide empty and inactive categories.
         * @param {string} [customerId] The customer id to be able to apply catalog restrictions.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubCategories(tenant: string, baseIds: Array<string>, hideEmpty?: boolean, customerId?: string, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling getSubCategories.');
            }
            // verify required parameter 'baseIds' is not null or undefined
            if (baseIds === null || baseIds === undefined) {
                throw new RequiredError('baseIds','Required parameter baseIds was null or undefined when calling getSubCategories.');
            }
            const localVarPath = `/t/{tenant}/categories/subOf/`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuthOptional required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuthOptional", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (baseIds) {
                localVarQueryParameter['baseIds'] = baseIds.join(COLLECTION_FORMATS["csv"]);
            }

            if (hideEmpty !== undefined) {
                localVarQueryParameter['hideEmpty'] = hideEmpty;
            }

            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve virtual categories that contain active products
         * @param {string} tenant The EGB code of the tenant to target
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVirtualCategories(tenant: string, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling getVirtualCategories.');
            }
            const localVarPath = `/t/{tenant}/categories/virtualCategories`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CategoriesApi - functional programming interface
 * @export
 */
export const CategoriesApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Retrieve a list of all root categories. These are categories that do not have a parent. Virtual categories are not included.
         * @summary Get root categories
         * @param {string} tenant The EGB code of the tenant to target
         * @param {boolean} [hideEmpty] Whether to omit empty and inactive categories.
         * @param {string} [customerId] The customer id to be able to apply catalog restrictions.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRootCategories(tenant: string, hideEmpty?: boolean, customerId?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<CategoryDto>> {
            const localVarFetchArgs = CategoriesApiFetchParamCreator(configuration).getRootCategories(tenant, hideEmpty, customerId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Retrieve sub-categories, that is, categories that have any of given base categories as their direct parent. Virtual categories are ignored here.
         * @summary Find sub-categories
         * @param {string} tenant The EGB code of the tenant to target
         * @param {Array&lt;string&gt;} baseIds The ids of the base categories to retrieve direct children of
         * @param {boolean} [hideEmpty] Whether to hide empty and inactive categories.
         * @param {string} [customerId] The customer id to be able to apply catalog restrictions.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubCategories(tenant: string, baseIds: Array<string>, hideEmpty?: boolean, customerId?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<CategoryDto>> {
            const localVarFetchArgs = CategoriesApiFetchParamCreator(configuration).getSubCategories(tenant, baseIds, hideEmpty, customerId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Retrieve virtual categories that contain active products
         * @param {string} tenant The EGB code of the tenant to target
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVirtualCategories(tenant: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<CategoryDto>> {
            const localVarFetchArgs = CategoriesApiFetchParamCreator(configuration).getVirtualCategories(tenant, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * CategoriesApi - factory interface
 * @export
 */
export const CategoriesApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * Retrieve a list of all root categories. These are categories that do not have a parent. Virtual categories are not included.
         * @summary Get root categories
         * @param {string} tenant The EGB code of the tenant to target
         * @param {boolean} [hideEmpty] Whether to omit empty and inactive categories.
         * @param {string} [customerId] The customer id to be able to apply catalog restrictions.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRootCategories(tenant: string, hideEmpty?: boolean, customerId?: string, options?: any) {
            return CategoriesApiFp(configuration).getRootCategories(tenant, hideEmpty, customerId, options)(fetch, basePath);
        },
        /**
         * Retrieve sub-categories, that is, categories that have any of given base categories as their direct parent. Virtual categories are ignored here.
         * @summary Find sub-categories
         * @param {string} tenant The EGB code of the tenant to target
         * @param {Array&lt;string&gt;} baseIds The ids of the base categories to retrieve direct children of
         * @param {boolean} [hideEmpty] Whether to hide empty and inactive categories.
         * @param {string} [customerId] The customer id to be able to apply catalog restrictions.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubCategories(tenant: string, baseIds: Array<string>, hideEmpty?: boolean, customerId?: string, options?: any) {
            return CategoriesApiFp(configuration).getSubCategories(tenant, baseIds, hideEmpty, customerId, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Retrieve virtual categories that contain active products
         * @param {string} tenant The EGB code of the tenant to target
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVirtualCategories(tenant: string, options?: any) {
            return CategoriesApiFp(configuration).getVirtualCategories(tenant, options)(fetch, basePath);
        },
    };
};

/**
 * CategoriesApi - object-oriented interface
 * @export
 * @class CategoriesApi
 * @extends {BaseAPI}
 */
export class CategoriesApi extends BaseAPI {
    /**
     * Retrieve a list of all root categories. These are categories that do not have a parent. Virtual categories are not included.
     * @summary Get root categories
     * @param {} tenant The EGB code of the tenant to target
     * @param {} [hideEmpty] Whether to omit empty and inactive categories.
     * @param {} [customerId] The customer id to be able to apply catalog restrictions.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoriesApi
     */
    public getRootCategories(tenant: string, hideEmpty?: boolean, customerId?: string, options?: any) {
        return CategoriesApiFp(this.configuration).getRootCategories(tenant, hideEmpty, customerId, options)(this.fetch, this.basePath);
    }

    /**
     * Retrieve sub-categories, that is, categories that have any of given base categories as their direct parent. Virtual categories are ignored here.
     * @summary Find sub-categories
     * @param {} tenant The EGB code of the tenant to target
     * @param {} baseIds The ids of the base categories to retrieve direct children of
     * @param {} [hideEmpty] Whether to hide empty and inactive categories.
     * @param {} [customerId] The customer id to be able to apply catalog restrictions.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoriesApi
     */
    public getSubCategories(tenant: string, baseIds: Array<string>, hideEmpty?: boolean, customerId?: string, options?: any) {
        return CategoriesApiFp(this.configuration).getSubCategories(tenant, baseIds, hideEmpty, customerId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Retrieve virtual categories that contain active products
     * @param {} tenant The EGB code of the tenant to target
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoriesApi
     */
    public getVirtualCategories(tenant: string, options?: any) {
        return CategoriesApiFp(this.configuration).getVirtualCategories(tenant, options)(this.fetch, this.basePath);
    }

}

/**
 * CustomersApi - fetch parameter creator
 * @export
 */
export const CustomersApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns true if and only if given customer has any own special order templates
         * @summary Does this customer have a special order template?
         * @param {string} tenant The tenant of the customer to target
         * @param {string} customerId The tenant-specific customerId of the customer to target
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doesCurrentCustomerHaveSpecialCart(tenant: string, customerId: string, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling doesCurrentCustomerHaveSpecialCart.');
            }
            // verify required parameter 'customerId' is not null or undefined
            if (customerId === null || customerId === undefined) {
                throw new RequiredError('customerId','Required parameter customerId was null or undefined when calling doesCurrentCustomerHaveSpecialCart.');
            }
            const localVarPath = `/customers/doesCurrentCustomerHaveSpecialCart/{tenant}/{customerId}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns true if and only if given customer has any user assigned that has a Best.Friend device assigned to them.
         * @summary Does this customer have a Best.Friend device?
         * @param {string} tenant The tenant of the customer to target
         * @param {string} customerId The tenant-specific customerId of the customer to target
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doesCustomerHaveBFUser(tenant: string, customerId: string, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling doesCustomerHaveBFUser.');
            }
            // verify required parameter 'customerId' is not null or undefined
            if (customerId === null || customerId === undefined) {
                throw new RequiredError('customerId','Required parameter customerId was null or undefined when calling doesCustomerHaveBFUser.');
            }
            const localVarPath = `/customers/doesCustomerHaveBFUser/{tenant}/{customerId}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve the non-empty and non-null emails to send order confirmations to for the current user. This includes the user's profile email address.
         * @summary Get order email addresses of current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfirmationEmails(options: any = {}): FetchArgs {
            const localVarPath = `/user/confirmation-emails`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get customers of current user
         * @param {string} tenant Tenant to limit results to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomersOfCurrentUser(tenant: string, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling getCustomersOfCurrentUser.');
            }
            const localVarPath = `/user/customers`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (tenant !== undefined) {
                localVarQueryParameter['tenant'] = tenant;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves delivery addresses for orders for a single customer. Each address may have multiple distinct unloading areas, which designate different positions to deliver to at the same address, e.g. front door or warehouse.
         * @summary Get delivery addresses with unloading areas of a customer
         * @param {string} tenant The tenant of the customer to target
         * @param {string} customerId The tenant-specific customerId of the customer to target
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeliveryAddresses(tenant: string, customerId: string, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling getDeliveryAddresses.');
            }
            // verify required parameter 'customerId' is not null or undefined
            if (customerId === null || customerId === undefined) {
                throw new RequiredError('customerId','Required parameter customerId was null or undefined when calling getDeliveryAddresses.');
            }
            const localVarPath = `/effective-customers/{tenant}/{customerId}/delivery-addresses`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get effective customer
         * @param {string} tenant The tenant of the customer to target
         * @param {string} customerId The tenant-specific customerId of the customer to target
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEffectiveCustomerByTenantAndCustomerId(tenant: string, customerId: string, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling getEffectiveCustomerByTenantAndCustomerId.');
            }
            // verify required parameter 'customerId' is not null or undefined
            if (customerId === null || customerId === undefined) {
                throw new RequiredError('customerId','Required parameter customerId was null or undefined when calling getEffectiveCustomerByTenantAndCustomerId.');
            }
            const localVarPath = `/effective-customers/{tenant}/{customerId}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the list of available delivery slots for a given customer. These are used to determine when an order should be delivered. Slots will be from the next n days, where n is a customer-specific integer.
         * @summary Get delivery slots for an effective customer
         * @param {string} tenant The tenant of the customer to target
         * @param {string} customerId The tenant-specific customerId of the customer to target
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEffectiveCustomerDeliverySlots(tenant: string, customerId: string, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling getEffectiveCustomerDeliverySlots.');
            }
            // verify required parameter 'customerId' is not null or undefined
            if (customerId === null || customerId === undefined) {
                throw new RequiredError('customerId','Required parameter customerId was null or undefined when calling getEffectiveCustomerDeliverySlots.');
            }
            const localVarPath = `/effective-customers/{tenant}/{customerId}/delivery-slots`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get invoices of customer
         * @param {string} tenant The tenant of the customer to target
         * @param {string} customerId The tenant-specific customerId of the customer to target
         * @param {string} type Format of the invoice to return
         * @param {number} [pageNumber] Zero-based page number
         * @param {number} [pageSize] Page size
         * @param {string} [sortDirection] ASC to sort in ascending order, DESC to sort in descending order.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEffectiveCustomerInvoicesByTenantAndCustomerId(tenant: string, customerId: string, type: string, pageNumber?: number, pageSize?: number, sortDirection?: string, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling getEffectiveCustomerInvoicesByTenantAndCustomerId.');
            }
            // verify required parameter 'customerId' is not null or undefined
            if (customerId === null || customerId === undefined) {
                throw new RequiredError('customerId','Required parameter customerId was null or undefined when calling getEffectiveCustomerInvoicesByTenantAndCustomerId.');
            }
            // verify required parameter 'type' is not null or undefined
            if (type === null || type === undefined) {
                throw new RequiredError('type','Required parameter type was null or undefined when calling getEffectiveCustomerInvoicesByTenantAndCustomerId.');
            }
            const localVarPath = `/effective-customers/{tenant}/{customerId}/receipt/{type}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)))
                .replace(`{${"type"}}`, encodeURIComponent(String(type)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get an order of a customer
         * @param {string} tenant The tenant of the customer to target
         * @param {string} customerId The tenant-specific customerId of the customer to target
         * @param {string} orderId The unique id of the order to find
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEffectiveCustomerOrderById(tenant: string, customerId: string, orderId: string, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling getEffectiveCustomerOrderById.');
            }
            // verify required parameter 'customerId' is not null or undefined
            if (customerId === null || customerId === undefined) {
                throw new RequiredError('customerId','Required parameter customerId was null or undefined when calling getEffectiveCustomerOrderById.');
            }
            // verify required parameter 'orderId' is not null or undefined
            if (orderId === null || orderId === undefined) {
                throw new RequiredError('orderId','Required parameter orderId was null or undefined when calling getEffectiveCustomerOrderById.');
            }
            const localVarPath = `/effective-customers/{tenant}/{customerId}/order/{orderId}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)))
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get orders of a customer
         * @param {string} tenant The tenant of the customer to target
         * @param {string} customerId The tenant-specific customerId of the customer to target
         * @param {string} [sortBy] Field to sort by
         * @param {string} [sortDirection] Direction to sort in
         * @param {number} [page] Zero-based page number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEffectiveCustomerOrders(tenant: string, customerId: string, sortBy?: string, sortDirection?: string, page?: number, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling getEffectiveCustomerOrders.');
            }
            // verify required parameter 'customerId' is not null or undefined
            if (customerId === null || customerId === undefined) {
                throw new RequiredError('customerId','Required parameter customerId was null or undefined when calling getEffectiveCustomerOrders.');
            }
            const localVarPath = `/effective-customers/{tenant}/{customerId}/orders`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get an invoice as PDF
         * @param {string} tenant The tenant of the effective customer to target
         * @param {string} customerId The tenant-specific customerId of the effective customer to target
         * @param {string} documentNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEffectiveCustomerReceiptPdf(tenant: string, customerId: string, documentNumber: string, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling getEffectiveCustomerReceiptPdf.');
            }
            // verify required parameter 'customerId' is not null or undefined
            if (customerId === null || customerId === undefined) {
                throw new RequiredError('customerId','Required parameter customerId was null or undefined when calling getEffectiveCustomerReceiptPdf.');
            }
            // verify required parameter 'documentNumber' is not null or undefined
            if (documentNumber === null || documentNumber === undefined) {
                throw new RequiredError('documentNumber','Required parameter documentNumber was null or undefined when calling getEffectiveCustomerReceiptPdf.');
            }
            const localVarPath = `/effective-customers/{tenant}/{customerId}/receipt/{documentNumber}/pdf`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)))
                .replace(`{${"documentNumber"}}`, encodeURIComponent(String(documentNumber)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the single invoice address of a customer. This is related to but not the same as a delivery address. Invoice addresses do not have an unloading area and are only used for invoice generation.
         * @summary Get invoice address of a customer
         * @param {string} tenant The tenant of the customer to target
         * @param {string} customerId The customerId of the customer to target
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoiceAddress(tenant: string, customerId: string, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling getInvoiceAddress.');
            }
            // verify required parameter 'customerId' is not null or undefined
            if (customerId === null || customerId === undefined) {
                throw new RequiredError('customerId','Required parameter customerId was null or undefined when calling getInvoiceAddress.');
            }
            const localVarPath = `/effective-customers/{tenant}/{customerId}/invoice-address`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get product restriction of customer
         * @param {string} tenant Tenant to limit results to
         * @param {string} customerId tenant-specific customer id to request info for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductRestrictionOfCustomer(tenant: string, customerId: string, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling getProductRestrictionOfCustomer.');
            }
            // verify required parameter 'customerId' is not null or undefined
            if (customerId === null || customerId === undefined) {
                throw new RequiredError('customerId','Required parameter customerId was null or undefined when calling getProductRestrictionOfCustomer.');
            }
            const localVarPath = `/t/{tenant}/user/customers/{customerId}/product-restriction`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomersApi - functional programming interface
 * @export
 */
export const CustomersApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Returns true if and only if given customer has any own special order templates
         * @summary Does this customer have a special order template?
         * @param {string} tenant The tenant of the customer to target
         * @param {string} customerId The tenant-specific customerId of the customer to target
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doesCurrentCustomerHaveSpecialCart(tenant: string, customerId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<BooleanResponse> {
            const localVarFetchArgs = CustomersApiFetchParamCreator(configuration).doesCurrentCustomerHaveSpecialCart(tenant, customerId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns true if and only if given customer has any user assigned that has a Best.Friend device assigned to them.
         * @summary Does this customer have a Best.Friend device?
         * @param {string} tenant The tenant of the customer to target
         * @param {string} customerId The tenant-specific customerId of the customer to target
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doesCustomerHaveBFUser(tenant: string, customerId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<BooleanResponse> {
            const localVarFetchArgs = CustomersApiFetchParamCreator(configuration).doesCustomerHaveBFUser(tenant, customerId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Retrieve the non-empty and non-null emails to send order confirmations to for the current user. This includes the user's profile email address.
         * @summary Get order email addresses of current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfirmationEmails(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<string>> {
            const localVarFetchArgs = CustomersApiFetchParamCreator(configuration).getConfirmationEmails(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get customers of current user
         * @param {string} tenant Tenant to limit results to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomersOfCurrentUser(tenant: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<EffectiveCustomerDto>> {
            const localVarFetchArgs = CustomersApiFetchParamCreator(configuration).getCustomersOfCurrentUser(tenant, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Retrieves delivery addresses for orders for a single customer. Each address may have multiple distinct unloading areas, which designate different positions to deliver to at the same address, e.g. front door or warehouse.
         * @summary Get delivery addresses with unloading areas of a customer
         * @param {string} tenant The tenant of the customer to target
         * @param {string} customerId The tenant-specific customerId of the customer to target
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeliveryAddresses(tenant: string, customerId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<DeliveryAddressDto>> {
            const localVarFetchArgs = CustomersApiFetchParamCreator(configuration).getDeliveryAddresses(tenant, customerId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get effective customer
         * @param {string} tenant The tenant of the customer to target
         * @param {string} customerId The tenant-specific customerId of the customer to target
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEffectiveCustomerByTenantAndCustomerId(tenant: string, customerId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<EffectiveCustomerDto> {
            const localVarFetchArgs = CustomersApiFetchParamCreator(configuration).getEffectiveCustomerByTenantAndCustomerId(tenant, customerId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Retrieves the list of available delivery slots for a given customer. These are used to determine when an order should be delivered. Slots will be from the next n days, where n is a customer-specific integer.
         * @summary Get delivery slots for an effective customer
         * @param {string} tenant The tenant of the customer to target
         * @param {string} customerId The tenant-specific customerId of the customer to target
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEffectiveCustomerDeliverySlots(tenant: string, customerId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<AvailableDeliverySlotDto>> {
            const localVarFetchArgs = CustomersApiFetchParamCreator(configuration).getEffectiveCustomerDeliverySlots(tenant, customerId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get invoices of customer
         * @param {string} tenant The tenant of the customer to target
         * @param {string} customerId The tenant-specific customerId of the customer to target
         * @param {string} type Format of the invoice to return
         * @param {number} [pageNumber] Zero-based page number
         * @param {number} [pageSize] Page size
         * @param {string} [sortDirection] ASC to sort in ascending order, DESC to sort in descending order.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEffectiveCustomerInvoicesByTenantAndCustomerId(tenant: string, customerId: string, type: string, pageNumber?: number, pageSize?: number, sortDirection?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<InvoicesDto> {
            const localVarFetchArgs = CustomersApiFetchParamCreator(configuration).getEffectiveCustomerInvoicesByTenantAndCustomerId(tenant, customerId, type, pageNumber, pageSize, sortDirection, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get an order of a customer
         * @param {string} tenant The tenant of the customer to target
         * @param {string} customerId The tenant-specific customerId of the customer to target
         * @param {string} orderId The unique id of the order to find
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEffectiveCustomerOrderById(tenant: string, customerId: string, orderId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<OrderDto> {
            const localVarFetchArgs = CustomersApiFetchParamCreator(configuration).getEffectiveCustomerOrderById(tenant, customerId, orderId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get orders of a customer
         * @param {string} tenant The tenant of the customer to target
         * @param {string} customerId The tenant-specific customerId of the customer to target
         * @param {string} [sortBy] Field to sort by
         * @param {string} [sortDirection] Direction to sort in
         * @param {number} [page] Zero-based page number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEffectiveCustomerOrders(tenant: string, customerId: string, sortBy?: string, sortDirection?: string, page?: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<PagedOrdersDto> {
            const localVarFetchArgs = CustomersApiFetchParamCreator(configuration).getEffectiveCustomerOrders(tenant, customerId, sortBy, sortDirection, page, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get an invoice as PDF
         * @param {string} tenant The tenant of the effective customer to target
         * @param {string} customerId The tenant-specific customerId of the effective customer to target
         * @param {string} documentNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEffectiveCustomerReceiptPdf(tenant: string, customerId: string, documentNumber: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = CustomersApiFetchParamCreator(configuration).getEffectiveCustomerReceiptPdf(tenant, customerId, documentNumber, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Retrieves the single invoice address of a customer. This is related to but not the same as a delivery address. Invoice addresses do not have an unloading area and are only used for invoice generation.
         * @summary Get invoice address of a customer
         * @param {string} tenant The tenant of the customer to target
         * @param {string} customerId The customerId of the customer to target
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoiceAddress(tenant: string, customerId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CustomerAddressDto> {
            const localVarFetchArgs = CustomersApiFetchParamCreator(configuration).getInvoiceAddress(tenant, customerId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get product restriction of customer
         * @param {string} tenant Tenant to limit results to
         * @param {string} customerId tenant-specific customer id to request info for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductRestrictionOfCustomer(tenant: string, customerId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ProductRestrictionDto> {
            const localVarFetchArgs = CustomersApiFetchParamCreator(configuration).getProductRestrictionOfCustomer(tenant, customerId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * CustomersApi - factory interface
 * @export
 */
export const CustomersApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * Returns true if and only if given customer has any own special order templates
         * @summary Does this customer have a special order template?
         * @param {string} tenant The tenant of the customer to target
         * @param {string} customerId The tenant-specific customerId of the customer to target
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doesCurrentCustomerHaveSpecialCart(tenant: string, customerId: string, options?: any) {
            return CustomersApiFp(configuration).doesCurrentCustomerHaveSpecialCart(tenant, customerId, options)(fetch, basePath);
        },
        /**
         * Returns true if and only if given customer has any user assigned that has a Best.Friend device assigned to them.
         * @summary Does this customer have a Best.Friend device?
         * @param {string} tenant The tenant of the customer to target
         * @param {string} customerId The tenant-specific customerId of the customer to target
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doesCustomerHaveBFUser(tenant: string, customerId: string, options?: any) {
            return CustomersApiFp(configuration).doesCustomerHaveBFUser(tenant, customerId, options)(fetch, basePath);
        },
        /**
         * Retrieve the non-empty and non-null emails to send order confirmations to for the current user. This includes the user's profile email address.
         * @summary Get order email addresses of current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfirmationEmails(options?: any) {
            return CustomersApiFp(configuration).getConfirmationEmails(options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get customers of current user
         * @param {string} tenant Tenant to limit results to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomersOfCurrentUser(tenant: string, options?: any) {
            return CustomersApiFp(configuration).getCustomersOfCurrentUser(tenant, options)(fetch, basePath);
        },
        /**
         * Retrieves delivery addresses for orders for a single customer. Each address may have multiple distinct unloading areas, which designate different positions to deliver to at the same address, e.g. front door or warehouse.
         * @summary Get delivery addresses with unloading areas of a customer
         * @param {string} tenant The tenant of the customer to target
         * @param {string} customerId The tenant-specific customerId of the customer to target
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeliveryAddresses(tenant: string, customerId: string, options?: any) {
            return CustomersApiFp(configuration).getDeliveryAddresses(tenant, customerId, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get effective customer
         * @param {string} tenant The tenant of the customer to target
         * @param {string} customerId The tenant-specific customerId of the customer to target
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEffectiveCustomerByTenantAndCustomerId(tenant: string, customerId: string, options?: any) {
            return CustomersApiFp(configuration).getEffectiveCustomerByTenantAndCustomerId(tenant, customerId, options)(fetch, basePath);
        },
        /**
         * Retrieves the list of available delivery slots for a given customer. These are used to determine when an order should be delivered. Slots will be from the next n days, where n is a customer-specific integer.
         * @summary Get delivery slots for an effective customer
         * @param {string} tenant The tenant of the customer to target
         * @param {string} customerId The tenant-specific customerId of the customer to target
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEffectiveCustomerDeliverySlots(tenant: string, customerId: string, options?: any) {
            return CustomersApiFp(configuration).getEffectiveCustomerDeliverySlots(tenant, customerId, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get invoices of customer
         * @param {string} tenant The tenant of the customer to target
         * @param {string} customerId The tenant-specific customerId of the customer to target
         * @param {string} type Format of the invoice to return
         * @param {number} [pageNumber] Zero-based page number
         * @param {number} [pageSize] Page size
         * @param {string} [sortDirection] ASC to sort in ascending order, DESC to sort in descending order.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEffectiveCustomerInvoicesByTenantAndCustomerId(tenant: string, customerId: string, type: string, pageNumber?: number, pageSize?: number, sortDirection?: string, options?: any) {
            return CustomersApiFp(configuration).getEffectiveCustomerInvoicesByTenantAndCustomerId(tenant, customerId, type, pageNumber, pageSize, sortDirection, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get an order of a customer
         * @param {string} tenant The tenant of the customer to target
         * @param {string} customerId The tenant-specific customerId of the customer to target
         * @param {string} orderId The unique id of the order to find
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEffectiveCustomerOrderById(tenant: string, customerId: string, orderId: string, options?: any) {
            return CustomersApiFp(configuration).getEffectiveCustomerOrderById(tenant, customerId, orderId, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get orders of a customer
         * @param {string} tenant The tenant of the customer to target
         * @param {string} customerId The tenant-specific customerId of the customer to target
         * @param {string} [sortBy] Field to sort by
         * @param {string} [sortDirection] Direction to sort in
         * @param {number} [page] Zero-based page number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEffectiveCustomerOrders(tenant: string, customerId: string, sortBy?: string, sortDirection?: string, page?: number, options?: any) {
            return CustomersApiFp(configuration).getEffectiveCustomerOrders(tenant, customerId, sortBy, sortDirection, page, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get an invoice as PDF
         * @param {string} tenant The tenant of the effective customer to target
         * @param {string} customerId The tenant-specific customerId of the effective customer to target
         * @param {string} documentNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEffectiveCustomerReceiptPdf(tenant: string, customerId: string, documentNumber: string, options?: any) {
            return CustomersApiFp(configuration).getEffectiveCustomerReceiptPdf(tenant, customerId, documentNumber, options)(fetch, basePath);
        },
        /**
         * Retrieves the single invoice address of a customer. This is related to but not the same as a delivery address. Invoice addresses do not have an unloading area and are only used for invoice generation.
         * @summary Get invoice address of a customer
         * @param {string} tenant The tenant of the customer to target
         * @param {string} customerId The customerId of the customer to target
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoiceAddress(tenant: string, customerId: string, options?: any) {
            return CustomersApiFp(configuration).getInvoiceAddress(tenant, customerId, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get product restriction of customer
         * @param {string} tenant Tenant to limit results to
         * @param {string} customerId tenant-specific customer id to request info for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductRestrictionOfCustomer(tenant: string, customerId: string, options?: any) {
            return CustomersApiFp(configuration).getProductRestrictionOfCustomer(tenant, customerId, options)(fetch, basePath);
        },
    };
};

/**
 * CustomersApi - object-oriented interface
 * @export
 * @class CustomersApi
 * @extends {BaseAPI}
 */
export class CustomersApi extends BaseAPI {
    /**
     * Returns true if and only if given customer has any own special order templates
     * @summary Does this customer have a special order template?
     * @param {} tenant The tenant of the customer to target
     * @param {} customerId The tenant-specific customerId of the customer to target
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    public doesCurrentCustomerHaveSpecialCart(tenant: string, customerId: string, options?: any) {
        return CustomersApiFp(this.configuration).doesCurrentCustomerHaveSpecialCart(tenant, customerId, options)(this.fetch, this.basePath);
    }

    /**
     * Returns true if and only if given customer has any user assigned that has a Best.Friend device assigned to them.
     * @summary Does this customer have a Best.Friend device?
     * @param {} tenant The tenant of the customer to target
     * @param {} customerId The tenant-specific customerId of the customer to target
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    public doesCustomerHaveBFUser(tenant: string, customerId: string, options?: any) {
        return CustomersApiFp(this.configuration).doesCustomerHaveBFUser(tenant, customerId, options)(this.fetch, this.basePath);
    }

    /**
     * Retrieve the non-empty and non-null emails to send order confirmations to for the current user. This includes the user's profile email address.
     * @summary Get order email addresses of current user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    public getConfirmationEmails(options?: any) {
        return CustomersApiFp(this.configuration).getConfirmationEmails(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get customers of current user
     * @param {} tenant Tenant to limit results to
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    public getCustomersOfCurrentUser(tenant: string, options?: any) {
        return CustomersApiFp(this.configuration).getCustomersOfCurrentUser(tenant, options)(this.fetch, this.basePath);
    }

    /**
     * Retrieves delivery addresses for orders for a single customer. Each address may have multiple distinct unloading areas, which designate different positions to deliver to at the same address, e.g. front door or warehouse.
     * @summary Get delivery addresses with unloading areas of a customer
     * @param {} tenant The tenant of the customer to target
     * @param {} customerId The tenant-specific customerId of the customer to target
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    public getDeliveryAddresses(tenant: string, customerId: string, options?: any) {
        return CustomersApiFp(this.configuration).getDeliveryAddresses(tenant, customerId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get effective customer
     * @param {} tenant The tenant of the customer to target
     * @param {} customerId The tenant-specific customerId of the customer to target
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    public getEffectiveCustomerByTenantAndCustomerId(tenant: string, customerId: string, options?: any) {
        return CustomersApiFp(this.configuration).getEffectiveCustomerByTenantAndCustomerId(tenant, customerId, options)(this.fetch, this.basePath);
    }

    /**
     * Retrieves the list of available delivery slots for a given customer. These are used to determine when an order should be delivered. Slots will be from the next n days, where n is a customer-specific integer.
     * @summary Get delivery slots for an effective customer
     * @param {} tenant The tenant of the customer to target
     * @param {} customerId The tenant-specific customerId of the customer to target
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    public getEffectiveCustomerDeliverySlots(tenant: string, customerId: string, options?: any) {
        return CustomersApiFp(this.configuration).getEffectiveCustomerDeliverySlots(tenant, customerId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get invoices of customer
     * @param {} tenant The tenant of the customer to target
     * @param {} customerId The tenant-specific customerId of the customer to target
     * @param {} type Format of the invoice to return
     * @param {} [pageNumber] Zero-based page number
     * @param {} [pageSize] Page size
     * @param {} [sortDirection] ASC to sort in ascending order, DESC to sort in descending order.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    public getEffectiveCustomerInvoicesByTenantAndCustomerId(tenant: string, customerId: string, type: string, pageNumber?: number, pageSize?: number, sortDirection?: string, options?: any) {
        return CustomersApiFp(this.configuration).getEffectiveCustomerInvoicesByTenantAndCustomerId(tenant, customerId, type, pageNumber, pageSize, sortDirection, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get an order of a customer
     * @param {} tenant The tenant of the customer to target
     * @param {} customerId The tenant-specific customerId of the customer to target
     * @param {} orderId The unique id of the order to find
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    public getEffectiveCustomerOrderById(tenant: string, customerId: string, orderId: string, options?: any) {
        return CustomersApiFp(this.configuration).getEffectiveCustomerOrderById(tenant, customerId, orderId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get orders of a customer
     * @param {} tenant The tenant of the customer to target
     * @param {} customerId The tenant-specific customerId of the customer to target
     * @param {} [sortBy] Field to sort by
     * @param {} [sortDirection] Direction to sort in
     * @param {} [page] Zero-based page number
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    public getEffectiveCustomerOrders(tenant: string, customerId: string, sortBy?: string, sortDirection?: string, page?: number, options?: any) {
        return CustomersApiFp(this.configuration).getEffectiveCustomerOrders(tenant, customerId, sortBy, sortDirection, page, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get an invoice as PDF
     * @param {} tenant The tenant of the effective customer to target
     * @param {} customerId The tenant-specific customerId of the effective customer to target
     * @param {} documentNumber 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    public getEffectiveCustomerReceiptPdf(tenant: string, customerId: string, documentNumber: string, options?: any) {
        return CustomersApiFp(this.configuration).getEffectiveCustomerReceiptPdf(tenant, customerId, documentNumber, options)(this.fetch, this.basePath);
    }

    /**
     * Retrieves the single invoice address of a customer. This is related to but not the same as a delivery address. Invoice addresses do not have an unloading area and are only used for invoice generation.
     * @summary Get invoice address of a customer
     * @param {} tenant The tenant of the customer to target
     * @param {} customerId The customerId of the customer to target
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    public getInvoiceAddress(tenant: string, customerId: string, options?: any) {
        return CustomersApiFp(this.configuration).getInvoiceAddress(tenant, customerId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get product restriction of customer
     * @param {} tenant Tenant to limit results to
     * @param {} customerId tenant-specific customer id to request info for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    public getProductRestrictionOfCustomer(tenant: string, customerId: string, options?: any) {
        return CustomersApiFp(this.configuration).getProductRestrictionOfCustomer(tenant, customerId, options)(this.fetch, this.basePath);
    }

}

/**
 * EssencesApi - fetch parameter creator
 * @export
 */
export const EssencesApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customerId of the effective customer to target
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllergensExcel(tenant: string, customerId: string, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling getAllergensExcel.');
            }
            // verify required parameter 'customerId' is not null or undefined
            if (customerId === null || customerId === undefined) {
                throw new RequiredError('customerId','Required parameter customerId was null or undefined when calling getAllergensExcel.');
            }
            const localVarPath = `/t/{tenant}/allergens/excel`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generate a PDF showing given customer's essence list. This will take some time for larger essence lists.
         * @summary Get a base64-encoded PDF showing the essence list
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The customer id to request the information for.
         * @param {boolean} [showImages] Whether to show images and barcodes in the PDF.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEssenceListPdf(tenant: string, customerId: string, showImages?: boolean, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling getEssenceListPdf.');
            }
            // verify required parameter 'customerId' is not null or undefined
            if (customerId === null || customerId === undefined) {
                throw new RequiredError('customerId','Required parameter customerId was null or undefined when calling getEssenceListPdf.');
            }
            const localVarPath = `/t/{tenant}/essence-list/pdf`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }

            if (showImages !== undefined) {
                localVarQueryParameter['showImages'] = showImages;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Like the bulk endpoint for this, but only for a single product.
         * @summary Get last three essence items for single product
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The customer id to request the information for.
         * @param {string} sku The SKU of the product to request essence items for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLastThreeEssenceItems(tenant: string, customerId: string, sku: string, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling getLastThreeEssenceItems.');
            }
            // verify required parameter 'customerId' is not null or undefined
            if (customerId === null || customerId === undefined) {
                throw new RequiredError('customerId','Required parameter customerId was null or undefined when calling getLastThreeEssenceItems.');
            }
            // verify required parameter 'sku' is not null or undefined
            if (sku === null || sku === undefined) {
                throw new RequiredError('sku','Required parameter sku was null or undefined when calling getLastThreeEssenceItems.');
            }
            const localVarPath = `/t/{tenant}/recent-essence-items/{sku}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"sku"}}`, encodeURIComponent(String(sku)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * For a list of SKUs, gets the three most recent essence items for each product. These loosely reflect the quantities and units that were recently ordered, such that a user may see what they usually order.
         * @summary Get last three essence items for each product
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The customer id to request the information for.
         * @param {Array&lt;string&gt;} skus 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLastThreeEssenceItemsFromList(tenant: string, customerId: string, skus: Array<string>, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling getLastThreeEssenceItemsFromList.');
            }
            // verify required parameter 'customerId' is not null or undefined
            if (customerId === null || customerId === undefined) {
                throw new RequiredError('customerId','Required parameter customerId was null or undefined when calling getLastThreeEssenceItemsFromList.');
            }
            // verify required parameter 'skus' is not null or undefined
            if (skus === null || skus === undefined) {
                throw new RequiredError('skus','Required parameter skus was null or undefined when calling getLastThreeEssenceItemsFromList.');
            }
            const localVarPath = `/t/{tenant}/recent-essence-items`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }

            if (skus) {
                localVarQueryParameter['skus'] = skus.join(COLLECTION_FORMATS["csv"]);
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sets visibility state of a product in the essence list. This is used to hide products per default from e.g. essence-restricted search, for example when a product is only ordered once, but still added to the essence list.
         * @summary Set a product visible or hidden in the essential products list
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The customer id to write to
         * @param {string} sku The SKU of the product to set the state for
         * @param {boolean} visible The new visibility state, true for visible.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setEssenceVisibility(tenant: string, customerId: string, sku: string, visible: boolean, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling setEssenceVisibility.');
            }
            // verify required parameter 'customerId' is not null or undefined
            if (customerId === null || customerId === undefined) {
                throw new RequiredError('customerId','Required parameter customerId was null or undefined when calling setEssenceVisibility.');
            }
            // verify required parameter 'sku' is not null or undefined
            if (sku === null || sku === undefined) {
                throw new RequiredError('sku','Required parameter sku was null or undefined when calling setEssenceVisibility.');
            }
            // verify required parameter 'visible' is not null or undefined
            if (visible === null || visible === undefined) {
                throw new RequiredError('visible','Required parameter visible was null or undefined when calling setEssenceVisibility.');
            }
            const localVarPath = `/t/{tenant}/set-essence-visibility/{sku}/{visible}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"sku"}}`, encodeURIComponent(String(sku)))
                .replace(`{${"visible"}}`, encodeURIComponent(String(visible)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EssencesApi - functional programming interface
 * @export
 */
export const EssencesApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customerId of the effective customer to target
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllergensExcel(tenant: string, customerId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = EssencesApiFetchParamCreator(configuration).getAllergensExcel(tenant, customerId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Generate a PDF showing given customer's essence list. This will take some time for larger essence lists.
         * @summary Get a base64-encoded PDF showing the essence list
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The customer id to request the information for.
         * @param {boolean} [showImages] Whether to show images and barcodes in the PDF.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEssenceListPdf(tenant: string, customerId: string, showImages?: boolean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = EssencesApiFetchParamCreator(configuration).getEssenceListPdf(tenant, customerId, showImages, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Like the bulk endpoint for this, but only for a single product.
         * @summary Get last three essence items for single product
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The customer id to request the information for.
         * @param {string} sku The SKU of the product to request essence items for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLastThreeEssenceItems(tenant: string, customerId: string, sku: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<EssenceItemDto>> {
            const localVarFetchArgs = EssencesApiFetchParamCreator(configuration).getLastThreeEssenceItems(tenant, customerId, sku, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * For a list of SKUs, gets the three most recent essence items for each product. These loosely reflect the quantities and units that were recently ordered, such that a user may see what they usually order.
         * @summary Get last three essence items for each product
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The customer id to request the information for.
         * @param {Array&lt;string&gt;} skus 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLastThreeEssenceItemsFromList(tenant: string, customerId: string, skus: Array<string>, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<EssenceItemDto>> {
            const localVarFetchArgs = EssencesApiFetchParamCreator(configuration).getLastThreeEssenceItemsFromList(tenant, customerId, skus, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Sets visibility state of a product in the essence list. This is used to hide products per default from e.g. essence-restricted search, for example when a product is only ordered once, but still added to the essence list.
         * @summary Set a product visible or hidden in the essential products list
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The customer id to write to
         * @param {string} sku The SKU of the product to set the state for
         * @param {boolean} visible The new visibility state, true for visible.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setEssenceVisibility(tenant: string, customerId: string, sku: string, visible: boolean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = EssencesApiFetchParamCreator(configuration).setEssenceVisibility(tenant, customerId, sku, visible, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * EssencesApi - factory interface
 * @export
 */
export const EssencesApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customerId of the effective customer to target
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllergensExcel(tenant: string, customerId: string, options?: any) {
            return EssencesApiFp(configuration).getAllergensExcel(tenant, customerId, options)(fetch, basePath);
        },
        /**
         * Generate a PDF showing given customer's essence list. This will take some time for larger essence lists.
         * @summary Get a base64-encoded PDF showing the essence list
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The customer id to request the information for.
         * @param {boolean} [showImages] Whether to show images and barcodes in the PDF.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEssenceListPdf(tenant: string, customerId: string, showImages?: boolean, options?: any) {
            return EssencesApiFp(configuration).getEssenceListPdf(tenant, customerId, showImages, options)(fetch, basePath);
        },
        /**
         * Like the bulk endpoint for this, but only for a single product.
         * @summary Get last three essence items for single product
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The customer id to request the information for.
         * @param {string} sku The SKU of the product to request essence items for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLastThreeEssenceItems(tenant: string, customerId: string, sku: string, options?: any) {
            return EssencesApiFp(configuration).getLastThreeEssenceItems(tenant, customerId, sku, options)(fetch, basePath);
        },
        /**
         * For a list of SKUs, gets the three most recent essence items for each product. These loosely reflect the quantities and units that were recently ordered, such that a user may see what they usually order.
         * @summary Get last three essence items for each product
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The customer id to request the information for.
         * @param {Array&lt;string&gt;} skus 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLastThreeEssenceItemsFromList(tenant: string, customerId: string, skus: Array<string>, options?: any) {
            return EssencesApiFp(configuration).getLastThreeEssenceItemsFromList(tenant, customerId, skus, options)(fetch, basePath);
        },
        /**
         * Sets visibility state of a product in the essence list. This is used to hide products per default from e.g. essence-restricted search, for example when a product is only ordered once, but still added to the essence list.
         * @summary Set a product visible or hidden in the essential products list
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The customer id to write to
         * @param {string} sku The SKU of the product to set the state for
         * @param {boolean} visible The new visibility state, true for visible.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setEssenceVisibility(tenant: string, customerId: string, sku: string, visible: boolean, options?: any) {
            return EssencesApiFp(configuration).setEssenceVisibility(tenant, customerId, sku, visible, options)(fetch, basePath);
        },
    };
};

/**
 * EssencesApi - object-oriented interface
 * @export
 * @class EssencesApi
 * @extends {BaseAPI}
 */
export class EssencesApi extends BaseAPI {
    /**
     * 
     * @param {} tenant The EGB code of the tenant to target
     * @param {} customerId The tenant-specific customerId of the effective customer to target
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EssencesApi
     */
    public getAllergensExcel(tenant: string, customerId: string, options?: any) {
        return EssencesApiFp(this.configuration).getAllergensExcel(tenant, customerId, options)(this.fetch, this.basePath);
    }

    /**
     * Generate a PDF showing given customer's essence list. This will take some time for larger essence lists.
     * @summary Get a base64-encoded PDF showing the essence list
     * @param {} tenant The EGB code of the tenant to target
     * @param {} customerId The customer id to request the information for.
     * @param {} [showImages] Whether to show images and barcodes in the PDF.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EssencesApi
     */
    public getEssenceListPdf(tenant: string, customerId: string, showImages?: boolean, options?: any) {
        return EssencesApiFp(this.configuration).getEssenceListPdf(tenant, customerId, showImages, options)(this.fetch, this.basePath);
    }

    /**
     * Like the bulk endpoint for this, but only for a single product.
     * @summary Get last three essence items for single product
     * @param {} tenant The EGB code of the tenant to target
     * @param {} customerId The customer id to request the information for.
     * @param {} sku The SKU of the product to request essence items for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EssencesApi
     */
    public getLastThreeEssenceItems(tenant: string, customerId: string, sku: string, options?: any) {
        return EssencesApiFp(this.configuration).getLastThreeEssenceItems(tenant, customerId, sku, options)(this.fetch, this.basePath);
    }

    /**
     * For a list of SKUs, gets the three most recent essence items for each product. These loosely reflect the quantities and units that were recently ordered, such that a user may see what they usually order.
     * @summary Get last three essence items for each product
     * @param {} tenant The EGB code of the tenant to target
     * @param {} customerId The customer id to request the information for.
     * @param {} skus 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EssencesApi
     */
    public getLastThreeEssenceItemsFromList(tenant: string, customerId: string, skus: Array<string>, options?: any) {
        return EssencesApiFp(this.configuration).getLastThreeEssenceItemsFromList(tenant, customerId, skus, options)(this.fetch, this.basePath);
    }

    /**
     * Sets visibility state of a product in the essence list. This is used to hide products per default from e.g. essence-restricted search, for example when a product is only ordered once, but still added to the essence list.
     * @summary Set a product visible or hidden in the essential products list
     * @param {} tenant The EGB code of the tenant to target
     * @param {} customerId The customer id to write to
     * @param {} sku The SKU of the product to set the state for
     * @param {} visible The new visibility state, true for visible.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EssencesApi
     */
    public setEssenceVisibility(tenant: string, customerId: string, sku: string, visible: boolean, options?: any) {
        return EssencesApiFp(this.configuration).setEssenceVisibility(tenant, customerId, sku, visible, options)(this.fetch, this.basePath);
    }

}

/**
 * FairApi - fetch parameter creator
 * @export
 */
export const FairApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Retrieve information for a fair with the given tenant and fair-code
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} fairCode The unique identifier of a fair cart-type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFair(tenant: string, fairCode: string, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling getFair.');
            }
            // verify required parameter 'fairCode' is not null or undefined
            if (fairCode === null || fairCode === undefined) {
                throw new RequiredError('fairCode','Required parameter fairCode was null or undefined when calling getFair.');
            }
            const localVarPath = `/t/{tenant}/fairs/{fairCode}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"fairCode"}}`, encodeURIComponent(String(fairCode)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FairApi - functional programming interface
 * @export
 */
export const FairApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Retrieve information for a fair with the given tenant and fair-code
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} fairCode The unique identifier of a fair cart-type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFair(tenant: string, fairCode: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<FairDto> {
            const localVarFetchArgs = FairApiFetchParamCreator(configuration).getFair(tenant, fairCode, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * FairApi - factory interface
 * @export
 */
export const FairApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Retrieve information for a fair with the given tenant and fair-code
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} fairCode The unique identifier of a fair cart-type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFair(tenant: string, fairCode: string, options?: any) {
            return FairApiFp(configuration).getFair(tenant, fairCode, options)(fetch, basePath);
        },
    };
};

/**
 * FairApi - object-oriented interface
 * @export
 * @class FairApi
 * @extends {BaseAPI}
 */
export class FairApi extends BaseAPI {
    /**
     * 
     * @summary Retrieve information for a fair with the given tenant and fair-code
     * @param {} tenant The EGB code of the tenant to target
     * @param {} fairCode The unique identifier of a fair cart-type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FairApi
     */
    public getFair(tenant: string, fairCode: string, options?: any) {
        return FairApiFp(this.configuration).getFair(tenant, fairCode, options)(this.fetch, this.basePath);
    }

}

/**
 * FairCartApi - fetch parameter creator
 * @export
 */
export const FairCartApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add an item to your shopping cart or override an existing one. Note that only the root-level properties (customer, user, sku, fairCode) are used for the primary key, any entities sent with the request will be ignored. Warning! This returns the whole shopping cart, which may contain a lot of items, therefore causing significant network traffic. Consider using the no-detail endpoint for this instead.
         * @summary Add an item to your fair-cart or override an existing one
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customer number of the customer to target
         * @param {string} fairCode Unique identifier of this fair/cart-type
         * @param {FairCartItemDto} item 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addItemToFairCart(tenant: string, customerId: string, fairCode: string, item: FairCartItemDto, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling addItemToFairCart.');
            }
            // verify required parameter 'customerId' is not null or undefined
            if (customerId === null || customerId === undefined) {
                throw new RequiredError('customerId','Required parameter customerId was null or undefined when calling addItemToFairCart.');
            }
            // verify required parameter 'fairCode' is not null or undefined
            if (fairCode === null || fairCode === undefined) {
                throw new RequiredError('fairCode','Required parameter fairCode was null or undefined when calling addItemToFairCart.');
            }
            // verify required parameter 'item' is not null or undefined
            if (item === null || item === undefined) {
                throw new RequiredError('item','Required parameter item was null or undefined when calling addItemToFairCart.');
            }
            const localVarPath = `/t/{tenant}/fair/{fairCode}/my/cart/{customerId}/items`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)))
                .replace(`{${"fairCode"}}`, encodeURIComponent(String(fairCode)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"FairCartItemDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(item || {}) : (item || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add an item to your fair cart or override an existing one. Note that only the root-level properties (user, customer, sku, fairCode) are used for the primary key, any entities sent with the request will be ignored. Returns the updated item. This does not return any details of the created cart item, that is, no product metadata. The update timestamp is returned.
         * @summary Add an item to your fair cart or override an existing one
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customer number of the customer to target
         * @param {string} fairCode Unique identifier of this fair/cart-type
         * @param {FairCartItemDto} item 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addItemToFairCartNoDetail(tenant: string, customerId: string, fairCode: string, item: FairCartItemDto, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling addItemToFairCartNoDetail.');
            }
            // verify required parameter 'customerId' is not null or undefined
            if (customerId === null || customerId === undefined) {
                throw new RequiredError('customerId','Required parameter customerId was null or undefined when calling addItemToFairCartNoDetail.');
            }
            // verify required parameter 'fairCode' is not null or undefined
            if (fairCode === null || fairCode === undefined) {
                throw new RequiredError('fairCode','Required parameter fairCode was null or undefined when calling addItemToFairCartNoDetail.');
            }
            // verify required parameter 'item' is not null or undefined
            if (item === null || item === undefined) {
                throw new RequiredError('item','Required parameter item was null or undefined when calling addItemToFairCartNoDetail.');
            }
            const localVarPath = `/t/{tenant}/fair/{fairCode}/my/cart/{customerId}/items/no-detail`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)))
                .replace(`{${"fairCode"}}`, encodeURIComponent(String(fairCode)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"FairCartItemDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(item || {}) : (item || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Clears the fair-specific-cart of your customer
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customer number of the customer to target
         * @param {string} fairCode Unique identifier of this fair/cart-type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearFairCart(tenant: string, customerId: string, fairCode: string, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling clearFairCart.');
            }
            // verify required parameter 'customerId' is not null or undefined
            if (customerId === null || customerId === undefined) {
                throw new RequiredError('customerId','Required parameter customerId was null or undefined when calling clearFairCart.');
            }
            // verify required parameter 'fairCode' is not null or undefined
            if (fairCode === null || fairCode === undefined) {
                throw new RequiredError('fairCode','Required parameter fairCode was null or undefined when calling clearFairCart.');
            }
            const localVarPath = `/t/{tenant}/fair/{fairCode}/my/cart/{customerId}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)))
                .replace(`{${"fairCode"}}`, encodeURIComponent(String(fairCode)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the current status of your customer/fair-specific cart
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customer number of the customer to target
         * @param {string} fairCode Unique identifier of this fair/cart-type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFairCart(tenant: string, customerId: string, fairCode: string, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling getFairCart.');
            }
            // verify required parameter 'customerId' is not null or undefined
            if (customerId === null || customerId === undefined) {
                throw new RequiredError('customerId','Required parameter customerId was null or undefined when calling getFairCart.');
            }
            // verify required parameter 'fairCode' is not null or undefined
            if (fairCode === null || fairCode === undefined) {
                throw new RequiredError('fairCode','Required parameter fairCode was null or undefined when calling getFairCart.');
            }
            const localVarPath = `/t/{tenant}/fair/{fairCode}/my/cart/{customerId}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)))
                .replace(`{${"fairCode"}}`, encodeURIComponent(String(fairCode)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Removes a fair-cart-item, does nothing if it did not exist or the database returned an error, e.g. related to optimistic locking.
         * @summary Remove an item from your shopping cart
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customer number of the customer to target
         * @param {string} fairCode Unique identifier of this fair/cart-type
         * @param {FairCartItemDto} item 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeItemFromFairCart(tenant: string, customerId: string, fairCode: string, item: FairCartItemDto, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling removeItemFromFairCart.');
            }
            // verify required parameter 'customerId' is not null or undefined
            if (customerId === null || customerId === undefined) {
                throw new RequiredError('customerId','Required parameter customerId was null or undefined when calling removeItemFromFairCart.');
            }
            // verify required parameter 'fairCode' is not null or undefined
            if (fairCode === null || fairCode === undefined) {
                throw new RequiredError('fairCode','Required parameter fairCode was null or undefined when calling removeItemFromFairCart.');
            }
            // verify required parameter 'item' is not null or undefined
            if (item === null || item === undefined) {
                throw new RequiredError('item','Required parameter item was null or undefined when calling removeItemFromFairCart.');
            }
            const localVarPath = `/t/{tenant}/fair/{fairCode}/my/cart/{customerId}/items`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)))
                .replace(`{${"fairCode"}}`, encodeURIComponent(String(fairCode)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"FairCartItemDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(item || {}) : (item || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a new order from the current  fair-cart and given parameters. Clears the fair-cart if submission was successful. Note that the order is transferred to the ERP asynchronously, so a positive response here does not mean that the order was actually received, but only that is was saved in the hub's database. If submission fails, it is periodically re-attempted until some threshold is met, after that, Eurogast needs to manually deal with the order. Confirmation emails are also sent asynchronously, after the ERP first receives the order. After submission, the ERP also confirms processing of the order later.
         * @summary Submit the current fair-cart into an order
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customer number of the customer to target
         * @param {string} fairCode Unique identifier of this fair/cart-type
         * @param {FairCartSubmitDto} orderInformation 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitFairCart(tenant: string, customerId: string, fairCode: string, orderInformation: FairCartSubmitDto, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling submitFairCart.');
            }
            // verify required parameter 'customerId' is not null or undefined
            if (customerId === null || customerId === undefined) {
                throw new RequiredError('customerId','Required parameter customerId was null or undefined when calling submitFairCart.');
            }
            // verify required parameter 'fairCode' is not null or undefined
            if (fairCode === null || fairCode === undefined) {
                throw new RequiredError('fairCode','Required parameter fairCode was null or undefined when calling submitFairCart.');
            }
            // verify required parameter 'orderInformation' is not null or undefined
            if (orderInformation === null || orderInformation === undefined) {
                throw new RequiredError('orderInformation','Required parameter orderInformation was null or undefined when calling submitFairCart.');
            }
            const localVarPath = `/t/{tenant}/fair/{fairCode}/my/cart/{customerId}/submit`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)))
                .replace(`{${"fairCode"}}`, encodeURIComponent(String(fairCode)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"FairCartSubmitDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(orderInformation || {}) : (orderInformation || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FairCartApi - functional programming interface
 * @export
 */
export const FairCartApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Add an item to your shopping cart or override an existing one. Note that only the root-level properties (customer, user, sku, fairCode) are used for the primary key, any entities sent with the request will be ignored. Warning! This returns the whole shopping cart, which may contain a lot of items, therefore causing significant network traffic. Consider using the no-detail endpoint for this instead.
         * @summary Add an item to your fair-cart or override an existing one
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customer number of the customer to target
         * @param {string} fairCode Unique identifier of this fair/cart-type
         * @param {FairCartItemDto} item 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addItemToFairCart(tenant: string, customerId: string, fairCode: string, item: FairCartItemDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<FairCartDto> {
            const localVarFetchArgs = FairCartApiFetchParamCreator(configuration).addItemToFairCart(tenant, customerId, fairCode, item, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Add an item to your fair cart or override an existing one. Note that only the root-level properties (user, customer, sku, fairCode) are used for the primary key, any entities sent with the request will be ignored. Returns the updated item. This does not return any details of the created cart item, that is, no product metadata. The update timestamp is returned.
         * @summary Add an item to your fair cart or override an existing one
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customer number of the customer to target
         * @param {string} fairCode Unique identifier of this fair/cart-type
         * @param {FairCartItemDto} item 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addItemToFairCartNoDetail(tenant: string, customerId: string, fairCode: string, item: FairCartItemDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<FairCartItemDto> {
            const localVarFetchArgs = FairCartApiFetchParamCreator(configuration).addItemToFairCartNoDetail(tenant, customerId, fairCode, item, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Clears the fair-specific-cart of your customer
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customer number of the customer to target
         * @param {string} fairCode Unique identifier of this fair/cart-type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearFairCart(tenant: string, customerId: string, fairCode: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<FairCartDto> {
            const localVarFetchArgs = FairCartApiFetchParamCreator(configuration).clearFairCart(tenant, customerId, fairCode, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get the current status of your customer/fair-specific cart
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customer number of the customer to target
         * @param {string} fairCode Unique identifier of this fair/cart-type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFairCart(tenant: string, customerId: string, fairCode: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<FairCartDto> {
            const localVarFetchArgs = FairCartApiFetchParamCreator(configuration).getFairCart(tenant, customerId, fairCode, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Removes a fair-cart-item, does nothing if it did not exist or the database returned an error, e.g. related to optimistic locking.
         * @summary Remove an item from your shopping cart
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customer number of the customer to target
         * @param {string} fairCode Unique identifier of this fair/cart-type
         * @param {FairCartItemDto} item 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeItemFromFairCart(tenant: string, customerId: string, fairCode: string, item: FairCartItemDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<FairCartDto> {
            const localVarFetchArgs = FairCartApiFetchParamCreator(configuration).removeItemFromFairCart(tenant, customerId, fairCode, item, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Creates a new order from the current  fair-cart and given parameters. Clears the fair-cart if submission was successful. Note that the order is transferred to the ERP asynchronously, so a positive response here does not mean that the order was actually received, but only that is was saved in the hub's database. If submission fails, it is periodically re-attempted until some threshold is met, after that, Eurogast needs to manually deal with the order. Confirmation emails are also sent asynchronously, after the ERP first receives the order. After submission, the ERP also confirms processing of the order later.
         * @summary Submit the current fair-cart into an order
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customer number of the customer to target
         * @param {string} fairCode Unique identifier of this fair/cart-type
         * @param {FairCartSubmitDto} orderInformation 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitFairCart(tenant: string, customerId: string, fairCode: string, orderInformation: FairCartSubmitDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<OrderDto> {
            const localVarFetchArgs = FairCartApiFetchParamCreator(configuration).submitFairCart(tenant, customerId, fairCode, orderInformation, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * FairCartApi - factory interface
 * @export
 */
export const FairCartApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * Add an item to your shopping cart or override an existing one. Note that only the root-level properties (customer, user, sku, fairCode) are used for the primary key, any entities sent with the request will be ignored. Warning! This returns the whole shopping cart, which may contain a lot of items, therefore causing significant network traffic. Consider using the no-detail endpoint for this instead.
         * @summary Add an item to your fair-cart or override an existing one
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customer number of the customer to target
         * @param {string} fairCode Unique identifier of this fair/cart-type
         * @param {FairCartItemDto} item 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addItemToFairCart(tenant: string, customerId: string, fairCode: string, item: FairCartItemDto, options?: any) {
            return FairCartApiFp(configuration).addItemToFairCart(tenant, customerId, fairCode, item, options)(fetch, basePath);
        },
        /**
         * Add an item to your fair cart or override an existing one. Note that only the root-level properties (user, customer, sku, fairCode) are used for the primary key, any entities sent with the request will be ignored. Returns the updated item. This does not return any details of the created cart item, that is, no product metadata. The update timestamp is returned.
         * @summary Add an item to your fair cart or override an existing one
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customer number of the customer to target
         * @param {string} fairCode Unique identifier of this fair/cart-type
         * @param {FairCartItemDto} item 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addItemToFairCartNoDetail(tenant: string, customerId: string, fairCode: string, item: FairCartItemDto, options?: any) {
            return FairCartApiFp(configuration).addItemToFairCartNoDetail(tenant, customerId, fairCode, item, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Clears the fair-specific-cart of your customer
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customer number of the customer to target
         * @param {string} fairCode Unique identifier of this fair/cart-type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearFairCart(tenant: string, customerId: string, fairCode: string, options?: any) {
            return FairCartApiFp(configuration).clearFairCart(tenant, customerId, fairCode, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get the current status of your customer/fair-specific cart
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customer number of the customer to target
         * @param {string} fairCode Unique identifier of this fair/cart-type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFairCart(tenant: string, customerId: string, fairCode: string, options?: any) {
            return FairCartApiFp(configuration).getFairCart(tenant, customerId, fairCode, options)(fetch, basePath);
        },
        /**
         * Removes a fair-cart-item, does nothing if it did not exist or the database returned an error, e.g. related to optimistic locking.
         * @summary Remove an item from your shopping cart
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customer number of the customer to target
         * @param {string} fairCode Unique identifier of this fair/cart-type
         * @param {FairCartItemDto} item 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeItemFromFairCart(tenant: string, customerId: string, fairCode: string, item: FairCartItemDto, options?: any) {
            return FairCartApiFp(configuration).removeItemFromFairCart(tenant, customerId, fairCode, item, options)(fetch, basePath);
        },
        /**
         * Creates a new order from the current  fair-cart and given parameters. Clears the fair-cart if submission was successful. Note that the order is transferred to the ERP asynchronously, so a positive response here does not mean that the order was actually received, but only that is was saved in the hub's database. If submission fails, it is periodically re-attempted until some threshold is met, after that, Eurogast needs to manually deal with the order. Confirmation emails are also sent asynchronously, after the ERP first receives the order. After submission, the ERP also confirms processing of the order later.
         * @summary Submit the current fair-cart into an order
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customer number of the customer to target
         * @param {string} fairCode Unique identifier of this fair/cart-type
         * @param {FairCartSubmitDto} orderInformation 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitFairCart(tenant: string, customerId: string, fairCode: string, orderInformation: FairCartSubmitDto, options?: any) {
            return FairCartApiFp(configuration).submitFairCart(tenant, customerId, fairCode, orderInformation, options)(fetch, basePath);
        },
    };
};

/**
 * FairCartApi - object-oriented interface
 * @export
 * @class FairCartApi
 * @extends {BaseAPI}
 */
export class FairCartApi extends BaseAPI {
    /**
     * Add an item to your shopping cart or override an existing one. Note that only the root-level properties (customer, user, sku, fairCode) are used for the primary key, any entities sent with the request will be ignored. Warning! This returns the whole shopping cart, which may contain a lot of items, therefore causing significant network traffic. Consider using the no-detail endpoint for this instead.
     * @summary Add an item to your fair-cart or override an existing one
     * @param {} tenant The EGB code of the tenant to target
     * @param {} customerId The tenant-specific customer number of the customer to target
     * @param {} fairCode Unique identifier of this fair/cart-type
     * @param {} item 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FairCartApi
     */
    public addItemToFairCart(tenant: string, customerId: string, fairCode: string, item: FairCartItemDto, options?: any) {
        return FairCartApiFp(this.configuration).addItemToFairCart(tenant, customerId, fairCode, item, options)(this.fetch, this.basePath);
    }

    /**
     * Add an item to your fair cart or override an existing one. Note that only the root-level properties (user, customer, sku, fairCode) are used for the primary key, any entities sent with the request will be ignored. Returns the updated item. This does not return any details of the created cart item, that is, no product metadata. The update timestamp is returned.
     * @summary Add an item to your fair cart or override an existing one
     * @param {} tenant The EGB code of the tenant to target
     * @param {} customerId The tenant-specific customer number of the customer to target
     * @param {} fairCode Unique identifier of this fair/cart-type
     * @param {} item 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FairCartApi
     */
    public addItemToFairCartNoDetail(tenant: string, customerId: string, fairCode: string, item: FairCartItemDto, options?: any) {
        return FairCartApiFp(this.configuration).addItemToFairCartNoDetail(tenant, customerId, fairCode, item, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Clears the fair-specific-cart of your customer
     * @param {} tenant The EGB code of the tenant to target
     * @param {} customerId The tenant-specific customer number of the customer to target
     * @param {} fairCode Unique identifier of this fair/cart-type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FairCartApi
     */
    public clearFairCart(tenant: string, customerId: string, fairCode: string, options?: any) {
        return FairCartApiFp(this.configuration).clearFairCart(tenant, customerId, fairCode, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get the current status of your customer/fair-specific cart
     * @param {} tenant The EGB code of the tenant to target
     * @param {} customerId The tenant-specific customer number of the customer to target
     * @param {} fairCode Unique identifier of this fair/cart-type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FairCartApi
     */
    public getFairCart(tenant: string, customerId: string, fairCode: string, options?: any) {
        return FairCartApiFp(this.configuration).getFairCart(tenant, customerId, fairCode, options)(this.fetch, this.basePath);
    }

    /**
     * Removes a fair-cart-item, does nothing if it did not exist or the database returned an error, e.g. related to optimistic locking.
     * @summary Remove an item from your shopping cart
     * @param {} tenant The EGB code of the tenant to target
     * @param {} customerId The tenant-specific customer number of the customer to target
     * @param {} fairCode Unique identifier of this fair/cart-type
     * @param {} item 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FairCartApi
     */
    public removeItemFromFairCart(tenant: string, customerId: string, fairCode: string, item: FairCartItemDto, options?: any) {
        return FairCartApiFp(this.configuration).removeItemFromFairCart(tenant, customerId, fairCode, item, options)(this.fetch, this.basePath);
    }

    /**
     * Creates a new order from the current  fair-cart and given parameters. Clears the fair-cart if submission was successful. Note that the order is transferred to the ERP asynchronously, so a positive response here does not mean that the order was actually received, but only that is was saved in the hub's database. If submission fails, it is periodically re-attempted until some threshold is met, after that, Eurogast needs to manually deal with the order. Confirmation emails are also sent asynchronously, after the ERP first receives the order. After submission, the ERP also confirms processing of the order later.
     * @summary Submit the current fair-cart into an order
     * @param {} tenant The EGB code of the tenant to target
     * @param {} customerId The tenant-specific customer number of the customer to target
     * @param {} fairCode Unique identifier of this fair/cart-type
     * @param {} orderInformation 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FairCartApi
     */
    public submitFairCart(tenant: string, customerId: string, fairCode: string, orderInformation: FairCartSubmitDto, options?: any) {
        return FairCartApiFp(this.configuration).submitFairCart(tenant, customerId, fairCode, orderInformation, options)(this.fetch, this.basePath);
    }

}

/**
 * FeatureFlagApi - fetch parameter creator
 * @export
 */
export const FeatureFlagApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Retrieve all active feature-flags for this tenant
         * @param {string} tenant The EGB code of the tenant to target
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeatureFlagsForTenant(tenant: string, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling getFeatureFlagsForTenant.');
            }
            const localVarPath = `/t/{tenant}/featureflags`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FeatureFlagApi - functional programming interface
 * @export
 */
export const FeatureFlagApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Retrieve all active feature-flags for this tenant
         * @param {string} tenant The EGB code of the tenant to target
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeatureFlagsForTenant(tenant: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<FeatureFlagDto>> {
            const localVarFetchArgs = FeatureFlagApiFetchParamCreator(configuration).getFeatureFlagsForTenant(tenant, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * FeatureFlagApi - factory interface
 * @export
 */
export const FeatureFlagApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Retrieve all active feature-flags for this tenant
         * @param {string} tenant The EGB code of the tenant to target
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeatureFlagsForTenant(tenant: string, options?: any) {
            return FeatureFlagApiFp(configuration).getFeatureFlagsForTenant(tenant, options)(fetch, basePath);
        },
    };
};

/**
 * FeatureFlagApi - object-oriented interface
 * @export
 * @class FeatureFlagApi
 * @extends {BaseAPI}
 */
export class FeatureFlagApi extends BaseAPI {
    /**
     * 
     * @summary Retrieve all active feature-flags for this tenant
     * @param {} tenant The EGB code of the tenant to target
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeatureFlagApi
     */
    public getFeatureFlagsForTenant(tenant: string, options?: any) {
        return FeatureFlagApiFp(this.configuration).getFeatureFlagsForTenant(tenant, options)(this.fetch, this.basePath);
    }

}

/**
 * InternalApi - fetch parameter creator
 * @export
 */
export const InternalApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Import a list of customers, replacing existing state. That means that if e.g. no delivery slots are provided, all existing slots will be deleted. See: https://confluence.eurogast.at/display/P1801/Schnittstellen+zu+ERP-Systeme
         * @summary Import a list of customers, replacing existing state.
         * @param {string} tenant The EGB code of the tenant to target
         * @param {Array&lt;EffectiveCustomerDto&gt;} [customers] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importCustomers(tenant: string, customers?: Array<EffectiveCustomerDto>, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling importCustomers.');
            }
            const localVarPath = `/.internal/import/{tenant}/customers`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"Array&lt;EffectiveCustomerDto&gt;" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(customers || {}) : (customers || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Looks for notifications that are not yet published but that have a publication date in the past, and publishes those. Ignores drafts. This is meant to be executed regularly by a scheduled job in the importer.
         * @summary Publish notifications that are due to be published
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishScheduledNotifications(options: any = {}): FetchArgs {
            const localVarPath = `/.internal/import/publish-scheduled-notifications`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Looks for orders that are flagged as not processed and are older than predefined value (default 5min) Also, checks if no order confirmation was received All orders that match both of the above criteria are then sent again. This is meant to be executed regularly by a scheduled job in the importer.
         * @summary Resend all unprocessed orders.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendOrders(options: any = {}): FetchArgs {
            const localVarPath = `/.internal/import/resend-orders`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates and sends a bestfriend update reminder notification for every user.
         * @summary Publish best friend update reminder notifications
         * @param {Array&lt;BestFriendUpdateNotificationDto&gt;} bfUpdateNotifications 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendBFUpdateReminderNotification(bfUpdateNotifications: Array<BestFriendUpdateNotificationDto>, options: any = {}): FetchArgs {
            // verify required parameter 'bfUpdateNotifications' is not null or undefined
            if (bfUpdateNotifications === null || bfUpdateNotifications === undefined) {
                throw new RequiredError('bfUpdateNotifications','Required parameter bfUpdateNotifications was null or undefined when calling sendBFUpdateReminderNotification.');
            }
            const localVarPath = `/.internal/import/send-bf-update-notifications`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"Array&lt;BestFriendUpdateNotificationDto&gt;" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(bfUpdateNotifications || {}) : (bfUpdateNotifications || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates and sends a notification for each user who has one of the newly inactive products on their essence. Is called via the importer after importing the new products.
         * @summary Send product information notifications when product is set to inactive.
         * @param {string} tenant 
         * @param {Array&lt;string&gt;} skus 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendProductRemovalNotification(tenant: string, skus: Array<string>, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling sendProductRemovalNotification.');
            }
            // verify required parameter 'skus' is not null or undefined
            if (skus === null || skus === undefined) {
                throw new RequiredError('skus','Required parameter skus was null or undefined when calling sendProductRemovalNotification.');
            }
            const localVarPath = `/.internal/import/send-product-removal-notification`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (tenant !== undefined) {
                localVarQueryParameter['tenant'] = tenant;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"Array&lt;string&gt;" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(skus || {}) : (skus || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Summarise order count per product in some time range, the count range. This will only include products that have been ordered in change consideration ranges (one at the start, one at the end), so that products where the popularity has not changed do not need to be updated.
         * @param {string} tenant Tenant to scope the request to
         * @param {string} countRangeStart The first day on which orders should be considered for counting
         * @param {string} countRangeEnd The last day on which orders should be considered for counting
         * @param {number} changeConsiderationOffsetDays Relevant for change computation. This specifies how many days before the start of the range and how many days before the end of the range ordered products should be considered as changed. This is also used at the start of the range so that when orders leave the count range, their respective products are updated.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        summarizeChangedProductPopularities(tenant: string, countRangeStart: string, countRangeEnd: string, changeConsiderationOffsetDays: number, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling summarizeChangedProductPopularities.');
            }
            // verify required parameter 'countRangeStart' is not null or undefined
            if (countRangeStart === null || countRangeStart === undefined) {
                throw new RequiredError('countRangeStart','Required parameter countRangeStart was null or undefined when calling summarizeChangedProductPopularities.');
            }
            // verify required parameter 'countRangeEnd' is not null or undefined
            if (countRangeEnd === null || countRangeEnd === undefined) {
                throw new RequiredError('countRangeEnd','Required parameter countRangeEnd was null or undefined when calling summarizeChangedProductPopularities.');
            }
            // verify required parameter 'changeConsiderationOffsetDays' is not null or undefined
            if (changeConsiderationOffsetDays === null || changeConsiderationOffsetDays === undefined) {
                throw new RequiredError('changeConsiderationOffsetDays','Required parameter changeConsiderationOffsetDays was null or undefined when calling summarizeChangedProductPopularities.');
            }
            const localVarPath = `/.internal/import/changed-product-propularities`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (tenant !== undefined) {
                localVarQueryParameter['tenant'] = tenant;
            }

            if (countRangeStart !== undefined) {
                localVarQueryParameter['countRangeStart'] = (countRangeStart as any).toISOString();
            }

            if (countRangeEnd !== undefined) {
                localVarQueryParameter['countRangeEnd'] = (countRangeEnd as any).toISOString();
            }

            if (changeConsiderationOffsetDays !== undefined) {
                localVarQueryParameter['changeConsiderationOffsetDays'] = changeConsiderationOffsetDays;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Summarise order count per product in some time range, the count range. This will only include products that match the SKUs passed.
         * @param {string} tenant Tenant to scope the request to
         * @param {string} countRangeStart The first day on which orders should be considered for counting
         * @param {string} countRangeEnd The last day on which orders should be considered for counting
         * @param {Array&lt;string&gt;} skus 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        summarizeProductPopularitiesForSkus(tenant: string, countRangeStart: string, countRangeEnd: string, skus: Array<string>, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling summarizeProductPopularitiesForSkus.');
            }
            // verify required parameter 'countRangeStart' is not null or undefined
            if (countRangeStart === null || countRangeStart === undefined) {
                throw new RequiredError('countRangeStart','Required parameter countRangeStart was null or undefined when calling summarizeProductPopularitiesForSkus.');
            }
            // verify required parameter 'countRangeEnd' is not null or undefined
            if (countRangeEnd === null || countRangeEnd === undefined) {
                throw new RequiredError('countRangeEnd','Required parameter countRangeEnd was null or undefined when calling summarizeProductPopularitiesForSkus.');
            }
            // verify required parameter 'skus' is not null or undefined
            if (skus === null || skus === undefined) {
                throw new RequiredError('skus','Required parameter skus was null or undefined when calling summarizeProductPopularitiesForSkus.');
            }
            const localVarPath = `/.internal/import/product-propularities-of`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (tenant !== undefined) {
                localVarQueryParameter['tenant'] = tenant;
            }

            if (countRangeStart !== undefined) {
                localVarQueryParameter['countRangeStart'] = (countRangeStart as any).toISOString();
            }

            if (countRangeEnd !== undefined) {
                localVarQueryParameter['countRangeEnd'] = (countRangeEnd as any).toISOString();
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"Array&lt;string&gt;" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(skus || {}) : (skus || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InternalApi - functional programming interface
 * @export
 */
export const InternalApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Import a list of customers, replacing existing state. That means that if e.g. no delivery slots are provided, all existing slots will be deleted. See: https://confluence.eurogast.at/display/P1801/Schnittstellen+zu+ERP-Systeme
         * @summary Import a list of customers, replacing existing state.
         * @param {string} tenant The EGB code of the tenant to target
         * @param {Array&lt;EffectiveCustomerDto&gt;} [customers] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importCustomers(tenant: string, customers?: Array<EffectiveCustomerDto>, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ImportErrors> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).importCustomers(tenant, customers, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Looks for notifications that are not yet published but that have a publication date in the past, and publishes those. Ignores drafts. This is meant to be executed regularly by a scheduled job in the importer.
         * @summary Publish notifications that are due to be published
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishScheduledNotifications(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).publishScheduledNotifications(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Looks for orders that are flagged as not processed and are older than predefined value (default 5min) Also, checks if no order confirmation was received All orders that match both of the above criteria are then sent again. This is meant to be executed regularly by a scheduled job in the importer.
         * @summary Resend all unprocessed orders.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendOrders(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).resendOrders(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Creates and sends a bestfriend update reminder notification for every user.
         * @summary Publish best friend update reminder notifications
         * @param {Array&lt;BestFriendUpdateNotificationDto&gt;} bfUpdateNotifications 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendBFUpdateReminderNotification(bfUpdateNotifications: Array<BestFriendUpdateNotificationDto>, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).sendBFUpdateReminderNotification(bfUpdateNotifications, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Creates and sends a notification for each user who has one of the newly inactive products on their essence. Is called via the importer after importing the new products.
         * @summary Send product information notifications when product is set to inactive.
         * @param {string} tenant 
         * @param {Array&lt;string&gt;} skus 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendProductRemovalNotification(tenant: string, skus: Array<string>, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).sendProductRemovalNotification(tenant, skus, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Summarise order count per product in some time range, the count range. This will only include products that have been ordered in change consideration ranges (one at the start, one at the end), so that products where the popularity has not changed do not need to be updated.
         * @param {string} tenant Tenant to scope the request to
         * @param {string} countRangeStart The first day on which orders should be considered for counting
         * @param {string} countRangeEnd The last day on which orders should be considered for counting
         * @param {number} changeConsiderationOffsetDays Relevant for change computation. This specifies how many days before the start of the range and how many days before the end of the range ordered products should be considered as changed. This is also used at the start of the range so that when orders leave the count range, their respective products are updated.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        summarizeChangedProductPopularities(tenant: string, countRangeStart: string, countRangeEnd: string, changeConsiderationOffsetDays: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<ProductOrderCountDto>> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).summarizeChangedProductPopularities(tenant, countRangeStart, countRangeEnd, changeConsiderationOffsetDays, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Summarise order count per product in some time range, the count range. This will only include products that match the SKUs passed.
         * @param {string} tenant Tenant to scope the request to
         * @param {string} countRangeStart The first day on which orders should be considered for counting
         * @param {string} countRangeEnd The last day on which orders should be considered for counting
         * @param {Array&lt;string&gt;} skus 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        summarizeProductPopularitiesForSkus(tenant: string, countRangeStart: string, countRangeEnd: string, skus: Array<string>, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<ProductOrderCountDto>> {
            const localVarFetchArgs = InternalApiFetchParamCreator(configuration).summarizeProductPopularitiesForSkus(tenant, countRangeStart, countRangeEnd, skus, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * InternalApi - factory interface
 * @export
 */
export const InternalApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * Import a list of customers, replacing existing state. That means that if e.g. no delivery slots are provided, all existing slots will be deleted. See: https://confluence.eurogast.at/display/P1801/Schnittstellen+zu+ERP-Systeme
         * @summary Import a list of customers, replacing existing state.
         * @param {string} tenant The EGB code of the tenant to target
         * @param {Array&lt;EffectiveCustomerDto&gt;} [customers] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importCustomers(tenant: string, customers?: Array<EffectiveCustomerDto>, options?: any) {
            return InternalApiFp(configuration).importCustomers(tenant, customers, options)(fetch, basePath);
        },
        /**
         * Looks for notifications that are not yet published but that have a publication date in the past, and publishes those. Ignores drafts. This is meant to be executed regularly by a scheduled job in the importer.
         * @summary Publish notifications that are due to be published
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishScheduledNotifications(options?: any) {
            return InternalApiFp(configuration).publishScheduledNotifications(options)(fetch, basePath);
        },
        /**
         * Looks for orders that are flagged as not processed and are older than predefined value (default 5min) Also, checks if no order confirmation was received All orders that match both of the above criteria are then sent again. This is meant to be executed regularly by a scheduled job in the importer.
         * @summary Resend all unprocessed orders.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendOrders(options?: any) {
            return InternalApiFp(configuration).resendOrders(options)(fetch, basePath);
        },
        /**
         * Creates and sends a bestfriend update reminder notification for every user.
         * @summary Publish best friend update reminder notifications
         * @param {Array&lt;BestFriendUpdateNotificationDto&gt;} bfUpdateNotifications 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendBFUpdateReminderNotification(bfUpdateNotifications: Array<BestFriendUpdateNotificationDto>, options?: any) {
            return InternalApiFp(configuration).sendBFUpdateReminderNotification(bfUpdateNotifications, options)(fetch, basePath);
        },
        /**
         * Creates and sends a notification for each user who has one of the newly inactive products on their essence. Is called via the importer after importing the new products.
         * @summary Send product information notifications when product is set to inactive.
         * @param {string} tenant 
         * @param {Array&lt;string&gt;} skus 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendProductRemovalNotification(tenant: string, skus: Array<string>, options?: any) {
            return InternalApiFp(configuration).sendProductRemovalNotification(tenant, skus, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Summarise order count per product in some time range, the count range. This will only include products that have been ordered in change consideration ranges (one at the start, one at the end), so that products where the popularity has not changed do not need to be updated.
         * @param {string} tenant Tenant to scope the request to
         * @param {string} countRangeStart The first day on which orders should be considered for counting
         * @param {string} countRangeEnd The last day on which orders should be considered for counting
         * @param {number} changeConsiderationOffsetDays Relevant for change computation. This specifies how many days before the start of the range and how many days before the end of the range ordered products should be considered as changed. This is also used at the start of the range so that when orders leave the count range, their respective products are updated.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        summarizeChangedProductPopularities(tenant: string, countRangeStart: string, countRangeEnd: string, changeConsiderationOffsetDays: number, options?: any) {
            return InternalApiFp(configuration).summarizeChangedProductPopularities(tenant, countRangeStart, countRangeEnd, changeConsiderationOffsetDays, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Summarise order count per product in some time range, the count range. This will only include products that match the SKUs passed.
         * @param {string} tenant Tenant to scope the request to
         * @param {string} countRangeStart The first day on which orders should be considered for counting
         * @param {string} countRangeEnd The last day on which orders should be considered for counting
         * @param {Array&lt;string&gt;} skus 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        summarizeProductPopularitiesForSkus(tenant: string, countRangeStart: string, countRangeEnd: string, skus: Array<string>, options?: any) {
            return InternalApiFp(configuration).summarizeProductPopularitiesForSkus(tenant, countRangeStart, countRangeEnd, skus, options)(fetch, basePath);
        },
    };
};

/**
 * InternalApi - object-oriented interface
 * @export
 * @class InternalApi
 * @extends {BaseAPI}
 */
export class InternalApi extends BaseAPI {
    /**
     * Import a list of customers, replacing existing state. That means that if e.g. no delivery slots are provided, all existing slots will be deleted. See: https://confluence.eurogast.at/display/P1801/Schnittstellen+zu+ERP-Systeme
     * @summary Import a list of customers, replacing existing state.
     * @param {} tenant The EGB code of the tenant to target
     * @param {} [customers] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public importCustomers(tenant: string, customers?: Array<EffectiveCustomerDto>, options?: any) {
        return InternalApiFp(this.configuration).importCustomers(tenant, customers, options)(this.fetch, this.basePath);
    }

    /**
     * Looks for notifications that are not yet published but that have a publication date in the past, and publishes those. Ignores drafts. This is meant to be executed regularly by a scheduled job in the importer.
     * @summary Publish notifications that are due to be published
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public publishScheduledNotifications(options?: any) {
        return InternalApiFp(this.configuration).publishScheduledNotifications(options)(this.fetch, this.basePath);
    }

    /**
     * Looks for orders that are flagged as not processed and are older than predefined value (default 5min) Also, checks if no order confirmation was received All orders that match both of the above criteria are then sent again. This is meant to be executed regularly by a scheduled job in the importer.
     * @summary Resend all unprocessed orders.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public resendOrders(options?: any) {
        return InternalApiFp(this.configuration).resendOrders(options)(this.fetch, this.basePath);
    }

    /**
     * Creates and sends a bestfriend update reminder notification for every user.
     * @summary Publish best friend update reminder notifications
     * @param {} bfUpdateNotifications 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public sendBFUpdateReminderNotification(bfUpdateNotifications: Array<BestFriendUpdateNotificationDto>, options?: any) {
        return InternalApiFp(this.configuration).sendBFUpdateReminderNotification(bfUpdateNotifications, options)(this.fetch, this.basePath);
    }

    /**
     * Creates and sends a notification for each user who has one of the newly inactive products on their essence. Is called via the importer after importing the new products.
     * @summary Send product information notifications when product is set to inactive.
     * @param {} tenant 
     * @param {} skus 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public sendProductRemovalNotification(tenant: string, skus: Array<string>, options?: any) {
        return InternalApiFp(this.configuration).sendProductRemovalNotification(tenant, skus, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Summarise order count per product in some time range, the count range. This will only include products that have been ordered in change consideration ranges (one at the start, one at the end), so that products where the popularity has not changed do not need to be updated.
     * @param {} tenant Tenant to scope the request to
     * @param {} countRangeStart The first day on which orders should be considered for counting
     * @param {} countRangeEnd The last day on which orders should be considered for counting
     * @param {} changeConsiderationOffsetDays Relevant for change computation. This specifies how many days before the start of the range and how many days before the end of the range ordered products should be considered as changed. This is also used at the start of the range so that when orders leave the count range, their respective products are updated.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public summarizeChangedProductPopularities(tenant: string, countRangeStart: string, countRangeEnd: string, changeConsiderationOffsetDays: number, options?: any) {
        return InternalApiFp(this.configuration).summarizeChangedProductPopularities(tenant, countRangeStart, countRangeEnd, changeConsiderationOffsetDays, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Summarise order count per product in some time range, the count range. This will only include products that match the SKUs passed.
     * @param {} tenant Tenant to scope the request to
     * @param {} countRangeStart The first day on which orders should be considered for counting
     * @param {} countRangeEnd The last day on which orders should be considered for counting
     * @param {} skus 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalApi
     */
    public summarizeProductPopularitiesForSkus(tenant: string, countRangeStart: string, countRangeEnd: string, skus: Array<string>, options?: any) {
        return InternalApiFp(this.configuration).summarizeProductPopularitiesForSkus(tenant, countRangeStart, countRangeEnd, skus, options)(this.fetch, this.basePath);
    }

}

/**
 * InternalCmsApi - fetch parameter creator
 * @export
 */
export const InternalCmsApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Submit a form backend by a CMS schema for email delivery. This endpoint assumes that the client has verified integrity of receivers and data. Requires the internal-bot-frontend role.
         * @param {string} tenant The tenant
         * @param {CmsForm} form 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitCmsForm(tenant: string, form: CmsForm, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling submitCmsForm.');
            }
            // verify required parameter 'form' is not null or undefined
            if (form === null || form === undefined) {
                throw new RequiredError('form','Required parameter form was null or undefined when calling submitCmsForm.');
            }
            const localVarPath = `/.internal/frontend/{tenant}/submit-cms-form`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"CmsForm" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(form || {}) : (form || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InternalCmsApi - functional programming interface
 * @export
 */
export const InternalCmsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Submit a form backend by a CMS schema for email delivery. This endpoint assumes that the client has verified integrity of receivers and data. Requires the internal-bot-frontend role.
         * @param {string} tenant The tenant
         * @param {CmsForm} form 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitCmsForm(tenant: string, form: CmsForm, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = InternalCmsApiFetchParamCreator(configuration).submitCmsForm(tenant, form, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * InternalCmsApi - factory interface
 * @export
 */
export const InternalCmsApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * Submit a form backend by a CMS schema for email delivery. This endpoint assumes that the client has verified integrity of receivers and data. Requires the internal-bot-frontend role.
         * @param {string} tenant The tenant
         * @param {CmsForm} form 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitCmsForm(tenant: string, form: CmsForm, options?: any) {
            return InternalCmsApiFp(configuration).submitCmsForm(tenant, form, options)(fetch, basePath);
        },
    };
};

/**
 * InternalCmsApi - object-oriented interface
 * @export
 * @class InternalCmsApi
 * @extends {BaseAPI}
 */
export class InternalCmsApi extends BaseAPI {
    /**
     * Submit a form backend by a CMS schema for email delivery. This endpoint assumes that the client has verified integrity of receivers and data. Requires the internal-bot-frontend role.
     * @param {} tenant The tenant
     * @param {} form 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalCmsApi
     */
    public submitCmsForm(tenant: string, form: CmsForm, options?: any) {
        return InternalCmsApiFp(this.configuration).submitCmsForm(tenant, form, options)(this.fetch, this.basePath);
    }

}

/**
 * InventoriesApi - fetch parameter creator
 * @export
 */
export const InventoriesApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Creates a inventory with the given item and sends a success-email to the currently logged-in user.
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customerId of the customer to target
         * @param {InventoryCreationDto} inventoryCreationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInventoryAndQueueConfirmationMail(tenant: string, customerId: string, inventoryCreationDto: InventoryCreationDto, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling createInventoryAndQueueConfirmationMail.');
            }
            // verify required parameter 'customerId' is not null or undefined
            if (customerId === null || customerId === undefined) {
                throw new RequiredError('customerId','Required parameter customerId was null or undefined when calling createInventoryAndQueueConfirmationMail.');
            }
            // verify required parameter 'inventoryCreationDto' is not null or undefined
            if (inventoryCreationDto === null || inventoryCreationDto === undefined) {
                throw new RequiredError('inventoryCreationDto','Required parameter inventoryCreationDto was null or undefined when calling createInventoryAndQueueConfirmationMail.');
            }
            const localVarPath = `/t/{tenant}/inventories`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"InventoryCreationDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(inventoryCreationDto || {}) : (inventoryCreationDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a specific inventory
         * @param {string} tenant The tenant of the customer to target
         * @param {number} inventoryId The id of the inventory to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteInventory(tenant: string, inventoryId: number, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling deleteInventory.');
            }
            // verify required parameter 'inventoryId' is not null or undefined
            if (inventoryId === null || inventoryId === undefined) {
                throw new RequiredError('inventoryId','Required parameter inventoryId was null or undefined when calling deleteInventory.');
            }
            const localVarPath = `/t/{tenant}/inventories/{inventoryId}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"inventoryId"}}`, encodeURIComponent(String(inventoryId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get inventories of a customer grouped by month and year
         * @param {string} tenant The tenant of the customer to target
         * @param {string} customerId The tenant-specific customerId of the customer to target
         * @param {string} [sortDirection] Sort direction
         * @param {number} [pageNumber] Page index
         * @param {number} [pageSize] Page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEffectiveCustomerInventoriesGrouped(tenant: string, customerId: string, sortDirection?: string, pageNumber?: number, pageSize?: number, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling getEffectiveCustomerInventoriesGrouped.');
            }
            // verify required parameter 'customerId' is not null or undefined
            if (customerId === null || customerId === undefined) {
                throw new RequiredError('customerId','Required parameter customerId was null or undefined when calling getEffectiveCustomerInventoriesGrouped.');
            }
            const localVarPath = `/t/{tenant}/groupedInventories`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customerId of the effective customer to target
         * @param {boolean} groupByArticleChecked Whether to group the calculations by unique products
         * @param {string} generationMode End date for the excel generation
         * @param {string} [fromDate] Beginning date for the excel generation
         * @param {string} [toDate] End date for the excel generation
         * @param {Array&lt;number&gt;} [inventoryIds] List of inventories by id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInventoriesExcel(tenant: string, customerId: string, groupByArticleChecked: boolean, generationMode: string, fromDate?: string, toDate?: string, inventoryIds?: Array<number>, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling getInventoriesExcel.');
            }
            // verify required parameter 'customerId' is not null or undefined
            if (customerId === null || customerId === undefined) {
                throw new RequiredError('customerId','Required parameter customerId was null or undefined when calling getInventoriesExcel.');
            }
            // verify required parameter 'groupByArticleChecked' is not null or undefined
            if (groupByArticleChecked === null || groupByArticleChecked === undefined) {
                throw new RequiredError('groupByArticleChecked','Required parameter groupByArticleChecked was null or undefined when calling getInventoriesExcel.');
            }
            // verify required parameter 'generationMode' is not null or undefined
            if (generationMode === null || generationMode === undefined) {
                throw new RequiredError('generationMode','Required parameter generationMode was null or undefined when calling getInventoriesExcel.');
            }
            const localVarPath = `/t/{tenant}/inventories/excel`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }

            if (groupByArticleChecked !== undefined) {
                localVarQueryParameter['groupByArticleChecked'] = groupByArticleChecked;
            }

            if (generationMode !== undefined) {
                localVarQueryParameter['generationMode'] = generationMode;
            }

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = (fromDate as any).toISOString();
            }

            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = (toDate as any).toISOString();
            }

            if (inventoryIds) {
                localVarQueryParameter['inventoryIds'] = inventoryIds.join(COLLECTION_FORMATS["csv"]);
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InventoriesApi - functional programming interface
 * @export
 */
export const InventoriesApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Creates a inventory with the given item and sends a success-email to the currently logged-in user.
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customerId of the customer to target
         * @param {InventoryCreationDto} inventoryCreationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInventoryAndQueueConfirmationMail(tenant: string, customerId: string, inventoryCreationDto: InventoryCreationDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<InventoryDto> {
            const localVarFetchArgs = InventoriesApiFetchParamCreator(configuration).createInventoryAndQueueConfirmationMail(tenant, customerId, inventoryCreationDto, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Delete a specific inventory
         * @param {string} tenant The tenant of the customer to target
         * @param {number} inventoryId The id of the inventory to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteInventory(tenant: string, inventoryId: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = InventoriesApiFetchParamCreator(configuration).deleteInventory(tenant, inventoryId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get inventories of a customer grouped by month and year
         * @param {string} tenant The tenant of the customer to target
         * @param {string} customerId The tenant-specific customerId of the customer to target
         * @param {string} [sortDirection] Sort direction
         * @param {number} [pageNumber] Page index
         * @param {number} [pageSize] Page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEffectiveCustomerInventoriesGrouped(tenant: string, customerId: string, sortDirection?: string, pageNumber?: number, pageSize?: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<GroupedPagedInventoriesDto> {
            const localVarFetchArgs = InventoriesApiFetchParamCreator(configuration).getEffectiveCustomerInventoriesGrouped(tenant, customerId, sortDirection, pageNumber, pageSize, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customerId of the effective customer to target
         * @param {boolean} groupByArticleChecked Whether to group the calculations by unique products
         * @param {string} generationMode End date for the excel generation
         * @param {string} [fromDate] Beginning date for the excel generation
         * @param {string} [toDate] End date for the excel generation
         * @param {Array&lt;number&gt;} [inventoryIds] List of inventories by id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInventoriesExcel(tenant: string, customerId: string, groupByArticleChecked: boolean, generationMode: string, fromDate?: string, toDate?: string, inventoryIds?: Array<number>, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = InventoriesApiFetchParamCreator(configuration).getInventoriesExcel(tenant, customerId, groupByArticleChecked, generationMode, fromDate, toDate, inventoryIds, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * InventoriesApi - factory interface
 * @export
 */
export const InventoriesApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Creates a inventory with the given item and sends a success-email to the currently logged-in user.
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customerId of the customer to target
         * @param {InventoryCreationDto} inventoryCreationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInventoryAndQueueConfirmationMail(tenant: string, customerId: string, inventoryCreationDto: InventoryCreationDto, options?: any) {
            return InventoriesApiFp(configuration).createInventoryAndQueueConfirmationMail(tenant, customerId, inventoryCreationDto, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Delete a specific inventory
         * @param {string} tenant The tenant of the customer to target
         * @param {number} inventoryId The id of the inventory to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteInventory(tenant: string, inventoryId: number, options?: any) {
            return InventoriesApiFp(configuration).deleteInventory(tenant, inventoryId, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get inventories of a customer grouped by month and year
         * @param {string} tenant The tenant of the customer to target
         * @param {string} customerId The tenant-specific customerId of the customer to target
         * @param {string} [sortDirection] Sort direction
         * @param {number} [pageNumber] Page index
         * @param {number} [pageSize] Page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEffectiveCustomerInventoriesGrouped(tenant: string, customerId: string, sortDirection?: string, pageNumber?: number, pageSize?: number, options?: any) {
            return InventoriesApiFp(configuration).getEffectiveCustomerInventoriesGrouped(tenant, customerId, sortDirection, pageNumber, pageSize, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customerId of the effective customer to target
         * @param {boolean} groupByArticleChecked Whether to group the calculations by unique products
         * @param {string} generationMode End date for the excel generation
         * @param {string} [fromDate] Beginning date for the excel generation
         * @param {string} [toDate] End date for the excel generation
         * @param {Array&lt;number&gt;} [inventoryIds] List of inventories by id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInventoriesExcel(tenant: string, customerId: string, groupByArticleChecked: boolean, generationMode: string, fromDate?: string, toDate?: string, inventoryIds?: Array<number>, options?: any) {
            return InventoriesApiFp(configuration).getInventoriesExcel(tenant, customerId, groupByArticleChecked, generationMode, fromDate, toDate, inventoryIds, options)(fetch, basePath);
        },
    };
};

/**
 * InventoriesApi - object-oriented interface
 * @export
 * @class InventoriesApi
 * @extends {BaseAPI}
 */
export class InventoriesApi extends BaseAPI {
    /**
     * 
     * @summary Creates a inventory with the given item and sends a success-email to the currently logged-in user.
     * @param {} tenant The EGB code of the tenant to target
     * @param {} customerId The tenant-specific customerId of the customer to target
     * @param {} inventoryCreationDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoriesApi
     */
    public createInventoryAndQueueConfirmationMail(tenant: string, customerId: string, inventoryCreationDto: InventoryCreationDto, options?: any) {
        return InventoriesApiFp(this.configuration).createInventoryAndQueueConfirmationMail(tenant, customerId, inventoryCreationDto, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Delete a specific inventory
     * @param {} tenant The tenant of the customer to target
     * @param {} inventoryId The id of the inventory to delete
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoriesApi
     */
    public deleteInventory(tenant: string, inventoryId: number, options?: any) {
        return InventoriesApiFp(this.configuration).deleteInventory(tenant, inventoryId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get inventories of a customer grouped by month and year
     * @param {} tenant The tenant of the customer to target
     * @param {} customerId The tenant-specific customerId of the customer to target
     * @param {} [sortDirection] Sort direction
     * @param {} [pageNumber] Page index
     * @param {} [pageSize] Page size
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoriesApi
     */
    public getEffectiveCustomerInventoriesGrouped(tenant: string, customerId: string, sortDirection?: string, pageNumber?: number, pageSize?: number, options?: any) {
        return InventoriesApiFp(this.configuration).getEffectiveCustomerInventoriesGrouped(tenant, customerId, sortDirection, pageNumber, pageSize, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {} tenant The EGB code of the tenant to target
     * @param {} customerId The tenant-specific customerId of the effective customer to target
     * @param {} groupByArticleChecked Whether to group the calculations by unique products
     * @param {} generationMode End date for the excel generation
     * @param {} [fromDate] Beginning date for the excel generation
     * @param {} [toDate] End date for the excel generation
     * @param {} [inventoryIds] List of inventories by id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoriesApi
     */
    public getInventoriesExcel(tenant: string, customerId: string, groupByArticleChecked: boolean, generationMode: string, fromDate?: string, toDate?: string, inventoryIds?: Array<number>, options?: any) {
        return InventoriesApiFp(this.configuration).getInventoriesExcel(tenant, customerId, groupByArticleChecked, generationMode, fromDate, toDate, inventoryIds, options)(this.fetch, this.basePath);
    }

}

/**
 * LabelSelectionApi - fetch parameter creator
 * @export
 */
export const LabelSelectionApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add visible essence items to label selection
         * @param {string} tenant 
         * @param {string} customerId The tenant-specific customer id to request the information for. This will affect things such as prices and articles.
         * @param {ProductSearchFilter} searchBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAllEssenceItemsToLabelPrint(tenant: string, customerId: string, searchBody: ProductSearchFilter, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling addAllEssenceItemsToLabelPrint.');
            }
            // verify required parameter 'customerId' is not null or undefined
            if (customerId === null || customerId === undefined) {
                throw new RequiredError('customerId','Required parameter customerId was null or undefined when calling addAllEssenceItemsToLabelPrint.');
            }
            // verify required parameter 'searchBody' is not null or undefined
            if (searchBody === null || searchBody === undefined) {
                throw new RequiredError('searchBody','Required parameter searchBody was null or undefined when calling addAllEssenceItemsToLabelPrint.');
            }
            const localVarPath = `/t/{tenant}/my/labels/add-all-from-essences`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ProductSearchFilter" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(searchBody || {}) : (searchBody || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a product the the label print selection for a single label. Does nothing if given product is already selected, regardless of quantity.
         * @summary Add a product to the label print selection
         * @param {string} tenant 
         * @param {string} sku 
         * @param {string} customerId The tenant-specific customer id to request the information for. This will affect things such as prices and articles.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addItemToLabelPrint(tenant: string, sku: string, customerId: string, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling addItemToLabelPrint.');
            }
            // verify required parameter 'sku' is not null or undefined
            if (sku === null || sku === undefined) {
                throw new RequiredError('sku','Required parameter sku was null or undefined when calling addItemToLabelPrint.');
            }
            // verify required parameter 'customerId' is not null or undefined
            if (customerId === null || customerId === undefined) {
                throw new RequiredError('customerId','Required parameter customerId was null or undefined when calling addItemToLabelPrint.');
            }
            const localVarPath = `/t/{tenant}/my/labels/{sku}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"sku"}}`, encodeURIComponent(String(sku)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deletes all labels for the current user within the customer
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customer id to request the information for. This will affect things such as prices and products.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearOwnLabelPrintList(tenant: string, customerId: string, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling clearOwnLabelPrintList.');
            }
            // verify required parameter 'customerId' is not null or undefined
            if (customerId === null || customerId === undefined) {
                throw new RequiredError('customerId','Required parameter customerId was null or undefined when calling clearOwnLabelPrintList.');
            }
            const localVarPath = `/t/{tenant}/my/labels`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove product from label selection
         * @param {string} tenant 
         * @param {string} sku 
         * @param {string} customerId The tenant-specific customer id to request the information for. This will affect things such as prices and articles.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteItemFromLabelPrint(tenant: string, sku: string, customerId: string, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling deleteItemFromLabelPrint.');
            }
            // verify required parameter 'sku' is not null or undefined
            if (sku === null || sku === undefined) {
                throw new RequiredError('sku','Required parameter sku was null or undefined when calling deleteItemFromLabelPrint.');
            }
            // verify required parameter 'customerId' is not null or undefined
            if (customerId === null || customerId === undefined) {
                throw new RequiredError('customerId','Required parameter customerId was null or undefined when calling deleteItemFromLabelPrint.');
            }
            const localVarPath = `/t/{tenant}/my/labels/{sku}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"sku"}}`, encodeURIComponent(String(sku)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove inactive products from label selection
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customer id to request the information for. This will affect things such as prices and products.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLabelPrintRecordsForInactiveProducts(tenant: string, customerId: string, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling deleteLabelPrintRecordsForInactiveProducts.');
            }
            // verify required parameter 'customerId' is not null or undefined
            if (customerId === null || customerId === undefined) {
                throw new RequiredError('customerId','Required parameter customerId was null or undefined when calling deleteLabelPrintRecordsForInactiveProducts.');
            }
            const localVarPath = `/t/{tenant}/my/labels/check-for-inactive-products`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Generates a label-print-pdf from the body and sends it to the currently logged in user as an email.
         * @param {string} tenant 
         * @param {string} customerId The tenant-specific customer id to request the information for.
         * @param {Array&lt;LabelMailItemDto&gt;} labelPrintData 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateLabelPrintPdfAndEmailToUser(tenant: string, customerId: string, labelPrintData: Array<LabelMailItemDto>, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling generateLabelPrintPdfAndEmailToUser.');
            }
            // verify required parameter 'customerId' is not null or undefined
            if (customerId === null || customerId === undefined) {
                throw new RequiredError('customerId','Required parameter customerId was null or undefined when calling generateLabelPrintPdfAndEmailToUser.');
            }
            // verify required parameter 'labelPrintData' is not null or undefined
            if (labelPrintData === null || labelPrintData === undefined) {
                throw new RequiredError('labelPrintData','Required parameter labelPrintData was null or undefined when calling generateLabelPrintPdfAndEmailToUser.');
            }
            const localVarPath = `/t/{tenant}/my/emails/label-print`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"Array&lt;LabelMailItemDto&gt;" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(labelPrintData || {}) : (labelPrintData || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customer id to request the information for. This will affect things such as prices and articles.
         * @param {LabelProductRequest} labelProductRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateLabelSelectionPdf(tenant: string, customerId: string, labelProductRequest: LabelProductRequest, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling generateLabelSelectionPdf.');
            }
            // verify required parameter 'customerId' is not null or undefined
            if (customerId === null || customerId === undefined) {
                throw new RequiredError('customerId','Required parameter customerId was null or undefined when calling generateLabelSelectionPdf.');
            }
            // verify required parameter 'labelProductRequest' is not null or undefined
            if (labelProductRequest === null || labelProductRequest === undefined) {
                throw new RequiredError('labelProductRequest','Required parameter labelProductRequest was null or undefined when calling generateLabelSelectionPdf.');
            }
            const localVarPath = `/t/{tenant}/my/labels/generate`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"LabelProductRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(labelProductRequest || {}) : (labelProductRequest || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Check whether a product is selected for label printing
         * @param {string} tenant 
         * @param {string} sku 
         * @param {string} customerId The tenant-specific customer id to request the information for. This will affect things such as prices and articles.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLabelPrintSku(tenant: string, sku: string, customerId: string, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling getLabelPrintSku.');
            }
            // verify required parameter 'sku' is not null or undefined
            if (sku === null || sku === undefined) {
                throw new RequiredError('sku','Required parameter sku was null or undefined when calling getLabelPrintSku.');
            }
            // verify required parameter 'customerId' is not null or undefined
            if (customerId === null || customerId === undefined) {
                throw new RequiredError('customerId','Required parameter customerId was null or undefined when calling getLabelPrintSku.');
            }
            const localVarPath = `/t/{tenant}/my/labels/{sku}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"sku"}}`, encodeURIComponent(String(sku)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get label selection
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customer id to request the information for. This will affect things such as prices and products.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOwnLabelPrint(tenant: string, customerId: string, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling getOwnLabelPrint.');
            }
            // verify required parameter 'customerId' is not null or undefined
            if (customerId === null || customerId === undefined) {
                throw new RequiredError('customerId','Required parameter customerId was null or undefined when calling getOwnLabelPrint.');
            }
            const localVarPath = `/t/{tenant}/my/labels`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary SKUs of products currently in the label selection
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customer id to request the information for. This will affect things such as prices and products.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOwnLabelSkus(tenant: string, customerId: string, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling getOwnLabelSkus.');
            }
            // verify required parameter 'customerId' is not null or undefined
            if (customerId === null || customerId === undefined) {
                throw new RequiredError('customerId','Required parameter customerId was null or undefined when calling getOwnLabelSkus.');
            }
            const localVarPath = `/t/{tenant}/my/label-skus`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Products currentlyin the label selection
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customer id to request the information for. This will affect things such as prices.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductsForLabelPrint(tenant: string, customerId: string, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling getProductsForLabelPrint.');
            }
            // verify required parameter 'customerId' is not null or undefined
            if (customerId === null || customerId === undefined) {
                throw new RequiredError('customerId','Required parameter customerId was null or undefined when calling getProductsForLabelPrint.');
            }
            const localVarPath = `/t/{tenant}/my/labels/products`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuthOptional required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuthOptional", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LabelSelectionApi - functional programming interface
 * @export
 */
export const LabelSelectionApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add visible essence items to label selection
         * @param {string} tenant 
         * @param {string} customerId The tenant-specific customer id to request the information for. This will affect things such as prices and articles.
         * @param {ProductSearchFilter} searchBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAllEssenceItemsToLabelPrint(tenant: string, customerId: string, searchBody: ProductSearchFilter, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<string>> {
            const localVarFetchArgs = LabelSelectionApiFetchParamCreator(configuration).addAllEssenceItemsToLabelPrint(tenant, customerId, searchBody, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Add a product the the label print selection for a single label. Does nothing if given product is already selected, regardless of quantity.
         * @summary Add a product to the label print selection
         * @param {string} tenant 
         * @param {string} sku 
         * @param {string} customerId The tenant-specific customer id to request the information for. This will affect things such as prices and articles.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addItemToLabelPrint(tenant: string, sku: string, customerId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = LabelSelectionApiFetchParamCreator(configuration).addItemToLabelPrint(tenant, sku, customerId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Deletes all labels for the current user within the customer
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customer id to request the information for. This will affect things such as prices and products.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearOwnLabelPrintList(tenant: string, customerId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = LabelSelectionApiFetchParamCreator(configuration).clearOwnLabelPrintList(tenant, customerId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Remove product from label selection
         * @param {string} tenant 
         * @param {string} sku 
         * @param {string} customerId The tenant-specific customer id to request the information for. This will affect things such as prices and articles.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteItemFromLabelPrint(tenant: string, sku: string, customerId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = LabelSelectionApiFetchParamCreator(configuration).deleteItemFromLabelPrint(tenant, sku, customerId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Remove inactive products from label selection
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customer id to request the information for. This will affect things such as prices and products.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLabelPrintRecordsForInactiveProducts(tenant: string, customerId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = LabelSelectionApiFetchParamCreator(configuration).deleteLabelPrintRecordsForInactiveProducts(tenant, customerId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Generates a label-print-pdf from the body and sends it to the currently logged in user as an email.
         * @param {string} tenant 
         * @param {string} customerId The tenant-specific customer id to request the information for.
         * @param {Array&lt;LabelMailItemDto&gt;} labelPrintData 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateLabelPrintPdfAndEmailToUser(tenant: string, customerId: string, labelPrintData: Array<LabelMailItemDto>, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = LabelSelectionApiFetchParamCreator(configuration).generateLabelPrintPdfAndEmailToUser(tenant, customerId, labelPrintData, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customer id to request the information for. This will affect things such as prices and articles.
         * @param {LabelProductRequest} labelProductRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateLabelSelectionPdf(tenant: string, customerId: string, labelProductRequest: LabelProductRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = LabelSelectionApiFetchParamCreator(configuration).generateLabelSelectionPdf(tenant, customerId, labelProductRequest, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Check whether a product is selected for label printing
         * @param {string} tenant 
         * @param {string} sku 
         * @param {string} customerId The tenant-specific customer id to request the information for. This will affect things such as prices and articles.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLabelPrintSku(tenant: string, sku: string, customerId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<boolean> {
            const localVarFetchArgs = LabelSelectionApiFetchParamCreator(configuration).getLabelPrintSku(tenant, sku, customerId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get label selection
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customer id to request the information for. This will affect things such as prices and products.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOwnLabelPrint(tenant: string, customerId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<LabelPrintDto> {
            const localVarFetchArgs = LabelSelectionApiFetchParamCreator(configuration).getOwnLabelPrint(tenant, customerId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary SKUs of products currently in the label selection
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customer id to request the information for. This will affect things such as prices and products.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOwnLabelSkus(tenant: string, customerId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<string>> {
            const localVarFetchArgs = LabelSelectionApiFetchParamCreator(configuration).getOwnLabelSkus(tenant, customerId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Products currentlyin the label selection
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customer id to request the information for. This will affect things such as prices.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductsForLabelPrint(tenant: string, customerId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<ProductDto>> {
            const localVarFetchArgs = LabelSelectionApiFetchParamCreator(configuration).getProductsForLabelPrint(tenant, customerId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * LabelSelectionApi - factory interface
 * @export
 */
export const LabelSelectionApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Add visible essence items to label selection
         * @param {string} tenant 
         * @param {string} customerId The tenant-specific customer id to request the information for. This will affect things such as prices and articles.
         * @param {ProductSearchFilter} searchBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAllEssenceItemsToLabelPrint(tenant: string, customerId: string, searchBody: ProductSearchFilter, options?: any) {
            return LabelSelectionApiFp(configuration).addAllEssenceItemsToLabelPrint(tenant, customerId, searchBody, options)(fetch, basePath);
        },
        /**
         * Add a product the the label print selection for a single label. Does nothing if given product is already selected, regardless of quantity.
         * @summary Add a product to the label print selection
         * @param {string} tenant 
         * @param {string} sku 
         * @param {string} customerId The tenant-specific customer id to request the information for. This will affect things such as prices and articles.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addItemToLabelPrint(tenant: string, sku: string, customerId: string, options?: any) {
            return LabelSelectionApiFp(configuration).addItemToLabelPrint(tenant, sku, customerId, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Deletes all labels for the current user within the customer
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customer id to request the information for. This will affect things such as prices and products.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearOwnLabelPrintList(tenant: string, customerId: string, options?: any) {
            return LabelSelectionApiFp(configuration).clearOwnLabelPrintList(tenant, customerId, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Remove product from label selection
         * @param {string} tenant 
         * @param {string} sku 
         * @param {string} customerId The tenant-specific customer id to request the information for. This will affect things such as prices and articles.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteItemFromLabelPrint(tenant: string, sku: string, customerId: string, options?: any) {
            return LabelSelectionApiFp(configuration).deleteItemFromLabelPrint(tenant, sku, customerId, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Remove inactive products from label selection
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customer id to request the information for. This will affect things such as prices and products.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLabelPrintRecordsForInactiveProducts(tenant: string, customerId: string, options?: any) {
            return LabelSelectionApiFp(configuration).deleteLabelPrintRecordsForInactiveProducts(tenant, customerId, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Generates a label-print-pdf from the body and sends it to the currently logged in user as an email.
         * @param {string} tenant 
         * @param {string} customerId The tenant-specific customer id to request the information for.
         * @param {Array&lt;LabelMailItemDto&gt;} labelPrintData 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateLabelPrintPdfAndEmailToUser(tenant: string, customerId: string, labelPrintData: Array<LabelMailItemDto>, options?: any) {
            return LabelSelectionApiFp(configuration).generateLabelPrintPdfAndEmailToUser(tenant, customerId, labelPrintData, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customer id to request the information for. This will affect things such as prices and articles.
         * @param {LabelProductRequest} labelProductRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateLabelSelectionPdf(tenant: string, customerId: string, labelProductRequest: LabelProductRequest, options?: any) {
            return LabelSelectionApiFp(configuration).generateLabelSelectionPdf(tenant, customerId, labelProductRequest, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Check whether a product is selected for label printing
         * @param {string} tenant 
         * @param {string} sku 
         * @param {string} customerId The tenant-specific customer id to request the information for. This will affect things such as prices and articles.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLabelPrintSku(tenant: string, sku: string, customerId: string, options?: any) {
            return LabelSelectionApiFp(configuration).getLabelPrintSku(tenant, sku, customerId, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get label selection
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customer id to request the information for. This will affect things such as prices and products.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOwnLabelPrint(tenant: string, customerId: string, options?: any) {
            return LabelSelectionApiFp(configuration).getOwnLabelPrint(tenant, customerId, options)(fetch, basePath);
        },
        /**
         * 
         * @summary SKUs of products currently in the label selection
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customer id to request the information for. This will affect things such as prices and products.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOwnLabelSkus(tenant: string, customerId: string, options?: any) {
            return LabelSelectionApiFp(configuration).getOwnLabelSkus(tenant, customerId, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Products currentlyin the label selection
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customer id to request the information for. This will affect things such as prices.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductsForLabelPrint(tenant: string, customerId: string, options?: any) {
            return LabelSelectionApiFp(configuration).getProductsForLabelPrint(tenant, customerId, options)(fetch, basePath);
        },
    };
};

/**
 * LabelSelectionApi - object-oriented interface
 * @export
 * @class LabelSelectionApi
 * @extends {BaseAPI}
 */
export class LabelSelectionApi extends BaseAPI {
    /**
     * 
     * @summary Add visible essence items to label selection
     * @param {} tenant 
     * @param {} customerId The tenant-specific customer id to request the information for. This will affect things such as prices and articles.
     * @param {} searchBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LabelSelectionApi
     */
    public addAllEssenceItemsToLabelPrint(tenant: string, customerId: string, searchBody: ProductSearchFilter, options?: any) {
        return LabelSelectionApiFp(this.configuration).addAllEssenceItemsToLabelPrint(tenant, customerId, searchBody, options)(this.fetch, this.basePath);
    }

    /**
     * Add a product the the label print selection for a single label. Does nothing if given product is already selected, regardless of quantity.
     * @summary Add a product to the label print selection
     * @param {} tenant 
     * @param {} sku 
     * @param {} customerId The tenant-specific customer id to request the information for. This will affect things such as prices and articles.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LabelSelectionApi
     */
    public addItemToLabelPrint(tenant: string, sku: string, customerId: string, options?: any) {
        return LabelSelectionApiFp(this.configuration).addItemToLabelPrint(tenant, sku, customerId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Deletes all labels for the current user within the customer
     * @param {} tenant The EGB code of the tenant to target
     * @param {} customerId The tenant-specific customer id to request the information for. This will affect things such as prices and products.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LabelSelectionApi
     */
    public clearOwnLabelPrintList(tenant: string, customerId: string, options?: any) {
        return LabelSelectionApiFp(this.configuration).clearOwnLabelPrintList(tenant, customerId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Remove product from label selection
     * @param {} tenant 
     * @param {} sku 
     * @param {} customerId The tenant-specific customer id to request the information for. This will affect things such as prices and articles.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LabelSelectionApi
     */
    public deleteItemFromLabelPrint(tenant: string, sku: string, customerId: string, options?: any) {
        return LabelSelectionApiFp(this.configuration).deleteItemFromLabelPrint(tenant, sku, customerId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Remove inactive products from label selection
     * @param {} tenant The EGB code of the tenant to target
     * @param {} customerId The tenant-specific customer id to request the information for. This will affect things such as prices and products.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LabelSelectionApi
     */
    public deleteLabelPrintRecordsForInactiveProducts(tenant: string, customerId: string, options?: any) {
        return LabelSelectionApiFp(this.configuration).deleteLabelPrintRecordsForInactiveProducts(tenant, customerId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Generates a label-print-pdf from the body and sends it to the currently logged in user as an email.
     * @param {} tenant 
     * @param {} customerId The tenant-specific customer id to request the information for.
     * @param {} labelPrintData 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LabelSelectionApi
     */
    public generateLabelPrintPdfAndEmailToUser(tenant: string, customerId: string, labelPrintData: Array<LabelMailItemDto>, options?: any) {
        return LabelSelectionApiFp(this.configuration).generateLabelPrintPdfAndEmailToUser(tenant, customerId, labelPrintData, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {} tenant The EGB code of the tenant to target
     * @param {} customerId The tenant-specific customer id to request the information for. This will affect things such as prices and articles.
     * @param {} labelProductRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LabelSelectionApi
     */
    public generateLabelSelectionPdf(tenant: string, customerId: string, labelProductRequest: LabelProductRequest, options?: any) {
        return LabelSelectionApiFp(this.configuration).generateLabelSelectionPdf(tenant, customerId, labelProductRequest, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Check whether a product is selected for label printing
     * @param {} tenant 
     * @param {} sku 
     * @param {} customerId The tenant-specific customer id to request the information for. This will affect things such as prices and articles.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LabelSelectionApi
     */
    public getLabelPrintSku(tenant: string, sku: string, customerId: string, options?: any) {
        return LabelSelectionApiFp(this.configuration).getLabelPrintSku(tenant, sku, customerId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get label selection
     * @param {} tenant The EGB code of the tenant to target
     * @param {} customerId The tenant-specific customer id to request the information for. This will affect things such as prices and products.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LabelSelectionApi
     */
    public getOwnLabelPrint(tenant: string, customerId: string, options?: any) {
        return LabelSelectionApiFp(this.configuration).getOwnLabelPrint(tenant, customerId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary SKUs of products currently in the label selection
     * @param {} tenant The EGB code of the tenant to target
     * @param {} customerId The tenant-specific customer id to request the information for. This will affect things such as prices and products.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LabelSelectionApi
     */
    public getOwnLabelSkus(tenant: string, customerId: string, options?: any) {
        return LabelSelectionApiFp(this.configuration).getOwnLabelSkus(tenant, customerId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Products currentlyin the label selection
     * @param {} tenant The EGB code of the tenant to target
     * @param {} customerId The tenant-specific customer id to request the information for. This will affect things such as prices.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LabelSelectionApi
     */
    public getProductsForLabelPrint(tenant: string, customerId: string, options?: any) {
        return LabelSelectionApiFp(this.configuration).getProductsForLabelPrint(tenant, customerId, options)(this.fetch, this.basePath);
    }

}

/**
 * ManageBestFriendApi - fetch parameter creator
 * @export
 */
export const ManageBestFriendApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create Best Friend Settings of Best Friend devices
         * @summary Create BestFriend settings
         * @param {BestFriendSettingsDto} bestFriendSettings 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBestFriendSettings(bestFriendSettings: BestFriendSettingsDto, options: any = {}): FetchArgs {
            // verify required parameter 'bestFriendSettings' is not null or undefined
            if (bestFriendSettings === null || bestFriendSettings === undefined) {
                throw new RequiredError('bestFriendSettings','Required parameter bestFriendSettings was null or undefined when calling createBestFriendSettings.');
            }
            const localVarPath = `/.internal/manage/bestfriend/bestFriendSettings`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"BestFriendSettingsDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(bestFriendSettings || {}) : (bestFriendSettings || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete BestFriendSetting by ID
         * @param {number} id The id to work with
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBestFriendSettingsById(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteBestFriendSettingsById.');
            }
            const localVarPath = `/.internal/manage/bestfriend/bestFriendSettings/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all BestFriendSettings
         * @param {number} pageNumber The page to get
         * @param {number} pageSize The amount of items to retrieve per page
         * @param {Array&lt;string&gt;} [tenants] Tenants to filter against, eg. tenants&#x3D;LL,LS
         * @param {string} [scannersn] Scanner serial number to filter against
         * @param {number} [id] Scanner ID to filter against
         * @param {string} [assignedUserName] The user name or part of it to filter against
         * @param {string} [status] 
         * @param {number} [priceDisplay] See&#39; preisanzeige&#39; here https://confluence.eurogast.at/x/hoCD
         * @param {boolean} [showPromotions] Filters BFs against promotion price display. If param is missing, both BFs which highlight promotion prices AND those which don&#39;t are returned.
         * @param {boolean} [showSpecialPrices] Filters BFs against special price display. If param is missing, both BFs which highlight special prices AND those which don&#39;t are returned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllBestFriendSettings(pageNumber: number, pageSize: number, tenants?: Array<string>, scannersn?: string, id?: number, assignedUserName?: string, status?: string, priceDisplay?: number, showPromotions?: boolean, showSpecialPrices?: boolean, options: any = {}): FetchArgs {
            // verify required parameter 'pageNumber' is not null or undefined
            if (pageNumber === null || pageNumber === undefined) {
                throw new RequiredError('pageNumber','Required parameter pageNumber was null or undefined when calling getAllBestFriendSettings.');
            }
            // verify required parameter 'pageSize' is not null or undefined
            if (pageSize === null || pageSize === undefined) {
                throw new RequiredError('pageSize','Required parameter pageSize was null or undefined when calling getAllBestFriendSettings.');
            }
            const localVarPath = `/.internal/manage/bestfriend/bestFriendSettings`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (tenants) {
                localVarQueryParameter['tenants'] = tenants.join(COLLECTION_FORMATS["csv"]);
            }

            if (scannersn !== undefined) {
                localVarQueryParameter['scannersn'] = scannersn;
            }

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (assignedUserName !== undefined) {
                localVarQueryParameter['assignedUserName'] = assignedUserName;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (priceDisplay !== undefined) {
                localVarQueryParameter['priceDisplay'] = priceDisplay;
            }

            if (showPromotions !== undefined) {
                localVarQueryParameter['showPromotions'] = showPromotions;
            }

            if (showSpecialPrices !== undefined) {
                localVarQueryParameter['showSpecialPrices'] = showSpecialPrices;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get BestFriendSettings by Id
         * @param {number} id The id to work with
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBestFriendSettingsById(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getBestFriendSettingsById.');
            }
            const localVarPath = `/.internal/manage/bestfriend/bestFriendSettings/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update BestFriend Settings of Best Friend devices
         * @summary Update BestFriendSettings
         * @param {BestFriendSettingsDto} bestFriendSettings 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBestFriendSettings(bestFriendSettings: BestFriendSettingsDto, options: any = {}): FetchArgs {
            // verify required parameter 'bestFriendSettings' is not null or undefined
            if (bestFriendSettings === null || bestFriendSettings === undefined) {
                throw new RequiredError('bestFriendSettings','Required parameter bestFriendSettings was null or undefined when calling updateBestFriendSettings.');
            }
            const localVarPath = `/.internal/manage/bestfriend/bestFriendSettings`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"BestFriendSettingsDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(bestFriendSettings || {}) : (bestFriendSettings || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ManageBestFriendApi - functional programming interface
 * @export
 */
export const ManageBestFriendApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Create Best Friend Settings of Best Friend devices
         * @summary Create BestFriend settings
         * @param {BestFriendSettingsDto} bestFriendSettings 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBestFriendSettings(bestFriendSettings: BestFriendSettingsDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<number> {
            const localVarFetchArgs = ManageBestFriendApiFetchParamCreator(configuration).createBestFriendSettings(bestFriendSettings, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Delete BestFriendSetting by ID
         * @param {number} id The id to work with
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBestFriendSettingsById(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = ManageBestFriendApiFetchParamCreator(configuration).deleteBestFriendSettingsById(id, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get all BestFriendSettings
         * @param {number} pageNumber The page to get
         * @param {number} pageSize The amount of items to retrieve per page
         * @param {Array&lt;string&gt;} [tenants] Tenants to filter against, eg. tenants&#x3D;LL,LS
         * @param {string} [scannersn] Scanner serial number to filter against
         * @param {number} [id] Scanner ID to filter against
         * @param {string} [assignedUserName] The user name or part of it to filter against
         * @param {string} [status] 
         * @param {number} [priceDisplay] See&#39; preisanzeige&#39; here https://confluence.eurogast.at/x/hoCD
         * @param {boolean} [showPromotions] Filters BFs against promotion price display. If param is missing, both BFs which highlight promotion prices AND those which don&#39;t are returned.
         * @param {boolean} [showSpecialPrices] Filters BFs against special price display. If param is missing, both BFs which highlight special prices AND those which don&#39;t are returned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllBestFriendSettings(pageNumber: number, pageSize: number, tenants?: Array<string>, scannersn?: string, id?: number, assignedUserName?: string, status?: string, priceDisplay?: number, showPromotions?: boolean, showSpecialPrices?: boolean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<BestFriendSettingsSearchResultDto> {
            const localVarFetchArgs = ManageBestFriendApiFetchParamCreator(configuration).getAllBestFriendSettings(pageNumber, pageSize, tenants, scannersn, id, assignedUserName, status, priceDisplay, showPromotions, showSpecialPrices, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get BestFriendSettings by Id
         * @param {number} id The id to work with
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBestFriendSettingsById(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<BestFriendSettingsDto> {
            const localVarFetchArgs = ManageBestFriendApiFetchParamCreator(configuration).getBestFriendSettingsById(id, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Update BestFriend Settings of Best Friend devices
         * @summary Update BestFriendSettings
         * @param {BestFriendSettingsDto} bestFriendSettings 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBestFriendSettings(bestFriendSettings: BestFriendSettingsDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = ManageBestFriendApiFetchParamCreator(configuration).updateBestFriendSettings(bestFriendSettings, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * ManageBestFriendApi - factory interface
 * @export
 */
export const ManageBestFriendApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * Create Best Friend Settings of Best Friend devices
         * @summary Create BestFriend settings
         * @param {BestFriendSettingsDto} bestFriendSettings 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBestFriendSettings(bestFriendSettings: BestFriendSettingsDto, options?: any) {
            return ManageBestFriendApiFp(configuration).createBestFriendSettings(bestFriendSettings, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Delete BestFriendSetting by ID
         * @param {number} id The id to work with
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBestFriendSettingsById(id: number, options?: any) {
            return ManageBestFriendApiFp(configuration).deleteBestFriendSettingsById(id, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get all BestFriendSettings
         * @param {number} pageNumber The page to get
         * @param {number} pageSize The amount of items to retrieve per page
         * @param {Array&lt;string&gt;} [tenants] Tenants to filter against, eg. tenants&#x3D;LL,LS
         * @param {string} [scannersn] Scanner serial number to filter against
         * @param {number} [id] Scanner ID to filter against
         * @param {string} [assignedUserName] The user name or part of it to filter against
         * @param {string} [status] 
         * @param {number} [priceDisplay] See&#39; preisanzeige&#39; here https://confluence.eurogast.at/x/hoCD
         * @param {boolean} [showPromotions] Filters BFs against promotion price display. If param is missing, both BFs which highlight promotion prices AND those which don&#39;t are returned.
         * @param {boolean} [showSpecialPrices] Filters BFs against special price display. If param is missing, both BFs which highlight special prices AND those which don&#39;t are returned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllBestFriendSettings(pageNumber: number, pageSize: number, tenants?: Array<string>, scannersn?: string, id?: number, assignedUserName?: string, status?: string, priceDisplay?: number, showPromotions?: boolean, showSpecialPrices?: boolean, options?: any) {
            return ManageBestFriendApiFp(configuration).getAllBestFriendSettings(pageNumber, pageSize, tenants, scannersn, id, assignedUserName, status, priceDisplay, showPromotions, showSpecialPrices, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get BestFriendSettings by Id
         * @param {number} id The id to work with
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBestFriendSettingsById(id: number, options?: any) {
            return ManageBestFriendApiFp(configuration).getBestFriendSettingsById(id, options)(fetch, basePath);
        },
        /**
         * Update BestFriend Settings of Best Friend devices
         * @summary Update BestFriendSettings
         * @param {BestFriendSettingsDto} bestFriendSettings 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBestFriendSettings(bestFriendSettings: BestFriendSettingsDto, options?: any) {
            return ManageBestFriendApiFp(configuration).updateBestFriendSettings(bestFriendSettings, options)(fetch, basePath);
        },
    };
};

/**
 * ManageBestFriendApi - object-oriented interface
 * @export
 * @class ManageBestFriendApi
 * @extends {BaseAPI}
 */
export class ManageBestFriendApi extends BaseAPI {
    /**
     * Create Best Friend Settings of Best Friend devices
     * @summary Create BestFriend settings
     * @param {} bestFriendSettings 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageBestFriendApi
     */
    public createBestFriendSettings(bestFriendSettings: BestFriendSettingsDto, options?: any) {
        return ManageBestFriendApiFp(this.configuration).createBestFriendSettings(bestFriendSettings, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Delete BestFriendSetting by ID
     * @param {} id The id to work with
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageBestFriendApi
     */
    public deleteBestFriendSettingsById(id: number, options?: any) {
        return ManageBestFriendApiFp(this.configuration).deleteBestFriendSettingsById(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get all BestFriendSettings
     * @param {} pageNumber The page to get
     * @param {} pageSize The amount of items to retrieve per page
     * @param {} [tenants] Tenants to filter against, eg. tenants&#x3D;LL,LS
     * @param {} [scannersn] Scanner serial number to filter against
     * @param {} [id] Scanner ID to filter against
     * @param {} [assignedUserName] The user name or part of it to filter against
     * @param {} [status] 
     * @param {} [priceDisplay] See&#39; preisanzeige&#39; here https://confluence.eurogast.at/x/hoCD
     * @param {} [showPromotions] Filters BFs against promotion price display. If param is missing, both BFs which highlight promotion prices AND those which don&#39;t are returned.
     * @param {} [showSpecialPrices] Filters BFs against special price display. If param is missing, both BFs which highlight special prices AND those which don&#39;t are returned.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageBestFriendApi
     */
    public getAllBestFriendSettings(pageNumber: number, pageSize: number, tenants?: Array<string>, scannersn?: string, id?: number, assignedUserName?: string, status?: string, priceDisplay?: number, showPromotions?: boolean, showSpecialPrices?: boolean, options?: any) {
        return ManageBestFriendApiFp(this.configuration).getAllBestFriendSettings(pageNumber, pageSize, tenants, scannersn, id, assignedUserName, status, priceDisplay, showPromotions, showSpecialPrices, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get BestFriendSettings by Id
     * @param {} id The id to work with
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageBestFriendApi
     */
    public getBestFriendSettingsById(id: number, options?: any) {
        return ManageBestFriendApiFp(this.configuration).getBestFriendSettingsById(id, options)(this.fetch, this.basePath);
    }

    /**
     * Update BestFriend Settings of Best Friend devices
     * @summary Update BestFriendSettings
     * @param {} bestFriendSettings 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageBestFriendApi
     */
    public updateBestFriendSettings(bestFriendSettings: BestFriendSettingsDto, options?: any) {
        return ManageBestFriendApiFp(this.configuration).updateBestFriendSettings(bestFriendSettings, options)(this.fetch, this.basePath);
    }

}

/**
 * ManageCategoriesApi - fetch parameter creator
 * @export
 */
export const ManageCategoriesApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get all categories
         * @param {string} tenant Tenant to filter against, eg. tenant&#x3D;LL
         * @param {number} pageNumber The page to get
         * @param {number} pageSize The amount of items to retrieve per page
         * @param {string} [id] The category id or part of it to filter against, e.g. &#39;02|08&#39;
         * @param {string} [name] The category name or part of it to filter against, e.g. &#39;Käse&#39;
         * @param {boolean} [virtual] Filter for virtual (Sortimentslisten) or real categories.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategories(tenant: string, pageNumber: number, pageSize: number, id?: string, name?: string, virtual?: boolean, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling getCategories.');
            }
            // verify required parameter 'pageNumber' is not null or undefined
            if (pageNumber === null || pageNumber === undefined) {
                throw new RequiredError('pageNumber','Required parameter pageNumber was null or undefined when calling getCategories.');
            }
            // verify required parameter 'pageSize' is not null or undefined
            if (pageSize === null || pageSize === undefined) {
                throw new RequiredError('pageSize','Required parameter pageSize was null or undefined when calling getCategories.');
            }
            const localVarPath = `/.internal/manage/categories/{tenant}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (virtual !== undefined) {
                localVarQueryParameter['virtual'] = virtual;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a specific category by Id
         * @param {string} tenant The tenant of the category
         * @param {string} categoryId The categoryId of the category
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategoryById(tenant: string, categoryId: string, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling getCategoryById.');
            }
            // verify required parameter 'categoryId' is not null or undefined
            if (categoryId === null || categoryId === undefined) {
                throw new RequiredError('categoryId','Required parameter categoryId was null or undefined when calling getCategoryById.');
            }
            const localVarPath = `/.internal/manage/categories/{tenant}/{categoryId}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"categoryId"}}`, encodeURIComponent(String(categoryId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update category for tenant
         * @param {string} tenant Tenant to filter against, eg. tenant&#x3D;LL
         * @param {ManagementCategoryDto} category 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCategoryForTenant(tenant: string, category: ManagementCategoryDto, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling updateCategoryForTenant.');
            }
            // verify required parameter 'category' is not null or undefined
            if (category === null || category === undefined) {
                throw new RequiredError('category','Required parameter category was null or undefined when calling updateCategoryForTenant.');
            }
            const localVarPath = `/.internal/manage/categories/{tenant}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ManagementCategoryDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(category || {}) : (category || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ManageCategoriesApi - functional programming interface
 * @export
 */
export const ManageCategoriesApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Get all categories
         * @param {string} tenant Tenant to filter against, eg. tenant&#x3D;LL
         * @param {number} pageNumber The page to get
         * @param {number} pageSize The amount of items to retrieve per page
         * @param {string} [id] The category id or part of it to filter against, e.g. &#39;02|08&#39;
         * @param {string} [name] The category name or part of it to filter against, e.g. &#39;Käse&#39;
         * @param {boolean} [virtual] Filter for virtual (Sortimentslisten) or real categories.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategories(tenant: string, pageNumber: number, pageSize: number, id?: string, name?: string, virtual?: boolean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ManagementCategorySearchResultDto> {
            const localVarFetchArgs = ManageCategoriesApiFetchParamCreator(configuration).getCategories(tenant, pageNumber, pageSize, id, name, virtual, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Get a specific category by Id
         * @param {string} tenant The tenant of the category
         * @param {string} categoryId The categoryId of the category
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategoryById(tenant: string, categoryId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ManagementCategoryDto> {
            const localVarFetchArgs = ManageCategoriesApiFetchParamCreator(configuration).getCategoryById(tenant, categoryId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Update category for tenant
         * @param {string} tenant Tenant to filter against, eg. tenant&#x3D;LL
         * @param {ManagementCategoryDto} category 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCategoryForTenant(tenant: string, category: ManagementCategoryDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = ManageCategoriesApiFetchParamCreator(configuration).updateCategoryForTenant(tenant, category, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * ManageCategoriesApi - factory interface
 * @export
 */
export const ManageCategoriesApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * Get all categories
         * @param {string} tenant Tenant to filter against, eg. tenant&#x3D;LL
         * @param {number} pageNumber The page to get
         * @param {number} pageSize The amount of items to retrieve per page
         * @param {string} [id] The category id or part of it to filter against, e.g. &#39;02|08&#39;
         * @param {string} [name] The category name or part of it to filter against, e.g. &#39;Käse&#39;
         * @param {boolean} [virtual] Filter for virtual (Sortimentslisten) or real categories.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategories(tenant: string, pageNumber: number, pageSize: number, id?: string, name?: string, virtual?: boolean, options?: any) {
            return ManageCategoriesApiFp(configuration).getCategories(tenant, pageNumber, pageSize, id, name, virtual, options)(fetch, basePath);
        },
        /**
         * Get a specific category by Id
         * @param {string} tenant The tenant of the category
         * @param {string} categoryId The categoryId of the category
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategoryById(tenant: string, categoryId: string, options?: any) {
            return ManageCategoriesApiFp(configuration).getCategoryById(tenant, categoryId, options)(fetch, basePath);
        },
        /**
         * Update category for tenant
         * @param {string} tenant Tenant to filter against, eg. tenant&#x3D;LL
         * @param {ManagementCategoryDto} category 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCategoryForTenant(tenant: string, category: ManagementCategoryDto, options?: any) {
            return ManageCategoriesApiFp(configuration).updateCategoryForTenant(tenant, category, options)(fetch, basePath);
        },
    };
};

/**
 * ManageCategoriesApi - object-oriented interface
 * @export
 * @class ManageCategoriesApi
 * @extends {BaseAPI}
 */
export class ManageCategoriesApi extends BaseAPI {
    /**
     * Get all categories
     * @param {} tenant Tenant to filter against, eg. tenant&#x3D;LL
     * @param {} pageNumber The page to get
     * @param {} pageSize The amount of items to retrieve per page
     * @param {} [id] The category id or part of it to filter against, e.g. &#39;02|08&#39;
     * @param {} [name] The category name or part of it to filter against, e.g. &#39;Käse&#39;
     * @param {} [virtual] Filter for virtual (Sortimentslisten) or real categories.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageCategoriesApi
     */
    public getCategories(tenant: string, pageNumber: number, pageSize: number, id?: string, name?: string, virtual?: boolean, options?: any) {
        return ManageCategoriesApiFp(this.configuration).getCategories(tenant, pageNumber, pageSize, id, name, virtual, options)(this.fetch, this.basePath);
    }

    /**
     * Get a specific category by Id
     * @param {} tenant The tenant of the category
     * @param {} categoryId The categoryId of the category
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageCategoriesApi
     */
    public getCategoryById(tenant: string, categoryId: string, options?: any) {
        return ManageCategoriesApiFp(this.configuration).getCategoryById(tenant, categoryId, options)(this.fetch, this.basePath);
    }

    /**
     * Update category for tenant
     * @param {} tenant Tenant to filter against, eg. tenant&#x3D;LL
     * @param {} category 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageCategoriesApi
     */
    public updateCategoryForTenant(tenant: string, category: ManagementCategoryDto, options?: any) {
        return ManageCategoriesApiFp(this.configuration).updateCategoryForTenant(tenant, category, options)(this.fetch, this.basePath);
    }

}

/**
 * ManageCustomersApi - fetch parameter creator
 * @export
 */
export const ManageCustomersApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get a customer by id.
         * @param {string} tenant The tenant of the customer
         * @param {string} customerId The Eurogast customer id of the customer to work with
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerById(tenant: string, customerId: string, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling getCustomerById.');
            }
            // verify required parameter 'customerId' is not null or undefined
            if (customerId === null || customerId === undefined) {
                throw new RequiredError('customerId','Required parameter customerId was null or undefined when calling getCustomerById.');
            }
            const localVarPath = `/.internal/manage/customers/{tenant}/{customerId}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all products a customer with catalog restrictions can see and order.
         * @param {number} pageNumber The page to get
         * @param {number} pageSize The amount of items to retrieve per page
         * @param {string} tenant The tenant of the customer
         * @param {string} customerId The Eurogast customer id of the customer to get all products he/she can order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerCatalogRestrictionById(pageNumber: number, pageSize: number, tenant: string, customerId: string, options: any = {}): FetchArgs {
            // verify required parameter 'pageNumber' is not null or undefined
            if (pageNumber === null || pageNumber === undefined) {
                throw new RequiredError('pageNumber','Required parameter pageNumber was null or undefined when calling getCustomerCatalogRestrictionById.');
            }
            // verify required parameter 'pageSize' is not null or undefined
            if (pageSize === null || pageSize === undefined) {
                throw new RequiredError('pageSize','Required parameter pageSize was null or undefined when calling getCustomerCatalogRestrictionById.');
            }
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling getCustomerCatalogRestrictionById.');
            }
            // verify required parameter 'customerId' is not null or undefined
            if (customerId === null || customerId === undefined) {
                throw new RequiredError('customerId','Required parameter customerId was null or undefined when calling getCustomerCatalogRestrictionById.');
            }
            const localVarPath = `/.internal/manage/customers/{tenant}/{customerId}/catalog-restrictions`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get customers
         * @param {number} pageNumber The page to get
         * @param {number} pageSize The amount of items to retrieve per page
         * @param {Array&lt;string&gt;} [tenants] Tenants to filter against, eg. tenants&#x3D;LL,LS
         * @param {string} [customerId] Eurogast Customer ID or part of it to filter against, e.g. 99000
         * @param {string} [postCode] Filters against the post code of the customer address (only customer address and not delivery address)
         * @param {boolean} [disabled] Filter for enabled/disabled customers. If param is missing, both enabled AND disabled customers are returned.
         * @param {boolean} [hasRestrictedCatalog] Filter for customers with catalog restriction. If param is missing, both customers with AND without restrictions are returned.
         * @param {string} [search] Filters against the customerName or customerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomers(pageNumber: number, pageSize: number, tenants?: Array<string>, customerId?: string, postCode?: string, disabled?: boolean, hasRestrictedCatalog?: boolean, search?: string, options: any = {}): FetchArgs {
            // verify required parameter 'pageNumber' is not null or undefined
            if (pageNumber === null || pageNumber === undefined) {
                throw new RequiredError('pageNumber','Required parameter pageNumber was null or undefined when calling getCustomers.');
            }
            // verify required parameter 'pageSize' is not null or undefined
            if (pageSize === null || pageSize === undefined) {
                throw new RequiredError('pageSize','Required parameter pageSize was null or undefined when calling getCustomers.');
            }
            const localVarPath = `/.internal/manage/customers`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (tenants) {
                localVarQueryParameter['tenants'] = tenants.join(COLLECTION_FORMATS["csv"]);
            }

            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }

            if (postCode !== undefined) {
                localVarQueryParameter['postCode'] = postCode;
            }

            if (disabled !== undefined) {
                localVarQueryParameter['disabled'] = disabled;
            }

            if (hasRestrictedCatalog !== undefined) {
                localVarQueryParameter['hasRestrictedCatalog'] = hasRestrictedCatalog;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The customer id cannot be changed.
         * @summary Update a single customer
         * @param {EffectiveCustomerDto} request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCustomer(request: EffectiveCustomerDto, options: any = {}): FetchArgs {
            // verify required parameter 'request' is not null or undefined
            if (request === null || request === undefined) {
                throw new RequiredError('request','Required parameter request was null or undefined when calling saveCustomer.');
            }
            const localVarPath = `/.internal/manage/customers`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"EffectiveCustomerDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(request || {}) : (request || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ManageCustomersApi - functional programming interface
 * @export
 */
export const ManageCustomersApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get a customer by id.
         * @param {string} tenant The tenant of the customer
         * @param {string} customerId The Eurogast customer id of the customer to work with
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerById(tenant: string, customerId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<EffectiveCustomerDto> {
            const localVarFetchArgs = ManageCustomersApiFetchParamCreator(configuration).getCustomerById(tenant, customerId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get all products a customer with catalog restrictions can see and order.
         * @param {number} pageNumber The page to get
         * @param {number} pageSize The amount of items to retrieve per page
         * @param {string} tenant The tenant of the customer
         * @param {string} customerId The Eurogast customer id of the customer to get all products he/she can order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerCatalogRestrictionById(pageNumber: number, pageSize: number, tenant: string, customerId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ProductSearchResultDto> {
            const localVarFetchArgs = ManageCustomersApiFetchParamCreator(configuration).getCustomerCatalogRestrictionById(pageNumber, pageSize, tenant, customerId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get customers
         * @param {number} pageNumber The page to get
         * @param {number} pageSize The amount of items to retrieve per page
         * @param {Array&lt;string&gt;} [tenants] Tenants to filter against, eg. tenants&#x3D;LL,LS
         * @param {string} [customerId] Eurogast Customer ID or part of it to filter against, e.g. 99000
         * @param {string} [postCode] Filters against the post code of the customer address (only customer address and not delivery address)
         * @param {boolean} [disabled] Filter for enabled/disabled customers. If param is missing, both enabled AND disabled customers are returned.
         * @param {boolean} [hasRestrictedCatalog] Filter for customers with catalog restriction. If param is missing, both customers with AND without restrictions are returned.
         * @param {string} [search] Filters against the customerName or customerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomers(pageNumber: number, pageSize: number, tenants?: Array<string>, customerId?: string, postCode?: string, disabled?: boolean, hasRestrictedCatalog?: boolean, search?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CustomerSearchResultDto> {
            const localVarFetchArgs = ManageCustomersApiFetchParamCreator(configuration).getCustomers(pageNumber, pageSize, tenants, customerId, postCode, disabled, hasRestrictedCatalog, search, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * The customer id cannot be changed.
         * @summary Update a single customer
         * @param {EffectiveCustomerDto} request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCustomer(request: EffectiveCustomerDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = ManageCustomersApiFetchParamCreator(configuration).saveCustomer(request, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * ManageCustomersApi - factory interface
 * @export
 */
export const ManageCustomersApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Get a customer by id.
         * @param {string} tenant The tenant of the customer
         * @param {string} customerId The Eurogast customer id of the customer to work with
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerById(tenant: string, customerId: string, options?: any) {
            return ManageCustomersApiFp(configuration).getCustomerById(tenant, customerId, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get all products a customer with catalog restrictions can see and order.
         * @param {number} pageNumber The page to get
         * @param {number} pageSize The amount of items to retrieve per page
         * @param {string} tenant The tenant of the customer
         * @param {string} customerId The Eurogast customer id of the customer to get all products he/she can order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerCatalogRestrictionById(pageNumber: number, pageSize: number, tenant: string, customerId: string, options?: any) {
            return ManageCustomersApiFp(configuration).getCustomerCatalogRestrictionById(pageNumber, pageSize, tenant, customerId, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get customers
         * @param {number} pageNumber The page to get
         * @param {number} pageSize The amount of items to retrieve per page
         * @param {Array&lt;string&gt;} [tenants] Tenants to filter against, eg. tenants&#x3D;LL,LS
         * @param {string} [customerId] Eurogast Customer ID or part of it to filter against, e.g. 99000
         * @param {string} [postCode] Filters against the post code of the customer address (only customer address and not delivery address)
         * @param {boolean} [disabled] Filter for enabled/disabled customers. If param is missing, both enabled AND disabled customers are returned.
         * @param {boolean} [hasRestrictedCatalog] Filter for customers with catalog restriction. If param is missing, both customers with AND without restrictions are returned.
         * @param {string} [search] Filters against the customerName or customerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomers(pageNumber: number, pageSize: number, tenants?: Array<string>, customerId?: string, postCode?: string, disabled?: boolean, hasRestrictedCatalog?: boolean, search?: string, options?: any) {
            return ManageCustomersApiFp(configuration).getCustomers(pageNumber, pageSize, tenants, customerId, postCode, disabled, hasRestrictedCatalog, search, options)(fetch, basePath);
        },
        /**
         * The customer id cannot be changed.
         * @summary Update a single customer
         * @param {EffectiveCustomerDto} request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCustomer(request: EffectiveCustomerDto, options?: any) {
            return ManageCustomersApiFp(configuration).saveCustomer(request, options)(fetch, basePath);
        },
    };
};

/**
 * ManageCustomersApi - object-oriented interface
 * @export
 * @class ManageCustomersApi
 * @extends {BaseAPI}
 */
export class ManageCustomersApi extends BaseAPI {
    /**
     * 
     * @summary Get a customer by id.
     * @param {} tenant The tenant of the customer
     * @param {} customerId The Eurogast customer id of the customer to work with
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageCustomersApi
     */
    public getCustomerById(tenant: string, customerId: string, options?: any) {
        return ManageCustomersApiFp(this.configuration).getCustomerById(tenant, customerId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get all products a customer with catalog restrictions can see and order.
     * @param {} pageNumber The page to get
     * @param {} pageSize The amount of items to retrieve per page
     * @param {} tenant The tenant of the customer
     * @param {} customerId The Eurogast customer id of the customer to get all products he/she can order
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageCustomersApi
     */
    public getCustomerCatalogRestrictionById(pageNumber: number, pageSize: number, tenant: string, customerId: string, options?: any) {
        return ManageCustomersApiFp(this.configuration).getCustomerCatalogRestrictionById(pageNumber, pageSize, tenant, customerId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get customers
     * @param {} pageNumber The page to get
     * @param {} pageSize The amount of items to retrieve per page
     * @param {} [tenants] Tenants to filter against, eg. tenants&#x3D;LL,LS
     * @param {} [customerId] Eurogast Customer ID or part of it to filter against, e.g. 99000
     * @param {} [postCode] Filters against the post code of the customer address (only customer address and not delivery address)
     * @param {} [disabled] Filter for enabled/disabled customers. If param is missing, both enabled AND disabled customers are returned.
     * @param {} [hasRestrictedCatalog] Filter for customers with catalog restriction. If param is missing, both customers with AND without restrictions are returned.
     * @param {} [search] Filters against the customerName or customerId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageCustomersApi
     */
    public getCustomers(pageNumber: number, pageSize: number, tenants?: Array<string>, customerId?: string, postCode?: string, disabled?: boolean, hasRestrictedCatalog?: boolean, search?: string, options?: any) {
        return ManageCustomersApiFp(this.configuration).getCustomers(pageNumber, pageSize, tenants, customerId, postCode, disabled, hasRestrictedCatalog, search, options)(this.fetch, this.basePath);
    }

    /**
     * The customer id cannot be changed.
     * @summary Update a single customer
     * @param {} request 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageCustomersApi
     */
    public saveCustomer(request: EffectiveCustomerDto, options?: any) {
        return ManageCustomersApiFp(this.configuration).saveCustomer(request, options)(this.fetch, this.basePath);
    }

}

/**
 * ManageEssencesApi - fetch parameter creator
 * @export
 */
export const ManageEssencesApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} tenant the tenant
         * @param {string} sourceCustomerId The customer of whom the essence should be copied
         * @param {string} destCustomerId The customer to whom the essence should be copied
         * @param {string} [startDate] Start of the essence time-range
         * @param {string} [endDate] End of the essence time-range
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        copyEssenceListFromCustomerToCustomer(tenant: string, sourceCustomerId: string, destCustomerId: string, startDate?: string, endDate?: string, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling copyEssenceListFromCustomerToCustomer.');
            }
            // verify required parameter 'sourceCustomerId' is not null or undefined
            if (sourceCustomerId === null || sourceCustomerId === undefined) {
                throw new RequiredError('sourceCustomerId','Required parameter sourceCustomerId was null or undefined when calling copyEssenceListFromCustomerToCustomer.');
            }
            // verify required parameter 'destCustomerId' is not null or undefined
            if (destCustomerId === null || destCustomerId === undefined) {
                throw new RequiredError('destCustomerId','Required parameter destCustomerId was null or undefined when calling copyEssenceListFromCustomerToCustomer.');
            }
            const localVarPath = `/.internal/manage/essence/copy`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (tenant !== undefined) {
                localVarQueryParameter['tenant'] = tenant;
            }

            if (sourceCustomerId !== undefined) {
                localVarQueryParameter['sourceCustomerId'] = sourceCustomerId;
            }

            if (destCustomerId !== undefined) {
                localVarQueryParameter['destCustomerId'] = destCustomerId;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any).toISOString();
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any).toISOString();
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ManageEssencesApi - functional programming interface
 * @export
 */
export const ManageEssencesApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} tenant the tenant
         * @param {string} sourceCustomerId The customer of whom the essence should be copied
         * @param {string} destCustomerId The customer to whom the essence should be copied
         * @param {string} [startDate] Start of the essence time-range
         * @param {string} [endDate] End of the essence time-range
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        copyEssenceListFromCustomerToCustomer(tenant: string, sourceCustomerId: string, destCustomerId: string, startDate?: string, endDate?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = ManageEssencesApiFetchParamCreator(configuration).copyEssenceListFromCustomerToCustomer(tenant, sourceCustomerId, destCustomerId, startDate, endDate, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * ManageEssencesApi - factory interface
 * @export
 */
export const ManageEssencesApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {string} tenant the tenant
         * @param {string} sourceCustomerId The customer of whom the essence should be copied
         * @param {string} destCustomerId The customer to whom the essence should be copied
         * @param {string} [startDate] Start of the essence time-range
         * @param {string} [endDate] End of the essence time-range
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        copyEssenceListFromCustomerToCustomer(tenant: string, sourceCustomerId: string, destCustomerId: string, startDate?: string, endDate?: string, options?: any) {
            return ManageEssencesApiFp(configuration).copyEssenceListFromCustomerToCustomer(tenant, sourceCustomerId, destCustomerId, startDate, endDate, options)(fetch, basePath);
        },
    };
};

/**
 * ManageEssencesApi - object-oriented interface
 * @export
 * @class ManageEssencesApi
 * @extends {BaseAPI}
 */
export class ManageEssencesApi extends BaseAPI {
    /**
     * 
     * @param {} tenant the tenant
     * @param {} sourceCustomerId The customer of whom the essence should be copied
     * @param {} destCustomerId The customer to whom the essence should be copied
     * @param {} [startDate] Start of the essence time-range
     * @param {} [endDate] End of the essence time-range
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageEssencesApi
     */
    public copyEssenceListFromCustomerToCustomer(tenant: string, sourceCustomerId: string, destCustomerId: string, startDate?: string, endDate?: string, options?: any) {
        return ManageEssencesApiFp(this.configuration).copyEssenceListFromCustomerToCustomer(tenant, sourceCustomerId, destCustomerId, startDate, endDate, options)(this.fetch, this.basePath);
    }

}

/**
 * ManageFairCartTypesApi - fetch parameter creator
 * @export
 */
export const ManageFairCartTypesApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Gets all fair cart-types (even disabled)
         * @param {string} tenant The EGB code of the tenant to target
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllFairCartTypes(tenant: string, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling getAllFairCartTypes.');
            }
            const localVarPath = `/.internal/manage/t/{tenant}/fairs`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the given fair-cart-type.
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} fairCode The unique code of a fair
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFairCartTypeByCode(tenant: string, fairCode: string, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling getFairCartTypeByCode.');
            }
            // verify required parameter 'fairCode' is not null or undefined
            if (fairCode === null || fairCode === undefined) {
                throw new RequiredError('fairCode','Required parameter fairCode was null or undefined when calling getFairCartTypeByCode.');
            }
            const localVarPath = `/.internal/manage/t/{tenant}/fairs/{fairCode}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"fairCode"}}`, encodeURIComponent(String(fairCode)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a fair-cart-type
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} fairCode The unique code of a fair
         * @param {ManagementFairCartTypeDto} fairCartTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insertOrUpdateFairCartType(tenant: string, fairCode: string, fairCartTypeDto: ManagementFairCartTypeDto, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling insertOrUpdateFairCartType.');
            }
            // verify required parameter 'fairCode' is not null or undefined
            if (fairCode === null || fairCode === undefined) {
                throw new RequiredError('fairCode','Required parameter fairCode was null or undefined when calling insertOrUpdateFairCartType.');
            }
            // verify required parameter 'fairCartTypeDto' is not null or undefined
            if (fairCartTypeDto === null || fairCartTypeDto === undefined) {
                throw new RequiredError('fairCartTypeDto','Required parameter fairCartTypeDto was null or undefined when calling insertOrUpdateFairCartType.');
            }
            const localVarPath = `/.internal/manage/t/{tenant}/fairs/{fairCode}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"fairCode"}}`, encodeURIComponent(String(fairCode)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ManagementFairCartTypeDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(fairCartTypeDto || {}) : (fairCartTypeDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ManageFairCartTypesApi - functional programming interface
 * @export
 */
export const ManageFairCartTypesApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Gets all fair cart-types (even disabled)
         * @param {string} tenant The EGB code of the tenant to target
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllFairCartTypes(tenant: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<ManagementFairCartTypeDto>> {
            const localVarFetchArgs = ManageFairCartTypesApiFetchParamCreator(configuration).getAllFairCartTypes(tenant, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Returns the given fair-cart-type.
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} fairCode The unique code of a fair
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFairCartTypeByCode(tenant: string, fairCode: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ManagementFairCartTypeDto> {
            const localVarFetchArgs = ManageFairCartTypesApiFetchParamCreator(configuration).getFairCartTypeByCode(tenant, fairCode, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Create a fair-cart-type
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} fairCode The unique code of a fair
         * @param {ManagementFairCartTypeDto} fairCartTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insertOrUpdateFairCartType(tenant: string, fairCode: string, fairCartTypeDto: ManagementFairCartTypeDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = ManageFairCartTypesApiFetchParamCreator(configuration).insertOrUpdateFairCartType(tenant, fairCode, fairCartTypeDto, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * ManageFairCartTypesApi - factory interface
 * @export
 */
export const ManageFairCartTypesApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Gets all fair cart-types (even disabled)
         * @param {string} tenant The EGB code of the tenant to target
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllFairCartTypes(tenant: string, options?: any) {
            return ManageFairCartTypesApiFp(configuration).getAllFairCartTypes(tenant, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Returns the given fair-cart-type.
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} fairCode The unique code of a fair
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFairCartTypeByCode(tenant: string, fairCode: string, options?: any) {
            return ManageFairCartTypesApiFp(configuration).getFairCartTypeByCode(tenant, fairCode, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Create a fair-cart-type
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} fairCode The unique code of a fair
         * @param {ManagementFairCartTypeDto} fairCartTypeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insertOrUpdateFairCartType(tenant: string, fairCode: string, fairCartTypeDto: ManagementFairCartTypeDto, options?: any) {
            return ManageFairCartTypesApiFp(configuration).insertOrUpdateFairCartType(tenant, fairCode, fairCartTypeDto, options)(fetch, basePath);
        },
    };
};

/**
 * ManageFairCartTypesApi - object-oriented interface
 * @export
 * @class ManageFairCartTypesApi
 * @extends {BaseAPI}
 */
export class ManageFairCartTypesApi extends BaseAPI {
    /**
     * 
     * @summary Gets all fair cart-types (even disabled)
     * @param {} tenant The EGB code of the tenant to target
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageFairCartTypesApi
     */
    public getAllFairCartTypes(tenant: string, options?: any) {
        return ManageFairCartTypesApiFp(this.configuration).getAllFairCartTypes(tenant, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Returns the given fair-cart-type.
     * @param {} tenant The EGB code of the tenant to target
     * @param {} fairCode The unique code of a fair
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageFairCartTypesApi
     */
    public getFairCartTypeByCode(tenant: string, fairCode: string, options?: any) {
        return ManageFairCartTypesApiFp(this.configuration).getFairCartTypeByCode(tenant, fairCode, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Create a fair-cart-type
     * @param {} tenant The EGB code of the tenant to target
     * @param {} fairCode The unique code of a fair
     * @param {} fairCartTypeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageFairCartTypesApi
     */
    public insertOrUpdateFairCartType(tenant: string, fairCode: string, fairCartTypeDto: ManagementFairCartTypeDto, options?: any) {
        return ManageFairCartTypesApiFp(this.configuration).insertOrUpdateFairCartType(tenant, fairCode, fairCartTypeDto, options)(this.fetch, this.basePath);
    }

}

/**
 * ManageFaultyOrderMailRecipientsApi - fetch parameter creator
 * @export
 */
export const ManageFaultyOrderMailRecipientsApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addFaultyOrderMailRecipient(email: string, options: any = {}): FetchArgs {
            // verify required parameter 'email' is not null or undefined
            if (email === null || email === undefined) {
                throw new RequiredError('email','Required parameter email was null or undefined when calling addFaultyOrderMailRecipient.');
            }
            const localVarPath = `/.internal/manage/faulty-order-mail-recipients`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"string" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(email || {}) : (email || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFaultyOrderMailRecipient(email: string, options: any = {}): FetchArgs {
            // verify required parameter 'email' is not null or undefined
            if (email === null || email === undefined) {
                throw new RequiredError('email','Required parameter email was null or undefined when calling deleteFaultyOrderMailRecipient.');
            }
            const localVarPath = `/.internal/manage/faulty-order-mail-recipients/delete`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"string" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(email || {}) : (email || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFaultyOrderMailRecipients(options: any = {}): FetchArgs {
            const localVarPath = `/.internal/manage/faulty-order-mail-recipients`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ManageFaultyOrderMailRecipientsApi - functional programming interface
 * @export
 */
export const ManageFaultyOrderMailRecipientsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addFaultyOrderMailRecipient(email: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = ManageFaultyOrderMailRecipientsApiFetchParamCreator(configuration).addFaultyOrderMailRecipient(email, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFaultyOrderMailRecipient(email: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = ManageFaultyOrderMailRecipientsApiFetchParamCreator(configuration).deleteFaultyOrderMailRecipient(email, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFaultyOrderMailRecipients(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<string>> {
            const localVarFetchArgs = ManageFaultyOrderMailRecipientsApiFetchParamCreator(configuration).getFaultyOrderMailRecipients(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * ManageFaultyOrderMailRecipientsApi - factory interface
 * @export
 */
export const ManageFaultyOrderMailRecipientsApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addFaultyOrderMailRecipient(email: string, options?: any) {
            return ManageFaultyOrderMailRecipientsApiFp(configuration).addFaultyOrderMailRecipient(email, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFaultyOrderMailRecipient(email: string, options?: any) {
            return ManageFaultyOrderMailRecipientsApiFp(configuration).deleteFaultyOrderMailRecipient(email, options)(fetch, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFaultyOrderMailRecipients(options?: any) {
            return ManageFaultyOrderMailRecipientsApiFp(configuration).getFaultyOrderMailRecipients(options)(fetch, basePath);
        },
    };
};

/**
 * ManageFaultyOrderMailRecipientsApi - object-oriented interface
 * @export
 * @class ManageFaultyOrderMailRecipientsApi
 * @extends {BaseAPI}
 */
export class ManageFaultyOrderMailRecipientsApi extends BaseAPI {
    /**
     * 
     * @param {} email 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageFaultyOrderMailRecipientsApi
     */
    public addFaultyOrderMailRecipient(email: string, options?: any) {
        return ManageFaultyOrderMailRecipientsApiFp(this.configuration).addFaultyOrderMailRecipient(email, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {} email 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageFaultyOrderMailRecipientsApi
     */
    public deleteFaultyOrderMailRecipient(email: string, options?: any) {
        return ManageFaultyOrderMailRecipientsApiFp(this.configuration).deleteFaultyOrderMailRecipient(email, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageFaultyOrderMailRecipientsApi
     */
    public getFaultyOrderMailRecipients(options?: any) {
        return ManageFaultyOrderMailRecipientsApiFp(this.configuration).getFaultyOrderMailRecipients(options)(this.fetch, this.basePath);
    }

}

/**
 * ManageFeatureFlagApi - fetch parameter creator
 * @export
 */
export const ManageFeatureFlagApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Deletes a feature-flag for the specified tenant.
         * @param {TenantFeatureFlagDto} tenantFeatureFlag 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFeatureFlag(tenantFeatureFlag: TenantFeatureFlagDto, options: any = {}): FetchArgs {
            // verify required parameter 'tenantFeatureFlag' is not null or undefined
            if (tenantFeatureFlag === null || tenantFeatureFlag === undefined) {
                throw new RequiredError('tenantFeatureFlag','Required parameter tenantFeatureFlag was null or undefined when calling deleteFeatureFlag.');
            }
            const localVarPath = `/.internal/manage/tenant/featureflags`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"TenantFeatureFlagDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(tenantFeatureFlag || {}) : (tenantFeatureFlag || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all feature flags for every tenant
         * @param {Array&lt;string&gt;} [tenants] A comma seperated list of tenant-codes. The response is filtered by the provided tenant-codes. If you omit this list the repsonse includes all tenants.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTenantFeatureFlags(tenants?: Array<string>, options: any = {}): FetchArgs {
            const localVarPath = `/.internal/manage/tenant/featureflags`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (tenants) {
                localVarQueryParameter['tenants'] = tenants.join(COLLECTION_FORMATS["csv"]);
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Adds a new feature-flag to the specified tenant
         * @param {TenantFeatureFlagDto} tenantFeatureFlag 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setFeatureFlag(tenantFeatureFlag: TenantFeatureFlagDto, options: any = {}): FetchArgs {
            // verify required parameter 'tenantFeatureFlag' is not null or undefined
            if (tenantFeatureFlag === null || tenantFeatureFlag === undefined) {
                throw new RequiredError('tenantFeatureFlag','Required parameter tenantFeatureFlag was null or undefined when calling setFeatureFlag.');
            }
            const localVarPath = `/.internal/manage/tenant/featureflags`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"TenantFeatureFlagDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(tenantFeatureFlag || {}) : (tenantFeatureFlag || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ManageFeatureFlagApi - functional programming interface
 * @export
 */
export const ManageFeatureFlagApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Deletes a feature-flag for the specified tenant.
         * @param {TenantFeatureFlagDto} tenantFeatureFlag 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFeatureFlag(tenantFeatureFlag: TenantFeatureFlagDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = ManageFeatureFlagApiFetchParamCreator(configuration).deleteFeatureFlag(tenantFeatureFlag, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get all feature flags for every tenant
         * @param {Array&lt;string&gt;} [tenants] A comma seperated list of tenant-codes. The response is filtered by the provided tenant-codes. If you omit this list the repsonse includes all tenants.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTenantFeatureFlags(tenants?: Array<string>, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<TenantFeatureFlagDto>> {
            const localVarFetchArgs = ManageFeatureFlagApiFetchParamCreator(configuration).getAllTenantFeatureFlags(tenants, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Adds a new feature-flag to the specified tenant
         * @param {TenantFeatureFlagDto} tenantFeatureFlag 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setFeatureFlag(tenantFeatureFlag: TenantFeatureFlagDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = ManageFeatureFlagApiFetchParamCreator(configuration).setFeatureFlag(tenantFeatureFlag, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * ManageFeatureFlagApi - factory interface
 * @export
 */
export const ManageFeatureFlagApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Deletes a feature-flag for the specified tenant.
         * @param {TenantFeatureFlagDto} tenantFeatureFlag 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFeatureFlag(tenantFeatureFlag: TenantFeatureFlagDto, options?: any) {
            return ManageFeatureFlagApiFp(configuration).deleteFeatureFlag(tenantFeatureFlag, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get all feature flags for every tenant
         * @param {Array&lt;string&gt;} [tenants] A comma seperated list of tenant-codes. The response is filtered by the provided tenant-codes. If you omit this list the repsonse includes all tenants.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTenantFeatureFlags(tenants?: Array<string>, options?: any) {
            return ManageFeatureFlagApiFp(configuration).getAllTenantFeatureFlags(tenants, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Adds a new feature-flag to the specified tenant
         * @param {TenantFeatureFlagDto} tenantFeatureFlag 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setFeatureFlag(tenantFeatureFlag: TenantFeatureFlagDto, options?: any) {
            return ManageFeatureFlagApiFp(configuration).setFeatureFlag(tenantFeatureFlag, options)(fetch, basePath);
        },
    };
};

/**
 * ManageFeatureFlagApi - object-oriented interface
 * @export
 * @class ManageFeatureFlagApi
 * @extends {BaseAPI}
 */
export class ManageFeatureFlagApi extends BaseAPI {
    /**
     * 
     * @summary Deletes a feature-flag for the specified tenant.
     * @param {} tenantFeatureFlag 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageFeatureFlagApi
     */
    public deleteFeatureFlag(tenantFeatureFlag: TenantFeatureFlagDto, options?: any) {
        return ManageFeatureFlagApiFp(this.configuration).deleteFeatureFlag(tenantFeatureFlag, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get all feature flags for every tenant
     * @param {} [tenants] A comma seperated list of tenant-codes. The response is filtered by the provided tenant-codes. If you omit this list the repsonse includes all tenants.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageFeatureFlagApi
     */
    public getAllTenantFeatureFlags(tenants?: Array<string>, options?: any) {
        return ManageFeatureFlagApiFp(this.configuration).getAllTenantFeatureFlags(tenants, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Adds a new feature-flag to the specified tenant
     * @param {} tenantFeatureFlag 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageFeatureFlagApi
     */
    public setFeatureFlag(tenantFeatureFlag: TenantFeatureFlagDto, options?: any) {
        return ManageFeatureFlagApiFp(this.configuration).setFeatureFlag(tenantFeatureFlag, options)(this.fetch, this.basePath);
    }

}

/**
 * ManageNotificationsApi - fetch parameter creator
 * @export
 */
export const ManageNotificationsApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create notification
         * @param {ManagementNotificationDto} notification 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNotification(notification: ManagementNotificationDto, options: any = {}): FetchArgs {
            // verify required parameter 'notification' is not null or undefined
            if (notification === null || notification === undefined) {
                throw new RequiredError('notification','Required parameter notification was null or undefined when calling createNotification.');
            }
            const localVarPath = `/.internal/manage/notifications`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ManagementNotificationDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(notification || {}) : (notification || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create notification customer group
         * @param {ManagementNotificationCustomerGroupDto} notificationCustomerGroup 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNotificationCustomerGroup(notificationCustomerGroup: ManagementNotificationCustomerGroupDto, options: any = {}): FetchArgs {
            // verify required parameter 'notificationCustomerGroup' is not null or undefined
            if (notificationCustomerGroup === null || notificationCustomerGroup === undefined) {
                throw new RequiredError('notificationCustomerGroup','Required parameter notificationCustomerGroup was null or undefined when calling createNotificationCustomerGroup.');
            }
            const localVarPath = `/.internal/manage/notification-customer-group`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ManagementNotificationCustomerGroupDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(notificationCustomerGroup || {}) : (notificationCustomerGroup || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create notification draft
         * @param {ManagementNotificationDto} draft 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNotificationDraft(draft: ManagementNotificationDto, options: any = {}): FetchArgs {
            // verify required parameter 'draft' is not null or undefined
            if (draft === null || draft === undefined) {
                throw new RequiredError('draft','Required parameter draft was null or undefined when calling createNotificationDraft.');
            }
            const localVarPath = `/.internal/manage/notification-drafts`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ManagementNotificationDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(draft || {}) : (draft || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create notification type
         * @param {NotificationTypeDto} type 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNotificationType(type: NotificationTypeDto, options: any = {}): FetchArgs {
            // verify required parameter 'type' is not null or undefined
            if (type === null || type === undefined) {
                throw new RequiredError('type','Required parameter type was null or undefined when calling createNotificationType.');
            }
            const localVarPath = `/.internal/manage/notification-types`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"NotificationTypeDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(type || {}) : (type || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete notification
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNotification(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteNotification.');
            }
            const localVarPath = `/.internal/manage/notifications/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete notification customer group
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNotificationCustomerGroup(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteNotificationCustomerGroup.');
            }
            const localVarPath = `/.internal/manage/notification-customer-group/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete notification draft
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNotificationDraft(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteNotificationDraft.');
            }
            const localVarPath = `/.internal/manage/notification-drafts/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete notification type
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNotificationType(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteNotificationType.');
            }
            const localVarPath = `/.internal/manage/notification-types/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a notification by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotification(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getNotification.');
            }
            const localVarPath = `/.internal/manage/notifications/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a notification customer group by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationCustomerGroup(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getNotificationCustomerGroup.');
            }
            const localVarPath = `/.internal/manage/notification-customer-group/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all notification customer groups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationCustomerGroups(options: any = {}): FetchArgs {
            const localVarPath = `/.internal/manage/notification-customer-group`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a notification draft by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationDraft(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getNotificationDraft.');
            }
            const localVarPath = `/.internal/manage/notification-drafts/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a page of notification drafts
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {Array&lt;string&gt;} [tenants] Tenants to filter against, eg. tenants&#x3D;LL,LS
         * @param {Array&lt;string&gt;} [visibleFor] Filter for erp system, eg. visibleFor&#x3D;GM,LL.
         * @param {string} [sortBy] Field to sort by and order. Field is either id or type. The id sort is used to show more recently created notifications first. Order is either asc or desc. These two are provided in the form field,order
         * @param {Array&lt;number&gt;} [typeIdFilter] Filter by type ids.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationDraftsPaged(page?: number, pageSize?: number, tenants?: Array<string>, visibleFor?: Array<string>, sortBy?: string, typeIdFilter?: Array<number>, options: any = {}): FetchArgs {
            const localVarPath = `/.internal/manage/notification-drafts`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (tenants) {
                localVarQueryParameter['tenants'] = tenants.join(COLLECTION_FORMATS["csv"]);
            }

            if (visibleFor) {
                localVarQueryParameter['visibleFor'] = visibleFor.join(COLLECTION_FORMATS["csv"]);
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (typeIdFilter) {
                localVarQueryParameter['typeIdFilter'] = typeIdFilter.join(COLLECTION_FORMATS["csv"]);
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a notification type by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationType(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getNotificationType.');
            }
            const localVarPath = `/.internal/manage/notification-types/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all notification types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationTypes(options: any = {}): FetchArgs {
            const localVarPath = `/.internal/manage/notification-types`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a page of notifications
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {Array&lt;string&gt;} [tenants] Tenants to filter against, eg. tenants&#x3D;LL,LS
         * @param {Array&lt;string&gt;} [visibleFor] Filter for erp system, eg. visibleFor&#x3D;GM,LL.
         * @param {string} [sortBy] Field to sort by and order. Field is either id or type. The id sort is used to show more recently created notifications first. Order is either asc or desc. These two are provided in the form field,order
         * @param {string} [dateMin] Filter by date, lower bound.
         * @param {string} [dateMax] Filter by date, upper bound.
         * @param {Array&lt;number&gt;} [typeIdFilter] Filter by type ids.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationsPaged(page?: number, pageSize?: number, tenants?: Array<string>, visibleFor?: Array<string>, sortBy?: string, dateMin?: string, dateMax?: string, typeIdFilter?: Array<number>, options: any = {}): FetchArgs {
            const localVarPath = `/.internal/manage/notifications`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (tenants) {
                localVarQueryParameter['tenants'] = tenants.join(COLLECTION_FORMATS["csv"]);
            }

            if (visibleFor) {
                localVarQueryParameter['visibleFor'] = visibleFor.join(COLLECTION_FORMATS["csv"]);
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (dateMin !== undefined) {
                localVarQueryParameter['dateMin'] = (dateMin as any).toISOString();
            }

            if (dateMax !== undefined) {
                localVarQueryParameter['dateMax'] = (dateMax as any).toISOString();
            }

            if (typeIdFilter) {
                localVarQueryParameter['typeIdFilter'] = typeIdFilter.join(COLLECTION_FORMATS["csv"]);
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get notification setting of the given tenant.
         * @param {string} tenant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTenantNotificationSettings(tenant: string, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling getTenantNotificationSettings.');
            }
            const localVarPath = `/.internal/manage/notification-settings/{tenant}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Publish and delete a notification draft by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishNotificationDraft(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling publishNotificationDraft.');
            }
            const localVarPath = `/.internal/manage/notification-drafts/{id}/publish`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update notification
         * @param {number} id 
         * @param {ManagementNotificationDto} notification 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNotification(id: number, notification: ManagementNotificationDto, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateNotification.');
            }
            // verify required parameter 'notification' is not null or undefined
            if (notification === null || notification === undefined) {
                throw new RequiredError('notification','Required parameter notification was null or undefined when calling updateNotification.');
            }
            const localVarPath = `/.internal/manage/notifications/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ManagementNotificationDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(notification || {}) : (notification || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update notification customer group
         * @param {number} id 
         * @param {ManagementNotificationCustomerGroupDto} notification 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNotificationCustomerGroup(id: number, notification: ManagementNotificationCustomerGroupDto, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateNotificationCustomerGroup.');
            }
            // verify required parameter 'notification' is not null or undefined
            if (notification === null || notification === undefined) {
                throw new RequiredError('notification','Required parameter notification was null or undefined when calling updateNotificationCustomerGroup.');
            }
            const localVarPath = `/.internal/manage/notification-customer-group/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ManagementNotificationCustomerGroupDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(notification || {}) : (notification || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update notification draft
         * @param {number} id 
         * @param {ManagementNotificationDto} draft 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNotificationDraft(id: number, draft: ManagementNotificationDto, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateNotificationDraft.');
            }
            // verify required parameter 'draft' is not null or undefined
            if (draft === null || draft === undefined) {
                throw new RequiredError('draft','Required parameter draft was null or undefined when calling updateNotificationDraft.');
            }
            const localVarPath = `/.internal/manage/notification-drafts/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ManagementNotificationDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(draft || {}) : (draft || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update notification type
         * @param {number} id 
         * @param {NotificationTypeDto} notification 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNotificationType(id: number, notification: NotificationTypeDto, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateNotificationType.');
            }
            // verify required parameter 'notification' is not null or undefined
            if (notification === null || notification === undefined) {
                throw new RequiredError('notification','Required parameter notification was null or undefined when calling updateNotificationType.');
            }
            const localVarPath = `/.internal/manage/notification-types/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"NotificationTypeDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(notification || {}) : (notification || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update notification settings of the given tenant.
         * @param {string} tenant 
         * @param {TenantNotificationSettingsDto} notificationSettings 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTenantNotificationSettings(tenant: string, notificationSettings: TenantNotificationSettingsDto, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling updateTenantNotificationSettings.');
            }
            // verify required parameter 'notificationSettings' is not null or undefined
            if (notificationSettings === null || notificationSettings === undefined) {
                throw new RequiredError('notificationSettings','Required parameter notificationSettings was null or undefined when calling updateTenantNotificationSettings.');
            }
            const localVarPath = `/.internal/manage/notification-settings/{tenant}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"TenantNotificationSettingsDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(notificationSettings || {}) : (notificationSettings || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ManageNotificationsApi - functional programming interface
 * @export
 */
export const ManageNotificationsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create notification
         * @param {ManagementNotificationDto} notification 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNotification(notification: ManagementNotificationDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ManagementNotificationDto> {
            const localVarFetchArgs = ManageNotificationsApiFetchParamCreator(configuration).createNotification(notification, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Create notification customer group
         * @param {ManagementNotificationCustomerGroupDto} notificationCustomerGroup 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNotificationCustomerGroup(notificationCustomerGroup: ManagementNotificationCustomerGroupDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ManagementNotificationCustomerGroupDto> {
            const localVarFetchArgs = ManageNotificationsApiFetchParamCreator(configuration).createNotificationCustomerGroup(notificationCustomerGroup, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Create notification draft
         * @param {ManagementNotificationDto} draft 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNotificationDraft(draft: ManagementNotificationDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ManagementNotificationDto> {
            const localVarFetchArgs = ManageNotificationsApiFetchParamCreator(configuration).createNotificationDraft(draft, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Create notification type
         * @param {NotificationTypeDto} type 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNotificationType(type: NotificationTypeDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<NotificationTypeDto> {
            const localVarFetchArgs = ManageNotificationsApiFetchParamCreator(configuration).createNotificationType(type, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Delete notification
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNotification(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = ManageNotificationsApiFetchParamCreator(configuration).deleteNotification(id, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Delete notification customer group
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNotificationCustomerGroup(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = ManageNotificationsApiFetchParamCreator(configuration).deleteNotificationCustomerGroup(id, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Delete notification draft
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNotificationDraft(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = ManageNotificationsApiFetchParamCreator(configuration).deleteNotificationDraft(id, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Delete notification type
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNotificationType(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = ManageNotificationsApiFetchParamCreator(configuration).deleteNotificationType(id, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get a notification by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotification(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ManagementNotificationDto> {
            const localVarFetchArgs = ManageNotificationsApiFetchParamCreator(configuration).getNotification(id, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get a notification customer group by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationCustomerGroup(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ManagementNotificationCustomerGroupDto> {
            const localVarFetchArgs = ManageNotificationsApiFetchParamCreator(configuration).getNotificationCustomerGroup(id, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get all notification customer groups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationCustomerGroups(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<BaseManagementNotificationCustomerGroupDto>> {
            const localVarFetchArgs = ManageNotificationsApiFetchParamCreator(configuration).getNotificationCustomerGroups(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get a notification draft by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationDraft(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ManagementNotificationDto> {
            const localVarFetchArgs = ManageNotificationsApiFetchParamCreator(configuration).getNotificationDraft(id, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get a page of notification drafts
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {Array&lt;string&gt;} [tenants] Tenants to filter against, eg. tenants&#x3D;LL,LS
         * @param {Array&lt;string&gt;} [visibleFor] Filter for erp system, eg. visibleFor&#x3D;GM,LL.
         * @param {string} [sortBy] Field to sort by and order. Field is either id or type. The id sort is used to show more recently created notifications first. Order is either asc or desc. These two are provided in the form field,order
         * @param {Array&lt;number&gt;} [typeIdFilter] Filter by type ids.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationDraftsPaged(page?: number, pageSize?: number, tenants?: Array<string>, visibleFor?: Array<string>, sortBy?: string, typeIdFilter?: Array<number>, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ManagementNotificationSearchResultDto> {
            const localVarFetchArgs = ManageNotificationsApiFetchParamCreator(configuration).getNotificationDraftsPaged(page, pageSize, tenants, visibleFor, sortBy, typeIdFilter, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get a notification type by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationType(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<NotificationTypeDto> {
            const localVarFetchArgs = ManageNotificationsApiFetchParamCreator(configuration).getNotificationType(id, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get all notification types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationTypes(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<NotificationTypeDto>> {
            const localVarFetchArgs = ManageNotificationsApiFetchParamCreator(configuration).getNotificationTypes(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get a page of notifications
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {Array&lt;string&gt;} [tenants] Tenants to filter against, eg. tenants&#x3D;LL,LS
         * @param {Array&lt;string&gt;} [visibleFor] Filter for erp system, eg. visibleFor&#x3D;GM,LL.
         * @param {string} [sortBy] Field to sort by and order. Field is either id or type. The id sort is used to show more recently created notifications first. Order is either asc or desc. These two are provided in the form field,order
         * @param {string} [dateMin] Filter by date, lower bound.
         * @param {string} [dateMax] Filter by date, upper bound.
         * @param {Array&lt;number&gt;} [typeIdFilter] Filter by type ids.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationsPaged(page?: number, pageSize?: number, tenants?: Array<string>, visibleFor?: Array<string>, sortBy?: string, dateMin?: string, dateMax?: string, typeIdFilter?: Array<number>, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ManagementNotificationSearchResultDto> {
            const localVarFetchArgs = ManageNotificationsApiFetchParamCreator(configuration).getNotificationsPaged(page, pageSize, tenants, visibleFor, sortBy, dateMin, dateMax, typeIdFilter, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get notification setting of the given tenant.
         * @param {string} tenant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTenantNotificationSettings(tenant: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TenantNotificationSettingsDto> {
            const localVarFetchArgs = ManageNotificationsApiFetchParamCreator(configuration).getTenantNotificationSettings(tenant, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Publish and delete a notification draft by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishNotificationDraft(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ManagementNotificationDto> {
            const localVarFetchArgs = ManageNotificationsApiFetchParamCreator(configuration).publishNotificationDraft(id, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Update notification
         * @param {number} id 
         * @param {ManagementNotificationDto} notification 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNotification(id: number, notification: ManagementNotificationDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = ManageNotificationsApiFetchParamCreator(configuration).updateNotification(id, notification, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Update notification customer group
         * @param {number} id 
         * @param {ManagementNotificationCustomerGroupDto} notification 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNotificationCustomerGroup(id: number, notification: ManagementNotificationCustomerGroupDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = ManageNotificationsApiFetchParamCreator(configuration).updateNotificationCustomerGroup(id, notification, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Update notification draft
         * @param {number} id 
         * @param {ManagementNotificationDto} draft 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNotificationDraft(id: number, draft: ManagementNotificationDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = ManageNotificationsApiFetchParamCreator(configuration).updateNotificationDraft(id, draft, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Update notification type
         * @param {number} id 
         * @param {NotificationTypeDto} notification 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNotificationType(id: number, notification: NotificationTypeDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = ManageNotificationsApiFetchParamCreator(configuration).updateNotificationType(id, notification, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Update notification settings of the given tenant.
         * @param {string} tenant 
         * @param {TenantNotificationSettingsDto} notificationSettings 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTenantNotificationSettings(tenant: string, notificationSettings: TenantNotificationSettingsDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TenantNotificationSettingsDto> {
            const localVarFetchArgs = ManageNotificationsApiFetchParamCreator(configuration).updateTenantNotificationSettings(tenant, notificationSettings, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * ManageNotificationsApi - factory interface
 * @export
 */
export const ManageNotificationsApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Create notification
         * @param {ManagementNotificationDto} notification 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNotification(notification: ManagementNotificationDto, options?: any) {
            return ManageNotificationsApiFp(configuration).createNotification(notification, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Create notification customer group
         * @param {ManagementNotificationCustomerGroupDto} notificationCustomerGroup 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNotificationCustomerGroup(notificationCustomerGroup: ManagementNotificationCustomerGroupDto, options?: any) {
            return ManageNotificationsApiFp(configuration).createNotificationCustomerGroup(notificationCustomerGroup, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Create notification draft
         * @param {ManagementNotificationDto} draft 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNotificationDraft(draft: ManagementNotificationDto, options?: any) {
            return ManageNotificationsApiFp(configuration).createNotificationDraft(draft, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Create notification type
         * @param {NotificationTypeDto} type 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNotificationType(type: NotificationTypeDto, options?: any) {
            return ManageNotificationsApiFp(configuration).createNotificationType(type, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Delete notification
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNotification(id: number, options?: any) {
            return ManageNotificationsApiFp(configuration).deleteNotification(id, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Delete notification customer group
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNotificationCustomerGroup(id: number, options?: any) {
            return ManageNotificationsApiFp(configuration).deleteNotificationCustomerGroup(id, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Delete notification draft
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNotificationDraft(id: number, options?: any) {
            return ManageNotificationsApiFp(configuration).deleteNotificationDraft(id, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Delete notification type
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNotificationType(id: number, options?: any) {
            return ManageNotificationsApiFp(configuration).deleteNotificationType(id, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get a notification by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotification(id: number, options?: any) {
            return ManageNotificationsApiFp(configuration).getNotification(id, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get a notification customer group by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationCustomerGroup(id: number, options?: any) {
            return ManageNotificationsApiFp(configuration).getNotificationCustomerGroup(id, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get all notification customer groups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationCustomerGroups(options?: any) {
            return ManageNotificationsApiFp(configuration).getNotificationCustomerGroups(options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get a notification draft by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationDraft(id: number, options?: any) {
            return ManageNotificationsApiFp(configuration).getNotificationDraft(id, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get a page of notification drafts
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {Array&lt;string&gt;} [tenants] Tenants to filter against, eg. tenants&#x3D;LL,LS
         * @param {Array&lt;string&gt;} [visibleFor] Filter for erp system, eg. visibleFor&#x3D;GM,LL.
         * @param {string} [sortBy] Field to sort by and order. Field is either id or type. The id sort is used to show more recently created notifications first. Order is either asc or desc. These two are provided in the form field,order
         * @param {Array&lt;number&gt;} [typeIdFilter] Filter by type ids.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationDraftsPaged(page?: number, pageSize?: number, tenants?: Array<string>, visibleFor?: Array<string>, sortBy?: string, typeIdFilter?: Array<number>, options?: any) {
            return ManageNotificationsApiFp(configuration).getNotificationDraftsPaged(page, pageSize, tenants, visibleFor, sortBy, typeIdFilter, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get a notification type by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationType(id: number, options?: any) {
            return ManageNotificationsApiFp(configuration).getNotificationType(id, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get all notification types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationTypes(options?: any) {
            return ManageNotificationsApiFp(configuration).getNotificationTypes(options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get a page of notifications
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {Array&lt;string&gt;} [tenants] Tenants to filter against, eg. tenants&#x3D;LL,LS
         * @param {Array&lt;string&gt;} [visibleFor] Filter for erp system, eg. visibleFor&#x3D;GM,LL.
         * @param {string} [sortBy] Field to sort by and order. Field is either id or type. The id sort is used to show more recently created notifications first. Order is either asc or desc. These two are provided in the form field,order
         * @param {string} [dateMin] Filter by date, lower bound.
         * @param {string} [dateMax] Filter by date, upper bound.
         * @param {Array&lt;number&gt;} [typeIdFilter] Filter by type ids.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationsPaged(page?: number, pageSize?: number, tenants?: Array<string>, visibleFor?: Array<string>, sortBy?: string, dateMin?: string, dateMax?: string, typeIdFilter?: Array<number>, options?: any) {
            return ManageNotificationsApiFp(configuration).getNotificationsPaged(page, pageSize, tenants, visibleFor, sortBy, dateMin, dateMax, typeIdFilter, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get notification setting of the given tenant.
         * @param {string} tenant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTenantNotificationSettings(tenant: string, options?: any) {
            return ManageNotificationsApiFp(configuration).getTenantNotificationSettings(tenant, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Publish and delete a notification draft by id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishNotificationDraft(id: number, options?: any) {
            return ManageNotificationsApiFp(configuration).publishNotificationDraft(id, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Update notification
         * @param {number} id 
         * @param {ManagementNotificationDto} notification 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNotification(id: number, notification: ManagementNotificationDto, options?: any) {
            return ManageNotificationsApiFp(configuration).updateNotification(id, notification, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Update notification customer group
         * @param {number} id 
         * @param {ManagementNotificationCustomerGroupDto} notification 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNotificationCustomerGroup(id: number, notification: ManagementNotificationCustomerGroupDto, options?: any) {
            return ManageNotificationsApiFp(configuration).updateNotificationCustomerGroup(id, notification, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Update notification draft
         * @param {number} id 
         * @param {ManagementNotificationDto} draft 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNotificationDraft(id: number, draft: ManagementNotificationDto, options?: any) {
            return ManageNotificationsApiFp(configuration).updateNotificationDraft(id, draft, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Update notification type
         * @param {number} id 
         * @param {NotificationTypeDto} notification 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNotificationType(id: number, notification: NotificationTypeDto, options?: any) {
            return ManageNotificationsApiFp(configuration).updateNotificationType(id, notification, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Update notification settings of the given tenant.
         * @param {string} tenant 
         * @param {TenantNotificationSettingsDto} notificationSettings 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTenantNotificationSettings(tenant: string, notificationSettings: TenantNotificationSettingsDto, options?: any) {
            return ManageNotificationsApiFp(configuration).updateTenantNotificationSettings(tenant, notificationSettings, options)(fetch, basePath);
        },
    };
};

/**
 * ManageNotificationsApi - object-oriented interface
 * @export
 * @class ManageNotificationsApi
 * @extends {BaseAPI}
 */
export class ManageNotificationsApi extends BaseAPI {
    /**
     * 
     * @summary Create notification
     * @param {} notification 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageNotificationsApi
     */
    public createNotification(notification: ManagementNotificationDto, options?: any) {
        return ManageNotificationsApiFp(this.configuration).createNotification(notification, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Create notification customer group
     * @param {} notificationCustomerGroup 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageNotificationsApi
     */
    public createNotificationCustomerGroup(notificationCustomerGroup: ManagementNotificationCustomerGroupDto, options?: any) {
        return ManageNotificationsApiFp(this.configuration).createNotificationCustomerGroup(notificationCustomerGroup, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Create notification draft
     * @param {} draft 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageNotificationsApi
     */
    public createNotificationDraft(draft: ManagementNotificationDto, options?: any) {
        return ManageNotificationsApiFp(this.configuration).createNotificationDraft(draft, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Create notification type
     * @param {} type 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageNotificationsApi
     */
    public createNotificationType(type: NotificationTypeDto, options?: any) {
        return ManageNotificationsApiFp(this.configuration).createNotificationType(type, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Delete notification
     * @param {} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageNotificationsApi
     */
    public deleteNotification(id: number, options?: any) {
        return ManageNotificationsApiFp(this.configuration).deleteNotification(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Delete notification customer group
     * @param {} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageNotificationsApi
     */
    public deleteNotificationCustomerGroup(id: number, options?: any) {
        return ManageNotificationsApiFp(this.configuration).deleteNotificationCustomerGroup(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Delete notification draft
     * @param {} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageNotificationsApi
     */
    public deleteNotificationDraft(id: number, options?: any) {
        return ManageNotificationsApiFp(this.configuration).deleteNotificationDraft(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Delete notification type
     * @param {} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageNotificationsApi
     */
    public deleteNotificationType(id: number, options?: any) {
        return ManageNotificationsApiFp(this.configuration).deleteNotificationType(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get a notification by id
     * @param {} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageNotificationsApi
     */
    public getNotification(id: number, options?: any) {
        return ManageNotificationsApiFp(this.configuration).getNotification(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get a notification customer group by id
     * @param {} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageNotificationsApi
     */
    public getNotificationCustomerGroup(id: number, options?: any) {
        return ManageNotificationsApiFp(this.configuration).getNotificationCustomerGroup(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get all notification customer groups
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageNotificationsApi
     */
    public getNotificationCustomerGroups(options?: any) {
        return ManageNotificationsApiFp(this.configuration).getNotificationCustomerGroups(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get a notification draft by id
     * @param {} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageNotificationsApi
     */
    public getNotificationDraft(id: number, options?: any) {
        return ManageNotificationsApiFp(this.configuration).getNotificationDraft(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get a page of notification drafts
     * @param {} [page] 
     * @param {} [pageSize] 
     * @param {} [tenants] Tenants to filter against, eg. tenants&#x3D;LL,LS
     * @param {} [visibleFor] Filter for erp system, eg. visibleFor&#x3D;GM,LL.
     * @param {} [sortBy] Field to sort by and order. Field is either id or type. The id sort is used to show more recently created notifications first. Order is either asc or desc. These two are provided in the form field,order
     * @param {} [typeIdFilter] Filter by type ids.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageNotificationsApi
     */
    public getNotificationDraftsPaged(page?: number, pageSize?: number, tenants?: Array<string>, visibleFor?: Array<string>, sortBy?: string, typeIdFilter?: Array<number>, options?: any) {
        return ManageNotificationsApiFp(this.configuration).getNotificationDraftsPaged(page, pageSize, tenants, visibleFor, sortBy, typeIdFilter, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get a notification type by id
     * @param {} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageNotificationsApi
     */
    public getNotificationType(id: number, options?: any) {
        return ManageNotificationsApiFp(this.configuration).getNotificationType(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get all notification types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageNotificationsApi
     */
    public getNotificationTypes(options?: any) {
        return ManageNotificationsApiFp(this.configuration).getNotificationTypes(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get a page of notifications
     * @param {} [page] 
     * @param {} [pageSize] 
     * @param {} [tenants] Tenants to filter against, eg. tenants&#x3D;LL,LS
     * @param {} [visibleFor] Filter for erp system, eg. visibleFor&#x3D;GM,LL.
     * @param {} [sortBy] Field to sort by and order. Field is either id or type. The id sort is used to show more recently created notifications first. Order is either asc or desc. These two are provided in the form field,order
     * @param {} [dateMin] Filter by date, lower bound.
     * @param {} [dateMax] Filter by date, upper bound.
     * @param {} [typeIdFilter] Filter by type ids.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageNotificationsApi
     */
    public getNotificationsPaged(page?: number, pageSize?: number, tenants?: Array<string>, visibleFor?: Array<string>, sortBy?: string, dateMin?: string, dateMax?: string, typeIdFilter?: Array<number>, options?: any) {
        return ManageNotificationsApiFp(this.configuration).getNotificationsPaged(page, pageSize, tenants, visibleFor, sortBy, dateMin, dateMax, typeIdFilter, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get notification setting of the given tenant.
     * @param {} tenant 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageNotificationsApi
     */
    public getTenantNotificationSettings(tenant: string, options?: any) {
        return ManageNotificationsApiFp(this.configuration).getTenantNotificationSettings(tenant, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Publish and delete a notification draft by id
     * @param {} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageNotificationsApi
     */
    public publishNotificationDraft(id: number, options?: any) {
        return ManageNotificationsApiFp(this.configuration).publishNotificationDraft(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Update notification
     * @param {} id 
     * @param {} notification 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageNotificationsApi
     */
    public updateNotification(id: number, notification: ManagementNotificationDto, options?: any) {
        return ManageNotificationsApiFp(this.configuration).updateNotification(id, notification, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Update notification customer group
     * @param {} id 
     * @param {} notification 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageNotificationsApi
     */
    public updateNotificationCustomerGroup(id: number, notification: ManagementNotificationCustomerGroupDto, options?: any) {
        return ManageNotificationsApiFp(this.configuration).updateNotificationCustomerGroup(id, notification, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Update notification draft
     * @param {} id 
     * @param {} draft 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageNotificationsApi
     */
    public updateNotificationDraft(id: number, draft: ManagementNotificationDto, options?: any) {
        return ManageNotificationsApiFp(this.configuration).updateNotificationDraft(id, draft, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Update notification type
     * @param {} id 
     * @param {} notification 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageNotificationsApi
     */
    public updateNotificationType(id: number, notification: NotificationTypeDto, options?: any) {
        return ManageNotificationsApiFp(this.configuration).updateNotificationType(id, notification, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Update notification settings of the given tenant.
     * @param {} tenant 
     * @param {} notificationSettings 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageNotificationsApi
     */
    public updateTenantNotificationSettings(tenant: string, notificationSettings: TenantNotificationSettingsDto, options?: any) {
        return ManageNotificationsApiFp(this.configuration).updateTenantNotificationSettings(tenant, notificationSettings, options)(this.fetch, this.basePath);
    }

}

/**
 * ManageOrderTemplatesApi - fetch parameter creator
 * @export
 */
export const ManageOrderTemplatesApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This enables the tenants to create order templates for their customers. A usage is the orders of the last fairy as sample for a new fairy.
         * @summary Creates order templates based on the customer and his items.
         * @param {string} tenant 
         * @param {string} orderTemplateName 
         * @param {Array&lt;ManageCustomerOrderTemplateItemDto&gt;} orderTemplateItems 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrderTemplates(tenant: string, orderTemplateName: string, orderTemplateItems: Array<ManageCustomerOrderTemplateItemDto>, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling createOrderTemplates.');
            }
            // verify required parameter 'orderTemplateName' is not null or undefined
            if (orderTemplateName === null || orderTemplateName === undefined) {
                throw new RequiredError('orderTemplateName','Required parameter orderTemplateName was null or undefined when calling createOrderTemplates.');
            }
            // verify required parameter 'orderTemplateItems' is not null or undefined
            if (orderTemplateItems === null || orderTemplateItems === undefined) {
                throw new RequiredError('orderTemplateItems','Required parameter orderTemplateItems was null or undefined when calling createOrderTemplates.');
            }
            const localVarPath = `/.internal/manage/order-templates/{tenant}/{orderTemplateName}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"orderTemplateName"}}`, encodeURIComponent(String(orderTemplateName)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"Array&lt;ManageCustomerOrderTemplateItemDto&gt;" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(orderTemplateItems || {}) : (orderTemplateItems || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ManageOrderTemplatesApi - functional programming interface
 * @export
 */
export const ManageOrderTemplatesApiFp = function(configuration?: Configuration) {
    return {
        /**
         * This enables the tenants to create order templates for their customers. A usage is the orders of the last fairy as sample for a new fairy.
         * @summary Creates order templates based on the customer and his items.
         * @param {string} tenant 
         * @param {string} orderTemplateName 
         * @param {Array&lt;ManageCustomerOrderTemplateItemDto&gt;} orderTemplateItems 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrderTemplates(tenant: string, orderTemplateName: string, orderTemplateItems: Array<ManageCustomerOrderTemplateItemDto>, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = ManageOrderTemplatesApiFetchParamCreator(configuration).createOrderTemplates(tenant, orderTemplateName, orderTemplateItems, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * ManageOrderTemplatesApi - factory interface
 * @export
 */
export const ManageOrderTemplatesApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * This enables the tenants to create order templates for their customers. A usage is the orders of the last fairy as sample for a new fairy.
         * @summary Creates order templates based on the customer and his items.
         * @param {string} tenant 
         * @param {string} orderTemplateName 
         * @param {Array&lt;ManageCustomerOrderTemplateItemDto&gt;} orderTemplateItems 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrderTemplates(tenant: string, orderTemplateName: string, orderTemplateItems: Array<ManageCustomerOrderTemplateItemDto>, options?: any) {
            return ManageOrderTemplatesApiFp(configuration).createOrderTemplates(tenant, orderTemplateName, orderTemplateItems, options)(fetch, basePath);
        },
    };
};

/**
 * ManageOrderTemplatesApi - object-oriented interface
 * @export
 * @class ManageOrderTemplatesApi
 * @extends {BaseAPI}
 */
export class ManageOrderTemplatesApi extends BaseAPI {
    /**
     * This enables the tenants to create order templates for their customers. A usage is the orders of the last fairy as sample for a new fairy.
     * @summary Creates order templates based on the customer and his items.
     * @param {} tenant 
     * @param {} orderTemplateName 
     * @param {} orderTemplateItems 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageOrderTemplatesApi
     */
    public createOrderTemplates(tenant: string, orderTemplateName: string, orderTemplateItems: Array<ManageCustomerOrderTemplateItemDto>, options?: any) {
        return ManageOrderTemplatesApiFp(this.configuration).createOrderTemplates(tenant, orderTemplateName, orderTemplateItems, options)(this.fetch, this.basePath);
    }

}

/**
 * ManageOrdersApi - fetch parameter creator
 * @export
 */
export const ManageOrdersApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Checks for faulty orders (processed but not confirmed) in the last 10 minutes  and send notifications for all of them.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkFaultyOrders(options: any = {}): FetchArgs {
            const localVarPath = `/.internal/manage/orders/check-faults`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Confirm that an order has been processed by the ERP system.
         * @param {string} orderId The orderId which has been processed by the ERP.
         * @param {OrderConfirmationManagementDto} confirmation 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmOrderProcessing(orderId: string, confirmation: OrderConfirmationManagementDto, options: any = {}): FetchArgs {
            // verify required parameter 'orderId' is not null or undefined
            if (orderId === null || orderId === undefined) {
                throw new RequiredError('orderId','Required parameter orderId was null or undefined when calling confirmOrderProcessing.');
            }
            // verify required parameter 'confirmation' is not null or undefined
            if (confirmation === null || confirmation === undefined) {
                throw new RequiredError('confirmation','Required parameter confirmation was null or undefined when calling confirmOrderProcessing.');
            }
            const localVarPath = `/.internal/manage/orders/{orderId}/confirmProcessing`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"OrderConfirmationManagementDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(confirmation || {}) : (confirmation || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all orders for customer
         * @param {OrderManagementFilterDto} filterDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllOrdersForCustomer(filterDto: OrderManagementFilterDto, options: any = {}): FetchArgs {
            // verify required parameter 'filterDto' is not null or undefined
            if (filterDto === null || filterDto === undefined) {
                throw new RequiredError('filterDto','Required parameter filterDto was null or undefined when calling getAllOrdersForCustomer.');
            }
            const localVarPath = `/.internal/manage/orders`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"OrderManagementFilterDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(filterDto || {}) : (filterDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the latest order-timestamp of a app-order with the given device-id.
         * @param {string} deviceId The deviceId of a bf-pro-device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestAppOrderTimestamp(deviceId: string, options: any = {}): FetchArgs {
            // verify required parameter 'deviceId' is not null or undefined
            if (deviceId === null || deviceId === undefined) {
                throw new RequiredError('deviceId','Required parameter deviceId was null or undefined when calling getLatestAppOrderTimestamp.');
            }
            const localVarPath = `/.internal/manage/app-orders/{deviceId}`
                .replace(`{${"deviceId"}}`, encodeURIComponent(String(deviceId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Order by Id
         * @param {string} orderId The Database Id of the order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderById(orderId: string, options: any = {}): FetchArgs {
            // verify required parameter 'orderId' is not null or undefined
            if (orderId === null || orderId === undefined) {
                throw new RequiredError('orderId','Required parameter orderId was null or undefined when calling getOrderById.');
            }
            const localVarPath = `/.internal/manage/orders/{orderId}`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Export an order to the ESB without sending confirmation emails.
         * @param {string} orderId The orderId which should be re-exported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reExportOrder(orderId: string, options: any = {}): FetchArgs {
            // verify required parameter 'orderId' is not null or undefined
            if (orderId === null || orderId === undefined) {
                throw new RequiredError('orderId','Required parameter orderId was null or undefined when calling reExportOrder.');
            }
            const localVarPath = `/.internal/manage/orders/{orderId}/reExport`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ManageOrdersApi - functional programming interface
 * @export
 */
export const ManageOrdersApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Checks for faulty orders (processed but not confirmed) in the last 10 minutes  and send notifications for all of them.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkFaultyOrders(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = ManageOrdersApiFetchParamCreator(configuration).checkFaultyOrders(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Confirm that an order has been processed by the ERP system.
         * @param {string} orderId The orderId which has been processed by the ERP.
         * @param {OrderConfirmationManagementDto} confirmation 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmOrderProcessing(orderId: string, confirmation: OrderConfirmationManagementDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = ManageOrdersApiFetchParamCreator(configuration).confirmOrderProcessing(orderId, confirmation, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Get all orders for customer
         * @param {OrderManagementFilterDto} filterDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllOrdersForCustomer(filterDto: OrderManagementFilterDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<OrderSearchResultDto> {
            const localVarFetchArgs = ManageOrdersApiFetchParamCreator(configuration).getAllOrdersForCustomer(filterDto, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Get the latest order-timestamp of a app-order with the given device-id.
         * @param {string} deviceId The deviceId of a bf-pro-device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestAppOrderTimestamp(deviceId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Date> {
            const localVarFetchArgs = ManageOrdersApiFetchParamCreator(configuration).getLatestAppOrderTimestamp(deviceId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get Order by Id
         * @param {string} orderId The Database Id of the order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderById(orderId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<OrderManagementDto> {
            const localVarFetchArgs = ManageOrdersApiFetchParamCreator(configuration).getOrderById(orderId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Export an order to the ESB without sending confirmation emails.
         * @param {string} orderId The orderId which should be re-exported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reExportOrder(orderId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = ManageOrdersApiFetchParamCreator(configuration).reExportOrder(orderId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * ManageOrdersApi - factory interface
 * @export
 */
export const ManageOrdersApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * Checks for faulty orders (processed but not confirmed) in the last 10 minutes  and send notifications for all of them.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkFaultyOrders(options?: any) {
            return ManageOrdersApiFp(configuration).checkFaultyOrders(options)(fetch, basePath);
        },
        /**
         * Confirm that an order has been processed by the ERP system.
         * @param {string} orderId The orderId which has been processed by the ERP.
         * @param {OrderConfirmationManagementDto} confirmation 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmOrderProcessing(orderId: string, confirmation: OrderConfirmationManagementDto, options?: any) {
            return ManageOrdersApiFp(configuration).confirmOrderProcessing(orderId, confirmation, options)(fetch, basePath);
        },
        /**
         * Get all orders for customer
         * @param {OrderManagementFilterDto} filterDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllOrdersForCustomer(filterDto: OrderManagementFilterDto, options?: any) {
            return ManageOrdersApiFp(configuration).getAllOrdersForCustomer(filterDto, options)(fetch, basePath);
        },
        /**
         * Get the latest order-timestamp of a app-order with the given device-id.
         * @param {string} deviceId The deviceId of a bf-pro-device.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestAppOrderTimestamp(deviceId: string, options?: any) {
            return ManageOrdersApiFp(configuration).getLatestAppOrderTimestamp(deviceId, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get Order by Id
         * @param {string} orderId The Database Id of the order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderById(orderId: string, options?: any) {
            return ManageOrdersApiFp(configuration).getOrderById(orderId, options)(fetch, basePath);
        },
        /**
         * Export an order to the ESB without sending confirmation emails.
         * @param {string} orderId The orderId which should be re-exported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reExportOrder(orderId: string, options?: any) {
            return ManageOrdersApiFp(configuration).reExportOrder(orderId, options)(fetch, basePath);
        },
    };
};

/**
 * ManageOrdersApi - object-oriented interface
 * @export
 * @class ManageOrdersApi
 * @extends {BaseAPI}
 */
export class ManageOrdersApi extends BaseAPI {
    /**
     * Checks for faulty orders (processed but not confirmed) in the last 10 minutes  and send notifications for all of them.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageOrdersApi
     */
    public checkFaultyOrders(options?: any) {
        return ManageOrdersApiFp(this.configuration).checkFaultyOrders(options)(this.fetch, this.basePath);
    }

    /**
     * Confirm that an order has been processed by the ERP system.
     * @param {} orderId The orderId which has been processed by the ERP.
     * @param {} confirmation 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageOrdersApi
     */
    public confirmOrderProcessing(orderId: string, confirmation: OrderConfirmationManagementDto, options?: any) {
        return ManageOrdersApiFp(this.configuration).confirmOrderProcessing(orderId, confirmation, options)(this.fetch, this.basePath);
    }

    /**
     * Get all orders for customer
     * @param {} filterDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageOrdersApi
     */
    public getAllOrdersForCustomer(filterDto: OrderManagementFilterDto, options?: any) {
        return ManageOrdersApiFp(this.configuration).getAllOrdersForCustomer(filterDto, options)(this.fetch, this.basePath);
    }

    /**
     * Get the latest order-timestamp of a app-order with the given device-id.
     * @param {} deviceId The deviceId of a bf-pro-device.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageOrdersApi
     */
    public getLatestAppOrderTimestamp(deviceId: string, options?: any) {
        return ManageOrdersApiFp(this.configuration).getLatestAppOrderTimestamp(deviceId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get Order by Id
     * @param {} orderId The Database Id of the order
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageOrdersApi
     */
    public getOrderById(orderId: string, options?: any) {
        return ManageOrdersApiFp(this.configuration).getOrderById(orderId, options)(this.fetch, this.basePath);
    }

    /**
     * Export an order to the ESB without sending confirmation emails.
     * @param {} orderId The orderId which should be re-exported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageOrdersApi
     */
    public reExportOrder(orderId: string, options?: any) {
        return ManageOrdersApiFp(this.configuration).reExportOrder(orderId, options)(this.fetch, this.basePath);
    }

}

/**
 * ManageProductPromotionsApi - fetch parameter creator
 * @export
 */
export const ManageProductPromotionsApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a promoted product
         * @param {ProductPromotionDto} promotedProduct 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProductPromotion(promotedProduct: ProductPromotionDto, options: any = {}): FetchArgs {
            // verify required parameter 'promotedProduct' is not null or undefined
            if (promotedProduct === null || promotedProduct === undefined) {
                throw new RequiredError('promotedProduct','Required parameter promotedProduct was null or undefined when calling createProductPromotion.');
            }
            const localVarPath = `/.internal/manage/promoted-product`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ProductPromotionDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(promotedProduct || {}) : (promotedProduct || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a single promoted product
         * @param {number} id The id of the promoted product to work with
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProductPromotionById(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteProductPromotionById.');
            }
            const localVarPath = `/.internal/manage/promoted-products/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a single promoted product by id
         * @param {number} id The id of the promoted product to work with
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductPromotionById(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getProductPromotionById.');
            }
            const localVarPath = `/.internal/manage/promoted-products/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all promoted products
         * @param {string} tenant Tenant to filter against
         * @param {number} [pageNumber] The page to get
         * @param {number} [pageSize] The amount of items to retrieve per page
         * @param {string} [sku] SKU to filter against
         * @param {boolean} [search] Filter for promoted products visible/invisible in search.
         * @param {boolean} [cart] Filter for promoted products visible/invisible in cart
         * @param {string} [dateFrom] Beginning of the time range to filter for. Only promotions active at any point in that range will be shown.
         * @param {string} [dateTo] End of the time range to filter for. Only promotions active at any point in that range will be shown.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductPromotions(tenant: string, pageNumber?: number, pageSize?: number, sku?: string, search?: boolean, cart?: boolean, dateFrom?: string, dateTo?: string, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling getProductPromotions.');
            }
            const localVarPath = `/.internal/manage/promoted-product`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (tenant !== undefined) {
                localVarQueryParameter['tenant'] = tenant;
            }

            if (sku !== undefined) {
                localVarQueryParameter['sku'] = sku;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (cart !== undefined) {
                localVarQueryParameter['cart'] = cart;
            }

            if (dateFrom !== undefined) {
                localVarQueryParameter['date-from'] = (dateFrom as any).toISOString();
            }

            if (dateTo !== undefined) {
                localVarQueryParameter['date-to'] = (dateTo as any).toISOString();
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a promoted product
         * @param {ProductPromotionDto} promotedProduct 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProductPromotion(promotedProduct: ProductPromotionDto, options: any = {}): FetchArgs {
            // verify required parameter 'promotedProduct' is not null or undefined
            if (promotedProduct === null || promotedProduct === undefined) {
                throw new RequiredError('promotedProduct','Required parameter promotedProduct was null or undefined when calling updateProductPromotion.');
            }
            const localVarPath = `/.internal/manage/promoted-product`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ProductPromotionDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(promotedProduct || {}) : (promotedProduct || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ManageProductPromotionsApi - functional programming interface
 * @export
 */
export const ManageProductPromotionsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a promoted product
         * @param {ProductPromotionDto} promotedProduct 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProductPromotion(promotedProduct: ProductPromotionDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ProductPromotionDto> {
            const localVarFetchArgs = ManageProductPromotionsApiFetchParamCreator(configuration).createProductPromotion(promotedProduct, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Delete a single promoted product
         * @param {number} id The id of the promoted product to work with
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProductPromotionById(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = ManageProductPromotionsApiFetchParamCreator(configuration).deleteProductPromotionById(id, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get a single promoted product by id
         * @param {number} id The id of the promoted product to work with
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductPromotionById(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ProductPromotionDto> {
            const localVarFetchArgs = ManageProductPromotionsApiFetchParamCreator(configuration).getProductPromotionById(id, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get all promoted products
         * @param {string} tenant Tenant to filter against
         * @param {number} [pageNumber] The page to get
         * @param {number} [pageSize] The amount of items to retrieve per page
         * @param {string} [sku] SKU to filter against
         * @param {boolean} [search] Filter for promoted products visible/invisible in search.
         * @param {boolean} [cart] Filter for promoted products visible/invisible in cart
         * @param {string} [dateFrom] Beginning of the time range to filter for. Only promotions active at any point in that range will be shown.
         * @param {string} [dateTo] End of the time range to filter for. Only promotions active at any point in that range will be shown.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductPromotions(tenant: string, pageNumber?: number, pageSize?: number, sku?: string, search?: boolean, cart?: boolean, dateFrom?: string, dateTo?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ProductPromotionSearchResultDto> {
            const localVarFetchArgs = ManageProductPromotionsApiFetchParamCreator(configuration).getProductPromotions(tenant, pageNumber, pageSize, sku, search, cart, dateFrom, dateTo, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Update a promoted product
         * @param {ProductPromotionDto} promotedProduct 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProductPromotion(promotedProduct: ProductPromotionDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = ManageProductPromotionsApiFetchParamCreator(configuration).updateProductPromotion(promotedProduct, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * ManageProductPromotionsApi - factory interface
 * @export
 */
export const ManageProductPromotionsApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Create a promoted product
         * @param {ProductPromotionDto} promotedProduct 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProductPromotion(promotedProduct: ProductPromotionDto, options?: any) {
            return ManageProductPromotionsApiFp(configuration).createProductPromotion(promotedProduct, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Delete a single promoted product
         * @param {number} id The id of the promoted product to work with
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProductPromotionById(id: number, options?: any) {
            return ManageProductPromotionsApiFp(configuration).deleteProductPromotionById(id, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get a single promoted product by id
         * @param {number} id The id of the promoted product to work with
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductPromotionById(id: number, options?: any) {
            return ManageProductPromotionsApiFp(configuration).getProductPromotionById(id, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get all promoted products
         * @param {string} tenant Tenant to filter against
         * @param {number} [pageNumber] The page to get
         * @param {number} [pageSize] The amount of items to retrieve per page
         * @param {string} [sku] SKU to filter against
         * @param {boolean} [search] Filter for promoted products visible/invisible in search.
         * @param {boolean} [cart] Filter for promoted products visible/invisible in cart
         * @param {string} [dateFrom] Beginning of the time range to filter for. Only promotions active at any point in that range will be shown.
         * @param {string} [dateTo] End of the time range to filter for. Only promotions active at any point in that range will be shown.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductPromotions(tenant: string, pageNumber?: number, pageSize?: number, sku?: string, search?: boolean, cart?: boolean, dateFrom?: string, dateTo?: string, options?: any) {
            return ManageProductPromotionsApiFp(configuration).getProductPromotions(tenant, pageNumber, pageSize, sku, search, cart, dateFrom, dateTo, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Update a promoted product
         * @param {ProductPromotionDto} promotedProduct 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProductPromotion(promotedProduct: ProductPromotionDto, options?: any) {
            return ManageProductPromotionsApiFp(configuration).updateProductPromotion(promotedProduct, options)(fetch, basePath);
        },
    };
};

/**
 * ManageProductPromotionsApi - object-oriented interface
 * @export
 * @class ManageProductPromotionsApi
 * @extends {BaseAPI}
 */
export class ManageProductPromotionsApi extends BaseAPI {
    /**
     * 
     * @summary Create a promoted product
     * @param {} promotedProduct 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageProductPromotionsApi
     */
    public createProductPromotion(promotedProduct: ProductPromotionDto, options?: any) {
        return ManageProductPromotionsApiFp(this.configuration).createProductPromotion(promotedProduct, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Delete a single promoted product
     * @param {} id The id of the promoted product to work with
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageProductPromotionsApi
     */
    public deleteProductPromotionById(id: number, options?: any) {
        return ManageProductPromotionsApiFp(this.configuration).deleteProductPromotionById(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get a single promoted product by id
     * @param {} id The id of the promoted product to work with
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageProductPromotionsApi
     */
    public getProductPromotionById(id: number, options?: any) {
        return ManageProductPromotionsApiFp(this.configuration).getProductPromotionById(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get all promoted products
     * @param {} tenant Tenant to filter against
     * @param {} [pageNumber] The page to get
     * @param {} [pageSize] The amount of items to retrieve per page
     * @param {} [sku] SKU to filter against
     * @param {} [search] Filter for promoted products visible/invisible in search.
     * @param {} [cart] Filter for promoted products visible/invisible in cart
     * @param {} [dateFrom] Beginning of the time range to filter for. Only promotions active at any point in that range will be shown.
     * @param {} [dateTo] End of the time range to filter for. Only promotions active at any point in that range will be shown.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageProductPromotionsApi
     */
    public getProductPromotions(tenant: string, pageNumber?: number, pageSize?: number, sku?: string, search?: boolean, cart?: boolean, dateFrom?: string, dateTo?: string, options?: any) {
        return ManageProductPromotionsApiFp(this.configuration).getProductPromotions(tenant, pageNumber, pageSize, sku, search, cart, dateFrom, dateTo, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Update a promoted product
     * @param {} promotedProduct 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageProductPromotionsApi
     */
    public updateProductPromotion(promotedProduct: ProductPromotionDto, options?: any) {
        return ManageProductPromotionsApiFp(this.configuration).updateProductPromotion(promotedProduct, options)(this.fetch, this.basePath);
    }

}

/**
 * ManageProductsApi - fetch parameter creator
 * @export
 */
export const ManageProductsApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get a specific product by Id
         * @param {string} tenant The tenant of the product
         * @param {string} sku The sku of the product
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductById(tenant: string, sku: string, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling getProductById.');
            }
            // verify required parameter 'sku' is not null or undefined
            if (sku === null || sku === undefined) {
                throw new RequiredError('sku','Required parameter sku was null or undefined when calling getProductById.');
            }
            const localVarPath = `/.internal/manage/products/{tenant}/{sku}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"sku"}}`, encodeURIComponent(String(sku)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Products
         * @param {string} tenant Tenant to filter against, eg. tenant&#x3D;LL
         * @param {number} pageNumber The page to get
         * @param {number} pageSize The amount of items to retrieve per page
         * @param {string} [sku] The Stock Keeping Unit or part of it to filter against.
         * @param {string} [categoryId] The category id to filter against, or part of it.
         * @param {number} [status] The article status to filter against. For allowed values see: https://confluence.eurogast.at/x/dIg5
         * @param {string} [bestFriendStatus] The bestfriend status of an article to filter against.
         * @param {string} [name] The article name to filter against, or part of it.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProducts(tenant: string, pageNumber: number, pageSize: number, sku?: string, categoryId?: string, status?: number, bestFriendStatus?: string, name?: string, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling getProducts.');
            }
            // verify required parameter 'pageNumber' is not null or undefined
            if (pageNumber === null || pageNumber === undefined) {
                throw new RequiredError('pageNumber','Required parameter pageNumber was null or undefined when calling getProducts.');
            }
            // verify required parameter 'pageSize' is not null or undefined
            if (pageSize === null || pageSize === undefined) {
                throw new RequiredError('pageSize','Required parameter pageSize was null or undefined when calling getProducts.');
            }
            const localVarPath = `/.internal/manage/products/{tenant}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (sku !== undefined) {
                localVarQueryParameter['sku'] = sku;
            }

            if (categoryId !== undefined) {
                localVarQueryParameter['categoryId'] = categoryId;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (bestFriendStatus !== undefined) {
                localVarQueryParameter['bestFriendStatus'] = bestFriendStatus;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update Product Information
         * @param {string} tenant Tenant to filter against, eg. tenant&#x3D;LL
         * @param {ManagementProductDto} product 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProduct(tenant: string, product: ManagementProductDto, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling updateProduct.');
            }
            // verify required parameter 'product' is not null or undefined
            if (product === null || product === undefined) {
                throw new RequiredError('product','Required parameter product was null or undefined when calling updateProduct.');
            }
            const localVarPath = `/.internal/manage/products/{tenant}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ManagementProductDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(product || {}) : (product || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ManageProductsApi - functional programming interface
 * @export
 */
export const ManageProductsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Get a specific product by Id
         * @param {string} tenant The tenant of the product
         * @param {string} sku The sku of the product
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductById(tenant: string, sku: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ManagementProductDto> {
            const localVarFetchArgs = ManageProductsApiFetchParamCreator(configuration).getProductById(tenant, sku, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Get Products
         * @param {string} tenant Tenant to filter against, eg. tenant&#x3D;LL
         * @param {number} pageNumber The page to get
         * @param {number} pageSize The amount of items to retrieve per page
         * @param {string} [sku] The Stock Keeping Unit or part of it to filter against.
         * @param {string} [categoryId] The category id to filter against, or part of it.
         * @param {number} [status] The article status to filter against. For allowed values see: https://confluence.eurogast.at/x/dIg5
         * @param {string} [bestFriendStatus] The bestfriend status of an article to filter against.
         * @param {string} [name] The article name to filter against, or part of it.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProducts(tenant: string, pageNumber: number, pageSize: number, sku?: string, categoryId?: string, status?: number, bestFriendStatus?: string, name?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ManagementProductSearchResultDto> {
            const localVarFetchArgs = ManageProductsApiFetchParamCreator(configuration).getProducts(tenant, pageNumber, pageSize, sku, categoryId, status, bestFriendStatus, name, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Update Product Information
         * @param {string} tenant Tenant to filter against, eg. tenant&#x3D;LL
         * @param {ManagementProductDto} product 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProduct(tenant: string, product: ManagementProductDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = ManageProductsApiFetchParamCreator(configuration).updateProduct(tenant, product, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * ManageProductsApi - factory interface
 * @export
 */
export const ManageProductsApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * Get a specific product by Id
         * @param {string} tenant The tenant of the product
         * @param {string} sku The sku of the product
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductById(tenant: string, sku: string, options?: any) {
            return ManageProductsApiFp(configuration).getProductById(tenant, sku, options)(fetch, basePath);
        },
        /**
         * Get Products
         * @param {string} tenant Tenant to filter against, eg. tenant&#x3D;LL
         * @param {number} pageNumber The page to get
         * @param {number} pageSize The amount of items to retrieve per page
         * @param {string} [sku] The Stock Keeping Unit or part of it to filter against.
         * @param {string} [categoryId] The category id to filter against, or part of it.
         * @param {number} [status] The article status to filter against. For allowed values see: https://confluence.eurogast.at/x/dIg5
         * @param {string} [bestFriendStatus] The bestfriend status of an article to filter against.
         * @param {string} [name] The article name to filter against, or part of it.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProducts(tenant: string, pageNumber: number, pageSize: number, sku?: string, categoryId?: string, status?: number, bestFriendStatus?: string, name?: string, options?: any) {
            return ManageProductsApiFp(configuration).getProducts(tenant, pageNumber, pageSize, sku, categoryId, status, bestFriendStatus, name, options)(fetch, basePath);
        },
        /**
         * Update Product Information
         * @param {string} tenant Tenant to filter against, eg. tenant&#x3D;LL
         * @param {ManagementProductDto} product 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProduct(tenant: string, product: ManagementProductDto, options?: any) {
            return ManageProductsApiFp(configuration).updateProduct(tenant, product, options)(fetch, basePath);
        },
    };
};

/**
 * ManageProductsApi - object-oriented interface
 * @export
 * @class ManageProductsApi
 * @extends {BaseAPI}
 */
export class ManageProductsApi extends BaseAPI {
    /**
     * Get a specific product by Id
     * @param {} tenant The tenant of the product
     * @param {} sku The sku of the product
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageProductsApi
     */
    public getProductById(tenant: string, sku: string, options?: any) {
        return ManageProductsApiFp(this.configuration).getProductById(tenant, sku, options)(this.fetch, this.basePath);
    }

    /**
     * Get Products
     * @param {} tenant Tenant to filter against, eg. tenant&#x3D;LL
     * @param {} pageNumber The page to get
     * @param {} pageSize The amount of items to retrieve per page
     * @param {} [sku] The Stock Keeping Unit or part of it to filter against.
     * @param {} [categoryId] The category id to filter against, or part of it.
     * @param {} [status] The article status to filter against. For allowed values see: https://confluence.eurogast.at/x/dIg5
     * @param {} [bestFriendStatus] The bestfriend status of an article to filter against.
     * @param {} [name] The article name to filter against, or part of it.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageProductsApi
     */
    public getProducts(tenant: string, pageNumber: number, pageSize: number, sku?: string, categoryId?: string, status?: number, bestFriendStatus?: string, name?: string, options?: any) {
        return ManageProductsApiFp(this.configuration).getProducts(tenant, pageNumber, pageSize, sku, categoryId, status, bestFriendStatus, name, options)(this.fetch, this.basePath);
    }

    /**
     * Update Product Information
     * @param {} tenant Tenant to filter against, eg. tenant&#x3D;LL
     * @param {} product 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageProductsApi
     */
    public updateProduct(tenant: string, product: ManagementProductDto, options?: any) {
        return ManageProductsApiFp(this.configuration).updateProduct(tenant, product, options)(this.fetch, this.basePath);
    }

}

/**
 * ManageTenantApi - fetch parameter creator
 * @export
 */
export const ManageTenantApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create Tenant Settings of Best Friend devices
         * @summary Create TenantSettings
         * @param {TenantSettingsDto} tenantSettings 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTenantSettings(tenantSettings: TenantSettingsDto, options: any = {}): FetchArgs {
            // verify required parameter 'tenantSettings' is not null or undefined
            if (tenantSettings === null || tenantSettings === undefined) {
                throw new RequiredError('tenantSettings','Required parameter tenantSettings was null or undefined when calling createTenantSettings.');
            }
            const localVarPath = `/.internal/manage/tenant`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"TenantSettingsDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(tenantSettings || {}) : (tenantSettings || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all tenant settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTenantSettings(options: any = {}): FetchArgs {
            const localVarPath = `/.internal/manage/tenant`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get single tenant settings
         * @param {string} tenant The Tenant to work with
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTenantSettingsByTenant(tenant: string, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling getTenantSettingsByTenant.');
            }
            const localVarPath = `/.internal/manage/tenant/{tenant}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update Tenant Settings of Best Friend devices
         * @summary Update TenantSettings
         * @param {TenantSettingsDto} tenantSettings 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTenantSettings(tenantSettings: TenantSettingsDto, options: any = {}): FetchArgs {
            // verify required parameter 'tenantSettings' is not null or undefined
            if (tenantSettings === null || tenantSettings === undefined) {
                throw new RequiredError('tenantSettings','Required parameter tenantSettings was null or undefined when calling updateTenantSettings.');
            }
            const localVarPath = `/.internal/manage/tenant`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"TenantSettingsDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(tenantSettings || {}) : (tenantSettings || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ManageTenantApi - functional programming interface
 * @export
 */
export const ManageTenantApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Create Tenant Settings of Best Friend devices
         * @summary Create TenantSettings
         * @param {TenantSettingsDto} tenantSettings 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTenantSettings(tenantSettings: TenantSettingsDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = ManageTenantApiFetchParamCreator(configuration).createTenantSettings(tenantSettings, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get all tenant settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTenantSettings(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<TenantSettingsDto>> {
            const localVarFetchArgs = ManageTenantApiFetchParamCreator(configuration).getAllTenantSettings(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get single tenant settings
         * @param {string} tenant The Tenant to work with
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTenantSettingsByTenant(tenant: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TenantSettingsDto> {
            const localVarFetchArgs = ManageTenantApiFetchParamCreator(configuration).getTenantSettingsByTenant(tenant, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Update Tenant Settings of Best Friend devices
         * @summary Update TenantSettings
         * @param {TenantSettingsDto} tenantSettings 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTenantSettings(tenantSettings: TenantSettingsDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = ManageTenantApiFetchParamCreator(configuration).updateTenantSettings(tenantSettings, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * ManageTenantApi - factory interface
 * @export
 */
export const ManageTenantApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * Create Tenant Settings of Best Friend devices
         * @summary Create TenantSettings
         * @param {TenantSettingsDto} tenantSettings 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTenantSettings(tenantSettings: TenantSettingsDto, options?: any) {
            return ManageTenantApiFp(configuration).createTenantSettings(tenantSettings, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get all tenant settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllTenantSettings(options?: any) {
            return ManageTenantApiFp(configuration).getAllTenantSettings(options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get single tenant settings
         * @param {string} tenant The Tenant to work with
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTenantSettingsByTenant(tenant: string, options?: any) {
            return ManageTenantApiFp(configuration).getTenantSettingsByTenant(tenant, options)(fetch, basePath);
        },
        /**
         * Update Tenant Settings of Best Friend devices
         * @summary Update TenantSettings
         * @param {TenantSettingsDto} tenantSettings 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTenantSettings(tenantSettings: TenantSettingsDto, options?: any) {
            return ManageTenantApiFp(configuration).updateTenantSettings(tenantSettings, options)(fetch, basePath);
        },
    };
};

/**
 * ManageTenantApi - object-oriented interface
 * @export
 * @class ManageTenantApi
 * @extends {BaseAPI}
 */
export class ManageTenantApi extends BaseAPI {
    /**
     * Create Tenant Settings of Best Friend devices
     * @summary Create TenantSettings
     * @param {} tenantSettings 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageTenantApi
     */
    public createTenantSettings(tenantSettings: TenantSettingsDto, options?: any) {
        return ManageTenantApiFp(this.configuration).createTenantSettings(tenantSettings, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get all tenant settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageTenantApi
     */
    public getAllTenantSettings(options?: any) {
        return ManageTenantApiFp(this.configuration).getAllTenantSettings(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get single tenant settings
     * @param {} tenant The Tenant to work with
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageTenantApi
     */
    public getTenantSettingsByTenant(tenant: string, options?: any) {
        return ManageTenantApiFp(this.configuration).getTenantSettingsByTenant(tenant, options)(this.fetch, this.basePath);
    }

    /**
     * Update Tenant Settings of Best Friend devices
     * @summary Update TenantSettings
     * @param {} tenantSettings 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageTenantApi
     */
    public updateTenantSettings(tenantSettings: TenantSettingsDto, options?: any) {
        return ManageTenantApiFp(this.configuration).updateTenantSettings(tenantSettings, options)(this.fetch, this.basePath);
    }

}

/**
 * ManageUsersApi - fetch parameter creator
 * @export
 */
export const ManageUsersApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Note that isEnabled cannot be changed via this endpoint. Use the specific endpoints where provided.
         * @summary Create a user
         * @param {UserManagementDto} userSpec 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser(userSpec: UserManagementDto, options: any = {}): FetchArgs {
            // verify required parameter 'userSpec' is not null or undefined
            if (userSpec === null || userSpec === undefined) {
                throw new RequiredError('userSpec','Required parameter userSpec was null or undefined when calling createUser.');
            }
            const localVarPath = `/.internal/manage/users`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"UserManagementDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(userSpec || {}) : (userSpec || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a single user
         * @param {string} userId The unique id of the user to work with
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserById(userId: string, options: any = {}): FetchArgs {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId','Required parameter userId was null or undefined when calling deleteUserById.');
            }
            const localVarPath = `/.internal/manage/users/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Disables all users that do not have an enabled customer
         * @param {string} tenant The EGB code of the tenant to target
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableAllUsersWithoutAnEnabledCustomer(tenant: string, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling disableAllUsersWithoutAnEnabledCustomer.');
            }
            const localVarPath = `/.internal/manage/users/{tenant}/without-enabled-customers`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets a page of all enabled UserDtos that do not have an enabled customer
         * @param {string} tenant The EGB code of the tenant to target
         * @param {number} pageNumber The number of the requested page
         * @param {number} pageSize The size of the requested page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnabledUsersWithoutAnEnabledCustomer(tenant: string, pageNumber: number, pageSize: number, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling getEnabledUsersWithoutAnEnabledCustomer.');
            }
            // verify required parameter 'pageNumber' is not null or undefined
            if (pageNumber === null || pageNumber === undefined) {
                throw new RequiredError('pageNumber','Required parameter pageNumber was null or undefined when calling getEnabledUsersWithoutAnEnabledCustomer.');
            }
            // verify required parameter 'pageSize' is not null or undefined
            if (pageSize === null || pageSize === undefined) {
                throw new RequiredError('pageSize','Required parameter pageSize was null or undefined when calling getEnabledUsersWithoutAnEnabledCustomer.');
            }
            const localVarPath = `/.internal/manage/users/{tenant}/without-enabled-customers`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a single user by id
         * @param {string} userId The unique id of the user to work with
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserById(userId: string, options: any = {}): FetchArgs {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId','Required parameter userId was null or undefined when calling getUserById.');
            }
            const localVarPath = `/.internal/manage/users/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all users which are not deleted
         * @param {number} pageNumber The page to get
         * @param {number} pageSize The amount of items to retrieve per page
         * @param {Array&lt;string&gt;} [tenants] Tenants to filter against, eg. tenants&#x3D;LL,LS
         * @param {string} [username] Username or part of it to filter against
         * @param {boolean} [isEnabled] Filter for enabled/disabled users. If param is missing, both enabled AND disabled users are returned.
         * @param {boolean} [canSeePrices] Filter for users who can see prices. If param is missing, both users who can see and those who cannot see prcies are returned.
         * @param {boolean} [highlightSpecialPrices] Filter for users who can see highlighted special prices. If param is missing, both users who can see and those who cannot see highlighted special prcies are returned.
         * @param {boolean} [canSeeDiscounts] Filter for users who can see discounts. If param is missing, both users who can see and those who cannot see discounts are returned.
         * @param {boolean} [highlightDiscounts] Filter for users who can see highlighted discounts. If param is missing, both users who can see and those who cannot see highlighted discounts are returned.
         * @param {string} [search] Matches value in email, username, firstname and lastname
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsers(pageNumber: number, pageSize: number, tenants?: Array<string>, username?: string, isEnabled?: boolean, canSeePrices?: boolean, highlightSpecialPrices?: boolean, canSeeDiscounts?: boolean, highlightDiscounts?: boolean, search?: string, options: any = {}): FetchArgs {
            // verify required parameter 'pageNumber' is not null or undefined
            if (pageNumber === null || pageNumber === undefined) {
                throw new RequiredError('pageNumber','Required parameter pageNumber was null or undefined when calling getUsers.');
            }
            // verify required parameter 'pageSize' is not null or undefined
            if (pageSize === null || pageSize === undefined) {
                throw new RequiredError('pageSize','Required parameter pageSize was null or undefined when calling getUsers.');
            }
            const localVarPath = `/.internal/manage/users`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (tenants) {
                localVarQueryParameter['tenants'] = tenants.join(COLLECTION_FORMATS["csv"]);
            }

            if (username !== undefined) {
                localVarQueryParameter['username'] = username;
            }

            if (isEnabled !== undefined) {
                localVarQueryParameter['isEnabled'] = isEnabled;
            }

            if (canSeePrices !== undefined) {
                localVarQueryParameter['canSeePrices'] = canSeePrices;
            }

            if (highlightSpecialPrices !== undefined) {
                localVarQueryParameter['highlightSpecialPrices'] = highlightSpecialPrices;
            }

            if (canSeeDiscounts !== undefined) {
                localVarQueryParameter['canSeeDiscounts'] = canSeeDiscounts;
            }

            if (highlightDiscounts !== undefined) {
                localVarQueryParameter['highlightDiscounts'] = highlightDiscounts;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Note that isEnabled cannot be changed via this endpoint. Use the specific endpoints where provided. The username cannot be changed at all.
         * @summary Update a user
         * @param {UserManagementDto} userSpec 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser(userSpec: UserManagementDto, options: any = {}): FetchArgs {
            // verify required parameter 'userSpec' is not null or undefined
            if (userSpec === null || userSpec === undefined) {
                throw new RequiredError('userSpec','Required parameter userSpec was null or undefined when calling updateUser.');
            }
            const localVarPath = `/.internal/manage/users`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"UserManagementDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(userSpec || {}) : (userSpec || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ManageUsersApi - functional programming interface
 * @export
 */
export const ManageUsersApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Note that isEnabled cannot be changed via this endpoint. Use the specific endpoints where provided.
         * @summary Create a user
         * @param {UserManagementDto} userSpec 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser(userSpec: UserManagementDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = ManageUsersApiFetchParamCreator(configuration).createUser(userSpec, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Delete a single user
         * @param {string} userId The unique id of the user to work with
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserById(userId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = ManageUsersApiFetchParamCreator(configuration).deleteUserById(userId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Disables all users that do not have an enabled customer
         * @param {string} tenant The EGB code of the tenant to target
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableAllUsersWithoutAnEnabledCustomer(tenant: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<string>> {
            const localVarFetchArgs = ManageUsersApiFetchParamCreator(configuration).disableAllUsersWithoutAnEnabledCustomer(tenant, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Gets a page of all enabled UserDtos that do not have an enabled customer
         * @param {string} tenant The EGB code of the tenant to target
         * @param {number} pageNumber The number of the requested page
         * @param {number} pageSize The size of the requested page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnabledUsersWithoutAnEnabledCustomer(tenant: string, pageNumber: number, pageSize: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UserManagementSearchResultDto> {
            const localVarFetchArgs = ManageUsersApiFetchParamCreator(configuration).getEnabledUsersWithoutAnEnabledCustomer(tenant, pageNumber, pageSize, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get a single user by id
         * @param {string} userId The unique id of the user to work with
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserById(userId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UserManagementDto> {
            const localVarFetchArgs = ManageUsersApiFetchParamCreator(configuration).getUserById(userId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get all users which are not deleted
         * @param {number} pageNumber The page to get
         * @param {number} pageSize The amount of items to retrieve per page
         * @param {Array&lt;string&gt;} [tenants] Tenants to filter against, eg. tenants&#x3D;LL,LS
         * @param {string} [username] Username or part of it to filter against
         * @param {boolean} [isEnabled] Filter for enabled/disabled users. If param is missing, both enabled AND disabled users are returned.
         * @param {boolean} [canSeePrices] Filter for users who can see prices. If param is missing, both users who can see and those who cannot see prcies are returned.
         * @param {boolean} [highlightSpecialPrices] Filter for users who can see highlighted special prices. If param is missing, both users who can see and those who cannot see highlighted special prcies are returned.
         * @param {boolean} [canSeeDiscounts] Filter for users who can see discounts. If param is missing, both users who can see and those who cannot see discounts are returned.
         * @param {boolean} [highlightDiscounts] Filter for users who can see highlighted discounts. If param is missing, both users who can see and those who cannot see highlighted discounts are returned.
         * @param {string} [search] Matches value in email, username, firstname and lastname
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsers(pageNumber: number, pageSize: number, tenants?: Array<string>, username?: string, isEnabled?: boolean, canSeePrices?: boolean, highlightSpecialPrices?: boolean, canSeeDiscounts?: boolean, highlightDiscounts?: boolean, search?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UserManagementSearchResultDto> {
            const localVarFetchArgs = ManageUsersApiFetchParamCreator(configuration).getUsers(pageNumber, pageSize, tenants, username, isEnabled, canSeePrices, highlightSpecialPrices, canSeeDiscounts, highlightDiscounts, search, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Note that isEnabled cannot be changed via this endpoint. Use the specific endpoints where provided. The username cannot be changed at all.
         * @summary Update a user
         * @param {UserManagementDto} userSpec 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser(userSpec: UserManagementDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = ManageUsersApiFetchParamCreator(configuration).updateUser(userSpec, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * ManageUsersApi - factory interface
 * @export
 */
export const ManageUsersApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * Note that isEnabled cannot be changed via this endpoint. Use the specific endpoints where provided.
         * @summary Create a user
         * @param {UserManagementDto} userSpec 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser(userSpec: UserManagementDto, options?: any) {
            return ManageUsersApiFp(configuration).createUser(userSpec, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Delete a single user
         * @param {string} userId The unique id of the user to work with
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserById(userId: string, options?: any) {
            return ManageUsersApiFp(configuration).deleteUserById(userId, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Disables all users that do not have an enabled customer
         * @param {string} tenant The EGB code of the tenant to target
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableAllUsersWithoutAnEnabledCustomer(tenant: string, options?: any) {
            return ManageUsersApiFp(configuration).disableAllUsersWithoutAnEnabledCustomer(tenant, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Gets a page of all enabled UserDtos that do not have an enabled customer
         * @param {string} tenant The EGB code of the tenant to target
         * @param {number} pageNumber The number of the requested page
         * @param {number} pageSize The size of the requested page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnabledUsersWithoutAnEnabledCustomer(tenant: string, pageNumber: number, pageSize: number, options?: any) {
            return ManageUsersApiFp(configuration).getEnabledUsersWithoutAnEnabledCustomer(tenant, pageNumber, pageSize, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get a single user by id
         * @param {string} userId The unique id of the user to work with
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserById(userId: string, options?: any) {
            return ManageUsersApiFp(configuration).getUserById(userId, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get all users which are not deleted
         * @param {number} pageNumber The page to get
         * @param {number} pageSize The amount of items to retrieve per page
         * @param {Array&lt;string&gt;} [tenants] Tenants to filter against, eg. tenants&#x3D;LL,LS
         * @param {string} [username] Username or part of it to filter against
         * @param {boolean} [isEnabled] Filter for enabled/disabled users. If param is missing, both enabled AND disabled users are returned.
         * @param {boolean} [canSeePrices] Filter for users who can see prices. If param is missing, both users who can see and those who cannot see prcies are returned.
         * @param {boolean} [highlightSpecialPrices] Filter for users who can see highlighted special prices. If param is missing, both users who can see and those who cannot see highlighted special prcies are returned.
         * @param {boolean} [canSeeDiscounts] Filter for users who can see discounts. If param is missing, both users who can see and those who cannot see discounts are returned.
         * @param {boolean} [highlightDiscounts] Filter for users who can see highlighted discounts. If param is missing, both users who can see and those who cannot see highlighted discounts are returned.
         * @param {string} [search] Matches value in email, username, firstname and lastname
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsers(pageNumber: number, pageSize: number, tenants?: Array<string>, username?: string, isEnabled?: boolean, canSeePrices?: boolean, highlightSpecialPrices?: boolean, canSeeDiscounts?: boolean, highlightDiscounts?: boolean, search?: string, options?: any) {
            return ManageUsersApiFp(configuration).getUsers(pageNumber, pageSize, tenants, username, isEnabled, canSeePrices, highlightSpecialPrices, canSeeDiscounts, highlightDiscounts, search, options)(fetch, basePath);
        },
        /**
         * Note that isEnabled cannot be changed via this endpoint. Use the specific endpoints where provided. The username cannot be changed at all.
         * @summary Update a user
         * @param {UserManagementDto} userSpec 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser(userSpec: UserManagementDto, options?: any) {
            return ManageUsersApiFp(configuration).updateUser(userSpec, options)(fetch, basePath);
        },
    };
};

/**
 * ManageUsersApi - object-oriented interface
 * @export
 * @class ManageUsersApi
 * @extends {BaseAPI}
 */
export class ManageUsersApi extends BaseAPI {
    /**
     * Note that isEnabled cannot be changed via this endpoint. Use the specific endpoints where provided.
     * @summary Create a user
     * @param {} userSpec 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageUsersApi
     */
    public createUser(userSpec: UserManagementDto, options?: any) {
        return ManageUsersApiFp(this.configuration).createUser(userSpec, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Delete a single user
     * @param {} userId The unique id of the user to work with
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageUsersApi
     */
    public deleteUserById(userId: string, options?: any) {
        return ManageUsersApiFp(this.configuration).deleteUserById(userId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Disables all users that do not have an enabled customer
     * @param {} tenant The EGB code of the tenant to target
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageUsersApi
     */
    public disableAllUsersWithoutAnEnabledCustomer(tenant: string, options?: any) {
        return ManageUsersApiFp(this.configuration).disableAllUsersWithoutAnEnabledCustomer(tenant, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Gets a page of all enabled UserDtos that do not have an enabled customer
     * @param {} tenant The EGB code of the tenant to target
     * @param {} pageNumber The number of the requested page
     * @param {} pageSize The size of the requested page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageUsersApi
     */
    public getEnabledUsersWithoutAnEnabledCustomer(tenant: string, pageNumber: number, pageSize: number, options?: any) {
        return ManageUsersApiFp(this.configuration).getEnabledUsersWithoutAnEnabledCustomer(tenant, pageNumber, pageSize, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get a single user by id
     * @param {} userId The unique id of the user to work with
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageUsersApi
     */
    public getUserById(userId: string, options?: any) {
        return ManageUsersApiFp(this.configuration).getUserById(userId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get all users which are not deleted
     * @param {} pageNumber The page to get
     * @param {} pageSize The amount of items to retrieve per page
     * @param {} [tenants] Tenants to filter against, eg. tenants&#x3D;LL,LS
     * @param {} [username] Username or part of it to filter against
     * @param {} [isEnabled] Filter for enabled/disabled users. If param is missing, both enabled AND disabled users are returned.
     * @param {} [canSeePrices] Filter for users who can see prices. If param is missing, both users who can see and those who cannot see prcies are returned.
     * @param {} [highlightSpecialPrices] Filter for users who can see highlighted special prices. If param is missing, both users who can see and those who cannot see highlighted special prcies are returned.
     * @param {} [canSeeDiscounts] Filter for users who can see discounts. If param is missing, both users who can see and those who cannot see discounts are returned.
     * @param {} [highlightDiscounts] Filter for users who can see highlighted discounts. If param is missing, both users who can see and those who cannot see highlighted discounts are returned.
     * @param {} [search] Matches value in email, username, firstname and lastname
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageUsersApi
     */
    public getUsers(pageNumber: number, pageSize: number, tenants?: Array<string>, username?: string, isEnabled?: boolean, canSeePrices?: boolean, highlightSpecialPrices?: boolean, canSeeDiscounts?: boolean, highlightDiscounts?: boolean, search?: string, options?: any) {
        return ManageUsersApiFp(this.configuration).getUsers(pageNumber, pageSize, tenants, username, isEnabled, canSeePrices, highlightSpecialPrices, canSeeDiscounts, highlightDiscounts, search, options)(this.fetch, this.basePath);
    }

    /**
     * Note that isEnabled cannot be changed via this endpoint. Use the specific endpoints where provided. The username cannot be changed at all.
     * @summary Update a user
     * @param {} userSpec 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManageUsersApi
     */
    public updateUser(userSpec: UserManagementDto, options?: any) {
        return ManageUsersApiFp(this.configuration).updateUser(userSpec, options)(this.fetch, this.basePath);
    }

}

/**
 * OrderConfirmationApi - fetch parameter creator
 * @export
 */
export const OrderConfirmationApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Generates order confirmation PDF. This may take some time. Only shows prices if the current user has access to prices.
         * @summary Generate order confirmation PDF
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} orderId The id of the order to request the confirmation PDF for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderConfirmationPdf(tenant: string, orderId: string, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling getOrderConfirmationPdf.');
            }
            // verify required parameter 'orderId' is not null or undefined
            if (orderId === null || orderId === undefined) {
                throw new RequiredError('orderId','Required parameter orderId was null or undefined when calling getOrderConfirmationPdf.');
            }
            const localVarPath = `/t/{tenant}/my/order/{orderId}/confirmation-pdf`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrderConfirmationApi - functional programming interface
 * @export
 */
export const OrderConfirmationApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Generates order confirmation PDF. This may take some time. Only shows prices if the current user has access to prices.
         * @summary Generate order confirmation PDF
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} orderId The id of the order to request the confirmation PDF for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderConfirmationPdf(tenant: string, orderId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = OrderConfirmationApiFetchParamCreator(configuration).getOrderConfirmationPdf(tenant, orderId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * OrderConfirmationApi - factory interface
 * @export
 */
export const OrderConfirmationApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * Generates order confirmation PDF. This may take some time. Only shows prices if the current user has access to prices.
         * @summary Generate order confirmation PDF
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} orderId The id of the order to request the confirmation PDF for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderConfirmationPdf(tenant: string, orderId: string, options?: any) {
            return OrderConfirmationApiFp(configuration).getOrderConfirmationPdf(tenant, orderId, options)(fetch, basePath);
        },
    };
};

/**
 * OrderConfirmationApi - object-oriented interface
 * @export
 * @class OrderConfirmationApi
 * @extends {BaseAPI}
 */
export class OrderConfirmationApi extends BaseAPI {
    /**
     * Generates order confirmation PDF. This may take some time. Only shows prices if the current user has access to prices.
     * @summary Generate order confirmation PDF
     * @param {} tenant The EGB code of the tenant to target
     * @param {} orderId The id of the order to request the confirmation PDF for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderConfirmationApi
     */
    public getOrderConfirmationPdf(tenant: string, orderId: string, options?: any) {
        return OrderConfirmationApiFp(this.configuration).getOrderConfirmationPdf(tenant, orderId, options)(this.fetch, this.basePath);
    }

}

/**
 * OrderTemplatesApi - fetch parameter creator
 * @export
 */
export const OrderTemplatesApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add a product to an order template
         * @param {string} tenant The EGB code of the tenant to target
         * @param {number} orderTemplateId The id for the order template to target
         * @param {OrderTemplateItemDto} orderTemplateItem 
         * @param {string} [customerId] The tenant-specific customer id to request the information for. This will affect things such as prices and articles.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOrderTemplateItem(tenant: string, orderTemplateId: number, orderTemplateItem: OrderTemplateItemDto, customerId?: string, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling addOrderTemplateItem.');
            }
            // verify required parameter 'orderTemplateId' is not null or undefined
            if (orderTemplateId === null || orderTemplateId === undefined) {
                throw new RequiredError('orderTemplateId','Required parameter orderTemplateId was null or undefined when calling addOrderTemplateItem.');
            }
            // verify required parameter 'orderTemplateItem' is not null or undefined
            if (orderTemplateItem === null || orderTemplateItem === undefined) {
                throw new RequiredError('orderTemplateItem','Required parameter orderTemplateItem was null or undefined when calling addOrderTemplateItem.');
            }
            const localVarPath = `/t/{tenant}/my/order-templates/{orderTemplateId}/order-template-item`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"orderTemplateId"}}`, encodeURIComponent(String(orderTemplateId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"OrderTemplateItemDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(orderTemplateItem || {}) : (orderTemplateItem || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Shares an order template with a user
         * @param {string} tenant The EGB code of the tenant to target
         * @param {number} orderTemplateId The id of the order template to target
         * @param {string} username 
         * @param {string} [customerId] The tenant-specific customer id to request the information for. This will affect things such as prices and products.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSharedWith(tenant: string, orderTemplateId: number, username: string, customerId?: string, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling addSharedWith.');
            }
            // verify required parameter 'orderTemplateId' is not null or undefined
            if (orderTemplateId === null || orderTemplateId === undefined) {
                throw new RequiredError('orderTemplateId','Required parameter orderTemplateId was null or undefined when calling addSharedWith.');
            }
            // verify required parameter 'username' is not null or undefined
            if (username === null || username === undefined) {
                throw new RequiredError('username','Required parameter username was null or undefined when calling addSharedWith.');
            }
            const localVarPath = `/t/{tenant}/my/order-templates/{orderTemplateId}/shared-with`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"orderTemplateId"}}`, encodeURIComponent(String(orderTemplateId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"string" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(username || {}) : (username || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create order template
         * @param {string} tenant The EGB code of the tenant to target
         * @param {OrderTemplateSubmitDto} orderTemplate 
         * @param {string} [customerId] The tenant-specific customer id to request the information for. This will affect things such as prices and articles.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNewOrderTemplate(tenant: string, orderTemplate: OrderTemplateSubmitDto, customerId?: string, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling createNewOrderTemplate.');
            }
            // verify required parameter 'orderTemplate' is not null or undefined
            if (orderTemplate === null || orderTemplate === undefined) {
                throw new RequiredError('orderTemplate','Required parameter orderTemplate was null or undefined when calling createNewOrderTemplate.');
            }
            const localVarPath = `/t/{tenant}/my/order-templates`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"OrderTemplateSubmitDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(orderTemplate || {}) : (orderTemplate || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the given order template. Including all items and already filtered products
         * @param {string} tenant The EGB code of the tenant to target
         * @param {number} orderTemplateId The id of the order template
         * @param {string} [customerId] The tenant-specific customer id to request the information for. This will affect things such as prices and articles.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderTemplateById(tenant: string, orderTemplateId: number, customerId?: string, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling getOrderTemplateById.');
            }
            // verify required parameter 'orderTemplateId' is not null or undefined
            if (orderTemplateId === null || orderTemplateId === undefined) {
                throw new RequiredError('orderTemplateId','Required parameter orderTemplateId was null or undefined when calling getOrderTemplateById.');
            }
            const localVarPath = `/t/{tenant}/my/order-templates/{orderTemplateId}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"orderTemplateId"}}`, encodeURIComponent(String(orderTemplateId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the given order template. Including all items and already filtered products
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} priceList The priceList of the order template
         * @param {string} [customerId] The tenant-specific customer id to request the information for. This will affect things such as prices and articles.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderTemplateByPriceList(tenant: string, priceList: string, customerId?: string, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling getOrderTemplateByPriceList.');
            }
            // verify required parameter 'priceList' is not null or undefined
            if (priceList === null || priceList === undefined) {
                throw new RequiredError('priceList','Required parameter priceList was null or undefined when calling getOrderTemplateByPriceList.');
            }
            const localVarPath = `/t/{tenant}/my/order-special-templates/{priceList}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"priceList"}}`, encodeURIComponent(String(priceList)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the list of order templates the current user has access to for given customer. This includes order templates created by the current user or shared with the current user.
         * @summary Get accessible order templates
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} [customerId] The tenant-specific customer id to request the information for. This will affect things such as prices and articles.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOwnOrderTemplates(tenant: string, customerId?: string, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling getOwnOrderTemplates.');
            }
            const localVarPath = `/t/{tenant}/my/order-templates`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Pages through accessible order templates
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} [customerId] The tenant-specific customer id to request the information for. This will affect things such as prices and articles.
         * @param {number} [page] the index of the page to retrieve
         * @param {number} [size] the amount of entries per page
         * @param {string} [sortBy] the field to sort by, or null if unsorted
         * @param {string} [sortDirection] ASC to sort in ascending order, DESC to sort in descending order. May be null if sortBy is null as well.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOwnOrderTemplatesPage(tenant: string, customerId?: string, page?: number, size?: number, sortBy?: string, sortDirection?: string, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling getOwnOrderTemplatesPage.');
            }
            const localVarPath = `/t/{tenant}/my/order-templates/search`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Generate order template PDF
         * @param {string} tenant The EGB code of the tenant to target
         * @param {number} orderTemplateId The id of the order tempalte to target
         * @param {string} [customerId] The tenant-specific customer id to request the information for. This will affect things such as prices and products.
         * @param {boolean} [showImages] Whether to show images and barcodes in the PDF.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPdf(tenant: string, orderTemplateId: number, customerId?: string, showImages?: boolean, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling getPdf.');
            }
            // verify required parameter 'orderTemplateId' is not null or undefined
            if (orderTemplateId === null || orderTemplateId === undefined) {
                throw new RequiredError('orderTemplateId','Required parameter orderTemplateId was null or undefined when calling getPdf.');
            }
            const localVarPath = `/t/{tenant}/my/order-templates/{orderTemplateId}/pdf`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"orderTemplateId"}}`, encodeURIComponent(String(orderTemplateId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }

            if (showImages !== undefined) {
                localVarQueryParameter['showImages'] = showImages;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Pages through accessible order templates
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} [customerId] The tenant-specific customer id to request the information for. This will affect things such as prices and articles.
         * @param {number} [page] the index of the page to retrieve
         * @param {number} [size] the amount of entries per page
         * @param {string} [sortBy] the field to sort by, or null if unsorted
         * @param {string} [sortDirection] ASC to sort in ascending order, DESC to sort in descending order. May be null if sortBy is null as well.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSpecialCartsPage(tenant: string, customerId?: string, page?: number, size?: number, sortBy?: string, sortDirection?: string, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling getSpecialCartsPage.');
            }
            const localVarPath = `/t/{tenant}/my/special-carts/search`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Removes the given order template, if the current user is the creator of the order template
         * @param {string} tenant The EGB code of the tenant to target
         * @param {number} orderTemplateId The id of the order template
         * @param {string} [customerId] The tenant-specific customer id to request the information for. This will affect things such as prices and articles.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeOrderTemplate(tenant: string, orderTemplateId: number, customerId?: string, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling removeOrderTemplate.');
            }
            // verify required parameter 'orderTemplateId' is not null or undefined
            if (orderTemplateId === null || orderTemplateId === undefined) {
                throw new RequiredError('orderTemplateId','Required parameter orderTemplateId was null or undefined when calling removeOrderTemplate.');
            }
            const localVarPath = `/t/{tenant}/my/order-templates/{orderTemplateId}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"orderTemplateId"}}`, encodeURIComponent(String(orderTemplateId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove a product from an order template
         * @param {string} tenant The EGB code of the tenant to target
         * @param {number} orderTemplateId The id for the order template to target
         * @param {OrderTemplateItemDto} orderTemplateItem 
         * @param {string} [customerId] The tenant-specific customer id to request the information for. This will affect things such as prices and articles.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeOrderTemplateItem(tenant: string, orderTemplateId: number, orderTemplateItem: OrderTemplateItemDto, customerId?: string, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling removeOrderTemplateItem.');
            }
            // verify required parameter 'orderTemplateId' is not null or undefined
            if (orderTemplateId === null || orderTemplateId === undefined) {
                throw new RequiredError('orderTemplateId','Required parameter orderTemplateId was null or undefined when calling removeOrderTemplateItem.');
            }
            // verify required parameter 'orderTemplateItem' is not null or undefined
            if (orderTemplateItem === null || orderTemplateItem === undefined) {
                throw new RequiredError('orderTemplateItem','Required parameter orderTemplateItem was null or undefined when calling removeOrderTemplateItem.');
            }
            const localVarPath = `/t/{tenant}/my/order-templates/{orderTemplateId}/order-template-item`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"orderTemplateId"}}`, encodeURIComponent(String(orderTemplateId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"OrderTemplateItemDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(orderTemplateItem || {}) : (orderTemplateItem || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Revokes access to an order template for a user
         * @param {string} tenant The EGB code of the tenant to target
         * @param {number} orderTemplateId The id of the order template to target
         * @param {string} username 
         * @param {string} [customerId] The tenant-specific customer id to request the information for. This will affect things such as prices and products.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeSharedWith(tenant: string, orderTemplateId: number, username: string, customerId?: string, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling removeSharedWith.');
            }
            // verify required parameter 'orderTemplateId' is not null or undefined
            if (orderTemplateId === null || orderTemplateId === undefined) {
                throw new RequiredError('orderTemplateId','Required parameter orderTemplateId was null or undefined when calling removeSharedWith.');
            }
            // verify required parameter 'username' is not null or undefined
            if (username === null || username === undefined) {
                throw new RequiredError('username','Required parameter username was null or undefined when calling removeSharedWith.');
            }
            const localVarPath = `/t/{tenant}/my/order-templates/{orderTemplateId}/shared-with`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"orderTemplateId"}}`, encodeURIComponent(String(orderTemplateId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"string" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(username || {}) : (username || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates a new order from the given order template and given parameters. Clears the shopping cart if submission was successful. Note that the order is transferred to the ERP asynchronously, so a positive response here does not mean that the order was actually received, but only that is was saved in the hub's database. If submission fails, it is periodically re-attempted until some threshold is met, after that, Eurogast needs to manually deal with the order. Confirmation emails are also sent asynchronously, after the ERP first receives the order. After submission, the ERP also confirms processing of the order later.
         * @param {string} tenant The EGB code of the tenant to target
         * @param {number} orderTemplateId The id of the order template
         * @param {string} customerId The tenant-specific customer id to request the information for. This will affect things such as prices and articles.
         * @param {OrderSubmitRequest} [orderInformation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitSpecialOrder(tenant: string, orderTemplateId: number, customerId: string, orderInformation?: OrderSubmitRequest, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling submitSpecialOrder.');
            }
            // verify required parameter 'orderTemplateId' is not null or undefined
            if (orderTemplateId === null || orderTemplateId === undefined) {
                throw new RequiredError('orderTemplateId','Required parameter orderTemplateId was null or undefined when calling submitSpecialOrder.');
            }
            // verify required parameter 'customerId' is not null or undefined
            if (customerId === null || customerId === undefined) {
                throw new RequiredError('customerId','Required parameter customerId was null or undefined when calling submitSpecialOrder.');
            }
            const localVarPath = `/t/{tenant}/order-templates/{orderTemplateId}/submit`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"orderTemplateId"}}`, encodeURIComponent(String(orderTemplateId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"OrderSubmitRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(orderInformation || {}) : (orderInformation || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates the given order template
         * @param {string} tenant The EGB code of the tenant to target
         * @param {number} orderTemplateId The id of the order template
         * @param {OrderTemplateSubmitDto} orderTemplate 
         * @param {string} [customerId] The tenant-specific customer id to request the information for. This will affect things such as prices and articles.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrderTemplate(tenant: string, orderTemplateId: number, orderTemplate: OrderTemplateSubmitDto, customerId?: string, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling updateOrderTemplate.');
            }
            // verify required parameter 'orderTemplateId' is not null or undefined
            if (orderTemplateId === null || orderTemplateId === undefined) {
                throw new RequiredError('orderTemplateId','Required parameter orderTemplateId was null or undefined when calling updateOrderTemplate.');
            }
            // verify required parameter 'orderTemplate' is not null or undefined
            if (orderTemplate === null || orderTemplate === undefined) {
                throw new RequiredError('orderTemplate','Required parameter orderTemplate was null or undefined when calling updateOrderTemplate.');
            }
            const localVarPath = `/t/{tenant}/my/order-templates/{orderTemplateId}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"orderTemplateId"}}`, encodeURIComponent(String(orderTemplateId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"OrderTemplateSubmitDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(orderTemplate || {}) : (orderTemplate || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrderTemplatesApi - functional programming interface
 * @export
 */
export const OrderTemplatesApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add a product to an order template
         * @param {string} tenant The EGB code of the tenant to target
         * @param {number} orderTemplateId The id for the order template to target
         * @param {OrderTemplateItemDto} orderTemplateItem 
         * @param {string} [customerId] The tenant-specific customer id to request the information for. This will affect things such as prices and articles.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOrderTemplateItem(tenant: string, orderTemplateId: number, orderTemplateItem: OrderTemplateItemDto, customerId?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<OrderTemplateDto> {
            const localVarFetchArgs = OrderTemplatesApiFetchParamCreator(configuration).addOrderTemplateItem(tenant, orderTemplateId, orderTemplateItem, customerId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Shares an order template with a user
         * @param {string} tenant The EGB code of the tenant to target
         * @param {number} orderTemplateId The id of the order template to target
         * @param {string} username 
         * @param {string} [customerId] The tenant-specific customer id to request the information for. This will affect things such as prices and products.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSharedWith(tenant: string, orderTemplateId: number, username: string, customerId?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<OrderTemplateDto> {
            const localVarFetchArgs = OrderTemplatesApiFetchParamCreator(configuration).addSharedWith(tenant, orderTemplateId, username, customerId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Create order template
         * @param {string} tenant The EGB code of the tenant to target
         * @param {OrderTemplateSubmitDto} orderTemplate 
         * @param {string} [customerId] The tenant-specific customer id to request the information for. This will affect things such as prices and articles.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNewOrderTemplate(tenant: string, orderTemplate: OrderTemplateSubmitDto, customerId?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<OrderTemplateDto> {
            const localVarFetchArgs = OrderTemplatesApiFetchParamCreator(configuration).createNewOrderTemplate(tenant, orderTemplate, customerId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Returns the given order template. Including all items and already filtered products
         * @param {string} tenant The EGB code of the tenant to target
         * @param {number} orderTemplateId The id of the order template
         * @param {string} [customerId] The tenant-specific customer id to request the information for. This will affect things such as prices and articles.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderTemplateById(tenant: string, orderTemplateId: number, customerId?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<AggregatedOrderTemplateDto> {
            const localVarFetchArgs = OrderTemplatesApiFetchParamCreator(configuration).getOrderTemplateById(tenant, orderTemplateId, customerId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Returns the given order template. Including all items and already filtered products
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} priceList The priceList of the order template
         * @param {string} [customerId] The tenant-specific customer id to request the information for. This will affect things such as prices and articles.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderTemplateByPriceList(tenant: string, priceList: string, customerId?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<OrderTemplateDto> {
            const localVarFetchArgs = OrderTemplatesApiFetchParamCreator(configuration).getOrderTemplateByPriceList(tenant, priceList, customerId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Retrieves the list of order templates the current user has access to for given customer. This includes order templates created by the current user or shared with the current user.
         * @summary Get accessible order templates
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} [customerId] The tenant-specific customer id to request the information for. This will affect things such as prices and articles.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOwnOrderTemplates(tenant: string, customerId?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<OrderTemplateDto>> {
            const localVarFetchArgs = OrderTemplatesApiFetchParamCreator(configuration).getOwnOrderTemplates(tenant, customerId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Pages through accessible order templates
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} [customerId] The tenant-specific customer id to request the information for. This will affect things such as prices and articles.
         * @param {number} [page] the index of the page to retrieve
         * @param {number} [size] the amount of entries per page
         * @param {string} [sortBy] the field to sort by, or null if unsorted
         * @param {string} [sortDirection] ASC to sort in ascending order, DESC to sort in descending order. May be null if sortBy is null as well.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOwnOrderTemplatesPage(tenant: string, customerId?: string, page?: number, size?: number, sortBy?: string, sortDirection?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<OrderTemplatePageDto> {
            const localVarFetchArgs = OrderTemplatesApiFetchParamCreator(configuration).getOwnOrderTemplatesPage(tenant, customerId, page, size, sortBy, sortDirection, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Generate order template PDF
         * @param {string} tenant The EGB code of the tenant to target
         * @param {number} orderTemplateId The id of the order tempalte to target
         * @param {string} [customerId] The tenant-specific customer id to request the information for. This will affect things such as prices and products.
         * @param {boolean} [showImages] Whether to show images and barcodes in the PDF.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPdf(tenant: string, orderTemplateId: number, customerId?: string, showImages?: boolean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = OrderTemplatesApiFetchParamCreator(configuration).getPdf(tenant, orderTemplateId, customerId, showImages, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Pages through accessible order templates
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} [customerId] The tenant-specific customer id to request the information for. This will affect things such as prices and articles.
         * @param {number} [page] the index of the page to retrieve
         * @param {number} [size] the amount of entries per page
         * @param {string} [sortBy] the field to sort by, or null if unsorted
         * @param {string} [sortDirection] ASC to sort in ascending order, DESC to sort in descending order. May be null if sortBy is null as well.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSpecialCartsPage(tenant: string, customerId?: string, page?: number, size?: number, sortBy?: string, sortDirection?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<OrderTemplatePageDto> {
            const localVarFetchArgs = OrderTemplatesApiFetchParamCreator(configuration).getSpecialCartsPage(tenant, customerId, page, size, sortBy, sortDirection, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Removes the given order template, if the current user is the creator of the order template
         * @param {string} tenant The EGB code of the tenant to target
         * @param {number} orderTemplateId The id of the order template
         * @param {string} [customerId] The tenant-specific customer id to request the information for. This will affect things such as prices and articles.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeOrderTemplate(tenant: string, orderTemplateId: number, customerId?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = OrderTemplatesApiFetchParamCreator(configuration).removeOrderTemplate(tenant, orderTemplateId, customerId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Remove a product from an order template
         * @param {string} tenant The EGB code of the tenant to target
         * @param {number} orderTemplateId The id for the order template to target
         * @param {OrderTemplateItemDto} orderTemplateItem 
         * @param {string} [customerId] The tenant-specific customer id to request the information for. This will affect things such as prices and articles.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeOrderTemplateItem(tenant: string, orderTemplateId: number, orderTemplateItem: OrderTemplateItemDto, customerId?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = OrderTemplatesApiFetchParamCreator(configuration).removeOrderTemplateItem(tenant, orderTemplateId, orderTemplateItem, customerId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Revokes access to an order template for a user
         * @param {string} tenant The EGB code of the tenant to target
         * @param {number} orderTemplateId The id of the order template to target
         * @param {string} username 
         * @param {string} [customerId] The tenant-specific customer id to request the information for. This will affect things such as prices and products.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeSharedWith(tenant: string, orderTemplateId: number, username: string, customerId?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = OrderTemplatesApiFetchParamCreator(configuration).removeSharedWith(tenant, orderTemplateId, username, customerId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Creates a new order from the given order template and given parameters. Clears the shopping cart if submission was successful. Note that the order is transferred to the ERP asynchronously, so a positive response here does not mean that the order was actually received, but only that is was saved in the hub's database. If submission fails, it is periodically re-attempted until some threshold is met, after that, Eurogast needs to manually deal with the order. Confirmation emails are also sent asynchronously, after the ERP first receives the order. After submission, the ERP also confirms processing of the order later.
         * @param {string} tenant The EGB code of the tenant to target
         * @param {number} orderTemplateId The id of the order template
         * @param {string} customerId The tenant-specific customer id to request the information for. This will affect things such as prices and articles.
         * @param {OrderSubmitRequest} [orderInformation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitSpecialOrder(tenant: string, orderTemplateId: number, customerId: string, orderInformation?: OrderSubmitRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<OrderDto> {
            const localVarFetchArgs = OrderTemplatesApiFetchParamCreator(configuration).submitSpecialOrder(tenant, orderTemplateId, customerId, orderInformation, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Updates the given order template
         * @param {string} tenant The EGB code of the tenant to target
         * @param {number} orderTemplateId The id of the order template
         * @param {OrderTemplateSubmitDto} orderTemplate 
         * @param {string} [customerId] The tenant-specific customer id to request the information for. This will affect things such as prices and articles.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrderTemplate(tenant: string, orderTemplateId: number, orderTemplate: OrderTemplateSubmitDto, customerId?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<OrderTemplateDto> {
            const localVarFetchArgs = OrderTemplatesApiFetchParamCreator(configuration).updateOrderTemplate(tenant, orderTemplateId, orderTemplate, customerId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * OrderTemplatesApi - factory interface
 * @export
 */
export const OrderTemplatesApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Add a product to an order template
         * @param {string} tenant The EGB code of the tenant to target
         * @param {number} orderTemplateId The id for the order template to target
         * @param {OrderTemplateItemDto} orderTemplateItem 
         * @param {string} [customerId] The tenant-specific customer id to request the information for. This will affect things such as prices and articles.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOrderTemplateItem(tenant: string, orderTemplateId: number, orderTemplateItem: OrderTemplateItemDto, customerId?: string, options?: any) {
            return OrderTemplatesApiFp(configuration).addOrderTemplateItem(tenant, orderTemplateId, orderTemplateItem, customerId, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Shares an order template with a user
         * @param {string} tenant The EGB code of the tenant to target
         * @param {number} orderTemplateId The id of the order template to target
         * @param {string} username 
         * @param {string} [customerId] The tenant-specific customer id to request the information for. This will affect things such as prices and products.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addSharedWith(tenant: string, orderTemplateId: number, username: string, customerId?: string, options?: any) {
            return OrderTemplatesApiFp(configuration).addSharedWith(tenant, orderTemplateId, username, customerId, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Create order template
         * @param {string} tenant The EGB code of the tenant to target
         * @param {OrderTemplateSubmitDto} orderTemplate 
         * @param {string} [customerId] The tenant-specific customer id to request the information for. This will affect things such as prices and articles.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNewOrderTemplate(tenant: string, orderTemplate: OrderTemplateSubmitDto, customerId?: string, options?: any) {
            return OrderTemplatesApiFp(configuration).createNewOrderTemplate(tenant, orderTemplate, customerId, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Returns the given order template. Including all items and already filtered products
         * @param {string} tenant The EGB code of the tenant to target
         * @param {number} orderTemplateId The id of the order template
         * @param {string} [customerId] The tenant-specific customer id to request the information for. This will affect things such as prices and articles.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderTemplateById(tenant: string, orderTemplateId: number, customerId?: string, options?: any) {
            return OrderTemplatesApiFp(configuration).getOrderTemplateById(tenant, orderTemplateId, customerId, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Returns the given order template. Including all items and already filtered products
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} priceList The priceList of the order template
         * @param {string} [customerId] The tenant-specific customer id to request the information for. This will affect things such as prices and articles.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderTemplateByPriceList(tenant: string, priceList: string, customerId?: string, options?: any) {
            return OrderTemplatesApiFp(configuration).getOrderTemplateByPriceList(tenant, priceList, customerId, options)(fetch, basePath);
        },
        /**
         * Retrieves the list of order templates the current user has access to for given customer. This includes order templates created by the current user or shared with the current user.
         * @summary Get accessible order templates
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} [customerId] The tenant-specific customer id to request the information for. This will affect things such as prices and articles.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOwnOrderTemplates(tenant: string, customerId?: string, options?: any) {
            return OrderTemplatesApiFp(configuration).getOwnOrderTemplates(tenant, customerId, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Pages through accessible order templates
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} [customerId] The tenant-specific customer id to request the information for. This will affect things such as prices and articles.
         * @param {number} [page] the index of the page to retrieve
         * @param {number} [size] the amount of entries per page
         * @param {string} [sortBy] the field to sort by, or null if unsorted
         * @param {string} [sortDirection] ASC to sort in ascending order, DESC to sort in descending order. May be null if sortBy is null as well.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOwnOrderTemplatesPage(tenant: string, customerId?: string, page?: number, size?: number, sortBy?: string, sortDirection?: string, options?: any) {
            return OrderTemplatesApiFp(configuration).getOwnOrderTemplatesPage(tenant, customerId, page, size, sortBy, sortDirection, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Generate order template PDF
         * @param {string} tenant The EGB code of the tenant to target
         * @param {number} orderTemplateId The id of the order tempalte to target
         * @param {string} [customerId] The tenant-specific customer id to request the information for. This will affect things such as prices and products.
         * @param {boolean} [showImages] Whether to show images and barcodes in the PDF.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPdf(tenant: string, orderTemplateId: number, customerId?: string, showImages?: boolean, options?: any) {
            return OrderTemplatesApiFp(configuration).getPdf(tenant, orderTemplateId, customerId, showImages, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Pages through accessible order templates
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} [customerId] The tenant-specific customer id to request the information for. This will affect things such as prices and articles.
         * @param {number} [page] the index of the page to retrieve
         * @param {number} [size] the amount of entries per page
         * @param {string} [sortBy] the field to sort by, or null if unsorted
         * @param {string} [sortDirection] ASC to sort in ascending order, DESC to sort in descending order. May be null if sortBy is null as well.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSpecialCartsPage(tenant: string, customerId?: string, page?: number, size?: number, sortBy?: string, sortDirection?: string, options?: any) {
            return OrderTemplatesApiFp(configuration).getSpecialCartsPage(tenant, customerId, page, size, sortBy, sortDirection, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Removes the given order template, if the current user is the creator of the order template
         * @param {string} tenant The EGB code of the tenant to target
         * @param {number} orderTemplateId The id of the order template
         * @param {string} [customerId] The tenant-specific customer id to request the information for. This will affect things such as prices and articles.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeOrderTemplate(tenant: string, orderTemplateId: number, customerId?: string, options?: any) {
            return OrderTemplatesApiFp(configuration).removeOrderTemplate(tenant, orderTemplateId, customerId, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Remove a product from an order template
         * @param {string} tenant The EGB code of the tenant to target
         * @param {number} orderTemplateId The id for the order template to target
         * @param {OrderTemplateItemDto} orderTemplateItem 
         * @param {string} [customerId] The tenant-specific customer id to request the information for. This will affect things such as prices and articles.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeOrderTemplateItem(tenant: string, orderTemplateId: number, orderTemplateItem: OrderTemplateItemDto, customerId?: string, options?: any) {
            return OrderTemplatesApiFp(configuration).removeOrderTemplateItem(tenant, orderTemplateId, orderTemplateItem, customerId, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Revokes access to an order template for a user
         * @param {string} tenant The EGB code of the tenant to target
         * @param {number} orderTemplateId The id of the order template to target
         * @param {string} username 
         * @param {string} [customerId] The tenant-specific customer id to request the information for. This will affect things such as prices and products.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeSharedWith(tenant: string, orderTemplateId: number, username: string, customerId?: string, options?: any) {
            return OrderTemplatesApiFp(configuration).removeSharedWith(tenant, orderTemplateId, username, customerId, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Creates a new order from the given order template and given parameters. Clears the shopping cart if submission was successful. Note that the order is transferred to the ERP asynchronously, so a positive response here does not mean that the order was actually received, but only that is was saved in the hub's database. If submission fails, it is periodically re-attempted until some threshold is met, after that, Eurogast needs to manually deal with the order. Confirmation emails are also sent asynchronously, after the ERP first receives the order. After submission, the ERP also confirms processing of the order later.
         * @param {string} tenant The EGB code of the tenant to target
         * @param {number} orderTemplateId The id of the order template
         * @param {string} customerId The tenant-specific customer id to request the information for. This will affect things such as prices and articles.
         * @param {OrderSubmitRequest} [orderInformation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitSpecialOrder(tenant: string, orderTemplateId: number, customerId: string, orderInformation?: OrderSubmitRequest, options?: any) {
            return OrderTemplatesApiFp(configuration).submitSpecialOrder(tenant, orderTemplateId, customerId, orderInformation, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Updates the given order template
         * @param {string} tenant The EGB code of the tenant to target
         * @param {number} orderTemplateId The id of the order template
         * @param {OrderTemplateSubmitDto} orderTemplate 
         * @param {string} [customerId] The tenant-specific customer id to request the information for. This will affect things such as prices and articles.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrderTemplate(tenant: string, orderTemplateId: number, orderTemplate: OrderTemplateSubmitDto, customerId?: string, options?: any) {
            return OrderTemplatesApiFp(configuration).updateOrderTemplate(tenant, orderTemplateId, orderTemplate, customerId, options)(fetch, basePath);
        },
    };
};

/**
 * OrderTemplatesApi - object-oriented interface
 * @export
 * @class OrderTemplatesApi
 * @extends {BaseAPI}
 */
export class OrderTemplatesApi extends BaseAPI {
    /**
     * 
     * @summary Add a product to an order template
     * @param {} tenant The EGB code of the tenant to target
     * @param {} orderTemplateId The id for the order template to target
     * @param {} orderTemplateItem 
     * @param {} [customerId] The tenant-specific customer id to request the information for. This will affect things such as prices and articles.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderTemplatesApi
     */
    public addOrderTemplateItem(tenant: string, orderTemplateId: number, orderTemplateItem: OrderTemplateItemDto, customerId?: string, options?: any) {
        return OrderTemplatesApiFp(this.configuration).addOrderTemplateItem(tenant, orderTemplateId, orderTemplateItem, customerId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Shares an order template with a user
     * @param {} tenant The EGB code of the tenant to target
     * @param {} orderTemplateId The id of the order template to target
     * @param {} username 
     * @param {} [customerId] The tenant-specific customer id to request the information for. This will affect things such as prices and products.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderTemplatesApi
     */
    public addSharedWith(tenant: string, orderTemplateId: number, username: string, customerId?: string, options?: any) {
        return OrderTemplatesApiFp(this.configuration).addSharedWith(tenant, orderTemplateId, username, customerId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Create order template
     * @param {} tenant The EGB code of the tenant to target
     * @param {} orderTemplate 
     * @param {} [customerId] The tenant-specific customer id to request the information for. This will affect things such as prices and articles.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderTemplatesApi
     */
    public createNewOrderTemplate(tenant: string, orderTemplate: OrderTemplateSubmitDto, customerId?: string, options?: any) {
        return OrderTemplatesApiFp(this.configuration).createNewOrderTemplate(tenant, orderTemplate, customerId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Returns the given order template. Including all items and already filtered products
     * @param {} tenant The EGB code of the tenant to target
     * @param {} orderTemplateId The id of the order template
     * @param {} [customerId] The tenant-specific customer id to request the information for. This will affect things such as prices and articles.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderTemplatesApi
     */
    public getOrderTemplateById(tenant: string, orderTemplateId: number, customerId?: string, options?: any) {
        return OrderTemplatesApiFp(this.configuration).getOrderTemplateById(tenant, orderTemplateId, customerId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Returns the given order template. Including all items and already filtered products
     * @param {} tenant The EGB code of the tenant to target
     * @param {} priceList The priceList of the order template
     * @param {} [customerId] The tenant-specific customer id to request the information for. This will affect things such as prices and articles.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderTemplatesApi
     */
    public getOrderTemplateByPriceList(tenant: string, priceList: string, customerId?: string, options?: any) {
        return OrderTemplatesApiFp(this.configuration).getOrderTemplateByPriceList(tenant, priceList, customerId, options)(this.fetch, this.basePath);
    }

    /**
     * Retrieves the list of order templates the current user has access to for given customer. This includes order templates created by the current user or shared with the current user.
     * @summary Get accessible order templates
     * @param {} tenant The EGB code of the tenant to target
     * @param {} [customerId] The tenant-specific customer id to request the information for. This will affect things such as prices and articles.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderTemplatesApi
     */
    public getOwnOrderTemplates(tenant: string, customerId?: string, options?: any) {
        return OrderTemplatesApiFp(this.configuration).getOwnOrderTemplates(tenant, customerId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Pages through accessible order templates
     * @param {} tenant The EGB code of the tenant to target
     * @param {} [customerId] The tenant-specific customer id to request the information for. This will affect things such as prices and articles.
     * @param {} [page] the index of the page to retrieve
     * @param {} [size] the amount of entries per page
     * @param {} [sortBy] the field to sort by, or null if unsorted
     * @param {} [sortDirection] ASC to sort in ascending order, DESC to sort in descending order. May be null if sortBy is null as well.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderTemplatesApi
     */
    public getOwnOrderTemplatesPage(tenant: string, customerId?: string, page?: number, size?: number, sortBy?: string, sortDirection?: string, options?: any) {
        return OrderTemplatesApiFp(this.configuration).getOwnOrderTemplatesPage(tenant, customerId, page, size, sortBy, sortDirection, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Generate order template PDF
     * @param {} tenant The EGB code of the tenant to target
     * @param {} orderTemplateId The id of the order tempalte to target
     * @param {} [customerId] The tenant-specific customer id to request the information for. This will affect things such as prices and products.
     * @param {} [showImages] Whether to show images and barcodes in the PDF.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderTemplatesApi
     */
    public getPdf(tenant: string, orderTemplateId: number, customerId?: string, showImages?: boolean, options?: any) {
        return OrderTemplatesApiFp(this.configuration).getPdf(tenant, orderTemplateId, customerId, showImages, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Pages through accessible order templates
     * @param {} tenant The EGB code of the tenant to target
     * @param {} [customerId] The tenant-specific customer id to request the information for. This will affect things such as prices and articles.
     * @param {} [page] the index of the page to retrieve
     * @param {} [size] the amount of entries per page
     * @param {} [sortBy] the field to sort by, or null if unsorted
     * @param {} [sortDirection] ASC to sort in ascending order, DESC to sort in descending order. May be null if sortBy is null as well.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderTemplatesApi
     */
    public getSpecialCartsPage(tenant: string, customerId?: string, page?: number, size?: number, sortBy?: string, sortDirection?: string, options?: any) {
        return OrderTemplatesApiFp(this.configuration).getSpecialCartsPage(tenant, customerId, page, size, sortBy, sortDirection, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Removes the given order template, if the current user is the creator of the order template
     * @param {} tenant The EGB code of the tenant to target
     * @param {} orderTemplateId The id of the order template
     * @param {} [customerId] The tenant-specific customer id to request the information for. This will affect things such as prices and articles.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderTemplatesApi
     */
    public removeOrderTemplate(tenant: string, orderTemplateId: number, customerId?: string, options?: any) {
        return OrderTemplatesApiFp(this.configuration).removeOrderTemplate(tenant, orderTemplateId, customerId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Remove a product from an order template
     * @param {} tenant The EGB code of the tenant to target
     * @param {} orderTemplateId The id for the order template to target
     * @param {} orderTemplateItem 
     * @param {} [customerId] The tenant-specific customer id to request the information for. This will affect things such as prices and articles.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderTemplatesApi
     */
    public removeOrderTemplateItem(tenant: string, orderTemplateId: number, orderTemplateItem: OrderTemplateItemDto, customerId?: string, options?: any) {
        return OrderTemplatesApiFp(this.configuration).removeOrderTemplateItem(tenant, orderTemplateId, orderTemplateItem, customerId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Revokes access to an order template for a user
     * @param {} tenant The EGB code of the tenant to target
     * @param {} orderTemplateId The id of the order template to target
     * @param {} username 
     * @param {} [customerId] The tenant-specific customer id to request the information for. This will affect things such as prices and products.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderTemplatesApi
     */
    public removeSharedWith(tenant: string, orderTemplateId: number, username: string, customerId?: string, options?: any) {
        return OrderTemplatesApiFp(this.configuration).removeSharedWith(tenant, orderTemplateId, username, customerId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Creates a new order from the given order template and given parameters. Clears the shopping cart if submission was successful. Note that the order is transferred to the ERP asynchronously, so a positive response here does not mean that the order was actually received, but only that is was saved in the hub's database. If submission fails, it is periodically re-attempted until some threshold is met, after that, Eurogast needs to manually deal with the order. Confirmation emails are also sent asynchronously, after the ERP first receives the order. After submission, the ERP also confirms processing of the order later.
     * @param {} tenant The EGB code of the tenant to target
     * @param {} orderTemplateId The id of the order template
     * @param {} customerId The tenant-specific customer id to request the information for. This will affect things such as prices and articles.
     * @param {} [orderInformation] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderTemplatesApi
     */
    public submitSpecialOrder(tenant: string, orderTemplateId: number, customerId: string, orderInformation?: OrderSubmitRequest, options?: any) {
        return OrderTemplatesApiFp(this.configuration).submitSpecialOrder(tenant, orderTemplateId, customerId, orderInformation, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Updates the given order template
     * @param {} tenant The EGB code of the tenant to target
     * @param {} orderTemplateId The id of the order template
     * @param {} orderTemplate 
     * @param {} [customerId] The tenant-specific customer id to request the information for. This will affect things such as prices and articles.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderTemplatesApi
     */
    public updateOrderTemplate(tenant: string, orderTemplateId: number, orderTemplate: OrderTemplateSubmitDto, customerId?: string, options?: any) {
        return OrderTemplatesApiFp(this.configuration).updateOrderTemplate(tenant, orderTemplateId, orderTemplate, customerId, options)(this.fetch, this.basePath);
    }

}

/**
 * ProductSearchApi - fetch parameter creator
 * @export
 */
export const ProductSearchApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * browse products in a category (any level), grouped by their third-level category. A single third-level category will be returned consecutively, that is, if another category grouping starts, no products from an already-seen category grouping will be returned any more. Note that this is relaxed if new products are added in the meantime, but this does not usually happen. The category to browse is set in the request entity.
         * @summary Browse a single page in a category
         * @param {string} tenant The EGB code of the tenant to target
         * @param {CategoryBrowseRequestDto} searchBody 
         * @param {string} [customerId] The customer id to request the information for. This will affect things such as prices.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        browseCategoryPage(tenant: string, searchBody: CategoryBrowseRequestDto, customerId?: string, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling browseCategoryPage.');
            }
            // verify required parameter 'searchBody' is not null or undefined
            if (searchBody === null || searchBody === undefined) {
                throw new RequiredError('searchBody','Required parameter searchBody was null or undefined when calling browseCategoryPage.');
            }
            const localVarPath = `/t/{tenant}/categories/browse`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuthOptional required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuthOptional", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"CategoryBrowseRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(searchBody || {}) : (searchBody || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Like the category browse endpoint, but only displays essential products by default. If an essential filter is passed in the request, that one is applied.
         * @summary Browse a page of essential products
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The customer id to request the information for.
         * @param {EssentialProductsRequestDto} searchBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        browseEssentialProducts(tenant: string, customerId: string, searchBody: EssentialProductsRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling browseEssentialProducts.');
            }
            // verify required parameter 'customerId' is not null or undefined
            if (customerId === null || customerId === undefined) {
                throw new RequiredError('customerId','Required parameter customerId was null or undefined when calling browseEssentialProducts.');
            }
            // verify required parameter 'searchBody' is not null or undefined
            if (searchBody === null || searchBody === undefined) {
                throw new RequiredError('searchBody','Required parameter searchBody was null or undefined when calling browseEssentialProducts.');
            }
            const localVarPath = `/t/{tenant}/essential-products/browse`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuthOptional required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuthOptional", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"EssentialProductsRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(searchBody || {}) : (searchBody || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Takes a partial search string from the search box and suggests related products so that a user may directly skip to the detail page without looking at the search result page. This effectively does the same thing as the search endpoint.
         * @summary Autocomplete product names
         * @param {string} tenant The EGB code of the tenant to target
         * @param {ProductCompletionRequest} completionBody 
         * @param {string} [customerId] The customer id to request the information for. This will affect things such as prices.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeProductName(tenant: string, completionBody: ProductCompletionRequest, customerId?: string, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling completeProductName.');
            }
            // verify required parameter 'completionBody' is not null or undefined
            if (completionBody === null || completionBody === undefined) {
                throw new RequiredError('completionBody','Required parameter completionBody was null or undefined when calling completeProductName.');
            }
            const localVarPath = `/t/{tenant}/products/complete`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuthOptional required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuthOptional", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ProductCompletionRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(completionBody || {}) : (completionBody || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search for a list of products
         * @param {string} tenant The EGB code of the tenant to target
         * @param {ProductSearchRequest} searchBody 
         * @param {string} [customerId] The customer id to request the information for. This will affect things such as prices.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchProducts(tenant: string, searchBody: ProductSearchRequest, customerId?: string, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling searchProducts.');
            }
            // verify required parameter 'searchBody' is not null or undefined
            if (searchBody === null || searchBody === undefined) {
                throw new RequiredError('searchBody','Required parameter searchBody was null or undefined when calling searchProducts.');
            }
            const localVarPath = `/t/{tenant}/products/search`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuthOptional required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuthOptional", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ProductSearchRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(searchBody || {}) : (searchBody || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductSearchApi - functional programming interface
 * @export
 */
export const ProductSearchApiFp = function(configuration?: Configuration) {
    return {
        /**
         * browse products in a category (any level), grouped by their third-level category. A single third-level category will be returned consecutively, that is, if another category grouping starts, no products from an already-seen category grouping will be returned any more. Note that this is relaxed if new products are added in the meantime, but this does not usually happen. The category to browse is set in the request entity.
         * @summary Browse a single page in a category
         * @param {string} tenant The EGB code of the tenant to target
         * @param {CategoryBrowseRequestDto} searchBody 
         * @param {string} [customerId] The customer id to request the information for. This will affect things such as prices.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        browseCategoryPage(tenant: string, searchBody: CategoryBrowseRequestDto, customerId?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<GroupedProductsDto> {
            const localVarFetchArgs = ProductSearchApiFetchParamCreator(configuration).browseCategoryPage(tenant, searchBody, customerId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Like the category browse endpoint, but only displays essential products by default. If an essential filter is passed in the request, that one is applied.
         * @summary Browse a page of essential products
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The customer id to request the information for.
         * @param {EssentialProductsRequestDto} searchBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        browseEssentialProducts(tenant: string, customerId: string, searchBody: EssentialProductsRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<GroupedProductsDto> {
            const localVarFetchArgs = ProductSearchApiFetchParamCreator(configuration).browseEssentialProducts(tenant, customerId, searchBody, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Takes a partial search string from the search box and suggests related products so that a user may directly skip to the detail page without looking at the search result page. This effectively does the same thing as the search endpoint.
         * @summary Autocomplete product names
         * @param {string} tenant The EGB code of the tenant to target
         * @param {ProductCompletionRequest} completionBody 
         * @param {string} [customerId] The customer id to request the information for. This will affect things such as prices.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeProductName(tenant: string, completionBody: ProductCompletionRequest, customerId?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ProductCompletionResponse> {
            const localVarFetchArgs = ProductSearchApiFetchParamCreator(configuration).completeProductName(tenant, completionBody, customerId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Search for a list of products
         * @param {string} tenant The EGB code of the tenant to target
         * @param {ProductSearchRequest} searchBody 
         * @param {string} [customerId] The customer id to request the information for. This will affect things such as prices.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchProducts(tenant: string, searchBody: ProductSearchRequest, customerId?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ProductSearchResult> {
            const localVarFetchArgs = ProductSearchApiFetchParamCreator(configuration).searchProducts(tenant, searchBody, customerId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * ProductSearchApi - factory interface
 * @export
 */
export const ProductSearchApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * browse products in a category (any level), grouped by their third-level category. A single third-level category will be returned consecutively, that is, if another category grouping starts, no products from an already-seen category grouping will be returned any more. Note that this is relaxed if new products are added in the meantime, but this does not usually happen. The category to browse is set in the request entity.
         * @summary Browse a single page in a category
         * @param {string} tenant The EGB code of the tenant to target
         * @param {CategoryBrowseRequestDto} searchBody 
         * @param {string} [customerId] The customer id to request the information for. This will affect things such as prices.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        browseCategoryPage(tenant: string, searchBody: CategoryBrowseRequestDto, customerId?: string, options?: any) {
            return ProductSearchApiFp(configuration).browseCategoryPage(tenant, searchBody, customerId, options)(fetch, basePath);
        },
        /**
         * Like the category browse endpoint, but only displays essential products by default. If an essential filter is passed in the request, that one is applied.
         * @summary Browse a page of essential products
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The customer id to request the information for.
         * @param {EssentialProductsRequestDto} searchBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        browseEssentialProducts(tenant: string, customerId: string, searchBody: EssentialProductsRequestDto, options?: any) {
            return ProductSearchApiFp(configuration).browseEssentialProducts(tenant, customerId, searchBody, options)(fetch, basePath);
        },
        /**
         * Takes a partial search string from the search box and suggests related products so that a user may directly skip to the detail page without looking at the search result page. This effectively does the same thing as the search endpoint.
         * @summary Autocomplete product names
         * @param {string} tenant The EGB code of the tenant to target
         * @param {ProductCompletionRequest} completionBody 
         * @param {string} [customerId] The customer id to request the information for. This will affect things such as prices.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeProductName(tenant: string, completionBody: ProductCompletionRequest, customerId?: string, options?: any) {
            return ProductSearchApiFp(configuration).completeProductName(tenant, completionBody, customerId, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Search for a list of products
         * @param {string} tenant The EGB code of the tenant to target
         * @param {ProductSearchRequest} searchBody 
         * @param {string} [customerId] The customer id to request the information for. This will affect things such as prices.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchProducts(tenant: string, searchBody: ProductSearchRequest, customerId?: string, options?: any) {
            return ProductSearchApiFp(configuration).searchProducts(tenant, searchBody, customerId, options)(fetch, basePath);
        },
    };
};

/**
 * ProductSearchApi - object-oriented interface
 * @export
 * @class ProductSearchApi
 * @extends {BaseAPI}
 */
export class ProductSearchApi extends BaseAPI {
    /**
     * browse products in a category (any level), grouped by their third-level category. A single third-level category will be returned consecutively, that is, if another category grouping starts, no products from an already-seen category grouping will be returned any more. Note that this is relaxed if new products are added in the meantime, but this does not usually happen. The category to browse is set in the request entity.
     * @summary Browse a single page in a category
     * @param {} tenant The EGB code of the tenant to target
     * @param {} searchBody 
     * @param {} [customerId] The customer id to request the information for. This will affect things such as prices.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductSearchApi
     */
    public browseCategoryPage(tenant: string, searchBody: CategoryBrowseRequestDto, customerId?: string, options?: any) {
        return ProductSearchApiFp(this.configuration).browseCategoryPage(tenant, searchBody, customerId, options)(this.fetch, this.basePath);
    }

    /**
     * Like the category browse endpoint, but only displays essential products by default. If an essential filter is passed in the request, that one is applied.
     * @summary Browse a page of essential products
     * @param {} tenant The EGB code of the tenant to target
     * @param {} customerId The customer id to request the information for.
     * @param {} searchBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductSearchApi
     */
    public browseEssentialProducts(tenant: string, customerId: string, searchBody: EssentialProductsRequestDto, options?: any) {
        return ProductSearchApiFp(this.configuration).browseEssentialProducts(tenant, customerId, searchBody, options)(this.fetch, this.basePath);
    }

    /**
     * Takes a partial search string from the search box and suggests related products so that a user may directly skip to the detail page without looking at the search result page. This effectively does the same thing as the search endpoint.
     * @summary Autocomplete product names
     * @param {} tenant The EGB code of the tenant to target
     * @param {} completionBody 
     * @param {} [customerId] The customer id to request the information for. This will affect things such as prices.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductSearchApi
     */
    public completeProductName(tenant: string, completionBody: ProductCompletionRequest, customerId?: string, options?: any) {
        return ProductSearchApiFp(this.configuration).completeProductName(tenant, completionBody, customerId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Search for a list of products
     * @param {} tenant The EGB code of the tenant to target
     * @param {} searchBody 
     * @param {} [customerId] The customer id to request the information for. This will affect things such as prices.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductSearchApi
     */
    public searchProducts(tenant: string, searchBody: ProductSearchRequest, customerId?: string, options?: any) {
        return ProductSearchApiFp(this.configuration).searchProducts(tenant, searchBody, customerId, options)(this.fetch, this.basePath);
    }

}

/**
 * ProductsApi - fetch parameter creator
 * @export
 */
export const ProductsApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Shows details for a list of product SKUs, grouped by category. Only one grouping will be returned per category. Products are grouped by their third-level category. Note that this endpoints is limited to 10 000 products by default, so do not request more than that.
         * @summary Show details about a list of products, grouped by category
         * @param {string} tenant The EGB code of the tenant to target
         * @param {Array&lt;string&gt;} sku The SKU ids of the products to target
         * @param {string} [customerId] The customer id to request the information for. This will affect things such as prices.
         * @param {boolean} [showInactive] This flag indicates whether inactive products should be returned as well. Should not normally be used in customer-facing endpoints. The use-case for this is for already-existing data that uses products that were since made inactive.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findGroupedProducts(tenant: string, sku: Array<string>, customerId?: string, showInactive?: boolean, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling findGroupedProducts.');
            }
            // verify required parameter 'sku' is not null or undefined
            if (sku === null || sku === undefined) {
                throw new RequiredError('sku','Required parameter sku was null or undefined when calling findGroupedProducts.');
            }
            const localVarPath = `/t/{tenant}/products/grouped`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuthOptional required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuthOptional", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }

            if (sku) {
                localVarQueryParameter['sku'] = sku.join(COLLECTION_FORMATS["csv"]);
            }

            if (showInactive !== undefined) {
                localVarQueryParameter['showInactive'] = showInactive;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get at most three promoted products for display next to the user's shopping cart. This will only dispay products where a product in the same category is already in the shopping cart.
         * @summary Get promoted products for user's cart
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} [customerId] The customer id to request the information for. This will affect things such as prices.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCartPromotedProducts(tenant: string, customerId?: string, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling getCartPromotedProducts.');
            }
            const localVarPath = `/t/{tenant}/products/promoted-for-cart`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Show details about a single product. If showInactive is false and the product is inactive, this endpoint will act as if the product did not exist at all.
         * @summary Show details about a single product
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} sku The SKU id of the product to target
         * @param {string} [customerId] The customer id to request the information for. This will affect things such as prices.
         * @param {boolean} [showInactive] This flag indicates whether inactive products should be returned as well. Should not normally be used in customer-facing endpoints. The use-case for this is for already-existing data that uses products that were since made inactive.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductBySku(tenant: string, sku: string, customerId?: string, showInactive?: boolean, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling getProductBySku.');
            }
            // verify required parameter 'sku' is not null or undefined
            if (sku === null || sku === undefined) {
                throw new RequiredError('sku','Required parameter sku was null or undefined when calling getProductBySku.');
            }
            const localVarPath = `/t/{tenant}/products/{sku}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"sku"}}`, encodeURIComponent(String(sku)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuthOptional required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuthOptional", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }

            if (showInactive !== undefined) {
                localVarQueryParameter['showInactive'] = showInactive;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Show details about a list of product SKUs. Note that this endpoints is limited to 10 000 products by default, so do not request more than that.
         * @summary Show details about a list of products
         * @param {string} tenant The EGB code of the tenant to target
         * @param {Array&lt;string&gt;} sku The SKU ids of the products to target
         * @param {string} [customerId] The customer id to request the information for. This will affect things such as prices.
         * @param {boolean} [showInactive] This flag indicates whether inactive products should be returned as well. Should not normally be used in customer-facing endpoints. The use-case for this is for already-existing data that uses products that were since made inactive.
         * @param {string} [cartType] The code of a specific cart-type. This parameter is in combination with the tenant unqiue.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductBySkuBatch(tenant: string, sku: Array<string>, customerId?: string, showInactive?: boolean, cartType?: string, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling getProductBySkuBatch.');
            }
            // verify required parameter 'sku' is not null or undefined
            if (sku === null || sku === undefined) {
                throw new RequiredError('sku','Required parameter sku was null or undefined when calling getProductBySkuBatch.');
            }
            const localVarPath = `/t/{tenant}/products/skuBatch`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuthOptional required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuthOptional", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }

            if (sku) {
                localVarQueryParameter['sku'] = sku.join(COLLECTION_FORMATS["csv"]);
            }

            if (showInactive !== undefined) {
                localVarQueryParameter['showInactive'] = showInactive;
            }

            if (cartType !== undefined) {
                localVarQueryParameter['cartType'] = cartType;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generate a data-sheet PDF for a single product on the fly. This may take some time. If showInactive is false, this will act as if inactive products did not exist at all.
         * @summary Generate data-sheet PDF for a product
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} sku The SKU id of the product to target
         * @param {string} [customerId] The customer id to request the information for. This will affect things such as prices.
         * @param {boolean} [showInactive] This flag indicates whether inactive products should be returned as well. Should not normally be used in customer-facing endpoints. The use-case for this is for already-existing data that uses products that were since made inactive.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductDatasheet(tenant: string, sku: string, customerId?: string, showInactive?: boolean, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling getProductDatasheet.');
            }
            // verify required parameter 'sku' is not null or undefined
            if (sku === null || sku === undefined) {
                throw new RequiredError('sku','Required parameter sku was null or undefined when calling getProductDatasheet.');
            }
            const localVarPath = `/t/{tenant}/products/{sku}/datasheet`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"sku"}}`, encodeURIComponent(String(sku)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuthOptional required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuthOptional", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }

            if (showInactive !== undefined) {
                localVarQueryParameter['showInactive'] = showInactive;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductsApi - functional programming interface
 * @export
 */
export const ProductsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Shows details for a list of product SKUs, grouped by category. Only one grouping will be returned per category. Products are grouped by their third-level category. Note that this endpoints is limited to 10 000 products by default, so do not request more than that.
         * @summary Show details about a list of products, grouped by category
         * @param {string} tenant The EGB code of the tenant to target
         * @param {Array&lt;string&gt;} sku The SKU ids of the products to target
         * @param {string} [customerId] The customer id to request the information for. This will affect things such as prices.
         * @param {boolean} [showInactive] This flag indicates whether inactive products should be returned as well. Should not normally be used in customer-facing endpoints. The use-case for this is for already-existing data that uses products that were since made inactive.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findGroupedProducts(tenant: string, sku: Array<string>, customerId?: string, showInactive?: boolean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<GroupedProductsDto> {
            const localVarFetchArgs = ProductsApiFetchParamCreator(configuration).findGroupedProducts(tenant, sku, customerId, showInactive, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Get at most three promoted products for display next to the user's shopping cart. This will only dispay products where a product in the same category is already in the shopping cart.
         * @summary Get promoted products for user's cart
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} [customerId] The customer id to request the information for. This will affect things such as prices.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCartPromotedProducts(tenant: string, customerId?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<ProductDto>> {
            const localVarFetchArgs = ProductsApiFetchParamCreator(configuration).getCartPromotedProducts(tenant, customerId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Show details about a single product. If showInactive is false and the product is inactive, this endpoint will act as if the product did not exist at all.
         * @summary Show details about a single product
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} sku The SKU id of the product to target
         * @param {string} [customerId] The customer id to request the information for. This will affect things such as prices.
         * @param {boolean} [showInactive] This flag indicates whether inactive products should be returned as well. Should not normally be used in customer-facing endpoints. The use-case for this is for already-existing data that uses products that were since made inactive.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductBySku(tenant: string, sku: string, customerId?: string, showInactive?: boolean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ProductDto> {
            const localVarFetchArgs = ProductsApiFetchParamCreator(configuration).getProductBySku(tenant, sku, customerId, showInactive, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Show details about a list of product SKUs. Note that this endpoints is limited to 10 000 products by default, so do not request more than that.
         * @summary Show details about a list of products
         * @param {string} tenant The EGB code of the tenant to target
         * @param {Array&lt;string&gt;} sku The SKU ids of the products to target
         * @param {string} [customerId] The customer id to request the information for. This will affect things such as prices.
         * @param {boolean} [showInactive] This flag indicates whether inactive products should be returned as well. Should not normally be used in customer-facing endpoints. The use-case for this is for already-existing data that uses products that were since made inactive.
         * @param {string} [cartType] The code of a specific cart-type. This parameter is in combination with the tenant unqiue.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductBySkuBatch(tenant: string, sku: Array<string>, customerId?: string, showInactive?: boolean, cartType?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<ProductDto>> {
            const localVarFetchArgs = ProductsApiFetchParamCreator(configuration).getProductBySkuBatch(tenant, sku, customerId, showInactive, cartType, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Generate a data-sheet PDF for a single product on the fly. This may take some time. If showInactive is false, this will act as if inactive products did not exist at all.
         * @summary Generate data-sheet PDF for a product
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} sku The SKU id of the product to target
         * @param {string} [customerId] The customer id to request the information for. This will affect things such as prices.
         * @param {boolean} [showInactive] This flag indicates whether inactive products should be returned as well. Should not normally be used in customer-facing endpoints. The use-case for this is for already-existing data that uses products that were since made inactive.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductDatasheet(tenant: string, sku: string, customerId?: string, showInactive?: boolean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = ProductsApiFetchParamCreator(configuration).getProductDatasheet(tenant, sku, customerId, showInactive, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * ProductsApi - factory interface
 * @export
 */
export const ProductsApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * Shows details for a list of product SKUs, grouped by category. Only one grouping will be returned per category. Products are grouped by their third-level category. Note that this endpoints is limited to 10 000 products by default, so do not request more than that.
         * @summary Show details about a list of products, grouped by category
         * @param {string} tenant The EGB code of the tenant to target
         * @param {Array&lt;string&gt;} sku The SKU ids of the products to target
         * @param {string} [customerId] The customer id to request the information for. This will affect things such as prices.
         * @param {boolean} [showInactive] This flag indicates whether inactive products should be returned as well. Should not normally be used in customer-facing endpoints. The use-case for this is for already-existing data that uses products that were since made inactive.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findGroupedProducts(tenant: string, sku: Array<string>, customerId?: string, showInactive?: boolean, options?: any) {
            return ProductsApiFp(configuration).findGroupedProducts(tenant, sku, customerId, showInactive, options)(fetch, basePath);
        },
        /**
         * Get at most three promoted products for display next to the user's shopping cart. This will only dispay products where a product in the same category is already in the shopping cart.
         * @summary Get promoted products for user's cart
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} [customerId] The customer id to request the information for. This will affect things such as prices.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCartPromotedProducts(tenant: string, customerId?: string, options?: any) {
            return ProductsApiFp(configuration).getCartPromotedProducts(tenant, customerId, options)(fetch, basePath);
        },
        /**
         * Show details about a single product. If showInactive is false and the product is inactive, this endpoint will act as if the product did not exist at all.
         * @summary Show details about a single product
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} sku The SKU id of the product to target
         * @param {string} [customerId] The customer id to request the information for. This will affect things such as prices.
         * @param {boolean} [showInactive] This flag indicates whether inactive products should be returned as well. Should not normally be used in customer-facing endpoints. The use-case for this is for already-existing data that uses products that were since made inactive.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductBySku(tenant: string, sku: string, customerId?: string, showInactive?: boolean, options?: any) {
            return ProductsApiFp(configuration).getProductBySku(tenant, sku, customerId, showInactive, options)(fetch, basePath);
        },
        /**
         * Show details about a list of product SKUs. Note that this endpoints is limited to 10 000 products by default, so do not request more than that.
         * @summary Show details about a list of products
         * @param {string} tenant The EGB code of the tenant to target
         * @param {Array&lt;string&gt;} sku The SKU ids of the products to target
         * @param {string} [customerId] The customer id to request the information for. This will affect things such as prices.
         * @param {boolean} [showInactive] This flag indicates whether inactive products should be returned as well. Should not normally be used in customer-facing endpoints. The use-case for this is for already-existing data that uses products that were since made inactive.
         * @param {string} [cartType] The code of a specific cart-type. This parameter is in combination with the tenant unqiue.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductBySkuBatch(tenant: string, sku: Array<string>, customerId?: string, showInactive?: boolean, cartType?: string, options?: any) {
            return ProductsApiFp(configuration).getProductBySkuBatch(tenant, sku, customerId, showInactive, cartType, options)(fetch, basePath);
        },
        /**
         * Generate a data-sheet PDF for a single product on the fly. This may take some time. If showInactive is false, this will act as if inactive products did not exist at all.
         * @summary Generate data-sheet PDF for a product
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} sku The SKU id of the product to target
         * @param {string} [customerId] The customer id to request the information for. This will affect things such as prices.
         * @param {boolean} [showInactive] This flag indicates whether inactive products should be returned as well. Should not normally be used in customer-facing endpoints. The use-case for this is for already-existing data that uses products that were since made inactive.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductDatasheet(tenant: string, sku: string, customerId?: string, showInactive?: boolean, options?: any) {
            return ProductsApiFp(configuration).getProductDatasheet(tenant, sku, customerId, showInactive, options)(fetch, basePath);
        },
    };
};

/**
 * ProductsApi - object-oriented interface
 * @export
 * @class ProductsApi
 * @extends {BaseAPI}
 */
export class ProductsApi extends BaseAPI {
    /**
     * Shows details for a list of product SKUs, grouped by category. Only one grouping will be returned per category. Products are grouped by their third-level category. Note that this endpoints is limited to 10 000 products by default, so do not request more than that.
     * @summary Show details about a list of products, grouped by category
     * @param {} tenant The EGB code of the tenant to target
     * @param {} sku The SKU ids of the products to target
     * @param {} [customerId] The customer id to request the information for. This will affect things such as prices.
     * @param {} [showInactive] This flag indicates whether inactive products should be returned as well. Should not normally be used in customer-facing endpoints. The use-case for this is for already-existing data that uses products that were since made inactive.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public findGroupedProducts(tenant: string, sku: Array<string>, customerId?: string, showInactive?: boolean, options?: any) {
        return ProductsApiFp(this.configuration).findGroupedProducts(tenant, sku, customerId, showInactive, options)(this.fetch, this.basePath);
    }

    /**
     * Get at most three promoted products for display next to the user's shopping cart. This will only dispay products where a product in the same category is already in the shopping cart.
     * @summary Get promoted products for user's cart
     * @param {} tenant The EGB code of the tenant to target
     * @param {} [customerId] The customer id to request the information for. This will affect things such as prices.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public getCartPromotedProducts(tenant: string, customerId?: string, options?: any) {
        return ProductsApiFp(this.configuration).getCartPromotedProducts(tenant, customerId, options)(this.fetch, this.basePath);
    }

    /**
     * Show details about a single product. If showInactive is false and the product is inactive, this endpoint will act as if the product did not exist at all.
     * @summary Show details about a single product
     * @param {} tenant The EGB code of the tenant to target
     * @param {} sku The SKU id of the product to target
     * @param {} [customerId] The customer id to request the information for. This will affect things such as prices.
     * @param {} [showInactive] This flag indicates whether inactive products should be returned as well. Should not normally be used in customer-facing endpoints. The use-case for this is for already-existing data that uses products that were since made inactive.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public getProductBySku(tenant: string, sku: string, customerId?: string, showInactive?: boolean, options?: any) {
        return ProductsApiFp(this.configuration).getProductBySku(tenant, sku, customerId, showInactive, options)(this.fetch, this.basePath);
    }

    /**
     * Show details about a list of product SKUs. Note that this endpoints is limited to 10 000 products by default, so do not request more than that.
     * @summary Show details about a list of products
     * @param {} tenant The EGB code of the tenant to target
     * @param {} sku The SKU ids of the products to target
     * @param {} [customerId] The customer id to request the information for. This will affect things such as prices.
     * @param {} [showInactive] This flag indicates whether inactive products should be returned as well. Should not normally be used in customer-facing endpoints. The use-case for this is for already-existing data that uses products that were since made inactive.
     * @param {} [cartType] The code of a specific cart-type. This parameter is in combination with the tenant unqiue.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public getProductBySkuBatch(tenant: string, sku: Array<string>, customerId?: string, showInactive?: boolean, cartType?: string, options?: any) {
        return ProductsApiFp(this.configuration).getProductBySkuBatch(tenant, sku, customerId, showInactive, cartType, options)(this.fetch, this.basePath);
    }

    /**
     * Generate a data-sheet PDF for a single product on the fly. This may take some time. If showInactive is false, this will act as if inactive products did not exist at all.
     * @summary Generate data-sheet PDF for a product
     * @param {} tenant The EGB code of the tenant to target
     * @param {} sku The SKU id of the product to target
     * @param {} [customerId] The customer id to request the information for. This will affect things such as prices.
     * @param {} [showInactive] This flag indicates whether inactive products should be returned as well. Should not normally be used in customer-facing endpoints. The use-case for this is for already-existing data that uses products that were since made inactive.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public getProductDatasheet(tenant: string, sku: string, customerId?: string, showInactive?: boolean, options?: any) {
        return ProductsApiFp(this.configuration).getProductDatasheet(tenant, sku, customerId, showInactive, options)(this.fetch, this.basePath);
    }

}

/**
 * ShoppingCartsApi - fetch parameter creator
 * @export
 */
export const ShoppingCartsApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add items to your customer-specific shopping cart in bulk. Note that only the root-level properties (customer, user, sku) are used for the primary key, any entities sent with the request will be ignored.
         * @summary Add multiple items to your shopping cart
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customer number of the customer to target
         * @param {Array&lt;ShoppingCartItem&gt;} item Items to add to the cart
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAllItemsToOwnShoppingCart(tenant: string, customerId: string, item: Array<ShoppingCartItem>, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling addAllItemsToOwnShoppingCart.');
            }
            // verify required parameter 'customerId' is not null or undefined
            if (customerId === null || customerId === undefined) {
                throw new RequiredError('customerId','Required parameter customerId was null or undefined when calling addAllItemsToOwnShoppingCart.');
            }
            // verify required parameter 'item' is not null or undefined
            if (item === null || item === undefined) {
                throw new RequiredError('item','Required parameter item was null or undefined when calling addAllItemsToOwnShoppingCart.');
            }
            const localVarPath = `/t/{tenant}/my/shopping-cart-items/{customerId}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"Array&lt;ShoppingCartItem&gt;" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(item || {}) : (item || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add an item to your shopping cart or override an existing one. Note that only the root-level properties (customer, user, sku) are used for the primary key, any entities sent with the request will be ignored. Warning! This returns the whole shopping cart, which may contain a lot of items, therefore causing significant network traffic. Consider using the no-detail endpoint for this instead.
         * @summary Add an item to your shopping cart or override an existing one
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customer number of the customer to target
         * @param {ShoppingCartItem} item 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addItemToOwnShoppingCart(tenant: string, customerId: string, item: ShoppingCartItem, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling addItemToOwnShoppingCart.');
            }
            // verify required parameter 'customerId' is not null or undefined
            if (customerId === null || customerId === undefined) {
                throw new RequiredError('customerId','Required parameter customerId was null or undefined when calling addItemToOwnShoppingCart.');
            }
            // verify required parameter 'item' is not null or undefined
            if (item === null || item === undefined) {
                throw new RequiredError('item','Required parameter item was null or undefined when calling addItemToOwnShoppingCart.');
            }
            const localVarPath = `/t/{tenant}/my/shopping-cart/{customerId}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ShoppingCartItem" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(item || {}) : (item || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add an item to your shopping cart or override an existing one. Note that only the root-level properties (user, customer, sku) are used for the primary key, any entities sent with the request will be ignored. Returns the updated item. This does not return any details of the created cart item, that is, no product metadata. The update timestamp is returned.
         * @summary Add an item to your shopping cart or override an existing one
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customer number of the customer to target
         * @param {ShoppingCartItem} item 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addItemToOwnShoppingCartNoDetail(tenant: string, customerId: string, item: ShoppingCartItem, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling addItemToOwnShoppingCartNoDetail.');
            }
            // verify required parameter 'customerId' is not null or undefined
            if (customerId === null || customerId === undefined) {
                throw new RequiredError('customerId','Required parameter customerId was null or undefined when calling addItemToOwnShoppingCartNoDetail.');
            }
            // verify required parameter 'item' is not null or undefined
            if (item === null || item === undefined) {
                throw new RequiredError('item','Required parameter item was null or undefined when calling addItemToOwnShoppingCartNoDetail.');
            }
            const localVarPath = `/t/{tenant}/my/shopping-cart-item/{customerId}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ShoppingCartItem" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(item || {}) : (item || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Clear your current shopping cart
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customer number of the customer to target
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearOwnShoppingCart(tenant: string, customerId: string, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling clearOwnShoppingCart.');
            }
            // verify required parameter 'customerId' is not null or undefined
            if (customerId === null || customerId === undefined) {
                throw new RequiredError('customerId','Required parameter customerId was null or undefined when calling clearOwnShoppingCart.');
            }
            const localVarPath = `/t/{tenant}/my/shopping-cart/{customerId}/clear`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the current status of your customer-specific shopping cart
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customer number of the customer to target
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOwnShoppingCart(tenant: string, customerId: string, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling getOwnShoppingCart.');
            }
            // verify required parameter 'customerId' is not null or undefined
            if (customerId === null || customerId === undefined) {
                throw new RequiredError('customerId','Required parameter customerId was null or undefined when calling getOwnShoppingCart.');
            }
            const localVarPath = `/t/{tenant}/my/shopping-cart/{customerId}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The list consists of every shopping-cart-event for this user and customer. For already sent or deleted carts there is only one entry with the type REMOVE_ALL left. All the other entries describe the events on the currently active shopping cart of this user and customer.
         * @summary Gets a list of all shopping-cart-events for this user and customer
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customer number of the customer to target
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShoppingCartEvents(tenant: string, customerId: string, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling getShoppingCartEvents.');
            }
            // verify required parameter 'customerId' is not null or undefined
            if (customerId === null || customerId === undefined) {
                throw new RequiredError('customerId','Required parameter customerId was null or undefined when calling getShoppingCartEvents.');
            }
            const localVarPath = `/t/{tenant}/my/shopping-cart/{customerId}/events`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Removes a shopping cart item, does nothing if it did not exist or the database returned an error, e.g. related to optimistic locking.
         * @summary Remove an item from your shopping cart
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customer number of the customer to target
         * @param {ShoppingCartItem} item 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeItemFromOwnShoppingCart(tenant: string, customerId: string, item: ShoppingCartItem, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling removeItemFromOwnShoppingCart.');
            }
            // verify required parameter 'customerId' is not null or undefined
            if (customerId === null || customerId === undefined) {
                throw new RequiredError('customerId','Required parameter customerId was null or undefined when calling removeItemFromOwnShoppingCart.');
            }
            // verify required parameter 'item' is not null or undefined
            if (item === null || item === undefined) {
                throw new RequiredError('item','Required parameter item was null or undefined when calling removeItemFromOwnShoppingCart.');
            }
            const localVarPath = `/t/{tenant}/my/shopping-cart/{customerId}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ShoppingCartItem" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(item || {}) : (item || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a new order from the current shopping cart and given parameters. Clears the shopping cart if submission was successful. Note that the order is transferred to the ERP asynchronously, so a positive response here does not mean that the order was actually received, but only that is was saved in the hub's database. If submission fails, it is periodically re-attempted until some threshold is met, after that, Eurogast needs to manually deal with the order. Confirmation emails are also sent asynchronously, after the ERP first receives the order. After submission, the ERP also confirms processing of the order later.
         * @summary Submit the current shopping cart into an order
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customer number of the customer to target
         * @param {OrderSubmitRequest} [orderInformation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitOwnShoppingCart(tenant: string, customerId: string, orderInformation?: OrderSubmitRequest, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling submitOwnShoppingCart.');
            }
            // verify required parameter 'customerId' is not null or undefined
            if (customerId === null || customerId === undefined) {
                throw new RequiredError('customerId','Required parameter customerId was null or undefined when calling submitOwnShoppingCart.');
            }
            const localVarPath = `/t/{tenant}/my/shopping-cart/{customerId}/submit`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"OrderSubmitRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(orderInformation || {}) : (orderInformation || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ShoppingCartsApi - functional programming interface
 * @export
 */
export const ShoppingCartsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Add items to your customer-specific shopping cart in bulk. Note that only the root-level properties (customer, user, sku) are used for the primary key, any entities sent with the request will be ignored.
         * @summary Add multiple items to your shopping cart
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customer number of the customer to target
         * @param {Array&lt;ShoppingCartItem&gt;} item Items to add to the cart
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAllItemsToOwnShoppingCart(tenant: string, customerId: string, item: Array<ShoppingCartItem>, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ShoppingCart> {
            const localVarFetchArgs = ShoppingCartsApiFetchParamCreator(configuration).addAllItemsToOwnShoppingCart(tenant, customerId, item, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Add an item to your shopping cart or override an existing one. Note that only the root-level properties (customer, user, sku) are used for the primary key, any entities sent with the request will be ignored. Warning! This returns the whole shopping cart, which may contain a lot of items, therefore causing significant network traffic. Consider using the no-detail endpoint for this instead.
         * @summary Add an item to your shopping cart or override an existing one
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customer number of the customer to target
         * @param {ShoppingCartItem} item 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addItemToOwnShoppingCart(tenant: string, customerId: string, item: ShoppingCartItem, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ShoppingCart> {
            const localVarFetchArgs = ShoppingCartsApiFetchParamCreator(configuration).addItemToOwnShoppingCart(tenant, customerId, item, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Add an item to your shopping cart or override an existing one. Note that only the root-level properties (user, customer, sku) are used for the primary key, any entities sent with the request will be ignored. Returns the updated item. This does not return any details of the created cart item, that is, no product metadata. The update timestamp is returned.
         * @summary Add an item to your shopping cart or override an existing one
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customer number of the customer to target
         * @param {ShoppingCartItem} item 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addItemToOwnShoppingCartNoDetail(tenant: string, customerId: string, item: ShoppingCartItem, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ShoppingCartItem> {
            const localVarFetchArgs = ShoppingCartsApiFetchParamCreator(configuration).addItemToOwnShoppingCartNoDetail(tenant, customerId, item, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Clear your current shopping cart
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customer number of the customer to target
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearOwnShoppingCart(tenant: string, customerId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ShoppingCart> {
            const localVarFetchArgs = ShoppingCartsApiFetchParamCreator(configuration).clearOwnShoppingCart(tenant, customerId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get the current status of your customer-specific shopping cart
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customer number of the customer to target
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOwnShoppingCart(tenant: string, customerId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ShoppingCart> {
            const localVarFetchArgs = ShoppingCartsApiFetchParamCreator(configuration).getOwnShoppingCart(tenant, customerId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * The list consists of every shopping-cart-event for this user and customer. For already sent or deleted carts there is only one entry with the type REMOVE_ALL left. All the other entries describe the events on the currently active shopping cart of this user and customer.
         * @summary Gets a list of all shopping-cart-events for this user and customer
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customer number of the customer to target
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShoppingCartEvents(tenant: string, customerId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<ShoppingCartEventDto>> {
            const localVarFetchArgs = ShoppingCartsApiFetchParamCreator(configuration).getShoppingCartEvents(tenant, customerId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Removes a shopping cart item, does nothing if it did not exist or the database returned an error, e.g. related to optimistic locking.
         * @summary Remove an item from your shopping cart
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customer number of the customer to target
         * @param {ShoppingCartItem} item 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeItemFromOwnShoppingCart(tenant: string, customerId: string, item: ShoppingCartItem, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ShoppingCart> {
            const localVarFetchArgs = ShoppingCartsApiFetchParamCreator(configuration).removeItemFromOwnShoppingCart(tenant, customerId, item, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Creates a new order from the current shopping cart and given parameters. Clears the shopping cart if submission was successful. Note that the order is transferred to the ERP asynchronously, so a positive response here does not mean that the order was actually received, but only that is was saved in the hub's database. If submission fails, it is periodically re-attempted until some threshold is met, after that, Eurogast needs to manually deal with the order. Confirmation emails are also sent asynchronously, after the ERP first receives the order. After submission, the ERP also confirms processing of the order later.
         * @summary Submit the current shopping cart into an order
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customer number of the customer to target
         * @param {OrderSubmitRequest} [orderInformation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitOwnShoppingCart(tenant: string, customerId: string, orderInformation?: OrderSubmitRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<OrderDto> {
            const localVarFetchArgs = ShoppingCartsApiFetchParamCreator(configuration).submitOwnShoppingCart(tenant, customerId, orderInformation, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * ShoppingCartsApi - factory interface
 * @export
 */
export const ShoppingCartsApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * Add items to your customer-specific shopping cart in bulk. Note that only the root-level properties (customer, user, sku) are used for the primary key, any entities sent with the request will be ignored.
         * @summary Add multiple items to your shopping cart
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customer number of the customer to target
         * @param {Array&lt;ShoppingCartItem&gt;} item Items to add to the cart
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAllItemsToOwnShoppingCart(tenant: string, customerId: string, item: Array<ShoppingCartItem>, options?: any) {
            return ShoppingCartsApiFp(configuration).addAllItemsToOwnShoppingCart(tenant, customerId, item, options)(fetch, basePath);
        },
        /**
         * Add an item to your shopping cart or override an existing one. Note that only the root-level properties (customer, user, sku) are used for the primary key, any entities sent with the request will be ignored. Warning! This returns the whole shopping cart, which may contain a lot of items, therefore causing significant network traffic. Consider using the no-detail endpoint for this instead.
         * @summary Add an item to your shopping cart or override an existing one
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customer number of the customer to target
         * @param {ShoppingCartItem} item 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addItemToOwnShoppingCart(tenant: string, customerId: string, item: ShoppingCartItem, options?: any) {
            return ShoppingCartsApiFp(configuration).addItemToOwnShoppingCart(tenant, customerId, item, options)(fetch, basePath);
        },
        /**
         * Add an item to your shopping cart or override an existing one. Note that only the root-level properties (user, customer, sku) are used for the primary key, any entities sent with the request will be ignored. Returns the updated item. This does not return any details of the created cart item, that is, no product metadata. The update timestamp is returned.
         * @summary Add an item to your shopping cart or override an existing one
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customer number of the customer to target
         * @param {ShoppingCartItem} item 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addItemToOwnShoppingCartNoDetail(tenant: string, customerId: string, item: ShoppingCartItem, options?: any) {
            return ShoppingCartsApiFp(configuration).addItemToOwnShoppingCartNoDetail(tenant, customerId, item, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Clear your current shopping cart
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customer number of the customer to target
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearOwnShoppingCart(tenant: string, customerId: string, options?: any) {
            return ShoppingCartsApiFp(configuration).clearOwnShoppingCart(tenant, customerId, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get the current status of your customer-specific shopping cart
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customer number of the customer to target
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOwnShoppingCart(tenant: string, customerId: string, options?: any) {
            return ShoppingCartsApiFp(configuration).getOwnShoppingCart(tenant, customerId, options)(fetch, basePath);
        },
        /**
         * The list consists of every shopping-cart-event for this user and customer. For already sent or deleted carts there is only one entry with the type REMOVE_ALL left. All the other entries describe the events on the currently active shopping cart of this user and customer.
         * @summary Gets a list of all shopping-cart-events for this user and customer
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customer number of the customer to target
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShoppingCartEvents(tenant: string, customerId: string, options?: any) {
            return ShoppingCartsApiFp(configuration).getShoppingCartEvents(tenant, customerId, options)(fetch, basePath);
        },
        /**
         * Removes a shopping cart item, does nothing if it did not exist or the database returned an error, e.g. related to optimistic locking.
         * @summary Remove an item from your shopping cart
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customer number of the customer to target
         * @param {ShoppingCartItem} item 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeItemFromOwnShoppingCart(tenant: string, customerId: string, item: ShoppingCartItem, options?: any) {
            return ShoppingCartsApiFp(configuration).removeItemFromOwnShoppingCart(tenant, customerId, item, options)(fetch, basePath);
        },
        /**
         * Creates a new order from the current shopping cart and given parameters. Clears the shopping cart if submission was successful. Note that the order is transferred to the ERP asynchronously, so a positive response here does not mean that the order was actually received, but only that is was saved in the hub's database. If submission fails, it is periodically re-attempted until some threshold is met, after that, Eurogast needs to manually deal with the order. Confirmation emails are also sent asynchronously, after the ERP first receives the order. After submission, the ERP also confirms processing of the order later.
         * @summary Submit the current shopping cart into an order
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customer number of the customer to target
         * @param {OrderSubmitRequest} [orderInformation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitOwnShoppingCart(tenant: string, customerId: string, orderInformation?: OrderSubmitRequest, options?: any) {
            return ShoppingCartsApiFp(configuration).submitOwnShoppingCart(tenant, customerId, orderInformation, options)(fetch, basePath);
        },
    };
};

/**
 * ShoppingCartsApi - object-oriented interface
 * @export
 * @class ShoppingCartsApi
 * @extends {BaseAPI}
 */
export class ShoppingCartsApi extends BaseAPI {
    /**
     * Add items to your customer-specific shopping cart in bulk. Note that only the root-level properties (customer, user, sku) are used for the primary key, any entities sent with the request will be ignored.
     * @summary Add multiple items to your shopping cart
     * @param {} tenant The EGB code of the tenant to target
     * @param {} customerId The tenant-specific customer number of the customer to target
     * @param {} item Items to add to the cart
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShoppingCartsApi
     */
    public addAllItemsToOwnShoppingCart(tenant: string, customerId: string, item: Array<ShoppingCartItem>, options?: any) {
        return ShoppingCartsApiFp(this.configuration).addAllItemsToOwnShoppingCart(tenant, customerId, item, options)(this.fetch, this.basePath);
    }

    /**
     * Add an item to your shopping cart or override an existing one. Note that only the root-level properties (customer, user, sku) are used for the primary key, any entities sent with the request will be ignored. Warning! This returns the whole shopping cart, which may contain a lot of items, therefore causing significant network traffic. Consider using the no-detail endpoint for this instead.
     * @summary Add an item to your shopping cart or override an existing one
     * @param {} tenant The EGB code of the tenant to target
     * @param {} customerId The tenant-specific customer number of the customer to target
     * @param {} item 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShoppingCartsApi
     */
    public addItemToOwnShoppingCart(tenant: string, customerId: string, item: ShoppingCartItem, options?: any) {
        return ShoppingCartsApiFp(this.configuration).addItemToOwnShoppingCart(tenant, customerId, item, options)(this.fetch, this.basePath);
    }

    /**
     * Add an item to your shopping cart or override an existing one. Note that only the root-level properties (user, customer, sku) are used for the primary key, any entities sent with the request will be ignored. Returns the updated item. This does not return any details of the created cart item, that is, no product metadata. The update timestamp is returned.
     * @summary Add an item to your shopping cart or override an existing one
     * @param {} tenant The EGB code of the tenant to target
     * @param {} customerId The tenant-specific customer number of the customer to target
     * @param {} item 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShoppingCartsApi
     */
    public addItemToOwnShoppingCartNoDetail(tenant: string, customerId: string, item: ShoppingCartItem, options?: any) {
        return ShoppingCartsApiFp(this.configuration).addItemToOwnShoppingCartNoDetail(tenant, customerId, item, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Clear your current shopping cart
     * @param {} tenant The EGB code of the tenant to target
     * @param {} customerId The tenant-specific customer number of the customer to target
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShoppingCartsApi
     */
    public clearOwnShoppingCart(tenant: string, customerId: string, options?: any) {
        return ShoppingCartsApiFp(this.configuration).clearOwnShoppingCart(tenant, customerId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get the current status of your customer-specific shopping cart
     * @param {} tenant The EGB code of the tenant to target
     * @param {} customerId The tenant-specific customer number of the customer to target
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShoppingCartsApi
     */
    public getOwnShoppingCart(tenant: string, customerId: string, options?: any) {
        return ShoppingCartsApiFp(this.configuration).getOwnShoppingCart(tenant, customerId, options)(this.fetch, this.basePath);
    }

    /**
     * The list consists of every shopping-cart-event for this user and customer. For already sent or deleted carts there is only one entry with the type REMOVE_ALL left. All the other entries describe the events on the currently active shopping cart of this user and customer.
     * @summary Gets a list of all shopping-cart-events for this user and customer
     * @param {} tenant The EGB code of the tenant to target
     * @param {} customerId The tenant-specific customer number of the customer to target
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShoppingCartsApi
     */
    public getShoppingCartEvents(tenant: string, customerId: string, options?: any) {
        return ShoppingCartsApiFp(this.configuration).getShoppingCartEvents(tenant, customerId, options)(this.fetch, this.basePath);
    }

    /**
     * Removes a shopping cart item, does nothing if it did not exist or the database returned an error, e.g. related to optimistic locking.
     * @summary Remove an item from your shopping cart
     * @param {} tenant The EGB code of the tenant to target
     * @param {} customerId The tenant-specific customer number of the customer to target
     * @param {} item 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShoppingCartsApi
     */
    public removeItemFromOwnShoppingCart(tenant: string, customerId: string, item: ShoppingCartItem, options?: any) {
        return ShoppingCartsApiFp(this.configuration).removeItemFromOwnShoppingCart(tenant, customerId, item, options)(this.fetch, this.basePath);
    }

    /**
     * Creates a new order from the current shopping cart and given parameters. Clears the shopping cart if submission was successful. Note that the order is transferred to the ERP asynchronously, so a positive response here does not mean that the order was actually received, but only that is was saved in the hub's database. If submission fails, it is periodically re-attempted until some threshold is met, after that, Eurogast needs to manually deal with the order. Confirmation emails are also sent asynchronously, after the ERP first receives the order. After submission, the ERP also confirms processing of the order later.
     * @summary Submit the current shopping cart into an order
     * @param {} tenant The EGB code of the tenant to target
     * @param {} customerId The tenant-specific customer number of the customer to target
     * @param {} [orderInformation] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShoppingCartsApi
     */
    public submitOwnShoppingCart(tenant: string, customerId: string, orderInformation?: OrderSubmitRequest, options?: any) {
        return ShoppingCartsApiFp(this.configuration).submitOwnShoppingCart(tenant, customerId, orderInformation, options)(this.fetch, this.basePath);
    }

}

/**
 * SpecialOrderTemplatesApi - fetch parameter creator
 * @export
 */
export const SpecialOrderTemplatesApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Returns the given order template. Including all items and already filtered products
         * @param {string} tenant The EGB code of the tenant to target
         * @param {number} orderTemplateId The id of the order template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveSpecialOrderTemplateById(tenant: string, orderTemplateId: number, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling getActiveSpecialOrderTemplateById.');
            }
            // verify required parameter 'orderTemplateId' is not null or undefined
            if (orderTemplateId === null || orderTemplateId === undefined) {
                throw new RequiredError('orderTemplateId','Required parameter orderTemplateId was null or undefined when calling getActiveSpecialOrderTemplateById.');
            }
            const localVarPath = `/t/{tenant}/special-order-templates/{orderTemplateId}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"orderTemplateId"}}`, encodeURIComponent(String(orderTemplateId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the given order template. Including all items and already filtered products
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} priceList The price list of the order template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveSpecialOrderTemplateByPriceList(tenant: string, priceList: string, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling getActiveSpecialOrderTemplateByPriceList.');
            }
            // verify required parameter 'priceList' is not null or undefined
            if (priceList === null || priceList === undefined) {
                throw new RequiredError('priceList','Required parameter priceList was null or undefined when calling getActiveSpecialOrderTemplateByPriceList.');
            }
            const localVarPath = `/t/{tenant}/order-templates/price-list/{priceList}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"priceList"}}`, encodeURIComponent(String(priceList)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the list of special order templates available for the tenant.
         * @summary Get accessible order templates
         * @param {string} tenant The EGB code of the tenant to target
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveSpecialOrderTemplates(tenant: string, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling getActiveSpecialOrderTemplates.');
            }
            const localVarPath = `/t/{tenant}/special-order-templates/`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the given order template merged with the user specific order template. Including all items and already filtered products
         * @param {string} tenant The EGB code of the tenant to target
         * @param {number} orderTemplateId The id of the order template
         * @param {string} customerId The tenant-specific customer id to request the information for. This will affect things such as prices and articles.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSpecialAggregatedOrderTemplateById(tenant: string, orderTemplateId: number, customerId: string, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling getSpecialAggregatedOrderTemplateById.');
            }
            // verify required parameter 'orderTemplateId' is not null or undefined
            if (orderTemplateId === null || orderTemplateId === undefined) {
                throw new RequiredError('orderTemplateId','Required parameter orderTemplateId was null or undefined when calling getSpecialAggregatedOrderTemplateById.');
            }
            // verify required parameter 'customerId' is not null or undefined
            if (customerId === null || customerId === undefined) {
                throw new RequiredError('customerId','Required parameter customerId was null or undefined when calling getSpecialAggregatedOrderTemplateById.');
            }
            const localVarPath = `/t/{tenant}/order-templates/aggregated/{orderTemplateId}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"orderTemplateId"}}`, encodeURIComponent(String(orderTemplateId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Generate order template PDF
         * @param {string} tenant The EGB code of the tenant to target
         * @param {number} orderTemplateId The id of the order tempalte to target
         * @param {string} [customerId] The tenant-specific customer id to request the information for. This will affect things such as prices and products.
         * @param {boolean} [showImages] Whether to show images and barcodes in the PDF.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSpecialOrderTemplatePdf(tenant: string, orderTemplateId: number, customerId?: string, showImages?: boolean, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling getSpecialOrderTemplatePdf.');
            }
            // verify required parameter 'orderTemplateId' is not null or undefined
            if (orderTemplateId === null || orderTemplateId === undefined) {
                throw new RequiredError('orderTemplateId','Required parameter orderTemplateId was null or undefined when calling getSpecialOrderTemplatePdf.');
            }
            const localVarPath = `/t/{tenant}/order-templates/{orderTemplateId}/pdf`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"orderTemplateId"}}`, encodeURIComponent(String(orderTemplateId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }

            if (showImages !== undefined) {
                localVarQueryParameter['showImages'] = showImages;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SpecialOrderTemplatesApi - functional programming interface
 * @export
 */
export const SpecialOrderTemplatesApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Returns the given order template. Including all items and already filtered products
         * @param {string} tenant The EGB code of the tenant to target
         * @param {number} orderTemplateId The id of the order template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveSpecialOrderTemplateById(tenant: string, orderTemplateId: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<SpecialOrderTemplateDto> {
            const localVarFetchArgs = SpecialOrderTemplatesApiFetchParamCreator(configuration).getActiveSpecialOrderTemplateById(tenant, orderTemplateId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Returns the given order template. Including all items and already filtered products
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} priceList The price list of the order template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveSpecialOrderTemplateByPriceList(tenant: string, priceList: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<SpecialOrderTemplateDto> {
            const localVarFetchArgs = SpecialOrderTemplatesApiFetchParamCreator(configuration).getActiveSpecialOrderTemplateByPriceList(tenant, priceList, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Retrieves the list of special order templates available for the tenant.
         * @summary Get accessible order templates
         * @param {string} tenant The EGB code of the tenant to target
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveSpecialOrderTemplates(tenant: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<SpecialOrderTemplateDto>> {
            const localVarFetchArgs = SpecialOrderTemplatesApiFetchParamCreator(configuration).getActiveSpecialOrderTemplates(tenant, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Returns the given order template merged with the user specific order template. Including all items and already filtered products
         * @param {string} tenant The EGB code of the tenant to target
         * @param {number} orderTemplateId The id of the order template
         * @param {string} customerId The tenant-specific customer id to request the information for. This will affect things such as prices and articles.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSpecialAggregatedOrderTemplateById(tenant: string, orderTemplateId: number, customerId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<SpecialAggregatedOrderTemplateDto> {
            const localVarFetchArgs = SpecialOrderTemplatesApiFetchParamCreator(configuration).getSpecialAggregatedOrderTemplateById(tenant, orderTemplateId, customerId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Generate order template PDF
         * @param {string} tenant The EGB code of the tenant to target
         * @param {number} orderTemplateId The id of the order tempalte to target
         * @param {string} [customerId] The tenant-specific customer id to request the information for. This will affect things such as prices and products.
         * @param {boolean} [showImages] Whether to show images and barcodes in the PDF.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSpecialOrderTemplatePdf(tenant: string, orderTemplateId: number, customerId?: string, showImages?: boolean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = SpecialOrderTemplatesApiFetchParamCreator(configuration).getSpecialOrderTemplatePdf(tenant, orderTemplateId, customerId, showImages, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * SpecialOrderTemplatesApi - factory interface
 * @export
 */
export const SpecialOrderTemplatesApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Returns the given order template. Including all items and already filtered products
         * @param {string} tenant The EGB code of the tenant to target
         * @param {number} orderTemplateId The id of the order template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveSpecialOrderTemplateById(tenant: string, orderTemplateId: number, options?: any) {
            return SpecialOrderTemplatesApiFp(configuration).getActiveSpecialOrderTemplateById(tenant, orderTemplateId, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Returns the given order template. Including all items and already filtered products
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} priceList The price list of the order template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveSpecialOrderTemplateByPriceList(tenant: string, priceList: string, options?: any) {
            return SpecialOrderTemplatesApiFp(configuration).getActiveSpecialOrderTemplateByPriceList(tenant, priceList, options)(fetch, basePath);
        },
        /**
         * Retrieves the list of special order templates available for the tenant.
         * @summary Get accessible order templates
         * @param {string} tenant The EGB code of the tenant to target
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveSpecialOrderTemplates(tenant: string, options?: any) {
            return SpecialOrderTemplatesApiFp(configuration).getActiveSpecialOrderTemplates(tenant, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Returns the given order template merged with the user specific order template. Including all items and already filtered products
         * @param {string} tenant The EGB code of the tenant to target
         * @param {number} orderTemplateId The id of the order template
         * @param {string} customerId The tenant-specific customer id to request the information for. This will affect things such as prices and articles.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSpecialAggregatedOrderTemplateById(tenant: string, orderTemplateId: number, customerId: string, options?: any) {
            return SpecialOrderTemplatesApiFp(configuration).getSpecialAggregatedOrderTemplateById(tenant, orderTemplateId, customerId, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Generate order template PDF
         * @param {string} tenant The EGB code of the tenant to target
         * @param {number} orderTemplateId The id of the order tempalte to target
         * @param {string} [customerId] The tenant-specific customer id to request the information for. This will affect things such as prices and products.
         * @param {boolean} [showImages] Whether to show images and barcodes in the PDF.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSpecialOrderTemplatePdf(tenant: string, orderTemplateId: number, customerId?: string, showImages?: boolean, options?: any) {
            return SpecialOrderTemplatesApiFp(configuration).getSpecialOrderTemplatePdf(tenant, orderTemplateId, customerId, showImages, options)(fetch, basePath);
        },
    };
};

/**
 * SpecialOrderTemplatesApi - object-oriented interface
 * @export
 * @class SpecialOrderTemplatesApi
 * @extends {BaseAPI}
 */
export class SpecialOrderTemplatesApi extends BaseAPI {
    /**
     * 
     * @summary Returns the given order template. Including all items and already filtered products
     * @param {} tenant The EGB code of the tenant to target
     * @param {} orderTemplateId The id of the order template
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpecialOrderTemplatesApi
     */
    public getActiveSpecialOrderTemplateById(tenant: string, orderTemplateId: number, options?: any) {
        return SpecialOrderTemplatesApiFp(this.configuration).getActiveSpecialOrderTemplateById(tenant, orderTemplateId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Returns the given order template. Including all items and already filtered products
     * @param {} tenant The EGB code of the tenant to target
     * @param {} priceList The price list of the order template
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpecialOrderTemplatesApi
     */
    public getActiveSpecialOrderTemplateByPriceList(tenant: string, priceList: string, options?: any) {
        return SpecialOrderTemplatesApiFp(this.configuration).getActiveSpecialOrderTemplateByPriceList(tenant, priceList, options)(this.fetch, this.basePath);
    }

    /**
     * Retrieves the list of special order templates available for the tenant.
     * @summary Get accessible order templates
     * @param {} tenant The EGB code of the tenant to target
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpecialOrderTemplatesApi
     */
    public getActiveSpecialOrderTemplates(tenant: string, options?: any) {
        return SpecialOrderTemplatesApiFp(this.configuration).getActiveSpecialOrderTemplates(tenant, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Returns the given order template merged with the user specific order template. Including all items and already filtered products
     * @param {} tenant The EGB code of the tenant to target
     * @param {} orderTemplateId The id of the order template
     * @param {} customerId The tenant-specific customer id to request the information for. This will affect things such as prices and articles.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpecialOrderTemplatesApi
     */
    public getSpecialAggregatedOrderTemplateById(tenant: string, orderTemplateId: number, customerId: string, options?: any) {
        return SpecialOrderTemplatesApiFp(this.configuration).getSpecialAggregatedOrderTemplateById(tenant, orderTemplateId, customerId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Generate order template PDF
     * @param {} tenant The EGB code of the tenant to target
     * @param {} orderTemplateId The id of the order tempalte to target
     * @param {} [customerId] The tenant-specific customer id to request the information for. This will affect things such as prices and products.
     * @param {} [showImages] Whether to show images and barcodes in the PDF.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpecialOrderTemplatesApi
     */
    public getSpecialOrderTemplatePdf(tenant: string, orderTemplateId: number, customerId?: string, showImages?: boolean, options?: any) {
        return SpecialOrderTemplatesApiFp(this.configuration).getSpecialOrderTemplatePdf(tenant, orderTemplateId, customerId, showImages, options)(this.fetch, this.basePath);
    }

}

/**
 * SubshopProductSearchApi - fetch parameter creator
 * @export
 */
export const SubshopProductSearchApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Same endpoint as /categories/browse, but it restricts the result to products who belong the subshop with the given cartType. This endpoint also includes nara-information about the deliverd products.
         * @summary Browse a single page in a category
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customer number of the customer to target
         * @param {string} cartType The code of a specific cart-type. This parameter is in combination with the tenant unqiue.
         * @param {CategoryBrowseRequestDto} searchBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        browseCustomerCategoryPage(tenant: string, customerId: string, cartType: string, searchBody: CategoryBrowseRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling browseCustomerCategoryPage.');
            }
            // verify required parameter 'customerId' is not null or undefined
            if (customerId === null || customerId === undefined) {
                throw new RequiredError('customerId','Required parameter customerId was null or undefined when calling browseCustomerCategoryPage.');
            }
            // verify required parameter 'cartType' is not null or undefined
            if (cartType === null || cartType === undefined) {
                throw new RequiredError('cartType','Required parameter cartType was null or undefined when calling browseCustomerCategoryPage.');
            }
            // verify required parameter 'searchBody' is not null or undefined
            if (searchBody === null || searchBody === undefined) {
                throw new RequiredError('searchBody','Required parameter searchBody was null or undefined when calling browseCustomerCategoryPage.');
            }
            const localVarPath = `/t/{tenant}/{customerId}/subshop/{cartType}/categories/browse`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)))
                .replace(`{${"cartType"}}`, encodeURIComponent(String(cartType)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"CategoryBrowseRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(searchBody || {}) : (searchBody || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The search-endpoint for subshop-requests.
         * @summary Autocomplete product names
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customer number of the customer to target
         * @param {string} cartType The code of a specific cart-type. This parameter is in combination with the tenant unqiue.
         * @param {ProductCompletionRequest} completionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeCustomerProductName(tenant: string, customerId: string, cartType: string, completionBody: ProductCompletionRequest, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling completeCustomerProductName.');
            }
            // verify required parameter 'customerId' is not null or undefined
            if (customerId === null || customerId === undefined) {
                throw new RequiredError('customerId','Required parameter customerId was null or undefined when calling completeCustomerProductName.');
            }
            // verify required parameter 'cartType' is not null or undefined
            if (cartType === null || cartType === undefined) {
                throw new RequiredError('cartType','Required parameter cartType was null or undefined when calling completeCustomerProductName.');
            }
            // verify required parameter 'completionBody' is not null or undefined
            if (completionBody === null || completionBody === undefined) {
                throw new RequiredError('completionBody','Required parameter completionBody was null or undefined when calling completeCustomerProductName.');
            }
            const localVarPath = `/t/{tenant}/{customerId}/subshop/{cartType}/products/complete`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)))
                .replace(`{${"cartType"}}`, encodeURIComponent(String(cartType)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ProductCompletionRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(completionBody || {}) : (completionBody || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Endpoint for product-detail including nara-information
         * @summary Endpoint to query the details of a single subshop-product
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customer number of the customer to target
         * @param {string} cartType The code of a specific cart-type. This parameter is in combination with the tenant unqiue.
         * @param {string} sku The SKU id of the product to target
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findProductDetail(tenant: string, customerId: string, cartType: string, sku: string, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling findProductDetail.');
            }
            // verify required parameter 'customerId' is not null or undefined
            if (customerId === null || customerId === undefined) {
                throw new RequiredError('customerId','Required parameter customerId was null or undefined when calling findProductDetail.');
            }
            // verify required parameter 'cartType' is not null or undefined
            if (cartType === null || cartType === undefined) {
                throw new RequiredError('cartType','Required parameter cartType was null or undefined when calling findProductDetail.');
            }
            // verify required parameter 'sku' is not null or undefined
            if (sku === null || sku === undefined) {
                throw new RequiredError('sku','Required parameter sku was null or undefined when calling findProductDetail.');
            }
            const localVarPath = `/t/{tenant}/{customerId}/subshop/{cartType}/products/{sku}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)))
                .replace(`{${"cartType"}}`, encodeURIComponent(String(cartType)))
                .replace(`{${"sku"}}`, encodeURIComponent(String(sku)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search for a list of products in a specific subshop
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customer number of the customer to target
         * @param {string} cartType The code of a specific cart-type. This parameter is in combination with the tenant unqiue.
         * @param {ProductSearchRequest} searchBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchSubshopProducts(tenant: string, customerId: string, cartType: string, searchBody: ProductSearchRequest, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling searchSubshopProducts.');
            }
            // verify required parameter 'customerId' is not null or undefined
            if (customerId === null || customerId === undefined) {
                throw new RequiredError('customerId','Required parameter customerId was null or undefined when calling searchSubshopProducts.');
            }
            // verify required parameter 'cartType' is not null or undefined
            if (cartType === null || cartType === undefined) {
                throw new RequiredError('cartType','Required parameter cartType was null or undefined when calling searchSubshopProducts.');
            }
            // verify required parameter 'searchBody' is not null or undefined
            if (searchBody === null || searchBody === undefined) {
                throw new RequiredError('searchBody','Required parameter searchBody was null or undefined when calling searchSubshopProducts.');
            }
            const localVarPath = `/t/{tenant}/{customerId}/subshop/{cartType}/products/search`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)))
                .replace(`{${"cartType"}}`, encodeURIComponent(String(cartType)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ProductSearchRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(searchBody || {}) : (searchBody || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SubshopProductSearchApi - functional programming interface
 * @export
 */
export const SubshopProductSearchApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Same endpoint as /categories/browse, but it restricts the result to products who belong the subshop with the given cartType. This endpoint also includes nara-information about the deliverd products.
         * @summary Browse a single page in a category
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customer number of the customer to target
         * @param {string} cartType The code of a specific cart-type. This parameter is in combination with the tenant unqiue.
         * @param {CategoryBrowseRequestDto} searchBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        browseCustomerCategoryPage(tenant: string, customerId: string, cartType: string, searchBody: CategoryBrowseRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<SubshopGroupedProductsDto> {
            const localVarFetchArgs = SubshopProductSearchApiFetchParamCreator(configuration).browseCustomerCategoryPage(tenant, customerId, cartType, searchBody, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * The search-endpoint for subshop-requests.
         * @summary Autocomplete product names
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customer number of the customer to target
         * @param {string} cartType The code of a specific cart-type. This parameter is in combination with the tenant unqiue.
         * @param {ProductCompletionRequest} completionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeCustomerProductName(tenant: string, customerId: string, cartType: string, completionBody: ProductCompletionRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<SubshopProductCompletionResponseDto> {
            const localVarFetchArgs = SubshopProductSearchApiFetchParamCreator(configuration).completeCustomerProductName(tenant, customerId, cartType, completionBody, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Endpoint for product-detail including nara-information
         * @summary Endpoint to query the details of a single subshop-product
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customer number of the customer to target
         * @param {string} cartType The code of a specific cart-type. This parameter is in combination with the tenant unqiue.
         * @param {string} sku The SKU id of the product to target
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findProductDetail(tenant: string, customerId: string, cartType: string, sku: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<SubshopProductDto> {
            const localVarFetchArgs = SubshopProductSearchApiFetchParamCreator(configuration).findProductDetail(tenant, customerId, cartType, sku, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Search for a list of products in a specific subshop
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customer number of the customer to target
         * @param {string} cartType The code of a specific cart-type. This parameter is in combination with the tenant unqiue.
         * @param {ProductSearchRequest} searchBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchSubshopProducts(tenant: string, customerId: string, cartType: string, searchBody: ProductSearchRequest, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<SubshopProductSearchResultDto> {
            const localVarFetchArgs = SubshopProductSearchApiFetchParamCreator(configuration).searchSubshopProducts(tenant, customerId, cartType, searchBody, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * SubshopProductSearchApi - factory interface
 * @export
 */
export const SubshopProductSearchApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * Same endpoint as /categories/browse, but it restricts the result to products who belong the subshop with the given cartType. This endpoint also includes nara-information about the deliverd products.
         * @summary Browse a single page in a category
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customer number of the customer to target
         * @param {string} cartType The code of a specific cart-type. This parameter is in combination with the tenant unqiue.
         * @param {CategoryBrowseRequestDto} searchBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        browseCustomerCategoryPage(tenant: string, customerId: string, cartType: string, searchBody: CategoryBrowseRequestDto, options?: any) {
            return SubshopProductSearchApiFp(configuration).browseCustomerCategoryPage(tenant, customerId, cartType, searchBody, options)(fetch, basePath);
        },
        /**
         * The search-endpoint for subshop-requests.
         * @summary Autocomplete product names
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customer number of the customer to target
         * @param {string} cartType The code of a specific cart-type. This parameter is in combination with the tenant unqiue.
         * @param {ProductCompletionRequest} completionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeCustomerProductName(tenant: string, customerId: string, cartType: string, completionBody: ProductCompletionRequest, options?: any) {
            return SubshopProductSearchApiFp(configuration).completeCustomerProductName(tenant, customerId, cartType, completionBody, options)(fetch, basePath);
        },
        /**
         * Endpoint for product-detail including nara-information
         * @summary Endpoint to query the details of a single subshop-product
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customer number of the customer to target
         * @param {string} cartType The code of a specific cart-type. This parameter is in combination with the tenant unqiue.
         * @param {string} sku The SKU id of the product to target
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findProductDetail(tenant: string, customerId: string, cartType: string, sku: string, options?: any) {
            return SubshopProductSearchApiFp(configuration).findProductDetail(tenant, customerId, cartType, sku, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Search for a list of products in a specific subshop
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customer number of the customer to target
         * @param {string} cartType The code of a specific cart-type. This parameter is in combination with the tenant unqiue.
         * @param {ProductSearchRequest} searchBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchSubshopProducts(tenant: string, customerId: string, cartType: string, searchBody: ProductSearchRequest, options?: any) {
            return SubshopProductSearchApiFp(configuration).searchSubshopProducts(tenant, customerId, cartType, searchBody, options)(fetch, basePath);
        },
    };
};

/**
 * SubshopProductSearchApi - object-oriented interface
 * @export
 * @class SubshopProductSearchApi
 * @extends {BaseAPI}
 */
export class SubshopProductSearchApi extends BaseAPI {
    /**
     * Same endpoint as /categories/browse, but it restricts the result to products who belong the subshop with the given cartType. This endpoint also includes nara-information about the deliverd products.
     * @summary Browse a single page in a category
     * @param {} tenant The EGB code of the tenant to target
     * @param {} customerId The tenant-specific customer number of the customer to target
     * @param {} cartType The code of a specific cart-type. This parameter is in combination with the tenant unqiue.
     * @param {} searchBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubshopProductSearchApi
     */
    public browseCustomerCategoryPage(tenant: string, customerId: string, cartType: string, searchBody: CategoryBrowseRequestDto, options?: any) {
        return SubshopProductSearchApiFp(this.configuration).browseCustomerCategoryPage(tenant, customerId, cartType, searchBody, options)(this.fetch, this.basePath);
    }

    /**
     * The search-endpoint for subshop-requests.
     * @summary Autocomplete product names
     * @param {} tenant The EGB code of the tenant to target
     * @param {} customerId The tenant-specific customer number of the customer to target
     * @param {} cartType The code of a specific cart-type. This parameter is in combination with the tenant unqiue.
     * @param {} completionBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubshopProductSearchApi
     */
    public completeCustomerProductName(tenant: string, customerId: string, cartType: string, completionBody: ProductCompletionRequest, options?: any) {
        return SubshopProductSearchApiFp(this.configuration).completeCustomerProductName(tenant, customerId, cartType, completionBody, options)(this.fetch, this.basePath);
    }

    /**
     * Endpoint for product-detail including nara-information
     * @summary Endpoint to query the details of a single subshop-product
     * @param {} tenant The EGB code of the tenant to target
     * @param {} customerId The tenant-specific customer number of the customer to target
     * @param {} cartType The code of a specific cart-type. This parameter is in combination with the tenant unqiue.
     * @param {} sku The SKU id of the product to target
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubshopProductSearchApi
     */
    public findProductDetail(tenant: string, customerId: string, cartType: string, sku: string, options?: any) {
        return SubshopProductSearchApiFp(this.configuration).findProductDetail(tenant, customerId, cartType, sku, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Search for a list of products in a specific subshop
     * @param {} tenant The EGB code of the tenant to target
     * @param {} customerId The tenant-specific customer number of the customer to target
     * @param {} cartType The code of a specific cart-type. This parameter is in combination with the tenant unqiue.
     * @param {} searchBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubshopProductSearchApi
     */
    public searchSubshopProducts(tenant: string, customerId: string, cartType: string, searchBody: ProductSearchRequest, options?: any) {
        return SubshopProductSearchApiFp(this.configuration).searchSubshopProducts(tenant, customerId, cartType, searchBody, options)(this.fetch, this.basePath);
    }

}

/**
 * TenantApi - fetch parameter creator
 * @export
 */
export const TenantApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns true if and only if given tenant has an active special order template
         * @summary Does this tenant have active Special Order Templates?
         * @param {string} tenant The tenant of the customer to target
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doesCurrentTenantHaveSpecialOrderTemplate(tenant: string, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling doesCurrentTenantHaveSpecialOrderTemplate.');
            }
            const localVarPath = `/t/{tenant}/doesCurrentTenantHaveSpecialOrderTemplate/`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TenantApi - functional programming interface
 * @export
 */
export const TenantApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Returns true if and only if given tenant has an active special order template
         * @summary Does this tenant have active Special Order Templates?
         * @param {string} tenant The tenant of the customer to target
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doesCurrentTenantHaveSpecialOrderTemplate(tenant: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<BooleanResponse> {
            const localVarFetchArgs = TenantApiFetchParamCreator(configuration).doesCurrentTenantHaveSpecialOrderTemplate(tenant, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * TenantApi - factory interface
 * @export
 */
export const TenantApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * Returns true if and only if given tenant has an active special order template
         * @summary Does this tenant have active Special Order Templates?
         * @param {string} tenant The tenant of the customer to target
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doesCurrentTenantHaveSpecialOrderTemplate(tenant: string, options?: any) {
            return TenantApiFp(configuration).doesCurrentTenantHaveSpecialOrderTemplate(tenant, options)(fetch, basePath);
        },
    };
};

/**
 * TenantApi - object-oriented interface
 * @export
 * @class TenantApi
 * @extends {BaseAPI}
 */
export class TenantApi extends BaseAPI {
    /**
     * Returns true if and only if given tenant has an active special order template
     * @summary Does this tenant have active Special Order Templates?
     * @param {} tenant The tenant of the customer to target
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantApi
     */
    public doesCurrentTenantHaveSpecialOrderTemplate(tenant: string, options?: any) {
        return TenantApiFp(this.configuration).doesCurrentTenantHaveSpecialOrderTemplate(tenant, options)(this.fetch, this.basePath);
    }

}

/**
 * UserNotificationsApi - fetch parameter creator
 * @export
 */
export const UserNotificationsApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get the number of unread notifications for the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findUnreadNotificationCount(options: any = {}): FetchArgs {
            const localVarPath = `/user/notifications/unread-count`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the number of unread notifications and information about pop-up notifications
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customer number of the customer to target
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findUrgentNotification(tenant: string, customerId: string, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling findUrgentNotification.');
            }
            // verify required parameter 'customerId' is not null or undefined
            if (customerId === null || customerId === undefined) {
                throw new RequiredError('customerId','Required parameter customerId was null or undefined when calling findUrgentNotification.');
            }
            const localVarPath = `/t/{tenant}/customers/{customerId}/user/notifications/urgent`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a single notification for the current user
         * @param {number} notificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserNotification(notificationId: number, options: any = {}): FetchArgs {
            // verify required parameter 'notificationId' is not null or undefined
            if (notificationId === null || notificationId === undefined) {
                throw new RequiredError('notificationId','Required parameter notificationId was null or undefined when calling getUserNotification.');
            }
            const localVarPath = `/user/notifications/{notificationId}`
                .replace(`{${"notificationId"}}`, encodeURIComponent(String(notificationId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the preferences of the current user.
         * @summary Get notification preferences of the current user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserNotificationPreferences(options: any = {}): FetchArgs {
            const localVarPath = `/user/notifications/preferences`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a page of notifications for the current user
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customer number of the customer to target
         * @param {number} pageIndex Zero-based index of the page to retrieve
         * @param {number} [perPage] How many items to include per page
         * @param {number} [typeFilterId] The notification type id to filter to, none if omitted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUserNotifications(tenant: string, customerId: string, pageIndex: number, perPage?: number, typeFilterId?: number, options: any = {}): FetchArgs {
            // verify required parameter 'tenant' is not null or undefined
            if (tenant === null || tenant === undefined) {
                throw new RequiredError('tenant','Required parameter tenant was null or undefined when calling listUserNotifications.');
            }
            // verify required parameter 'customerId' is not null or undefined
            if (customerId === null || customerId === undefined) {
                throw new RequiredError('customerId','Required parameter customerId was null or undefined when calling listUserNotifications.');
            }
            // verify required parameter 'pageIndex' is not null or undefined
            if (pageIndex === null || pageIndex === undefined) {
                throw new RequiredError('pageIndex','Required parameter pageIndex was null or undefined when calling listUserNotifications.');
            }
            const localVarPath = `/t/{tenant}/customers/{customerId}/user/notifications/page/{pageIndex}`
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)))
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)))
                .replace(`{${"pageIndex"}}`, encodeURIComponent(String(pageIndex)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (perPage !== undefined) {
                localVarQueryParameter['perPage'] = perPage;
            }

            if (typeFilterId !== undefined) {
                localVarQueryParameter['typeFilterId'] = typeFilterId;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Marks the notifications as read.
         * @summary Mark notifications as read.
         * @param {Array&lt;number&gt;} notificationIds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markNotificationsRead(notificationIds: Array<number>, options: any = {}): FetchArgs {
            // verify required parameter 'notificationIds' is not null or undefined
            if (notificationIds === null || notificationIds === undefined) {
                throw new RequiredError('notificationIds','Required parameter notificationIds was null or undefined when calling markNotificationsRead.');
            }
            const localVarPath = `/user/notifications/mark-read`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"Array&lt;number&gt;" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(notificationIds || {}) : (notificationIds || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the notification preferences of the current user.
         * @summary Update notification preferences of current user.
         * @param {Array&lt;NotificationPreferenceDto&gt;} preferences 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserNotificationPreferences(preferences: Array<NotificationPreferenceDto>, options: any = {}): FetchArgs {
            // verify required parameter 'preferences' is not null or undefined
            if (preferences === null || preferences === undefined) {
                throw new RequiredError('preferences','Required parameter preferences was null or undefined when calling updateUserNotificationPreferences.');
            }
            const localVarPath = `/user/notifications/preferences`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"Array&lt;NotificationPreferenceDto&gt;" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(preferences || {}) : (preferences || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserNotificationsApi - functional programming interface
 * @export
 */
export const UserNotificationsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get the number of unread notifications for the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findUnreadNotificationCount(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<number> {
            const localVarFetchArgs = UserNotificationsApiFetchParamCreator(configuration).findUnreadNotificationCount(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get the number of unread notifications and information about pop-up notifications
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customer number of the customer to target
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findUrgentNotification(tenant: string, customerId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UrgentNotificationDto> {
            const localVarFetchArgs = UserNotificationsApiFetchParamCreator(configuration).findUrgentNotification(tenant, customerId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get a single notification for the current user
         * @param {number} notificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserNotification(notificationId: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UserNotificationDto> {
            const localVarFetchArgs = UserNotificationsApiFetchParamCreator(configuration).getUserNotification(notificationId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Retrieves the preferences of the current user.
         * @summary Get notification preferences of the current user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserNotificationPreferences(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<NotificationPreferenceDto>> {
            const localVarFetchArgs = UserNotificationsApiFetchParamCreator(configuration).getUserNotificationPreferences(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get a page of notifications for the current user
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customer number of the customer to target
         * @param {number} pageIndex Zero-based index of the page to retrieve
         * @param {number} [perPage] How many items to include per page
         * @param {number} [typeFilterId] The notification type id to filter to, none if omitted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUserNotifications(tenant: string, customerId: string, pageIndex: number, perPage?: number, typeFilterId?: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UserNotificationsResultDto> {
            const localVarFetchArgs = UserNotificationsApiFetchParamCreator(configuration).listUserNotifications(tenant, customerId, pageIndex, perPage, typeFilterId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Marks the notifications as read.
         * @summary Mark notifications as read.
         * @param {Array&lt;number&gt;} notificationIds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markNotificationsRead(notificationIds: Array<number>, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = UserNotificationsApiFetchParamCreator(configuration).markNotificationsRead(notificationIds, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Updates the notification preferences of the current user.
         * @summary Update notification preferences of current user.
         * @param {Array&lt;NotificationPreferenceDto&gt;} preferences 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserNotificationPreferences(preferences: Array<NotificationPreferenceDto>, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = UserNotificationsApiFetchParamCreator(configuration).updateUserNotificationPreferences(preferences, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * UserNotificationsApi - factory interface
 * @export
 */
export const UserNotificationsApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Get the number of unread notifications for the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findUnreadNotificationCount(options?: any) {
            return UserNotificationsApiFp(configuration).findUnreadNotificationCount(options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get the number of unread notifications and information about pop-up notifications
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customer number of the customer to target
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findUrgentNotification(tenant: string, customerId: string, options?: any) {
            return UserNotificationsApiFp(configuration).findUrgentNotification(tenant, customerId, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get a single notification for the current user
         * @param {number} notificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserNotification(notificationId: number, options?: any) {
            return UserNotificationsApiFp(configuration).getUserNotification(notificationId, options)(fetch, basePath);
        },
        /**
         * Retrieves the preferences of the current user.
         * @summary Get notification preferences of the current user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserNotificationPreferences(options?: any) {
            return UserNotificationsApiFp(configuration).getUserNotificationPreferences(options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get a page of notifications for the current user
         * @param {string} tenant The EGB code of the tenant to target
         * @param {string} customerId The tenant-specific customer number of the customer to target
         * @param {number} pageIndex Zero-based index of the page to retrieve
         * @param {number} [perPage] How many items to include per page
         * @param {number} [typeFilterId] The notification type id to filter to, none if omitted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUserNotifications(tenant: string, customerId: string, pageIndex: number, perPage?: number, typeFilterId?: number, options?: any) {
            return UserNotificationsApiFp(configuration).listUserNotifications(tenant, customerId, pageIndex, perPage, typeFilterId, options)(fetch, basePath);
        },
        /**
         * Marks the notifications as read.
         * @summary Mark notifications as read.
         * @param {Array&lt;number&gt;} notificationIds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markNotificationsRead(notificationIds: Array<number>, options?: any) {
            return UserNotificationsApiFp(configuration).markNotificationsRead(notificationIds, options)(fetch, basePath);
        },
        /**
         * Updates the notification preferences of the current user.
         * @summary Update notification preferences of current user.
         * @param {Array&lt;NotificationPreferenceDto&gt;} preferences 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserNotificationPreferences(preferences: Array<NotificationPreferenceDto>, options?: any) {
            return UserNotificationsApiFp(configuration).updateUserNotificationPreferences(preferences, options)(fetch, basePath);
        },
    };
};

/**
 * UserNotificationsApi - object-oriented interface
 * @export
 * @class UserNotificationsApi
 * @extends {BaseAPI}
 */
export class UserNotificationsApi extends BaseAPI {
    /**
     * 
     * @summary Get the number of unread notifications for the current user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserNotificationsApi
     */
    public findUnreadNotificationCount(options?: any) {
        return UserNotificationsApiFp(this.configuration).findUnreadNotificationCount(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get the number of unread notifications and information about pop-up notifications
     * @param {} tenant The EGB code of the tenant to target
     * @param {} customerId The tenant-specific customer number of the customer to target
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserNotificationsApi
     */
    public findUrgentNotification(tenant: string, customerId: string, options?: any) {
        return UserNotificationsApiFp(this.configuration).findUrgentNotification(tenant, customerId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get a single notification for the current user
     * @param {} notificationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserNotificationsApi
     */
    public getUserNotification(notificationId: number, options?: any) {
        return UserNotificationsApiFp(this.configuration).getUserNotification(notificationId, options)(this.fetch, this.basePath);
    }

    /**
     * Retrieves the preferences of the current user.
     * @summary Get notification preferences of the current user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserNotificationsApi
     */
    public getUserNotificationPreferences(options?: any) {
        return UserNotificationsApiFp(this.configuration).getUserNotificationPreferences(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get a page of notifications for the current user
     * @param {} tenant The EGB code of the tenant to target
     * @param {} customerId The tenant-specific customer number of the customer to target
     * @param {} pageIndex Zero-based index of the page to retrieve
     * @param {} [perPage] How many items to include per page
     * @param {} [typeFilterId] The notification type id to filter to, none if omitted
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserNotificationsApi
     */
    public listUserNotifications(tenant: string, customerId: string, pageIndex: number, perPage?: number, typeFilterId?: number, options?: any) {
        return UserNotificationsApiFp(this.configuration).listUserNotifications(tenant, customerId, pageIndex, perPage, typeFilterId, options)(this.fetch, this.basePath);
    }

    /**
     * Marks the notifications as read.
     * @summary Mark notifications as read.
     * @param {} notificationIds 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserNotificationsApi
     */
    public markNotificationsRead(notificationIds: Array<number>, options?: any) {
        return UserNotificationsApiFp(this.configuration).markNotificationsRead(notificationIds, options)(this.fetch, this.basePath);
    }

    /**
     * Updates the notification preferences of the current user.
     * @summary Update notification preferences of current user.
     * @param {} preferences 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserNotificationsApi
     */
    public updateUserNotificationPreferences(preferences: Array<NotificationPreferenceDto>, options?: any) {
        return UserNotificationsApiFp(this.configuration).updateUserNotificationPreferences(preferences, options)(this.fetch, this.basePath);
    }

}

/**
 * UsersApi - fetch parameter creator
 * @export
 */
export const UsersApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Adds a label-print email to the current user
         * @param {string} mail Email address to add, which will receive printed labels per email.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addLabelMail(mail: string, options: any = {}): FetchArgs {
            // verify required parameter 'mail' is not null or undefined
            if (mail === null || mail === undefined) {
                throw new RequiredError('mail','Required parameter mail was null or undefined when calling addLabelMail.');
            }
            const localVarPath = `/user/labelMail`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (mail !== undefined) {
                localVarQueryParameter['mail'] = mail;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Adds an additional order email address to the current user
         * @param {string} mail Email address to add, which will receive notifications each time an order is submitted by the current user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOrderMail(mail: string, options: any = {}): FetchArgs {
            // verify required parameter 'mail' is not null or undefined
            if (mail === null || mail === undefined) {
                throw new RequiredError('mail','Required parameter mail was null or undefined when calling addOrderMail.');
            }
            const localVarPath = `/user/orderMail`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (mail !== undefined) {
                localVarQueryParameter['mail'] = mail;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * For users assigned to one of the Landmarkt tenants, returns which one they are assigned to, as tenant code. This is used for the Landmarkt landing page redirect. If no such user exists or the user is not assigned to any Landmarkt tenant, an empty string is returned.
         * @summary Finds the Landmarkt tenant assigned to given user
         * @param {string} userName The name of the user to look up the tenant for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findLandmarktTenant(userName: string, options: any = {}): FetchArgs {
            // verify required parameter 'userName' is not null or undefined
            if (userName === null || userName === undefined) {
                throw new RequiredError('userName','Required parameter userName was null or undefined when calling findLandmarktTenant.');
            }
            const localVarPath = `/landmarktTenant/{userName}`
                .replace(`{${"userName"}}`, encodeURIComponent(String(userName)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentUser(options: any = {}): FetchArgs {
            const localVarPath = `/user/getCurrentUser`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Removes a label-print email from the current user
         * @param {string} mail Label-print email address to remove
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeLabelMail(mail: string, options: any = {}): FetchArgs {
            // verify required parameter 'mail' is not null or undefined
            if (mail === null || mail === undefined) {
                throw new RequiredError('mail','Required parameter mail was null or undefined when calling removeLabelMail.');
            }
            const localVarPath = `/user/labelMail`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (mail !== undefined) {
                localVarQueryParameter['mail'] = mail;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Removes an order email address from the current user
         * @param {string} mail Order email address to remove
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeOrderMail(mail: string, options: any = {}): FetchArgs {
            // verify required parameter 'mail' is not null or undefined
            if (mail === null || mail === undefined) {
                throw new RequiredError('mail','Required parameter mail was null or undefined when calling removeOrderMail.');
            }
            const localVarPath = `/user/orderMail`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (mail !== undefined) {
                localVarQueryParameter['mail'] = mail;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates the current user last login
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setLastSuccessfulLogin(options: any = {}): FetchArgs {
            const localVarPath = `/user/last-login-date`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Changes profile information of the current user. Here, first and last name as well as the email address may be changed. The email address is not updated in Keycloak.
         * @summary Updates the current user
         * @param {UserSubmitDto} user 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserData(user: UserSubmitDto, options: any = {}): FetchArgs {
            // verify required parameter 'user' is not null or undefined
            if (user === null || user === undefined) {
                throw new RequiredError('user','Required parameter user was null or undefined when calling updateUserData.');
            }
            const localVarPath = `/user/updateUserData`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"UserSubmitDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(user || {}) : (user || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates the current user locale
         * @param {string} locale 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserLocale(locale: string, options: any = {}): FetchArgs {
            // verify required parameter 'locale' is not null or undefined
            if (locale === null || locale === undefined) {
                throw new RequiredError('locale','Required parameter locale was null or undefined when calling updateUserLocale.');
            }
            const localVarPath = `/user/locale`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            // oauth required
            if (configuration && configuration.accessToken) {
				const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
					? configuration.accessToken("BearerAuth", [])
					: configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"string" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(locale || {}) : (locale || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UsersApi - functional programming interface
 * @export
 */
export const UsersApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Adds a label-print email to the current user
         * @param {string} mail Email address to add, which will receive printed labels per email.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addLabelMail(mail: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UserDto> {
            const localVarFetchArgs = UsersApiFetchParamCreator(configuration).addLabelMail(mail, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Adds an additional order email address to the current user
         * @param {string} mail Email address to add, which will receive notifications each time an order is submitted by the current user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOrderMail(mail: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UserDto> {
            const localVarFetchArgs = UsersApiFetchParamCreator(configuration).addOrderMail(mail, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * For users assigned to one of the Landmarkt tenants, returns which one they are assigned to, as tenant code. This is used for the Landmarkt landing page redirect. If no such user exists or the user is not assigned to any Landmarkt tenant, an empty string is returned.
         * @summary Finds the Landmarkt tenant assigned to given user
         * @param {string} userName The name of the user to look up the tenant for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findLandmarktTenant(userName: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = UsersApiFetchParamCreator(configuration).findLandmarktTenant(userName, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Get the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentUser(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UserDto> {
            const localVarFetchArgs = UsersApiFetchParamCreator(configuration).getCurrentUser(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Removes a label-print email from the current user
         * @param {string} mail Label-print email address to remove
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeLabelMail(mail: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UserDto> {
            const localVarFetchArgs = UsersApiFetchParamCreator(configuration).removeLabelMail(mail, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Removes an order email address from the current user
         * @param {string} mail Order email address to remove
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeOrderMail(mail: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UserDto> {
            const localVarFetchArgs = UsersApiFetchParamCreator(configuration).removeOrderMail(mail, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Updates the current user last login
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setLastSuccessfulLogin(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = UsersApiFetchParamCreator(configuration).setLastSuccessfulLogin(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Changes profile information of the current user. Here, first and last name as well as the email address may be changed. The email address is not updated in Keycloak.
         * @summary Updates the current user
         * @param {UserSubmitDto} user 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserData(user: UserSubmitDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UserDto> {
            const localVarFetchArgs = UsersApiFetchParamCreator(configuration).updateUserData(user, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Updates the current user locale
         * @param {string} locale 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserLocale(locale: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UserDto> {
            const localVarFetchArgs = UsersApiFetchParamCreator(configuration).updateUserLocale(locale, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * UsersApi - factory interface
 * @export
 */
export const UsersApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Adds a label-print email to the current user
         * @param {string} mail Email address to add, which will receive printed labels per email.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addLabelMail(mail: string, options?: any) {
            return UsersApiFp(configuration).addLabelMail(mail, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Adds an additional order email address to the current user
         * @param {string} mail Email address to add, which will receive notifications each time an order is submitted by the current user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addOrderMail(mail: string, options?: any) {
            return UsersApiFp(configuration).addOrderMail(mail, options)(fetch, basePath);
        },
        /**
         * For users assigned to one of the Landmarkt tenants, returns which one they are assigned to, as tenant code. This is used for the Landmarkt landing page redirect. If no such user exists or the user is not assigned to any Landmarkt tenant, an empty string is returned.
         * @summary Finds the Landmarkt tenant assigned to given user
         * @param {string} userName The name of the user to look up the tenant for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findLandmarktTenant(userName: string, options?: any) {
            return UsersApiFp(configuration).findLandmarktTenant(userName, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Get the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentUser(options?: any) {
            return UsersApiFp(configuration).getCurrentUser(options)(fetch, basePath);
        },
        /**
         * 
         * @summary Removes a label-print email from the current user
         * @param {string} mail Label-print email address to remove
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeLabelMail(mail: string, options?: any) {
            return UsersApiFp(configuration).removeLabelMail(mail, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Removes an order email address from the current user
         * @param {string} mail Order email address to remove
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeOrderMail(mail: string, options?: any) {
            return UsersApiFp(configuration).removeOrderMail(mail, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Updates the current user last login
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setLastSuccessfulLogin(options?: any) {
            return UsersApiFp(configuration).setLastSuccessfulLogin(options)(fetch, basePath);
        },
        /**
         * Changes profile information of the current user. Here, first and last name as well as the email address may be changed. The email address is not updated in Keycloak.
         * @summary Updates the current user
         * @param {UserSubmitDto} user 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserData(user: UserSubmitDto, options?: any) {
            return UsersApiFp(configuration).updateUserData(user, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Updates the current user locale
         * @param {string} locale 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserLocale(locale: string, options?: any) {
            return UsersApiFp(configuration).updateUserLocale(locale, options)(fetch, basePath);
        },
    };
};

/**
 * UsersApi - object-oriented interface
 * @export
 * @class UsersApi
 * @extends {BaseAPI}
 */
export class UsersApi extends BaseAPI {
    /**
     * 
     * @summary Adds a label-print email to the current user
     * @param {} mail Email address to add, which will receive printed labels per email.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public addLabelMail(mail: string, options?: any) {
        return UsersApiFp(this.configuration).addLabelMail(mail, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Adds an additional order email address to the current user
     * @param {} mail Email address to add, which will receive notifications each time an order is submitted by the current user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public addOrderMail(mail: string, options?: any) {
        return UsersApiFp(this.configuration).addOrderMail(mail, options)(this.fetch, this.basePath);
    }

    /**
     * For users assigned to one of the Landmarkt tenants, returns which one they are assigned to, as tenant code. This is used for the Landmarkt landing page redirect. If no such user exists or the user is not assigned to any Landmarkt tenant, an empty string is returned.
     * @summary Finds the Landmarkt tenant assigned to given user
     * @param {} userName The name of the user to look up the tenant for.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public findLandmarktTenant(userName: string, options?: any) {
        return UsersApiFp(this.configuration).findLandmarktTenant(userName, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Get the current user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public getCurrentUser(options?: any) {
        return UsersApiFp(this.configuration).getCurrentUser(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Removes a label-print email from the current user
     * @param {} mail Label-print email address to remove
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public removeLabelMail(mail: string, options?: any) {
        return UsersApiFp(this.configuration).removeLabelMail(mail, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Removes an order email address from the current user
     * @param {} mail Order email address to remove
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public removeOrderMail(mail: string, options?: any) {
        return UsersApiFp(this.configuration).removeOrderMail(mail, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Updates the current user last login
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public setLastSuccessfulLogin(options?: any) {
        return UsersApiFp(this.configuration).setLastSuccessfulLogin(options)(this.fetch, this.basePath);
    }

    /**
     * Changes profile information of the current user. Here, first and last name as well as the email address may be changed. The email address is not updated in Keycloak.
     * @summary Updates the current user
     * @param {} user 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public updateUserData(user: UserSubmitDto, options?: any) {
        return UsersApiFp(this.configuration).updateUserData(user, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Updates the current user locale
     * @param {} locale 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public updateUserLocale(locale: string, options?: any) {
        return UsersApiFp(this.configuration).updateUserLocale(locale, options)(this.fetch, this.basePath);
    }

}

